/* tslint:disable */
/* eslint-disable */
/**
 * BerkshireServicesPortal.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
 */
export interface ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO {
    /**
     * 
     * @type {string}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'group': string;
    /**
     * 
     * @type {string}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'groupDescription': string;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'totalForGroup': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'minCount': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'nonMinCount': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'unknownCount': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'asiCount': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'blkCount': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'hisCount': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'indCount': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'pacCount': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'twoCount': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'whtCount': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'minGenderCount': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'nonMinGenderCount': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'unknownGenderCount': number;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO
     */
    'sortOrder': number;
}
/**
 * 
 * @export
 * @interface ApplicantFlowApplicantFlowResultCount
 */
export interface ApplicantFlowApplicantFlowResultCount {
    /**
     * 
     * @type {string}
     * @memberof ApplicantFlowApplicantFlowResultCount
     */
    'resultType': string;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowApplicantFlowResultCount
     */
    'count'?: number | null;
}
/**
 * 
 * @export
 * @interface ApplicantFlowApplicantFlowTypeSettingsResponse
 */
export interface ApplicantFlowApplicantFlowTypeSettingsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ApplicantFlowApplicantFlowTypeSettingsResponse
     */
    'isSelected': boolean;
    /**
     * 
     * @type {string}
     * @memberof ApplicantFlowApplicantFlowTypeSettingsResponse
     */
    'actionTypeName': string;
}
/**
 * 
 * @export
 * @interface ApplicantFlowDispositionCountsByRaceGenderDTO
 */
export interface ApplicantFlowDispositionCountsByRaceGenderDTO {
    /**
     * 
     * @type {string}
     * @memberof ApplicantFlowDispositionCountsByRaceGenderDTO
     */
    'group': string;
    /**
     * 
     * @type {string}
     * @memberof ApplicantFlowDispositionCountsByRaceGenderDTO
     */
    'groupDescription': string;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowDispositionCountsByRaceGenderDTO
     */
    'count': number;
    /**
     * 
     * @type {Array<ApplicantFlowApplicantFlowResultCount>}
     * @memberof ApplicantFlowDispositionCountsByRaceGenderDTO
     */
    'resultCounts': Array<ApplicantFlowApplicantFlowResultCount>;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowDispositionCountsByRaceGenderDTO
     */
    'sortOrder': number;
}
/**
 * 
 * @export
 * @interface ApplicantFlowDispositionCountsOverallDTO
 */
export interface ApplicantFlowDispositionCountsOverallDTO {
    /**
     * 
     * @type {string}
     * @memberof ApplicantFlowDispositionCountsOverallDTO
     */
    'dispCode': string;
    /**
     * 
     * @type {string}
     * @memberof ApplicantFlowDispositionCountsOverallDTO
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof ApplicantFlowDispositionCountsOverallDTO
     */
    'count'?: number | null;
}
/**
 * 
 * @export
 * @interface ApplicantFlowTop5DispositionCountsByJobGroupDTO
 */
export interface ApplicantFlowTop5DispositionCountsByJobGroupDTO {
    /**
     * 
     * @type {string}
     * @memberof ApplicantFlowTop5DispositionCountsByJobGroupDTO
     */
    'jobGroup': string;
    /**
     * 
     * @type {string}
     * @memberof ApplicantFlowTop5DispositionCountsByJobGroupDTO
     */
    'jobGroupDescription': string;
    /**
     * 
     * @type {Array<ApplicantFlowDispositionCountsOverallDTO>}
     * @memberof ApplicantFlowTop5DispositionCountsByJobGroupDTO
     */
    'resultCounts': Array<ApplicantFlowDispositionCountsOverallDTO>;
}
/**
 * 
 * @export
 * @interface ClientDataModelsDocumentUploadFile
 */
export interface ClientDataModelsDocumentUploadFile {
    /**
     * 
     * @type {string}
     * @memberof ClientDataModelsDocumentUploadFile
     */
    'documentUploadFileID': string;
    /**
     * 
     * @type {string}
     * @memberof ClientDataModelsDocumentUploadFile
     */
    'documentUploadID': string;
    /**
     * 
     * @type {string}
     * @memberof ClientDataModelsDocumentUploadFile
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {EnumerationsFileType}
     * @memberof ClientDataModelsDocumentUploadFile
     */
    'fileTypeID': EnumerationsFileType;
    /**
     * 
     * @type {number}
     * @memberof ClientDataModelsDocumentUploadFile
     */
    'fileSize': number;
}


/**
 * 
 * @export
 * @interface CommandsAcknowledgeAlertRequest
 */
export interface CommandsAcknowledgeAlertRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsAcknowledgeAlertRequest
     */
    'systemAlertID': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsAcknowledgeAlertRequest
     */
    'acknowledgePolicy'?: boolean | null;
}
/**
 * 
 * @export
 * @interface CommandsCopyLocationsCommand
 */
export interface CommandsCopyLocationsCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsCopyLocationsCommand
     */
    'oldProjectID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCopyLocationsCommand
     */
    'newProjectID': string;
}
/**
 * 
 * @export
 * @interface CommandsCreateAlertRequest
 */
export interface CommandsCreateAlertRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAlertRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAlertRequest
     */
    'htmlBody': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAlertRequest
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAlertRequest
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {Array<SystemAlertsSystemAlertReceivingClientDTO>}
     * @memberof CommandsCreateAlertRequest
     */
    'clients': Array<SystemAlertsSystemAlertReceivingClientDTO>;
    /**
     * 
     * @type {EnumerationsSystemAlertLabelType}
     * @memberof CommandsCreateAlertRequest
     */
    'clientNamesLabelTypeID': EnumerationsSystemAlertLabelType;
    /**
     * 
     * @type {Array<SystemAlertsSystemAlertReceivingServiceDTO>}
     * @memberof CommandsCreateAlertRequest
     */
    'serviceLines': Array<SystemAlertsSystemAlertReceivingServiceDTO>;
    /**
     * 
     * @type {EnumerationsSystemAlertLabelType}
     * @memberof CommandsCreateAlertRequest
     */
    'serviceLinesLabelTypeID': EnumerationsSystemAlertLabelType;
    /**
     * 
     * @type {Array<SystemAlertsSystemAlertReceivingRoleDTO>}
     * @memberof CommandsCreateAlertRequest
     */
    'roles': Array<SystemAlertsSystemAlertReceivingRoleDTO>;
    /**
     * 
     * @type {EnumerationsSystemAlertLabelType}
     * @memberof CommandsCreateAlertRequest
     */
    'rolesLabelTypeID': EnumerationsSystemAlertLabelType;
    /**
     * 
     * @type {EnumerationsRecurringInterval}
     * @memberof CommandsCreateAlertRequest
     */
    'recurringIntervalID': EnumerationsRecurringInterval;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateAlertRequest
     */
    'requireAcknowledgement': boolean;
}


/**
 * 
 * @export
 * @interface CommandsCreateAlertResponse
 */
export interface CommandsCreateAlertResponse {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAlertResponse
     */
    'systemAlertID'?: string | null;
}
/**
 * 
 * @export
 * @interface CommandsCreateAuditCommand
 */
export interface CommandsCreateAuditCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAuditCommand
     */
    'location': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAuditCommand
     */
    'snapshotDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAuditCommand
     */
    'dateContactedByCO'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAuditCommand
     */
    'dateReceivedAuditLetter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAuditCommand
     */
    'dueDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAuditCommand
     */
    'coid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAuditCommand
     */
    'ofccpOffice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAuditCommand
     */
    'primaryContact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAuditCommand
     */
    'secondaryContact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAuditCommand
     */
    'notes'?: string | null;
}
/**
 * 
 * @export
 * @interface CommandsCreateAuditItemNoteCommand
 */
export interface CommandsCreateAuditItemNoteCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAuditItemNoteCommand
     */
    'audit2AuditItemID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAuditItemNoteCommand
     */
    'note': string;
}
/**
 * 
 * @export
 * @interface CommandsCreateGFEDataCommand
 */
export interface CommandsCreateGFEDataCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'location': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'activity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'description': string;
    /**
     * 
     * @type {Array<EnumerationsGFETargetedGroup>}
     * @memberof CommandsCreateGFEDataCommand
     */
    'targetedGroups': Array<EnumerationsGFETargetedGroup>;
    /**
     * 
     * @type {number}
     * @memberof CommandsCreateGFEDataCommand
     */
    'effectiveness'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'evaluation': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'requisitionNo'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommandsCreateGFEDataCommand
     */
    'numberOfCandidates'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommandsCreateGFEDataCommand
     */
    'numberOfHires'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommandsCreateGFEDataCommand
     */
    'hoursSpent'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommandsCreateGFEDataCommand
     */
    'cost'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'customField1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'customField2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'customField3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'customField4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'customField5'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'customField6'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'customField7'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'customField8'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'customField9'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGFEDataCommand
     */
    'customField10'?: string | null;
}
/**
 * 
 * @export
 * @interface CommandsCreateLocationRequest
 */
export interface CommandsCreateLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateLocationRequest
     */
    'projectID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateLocationRequest
     */
    'locationName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateLocationRequest
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface CommandsCreatePreviewIDRequest
 */
export interface CommandsCreatePreviewIDRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreatePreviewIDRequest
     */
    'aapReport2ClientID': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsCreatePreviewIDRequest
     */
    'planIDs': Array<string>;
    /**
     * 
     * @type {EnumerationsDataVisualizationType}
     * @memberof CommandsCreatePreviewIDRequest
     */
    'dataVisualizationTypeID': EnumerationsDataVisualizationType;
}


/**
 * 
 * @export
 * @interface CommandsCreatePreviewIDResponse
 */
export interface CommandsCreatePreviewIDResponse {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreatePreviewIDResponse
     */
    'aapReportPreviewID': string;
}
/**
 * 
 * @export
 * @interface CommandsCreateProjectRequest
 */
export interface CommandsCreateProjectRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProjectRequest
     */
    'clientID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProjectRequest
     */
    'projectName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateProjectRequest
     */
    'isDefault': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateProjectRequest
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProjectRequest
     */
    'oldProjectID'?: string | null;
}
/**
 * 
 * @export
 * @interface CommandsCreateSectionCommand
 */
export interface CommandsCreateSectionCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateSectionCommand
     */
    'serviceID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateSectionCommand
     */
    'pageID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateSectionCommand
     */
    'sectionName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateSectionCommand
     */
    'publishRequest': boolean;
}
/**
 * 
 * @export
 * @interface CommandsCreateServiceDeliverablePageCommand
 */
export interface CommandsCreateServiceDeliverablePageCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateServiceDeliverablePageCommand
     */
    'pageName': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateServiceDeliverablePageCommand
     */
    'serviceID': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateServiceDeliverablePageCommand
     */
    'activate': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateServiceDeliverablePageCommand
     */
    'publishRequest': boolean;
}
/**
 * 
 * @export
 * @interface CommandsEditAlertRequest
 */
export interface CommandsEditAlertRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsEditAlertRequest
     */
    'systemAlertID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsEditAlertRequest
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsEditAlertRequest
     */
    'htmlBody': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsEditAlertRequest
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsEditAlertRequest
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {Array<SystemAlertsSystemAlertReceivingClientDTO>}
     * @memberof CommandsEditAlertRequest
     */
    'clients': Array<SystemAlertsSystemAlertReceivingClientDTO>;
    /**
     * 
     * @type {EnumerationsSystemAlertLabelType}
     * @memberof CommandsEditAlertRequest
     */
    'clientNamesLabelTypeID': EnumerationsSystemAlertLabelType;
    /**
     * 
     * @type {Array<SystemAlertsSystemAlertReceivingServiceDTO>}
     * @memberof CommandsEditAlertRequest
     */
    'serviceLines': Array<SystemAlertsSystemAlertReceivingServiceDTO>;
    /**
     * 
     * @type {EnumerationsSystemAlertLabelType}
     * @memberof CommandsEditAlertRequest
     */
    'serviceLinesLabelTypeID': EnumerationsSystemAlertLabelType;
    /**
     * 
     * @type {Array<SystemAlertsSystemAlertReceivingRoleDTO>}
     * @memberof CommandsEditAlertRequest
     */
    'roles': Array<SystemAlertsSystemAlertReceivingRoleDTO>;
    /**
     * 
     * @type {EnumerationsSystemAlertLabelType}
     * @memberof CommandsEditAlertRequest
     */
    'rolesLabelTypeID': EnumerationsSystemAlertLabelType;
    /**
     * 
     * @type {EnumerationsRecurringInterval}
     * @memberof CommandsEditAlertRequest
     */
    'recurringIntervalID': EnumerationsRecurringInterval;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsEditAlertRequest
     */
    'requireAcknowledgement': boolean;
}


/**
 * 
 * @export
 * @interface CommandsExportSettingsCommand
 */
export interface CommandsExportSettingsCommand {
    /**
     * 
     * @type {EnumerationsExportFormat}
     * @memberof CommandsExportSettingsCommand
     */
    'exportFormatID': EnumerationsExportFormat;
    /**
     * 
     * @type {EnumerationsExportType}
     * @memberof CommandsExportSettingsCommand
     */
    'exportTypeID': EnumerationsExportType;
}


/**
 * 
 * @export
 * @interface CommandsGenerateAssessmentRequest
 */
export interface CommandsGenerateAssessmentRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsGenerateAssessmentRequest
     */
    'planID': string;
    /**
     * 
     * @type {number}
     * @memberof CommandsGenerateAssessmentRequest
     */
    'targetedGroup': number;
    /**
     * 
     * @type {number}
     * @memberof CommandsGenerateAssessmentRequest
     */
    'evaluationBy': number;
    /**
     * 
     * @type {number}
     * @memberof CommandsGenerateAssessmentRequest
     */
    'fileType': number;
}
/**
 * 
 * @export
 * @interface CommandsGeneratePreviewResponse
 */
export interface CommandsGeneratePreviewResponse {
    /**
     * 
     * @type {string}
     * @memberof CommandsGeneratePreviewResponse
     */
    'reportName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsGeneratePreviewResponse
     */
    'previewExists': boolean;
}
/**
 * 
 * @export
 * @interface CommandsImportGoodFaithEffortsResponse
 */
export interface CommandsImportGoodFaithEffortsResponse {
    /**
     * 
     * @type {TransferObjectsResponseDTO}
     * @memberof CommandsImportGoodFaithEffortsResponse
     */
    'response': TransferObjectsResponseDTO;
    /**
     * 
     * @type {number}
     * @memberof CommandsImportGoodFaithEffortsResponse
     */
    'numberOfImportedRecords': number;
    /**
     * 
     * @type {File}
     * @memberof CommandsImportGoodFaithEffortsResponse
     */
    'errorFile'?: File | null;
}
/**
 * 
 * @export
 * @interface CommandsInitiateExternalFileUploadRequest
 */
export interface CommandsInitiateExternalFileUploadRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsInitiateExternalFileUploadRequest
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsInitiateExternalFileUploadRequest
     */
    'senderName': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsInitiateExternalFileUploadRequest
     */
    'senderCompany': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsInitiateExternalFileUploadRequest
     */
    'senderEmailAddress': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsInitiateExternalFileUploadRequest
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsInitiateExternalFileUploadRequest
     */
    'projectID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsInitiateExternalFileUploadRequest
     */
    'locationID'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsInitiateExternalFileUploadRequest
     */
    'recipientUserIDs': Array<string>;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CommandsInitiateExternalFileUploadRequest
     */
    'fileNamesAndSizes': { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface CommandsInitiateInternalFileUploadRequest
 */
export interface CommandsInitiateInternalFileUploadRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsInitiateInternalFileUploadRequest
     */
    'clientName': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsInitiateInternalFileUploadRequest
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsInitiateInternalFileUploadRequest
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsInitiateInternalFileUploadRequest
     */
    'projectID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsInitiateInternalFileUploadRequest
     */
    'locationID'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsInitiateInternalFileUploadRequest
     */
    'recipientUserIDs': Array<string>;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CommandsInitiateInternalFileUploadRequest
     */
    'fileNamesAndSizes': { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface CommandsReorderCommand
 */
export interface CommandsReorderCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsReorderCommand
     */
    'pageID': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsReorderCommand
     */
    'sectionIDs': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsReorderCommand
     */
    'fileIDs': Array<string>;
}
/**
 * 
 * @export
 * @interface CommandsReportGroupToSave
 */
export interface CommandsReportGroupToSave {
    /**
     * 
     * @type {string}
     * @memberof CommandsReportGroupToSave
     */
    'groupName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsReportGroupToSave
     */
    'aapReport2ClientIDs': Array<string>;
}
/**
 * 
 * @export
 * @interface CommandsSaveGFEAssessmentCommand
 */
export interface CommandsSaveGFEAssessmentCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsSaveGFEAssessmentCommand
     */
    'planID': string;
    /**
     * 
     * @type {EnumerationsGFETargetedGroup}
     * @memberof CommandsSaveGFEAssessmentCommand
     */
    'targetedGroup': EnumerationsGFETargetedGroup;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsSaveGFEAssessmentCommand
     */
    'customCriteria': Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CommandsSaveGFEAssessmentCommand
     */
    'selectedCriteria': Array<number>;
    /**
     * 
     * @type {string}
     * @memberof CommandsSaveGFEAssessmentCommand
     */
    'evaluationDetail': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsSaveGFEAssessmentCommand
     */
    'actionPlan': string;
}


/**
 * 
 * @export
 * @interface CommandsSavePageOrderAndActiveStatusCommand
 */
export interface CommandsSavePageOrderAndActiveStatusCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsSavePageOrderAndActiveStatusCommand
     */
    'serviceID': string;
    /**
     * 
     * @type {Array<CommandsServiceDeliverableForRearrange>}
     * @memberof CommandsSavePageOrderAndActiveStatusCommand
     */
    'deliverablePages': Array<CommandsServiceDeliverableForRearrange>;
}
/**
 * 
 * @export
 * @interface CommandsSaveReportGroupsCommand
 */
export interface CommandsSaveReportGroupsCommand {
    /**
     * 
     * @type {Array<CommandsReportGroupToSave>}
     * @memberof CommandsSaveReportGroupsCommand
     */
    'reportGroups': Array<CommandsReportGroupToSave>;
}
/**
 * 
 * @export
 * @interface CommandsSelectAllAssignDocumentsToUserCommand
 */
export interface CommandsSelectAllAssignDocumentsToUserCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsSelectAllAssignDocumentsToUserCommand
     */
    'userIDs': Array<string>;
    /**
     * 
     * @type {EnumerationsDocumentCenterTab}
     * @memberof CommandsSelectAllAssignDocumentsToUserCommand
     */
    'tab': EnumerationsDocumentCenterTab;
    /**
     * 
     * @type {EnumerationsDocumentCenterView}
     * @memberof CommandsSelectAllAssignDocumentsToUserCommand
     */
    'view': EnumerationsDocumentCenterView;
    /**
     * 
     * @type {string}
     * @memberof CommandsSelectAllAssignDocumentsToUserCommand
     */
    'searchTerm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsSelectAllAssignDocumentsToUserCommand
     */
    'uploadID'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsSelectAllAssignDocumentsToUserCommand
     */
    'excludedDocumentUploadIDs': Array<string>;
}


/**
 * 
 * @export
 * @interface CommandsSelectAllUpdateReadStatusRequest
 */
export interface CommandsSelectAllUpdateReadStatusRequest {
    /**
     * 
     * @type {EnumerationsDocumentCenterTab}
     * @memberof CommandsSelectAllUpdateReadStatusRequest
     */
    'tab': EnumerationsDocumentCenterTab;
    /**
     * 
     * @type {EnumerationsDocumentCenterView}
     * @memberof CommandsSelectAllUpdateReadStatusRequest
     */
    'view': EnumerationsDocumentCenterView;
    /**
     * 
     * @type {EnumerationsDocumentCenterSortColumn}
     * @memberof CommandsSelectAllUpdateReadStatusRequest
     */
    'sortColumn': EnumerationsDocumentCenterSortColumn;
    /**
     * 
     * @type {EnumerationsSortDirection}
     * @memberof CommandsSelectAllUpdateReadStatusRequest
     */
    'sortDirection': EnumerationsSortDirection;
    /**
     * 
     * @type {string}
     * @memberof CommandsSelectAllUpdateReadStatusRequest
     */
    'searchTerm'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsSelectAllUpdateReadStatusRequest
     */
    'uploadID'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsSelectAllUpdateReadStatusRequest
     */
    'excludedDocumentUploadIDs': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsSelectAllUpdateReadStatusRequest
     */
    'newStatus': boolean;
}


/**
 * 
 * @export
 * @interface CommandsServiceDeliverableForRearrange
 */
export interface CommandsServiceDeliverableForRearrange {
    /**
     * 
     * @type {string}
     * @memberof CommandsServiceDeliverableForRearrange
     */
    'pageID': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsServiceDeliverableForRearrange
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface CommandsToggleAlertStatusRequest
 */
export interface CommandsToggleAlertStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsToggleAlertStatusRequest
     */
    'systemAlertID': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsToggleAlertStatusRequest
     */
    'isInactive': boolean;
}
/**
 * 
 * @export
 * @interface CommandsUnzipAndSaveFilesCommand
 */
export interface CommandsUnzipAndSaveFilesCommand {
    /**
     * 
     * @type {number}
     * @memberof CommandsUnzipAndSaveFilesCommand
     */
    'errorCount': number;
    /**
     * 
     * @type {number}
     * @memberof CommandsUnzipAndSaveFilesCommand
     */
    'fileCount': number;
    /**
     * 
     * @type {Array<TransferObjectsSectionZipResponse>}
     * @memberof CommandsUnzipAndSaveFilesCommand
     */
    'sections': Array<TransferObjectsSectionZipResponse>;
    /**
     * 
     * @type {string}
     * @memberof CommandsUnzipAndSaveFilesCommand
     */
    'zipName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUnzipAndSaveFilesCommand
     */
    'hasNestedFolders': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsUnzipAndSaveFilesCommand
     */
    'batchID': string;
    /**
     * 
     * @type {ModelsServiceDeliverablePage}
     * @memberof CommandsUnzipAndSaveFilesCommand
     */
    'page': ModelsServiceDeliverablePage;
}
/**
 * 
 * @export
 * @interface CommandsUpdateActionOrientedProgramGoalsRequest
 */
export interface CommandsUpdateActionOrientedProgramGoalsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsUpdateActionOrientedProgramGoalsRequest
     */
    'actionOrientedProgramGoalsIDs': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateActionOrientedProgramGoalsRequest
     */
    'analysis': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateActionOrientedProgramGoalsRequest
     */
    'actionOrientedProgram': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateActionOrientedProgramGoalsRequest
     */
    'personResponsible': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateActionOrientedProgramGoalsRequest
     */
    'targetCompletionDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateActionOrientedProgramGoalsRequest
     */
    'notes': string;
}
/**
 * 
 * @export
 * @interface CommandsUpdateAuditCommand
 */
export interface CommandsUpdateAuditCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAuditCommand
     */
    'auditID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAuditCommand
     */
    'location': string;
    /**
     * 
     * @type {EnumerationsAuditStatus}
     * @memberof CommandsUpdateAuditCommand
     */
    'statusID': EnumerationsAuditStatus;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAuditCommand
     */
    'snapshotDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAuditCommand
     */
    'dateContactedByCO'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAuditCommand
     */
    'dateReceivedAuditLetter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAuditCommand
     */
    'dueDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAuditCommand
     */
    'coid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAuditCommand
     */
    'ofccpOffice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAuditCommand
     */
    'primaryContact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAuditCommand
     */
    'secondaryContact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAuditCommand
     */
    'notes'?: string | null;
}


/**
 * 
 * @export
 * @interface CommandsUpdateAuditItemCommand
 */
export interface CommandsUpdateAuditItemCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAuditItemCommand
     */
    'audit2AuditItemID': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateAuditItemCommand
     */
    'isCompleted': boolean;
}
/**
 * 
 * @export
 * @interface CommandsUpdateAuditItemNoteCommand
 */
export interface CommandsUpdateAuditItemNoteCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAuditItemNoteCommand
     */
    'noteID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAuditItemNoteCommand
     */
    'note': string;
}
/**
 * 
 * @export
 * @interface CommandsUpdateChecklistCommand
 */
export interface CommandsUpdateChecklistCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateChecklistCommand
     */
    'complianceChecklist2ComplianceChecklistItemID': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateChecklistCommand
     */
    'isNA': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateChecklistCommand
     */
    'isCompleted': boolean;
}
/**
 * 
 * @export
 * @interface CommandsUpdateGFEDataCommand
 */
export interface CommandsUpdateGFEDataCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'gfeid': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'location': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'activity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'description': string;
    /**
     * 
     * @type {Array<EnumerationsGFETargetedGroup>}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'targetedGroups': Array<EnumerationsGFETargetedGroup>;
    /**
     * 
     * @type {number}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'effectiveness'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'evaluation': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'requisitionNo'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'numberOfCandidates'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'numberOfHires'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'hoursSpent'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'cost'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'customField1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'customField2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'customField3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'customField4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'customField5'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'customField6'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'customField7'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'customField8'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'customField9'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGFEDataCommand
     */
    'customField10'?: string | null;
}
/**
 * 
 * @export
 * @interface CommandsUpdateGlobalReportSettingsCommand
 */
export interface CommandsUpdateGlobalReportSettingsCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGlobalReportSettingsCommand
     */
    'planID': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateGlobalReportSettingsCommand
     */
    'suppressStatisticalSignificanceFootnotes': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateGlobalReportSettingsCommand
     */
    'includeDateFooter': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateGlobalReportSettingsCommand
     */
    'customFooter': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateGlobalReportSettingsCommand
     */
    'cascadeToSubPlans': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateGlobalReportSettingsCommand
     */
    'includePageNumbers': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateGlobalReportSettingsCommand
     */
    'includeBookmarks': boolean;
}
/**
 * 
 * @export
 * @interface CommandsUpdateLocationRequest
 */
export interface CommandsUpdateLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateLocationRequest
     */
    'locationID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateLocationRequest
     */
    'locationName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateLocationRequest
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface CommandsUpdateOverviewReportExportSettingsCommand
 */
export interface CommandsUpdateOverviewReportExportSettingsCommand {
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateOverviewReportExportSettingsCommand
     */
    'includeOverview': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateOverviewReportExportSettingsCommand
     */
    'includeUtilizationSummary': boolean;
    /**
     * 
     * @type {EnumerationsUtilizationSummaryResultsDisplayed}
     * @memberof CommandsUpdateOverviewReportExportSettingsCommand
     */
    'utilizationSummaryResultsDisplayed': EnumerationsUtilizationSummaryResultsDisplayed;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateOverviewReportExportSettingsCommand
     */
    'includeAdverseImpactSummary': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateOverviewReportExportSettingsCommand
     */
    'adverseImpactIncludeTotalMinoritiesAndNonMinorities': boolean;
    /**
     * 
     * @type {EnumerationsAdverseImpactSummaryRunReportBy}
     * @memberof CommandsUpdateOverviewReportExportSettingsCommand
     */
    'adverseImpactSummaryRunReportBy': EnumerationsAdverseImpactSummaryRunReportBy;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateOverviewReportExportSettingsCommand
     */
    'includeGoalAttainmentSummary': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateOverviewReportExportSettingsCommand
     */
    'includeIWDSummary': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateOverviewReportExportSettingsCommand
     */
    'includeProtectedVeteransSummary': boolean;
    /**
     * 
     * @type {Array<OverviewSelectedActionTypesDTO>}
     * @memberof CommandsUpdateOverviewReportExportSettingsCommand
     */
    'adverseImpactIncludedActionTypes': Array<OverviewSelectedActionTypesDTO>;
    /**
     * 
     * @type {EnumerationsRunByForProtectedClasses}
     * @memberof CommandsUpdateOverviewReportExportSettingsCommand
     */
    'runByForByProtectedClassesID': EnumerationsRunByForProtectedClasses;
}


/**
 * 
 * @export
 * @interface CommandsUpdateOverviewSettingsCommand
 */
export interface CommandsUpdateOverviewSettingsCommand {
    /**
     * 
     * @type {EnumerationsNumericDisplayOption}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'employmentDisplay': EnumerationsNumericDisplayOption;
    /**
     * 
     * @type {EnumerationsNumericDisplayOption}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'goalsDisplay': EnumerationsNumericDisplayOption;
    /**
     * 
     * @type {EnumerationsNumericDisplayOption}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'personnelActivityDisplay': EnumerationsNumericDisplayOption;
    /**
     * 
     * @type {EnumerationsPersonnelActivityResultsDisplayed}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'personnelActivityResults': EnumerationsPersonnelActivityResultsDisplayed;
    /**
     * 
     * @type {EnumerationsAdverseImpactDisplayOption}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'adverseImpactDisplay': EnumerationsAdverseImpactDisplayOption;
    /**
     * 
     * @type {EnumerationsNumericDisplayOption}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'applicantFlowDisplay': EnumerationsNumericDisplayOption;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'applicantFlowResultsIncludeTotalApplicants': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'applicantFlowResultsIncludeTotalSelections': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'applicantFlowResultsIncludeHiringAnalysis': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'applicantFlowResultsIncludeCompetitivePromotions': boolean;
    /**
     * 
     * @type {EnumerationsNumericDisplayOption}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'goalAttainmentDisplay': EnumerationsNumericDisplayOption;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'goalAttainmentResultsIncludeAchieved': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'goalAttainmentResultsIncludeNotAchieved': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'goalAttainmentResultsIncludeLimited': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'goalAttainmentResultsIncludeNoOpps': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'adverseImpactTotalMinoritiesAndNonMinorities': boolean;
    /**
     * 
     * @type {Array<OverviewOverviewSectionSettingsDTO>}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'overviewSectionSettings': Array<OverviewOverviewSectionSettingsDTO>;
    /**
     * 
     * @type {Array<OverviewSelectedActionTypesDTO>}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'adverseImpactIncludedActionTypes': Array<OverviewSelectedActionTypesDTO>;
    /**
     * 
     * @type {Array<OverviewSelectedActionTypesDTO>}
     * @memberof CommandsUpdateOverviewSettingsCommand
     */
    'personnelActivityIncludedActionTypes': Array<OverviewSelectedActionTypesDTO>;
}


/**
 * 
 * @export
 * @interface CommandsUpdatePlanActionOrientedProgramLastAccessedDateRequest
 */
export interface CommandsUpdatePlanActionOrientedProgramLastAccessedDateRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdatePlanActionOrientedProgramLastAccessedDateRequest
     */
    'planID': string;
}
/**
 * 
 * @export
 * @interface CommandsUpdatePlanDateCommand
 */
export interface CommandsUpdatePlanDateCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdatePlanDateCommand
     */
    'planDate': string;
}
/**
 * 
 * @export
 * @interface CommandsUpdatePlanGFEAssessmentLastAccessedDateRequest
 */
export interface CommandsUpdatePlanGFEAssessmentLastAccessedDateRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdatePlanGFEAssessmentLastAccessedDateRequest
     */
    'planID': string;
}
/**
 * 
 * @export
 * @interface CommandsUpdatePlanReportLastAccessedDateCommand
 */
export interface CommandsUpdatePlanReportLastAccessedDateCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdatePlanReportLastAccessedDateCommand
     */
    'planID': string;
}
/**
 * 
 * @export
 * @interface CommandsUpdatePlanSummaryReportSettingsCommand
 */
export interface CommandsUpdatePlanSummaryReportSettingsCommand {
    /**
     * 
     * @type {EnumerationsRunByForProtectedClasses}
     * @memberof CommandsUpdatePlanSummaryReportSettingsCommand
     */
    'runByForProtectedClasses': EnumerationsRunByForProtectedClasses;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdatePlanSummaryReportSettingsCommand
     */
    'includeIWDAnalysis': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdatePlanSummaryReportSettingsCommand
     */
    'includeProtectedVetAnalysis': boolean;
    /**
     * 
     * @type {EnumerationsPlanSummaryIncvsEstShowFor}
     * @memberof CommandsUpdatePlanSummaryReportSettingsCommand
     */
    'incvsEstShowFor': EnumerationsPlanSummaryIncvsEstShowFor;
    /**
     * 
     * @type {EnumerationsPlanSummaryAIShowFor}
     * @memberof CommandsUpdatePlanSummaryReportSettingsCommand
     */
    'aiShowFor': EnumerationsPlanSummaryAIShowFor;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdatePlanSummaryReportSettingsCommand
     */
    'hideRecruitmentAreasSection': boolean;
    /**
     * 
     * @type {Array<OverviewSelectedActionTypesDTO>}
     * @memberof CommandsUpdatePlanSummaryReportSettingsCommand
     */
    'actionTypes': Array<OverviewSelectedActionTypesDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdatePlanSummaryReportSettingsCommand
     */
    'adverseImpactIncludeTotalMinoritiesAndNonMinorities': boolean;
}


/**
 * 
 * @export
 * @interface CommandsUpdateProjectRequest
 */
export interface CommandsUpdateProjectRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateProjectRequest
     */
    'clientID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateProjectRequest
     */
    'projectID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateProjectRequest
     */
    'projectName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateProjectRequest
     */
    'isDefault': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateProjectRequest
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface CommandsUpdateReadStatusRequest
 */
export interface CommandsUpdateReadStatusRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsUpdateReadStatusRequest
     */
    'documentUploadIDs': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateReadStatusRequest
     */
    'newStatus': boolean;
}
/**
 * 
 * @export
 * @interface CommandsUpdateReportSettingsCommand
 */
export interface CommandsUpdateReportSettingsCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateReportSettingsCommand
     */
    'planID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateReportSettingsCommand
     */
    'aapReport2ClientID': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateReportSettingsCommand
     */
    'cascadeToSubPlans': boolean;
    /**
     * 
     * @type {ModelsAvailabilityReportSettings}
     * @memberof CommandsUpdateReportSettingsCommand
     */
    'availabilityReportSettings': ModelsAvailabilityReportSettings;
    /**
     * 
     * @type {ModelsJobGroupAnalysisReportSettings}
     * @memberof CommandsUpdateReportSettingsCommand
     */
    'jobGroupAnalysisReportSettings': ModelsJobGroupAnalysisReportSettings;
    /**
     * 
     * @type {ModelsDataCollectionReportSettings}
     * @memberof CommandsUpdateReportSettingsCommand
     */
    'dataCollectionReportSettings': ModelsDataCollectionReportSettings;
    /**
     * 
     * @type {ModelsApplicantSummaryReportSettings}
     * @memberof CommandsUpdateReportSettingsCommand
     */
    'applicantSummaryReportSettings': ModelsApplicantSummaryReportSettings;
    /**
     * 
     * @type {ModelsWorkforceAnalysisReportSettings}
     * @memberof CommandsUpdateReportSettingsCommand
     */
    'workforceAnalysisReportSettings': ModelsWorkforceAnalysisReportSettings;
    /**
     * 
     * @type {ModelsAdverseImpactReportSettings}
     * @memberof CommandsUpdateReportSettingsCommand
     */
    'adverseImpactReportSettings': ModelsAdverseImpactReportSettings;
    /**
     * 
     * @type {ModelsCompensationSummaryReportSettings}
     * @memberof CommandsUpdateReportSettingsCommand
     */
    'compensationSummaryReportSettings': ModelsCompensationSummaryReportSettings;
    /**
     * 
     * @type {Array<TransferObjectsAdverseImpactJobGroupDTO>}
     * @memberof CommandsUpdateReportSettingsCommand
     */
    'adverseImpactJobGroups'?: Array<TransferObjectsAdverseImpactJobGroupDTO> | null;
}
/**
 * 
 * @export
 * @interface CommandsUpdateServiceDeliverablePageCommand
 */
export interface CommandsUpdateServiceDeliverablePageCommand {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateServiceDeliverablePageCommand
     */
    'pageName': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateServiceDeliverablePageCommand
     */
    'pageID': string;
}
/**
 * 
 * @export
 * @interface CommandsUploadAuditAttachmentCommand
 */
export interface CommandsUploadAuditAttachmentCommand {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CommandsUploadAuditAttachmentCommand
     */
    'fileNamesAndSizes': { [key: string]: number; };
    /**
     * 
     * @type {string}
     * @memberof CommandsUploadAuditAttachmentCommand
     */
    'audit2AuditItemID': string;
}
/**
 * 
 * @export
 * @interface CommandsUploadFilesCommand
 */
export interface CommandsUploadFilesCommand {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof CommandsUploadFilesCommand
     */
    'fileNamesAndSizes': { [key: string]: number; };
    /**
     * 
     * @type {string}
     * @memberof CommandsUploadFilesCommand
     */
    'sectionID': string;
}
/**
 * 
 * @export
 * @interface CommonAssignDocumentsToUserCommand
 */
export interface CommonAssignDocumentsToUserCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof CommonAssignDocumentsToUserCommand
     */
    'documentUploads': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommonAssignDocumentsToUserCommand
     */
    'userIDs': Array<string>;
}
/**
 * 
 * @export
 * @interface CommonDataVizJobGroup
 */
export interface CommonDataVizJobGroup {
    /**
     * 
     * @type {string}
     * @memberof CommonDataVizJobGroup
     */
    'jobGroup': string;
    /**
     * 
     * @type {string}
     * @memberof CommonDataVizJobGroup
     */
    'jobGroupDescription': string;
}
/**
 * 
 * @export
 * @interface CommonGetJobGroupsForPlansResponse
 */
export interface CommonGetJobGroupsForPlansResponse {
    /**
     * 
     * @type {Array<CommonDataVizJobGroup>}
     * @memberof CommonGetJobGroupsForPlansResponse
     */
    'jobGroupList': Array<CommonDataVizJobGroup>;
}
/**
 * 
 * @export
 * @interface DataExportDataExportTables
 */
export interface DataExportDataExportTables {
    /**
     * 
     * @type {string}
     * @memberof DataExportDataExportTables
     */
    'tableCode': string;
    /**
     * 
     * @type {number}
     * @memberof DataExportDataExportTables
     */
    'exportStepTypeID': number;
    /**
     * 
     * @type {string}
     * @memberof DataExportDataExportTables
     */
    'displayName': string;
    /**
     * 
     * @type {number}
     * @memberof DataExportDataExportTables
     */
    'actionTypeID': number;
    /**
     * 
     * @type {string}
     * @memberof DataExportDataExportTables
     */
    'tableTypeName': string;
    /**
     * 
     * @type {number}
     * @memberof DataExportDataExportTables
     */
    'sortOrder': number;
}
/**
 * 
 * @export
 * @interface DataVizActionTypeDropdownItem
 */
export interface DataVizActionTypeDropdownItem {
    /**
     * 
     * @type {string}
     * @memberof DataVizActionTypeDropdownItem
     */
    'actionTypeName': string;
    /**
     * 
     * @type {boolean}
     * @memberof DataVizActionTypeDropdownItem
     */
    'positive'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DataVizActionTypeDropdownItem
     */
    'disableCalculateByDropdown': boolean;
}
/**
 * 
 * @export
 * @interface DataVizActionTypeSelection
 */
export interface DataVizActionTypeSelection {
    /**
     * 
     * @type {string}
     * @memberof DataVizActionTypeSelection
     */
    'actionTypeName': string;
    /**
     * 
     * @type {boolean}
     * @memberof DataVizActionTypeSelection
     */
    'isSelectedForDropdown': boolean;
}
/**
 * 
 * @export
 * @interface DataVizCountPercentByEntity
 */
export interface DataVizCountPercentByEntity {
    /**
     * 
     * @type {string}
     * @memberof DataVizCountPercentByEntity
     */
    'description': string;
    /**
     * 
     * @type {Array<DataVizCountPercentDTO>}
     * @memberof DataVizCountPercentByEntity
     */
    'countPercents': Array<DataVizCountPercentDTO>;
}
/**
 * 
 * @export
 * @interface DataVizCountPercentDTO
 */
export interface DataVizCountPercentDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizCountPercentDTO
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof DataVizCountPercentDTO
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizCountPercentDTO
     */
    'percent': number;
    /**
     * 
     * @type {EnumerationsDataVisualizationResultsBy}
     * @memberof DataVizCountPercentDTO
     */
    'resultsByToDisplayFor': EnumerationsDataVisualizationResultsBy;
}


/**
 * 
 * @export
 * @interface DataVizDemographicCountByCalcTypeDTO
 */
export interface DataVizDemographicCountByCalcTypeDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizDemographicCountByCalcTypeDTO
     */
    'demographic': string;
    /**
     * 
     * @type {number}
     * @memberof DataVizDemographicCountByCalcTypeDTO
     */
    'count'?: number | null;
    /**
     * 
     * @type {EnumerationsCalcType}
     * @memberof DataVizDemographicCountByCalcTypeDTO
     */
    'calcType': EnumerationsCalcType;
}


/**
 * 
 * @export
 * @interface DataVizDemographicCountByJobGroup
 */
export interface DataVizDemographicCountByJobGroup {
    /**
     * 
     * @type {string}
     * @memberof DataVizDemographicCountByJobGroup
     */
    'jobGroup': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizDemographicCountByJobGroup
     */
    'jobGroupName': string;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof DataVizDemographicCountByJobGroup
     */
    'counts': Array<DataVizDemographicCountDTO>;
}
/**
 * 
 * @export
 * @interface DataVizDemographicCountByJobTitle
 */
export interface DataVizDemographicCountByJobTitle {
    /**
     * 
     * @type {string}
     * @memberof DataVizDemographicCountByJobTitle
     */
    'jobCode': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizDemographicCountByJobTitle
     */
    'jobTitle': string;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof DataVizDemographicCountByJobTitle
     */
    'counts': Array<DataVizDemographicCountDTO>;
}
/**
 * 
 * @export
 * @interface DataVizDemographicCountDTO
 */
export interface DataVizDemographicCountDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizDemographicCountDTO
     */
    'demographic': string;
    /**
     * 
     * @type {number}
     * @memberof DataVizDemographicCountDTO
     */
    'count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataVizDemographicCountDTO
     */
    'percent'?: number | null;
    /**
     * 
     * @type {EnumerationsDataVisualizationResultsBy}
     * @memberof DataVizDemographicCountDTO
     */
    'resultsByToDisplayFor': EnumerationsDataVisualizationResultsBy;
}


/**
 * 
 * @export
 * @interface DataVizDemographicInfoByPlanDTO
 */
export interface DataVizDemographicInfoByPlanDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizDemographicInfoByPlanDTO
     */
    'planID': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizDemographicInfoByPlanDTO
     */
    'planIdentifier': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizDemographicInfoByPlanDTO
     */
    'planName': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizDemographicInfoByPlanDTO
     */
    'establishment': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizDemographicInfoByPlanDTO
     */
    'planDate': string;
    /**
     * 
     * @type {Array<DataVizCountPercentDTO>}
     * @memberof DataVizDemographicInfoByPlanDTO
     */
    'races': Array<DataVizCountPercentDTO>;
    /**
     * 
     * @type {Array<DataVizCountPercentDTO>}
     * @memberof DataVizDemographicInfoByPlanDTO
     */
    'genders': Array<DataVizCountPercentDTO>;
}
/**
 * 
 * @export
 * @interface DataVizDemographicPercentDTO
 */
export interface DataVizDemographicPercentDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizDemographicPercentDTO
     */
    'demographic': string;
    /**
     * 
     * @type {number}
     * @memberof DataVizDemographicPercentDTO
     */
    'percent': number;
    /**
     * 
     * @type {EnumerationsDataVisualizationResultsBy}
     * @memberof DataVizDemographicPercentDTO
     */
    'resultsByToDisplayFor': EnumerationsDataVisualizationResultsBy;
}


/**
 * 
 * @export
 * @interface DataVizDrilldownTileDTO
 */
export interface DataVizDrilldownTileDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizDrilldownTileDTO
     */
    'topLabel': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizDrilldownTileDTO
     */
    'data': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizDrilldownTileDTO
     */
    'bottomLabel': string;
}
/**
 * 
 * @export
 * @interface DataVizGetAllActionTypesResponse
 */
export interface DataVizGetAllActionTypesResponse {
    /**
     * 
     * @type {Array<DataVizActionTypeSelection>}
     * @memberof DataVizGetAllActionTypesResponse
     */
    'positiveActionTypes': Array<DataVizActionTypeSelection>;
    /**
     * 
     * @type {Array<DataVizActionTypeSelection>}
     * @memberof DataVizGetAllActionTypesResponse
     */
    'negativeActionTypes': Array<DataVizActionTypeSelection>;
}
/**
 * 
 * @export
 * @interface DataVizGoalCountTile
 */
export interface DataVizGoalCountTile {
    /**
     * 
     * @type {number}
     * @memberof DataVizGoalCountTile
     */
    'count': number;
    /**
     * 
     * @type {boolean}
     * @memberof DataVizGoalCountTile
     */
    'goalDirection': boolean;
}
/**
 * 
 * @export
 * @interface DataVizNullableCountPercentByEntity
 */
export interface DataVizNullableCountPercentByEntity {
    /**
     * 
     * @type {string}
     * @memberof DataVizNullableCountPercentByEntity
     */
    'description': string;
    /**
     * 
     * @type {Array<DataVizNullableCountPercentDTO>}
     * @memberof DataVizNullableCountPercentByEntity
     */
    'countPercents': Array<DataVizNullableCountPercentDTO>;
}
/**
 * 
 * @export
 * @interface DataVizNullableCountPercentDTO
 */
export interface DataVizNullableCountPercentDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizNullableCountPercentDTO
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof DataVizNullableCountPercentDTO
     */
    'count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DataVizNullableCountPercentDTO
     */
    'percent'?: number | null;
}
/**
 * 
 * @export
 * @interface DataVizRaceDataForJobGroup
 */
export interface DataVizRaceDataForJobGroup {
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof DataVizRaceDataForJobGroup
     */
    'demographicCounts': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {string}
     * @memberof DataVizRaceDataForJobGroup
     */
    'jobGroup': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizRaceDataForJobGroup
     */
    'jobGroupName': string;
}
/**
 * 
 * @export
 * @interface DataVizRaceDataForJobTitle
 */
export interface DataVizRaceDataForJobTitle {
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof DataVizRaceDataForJobTitle
     */
    'demographicCounts': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {string}
     * @memberof DataVizRaceDataForJobTitle
     */
    'jobCode': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizRaceDataForJobTitle
     */
    'jobTitle': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsAAPReportCategory = {
    AdverseImpact: 1,
    Availability: 2,
    Compensation: 3,
    Employment: 4,
    Monitoring: 5,
    PersonnelActions: 6,
    Workforce: 7,
    Narratives: 8,
    Communication: 9,
    IWDVeteran: 10
} as const;

export type EnumerationsAAPReportCategory = typeof EnumerationsAAPReportCategory[keyof typeof EnumerationsAAPReportCategory];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsAAPReportClassification = {
    Primary: 1,
    Support: 2
} as const;

export type EnumerationsAAPReportClassification = typeof EnumerationsAAPReportClassification[keyof typeof EnumerationsAAPReportClassification];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsAAPReportSettingsCategory = {
    PlanSummary: 1,
    Availability: 2,
    JobGroupAnalysis: 3,
    DataCollection: 4,
    ApplicantSummary: 5,
    WorkforceAnalysis: 6,
    AdverseImpact: 7,
    Compensation: 8
} as const;

export type EnumerationsAAPReportSettingsCategory = typeof EnumerationsAAPReportSettingsCategory[keyof typeof EnumerationsAAPReportSettingsCategory];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsAAPSummary = {
    PlanSummary: 1,
    OverviewSummary: 2
} as const;

export type EnumerationsAAPSummary = typeof EnumerationsAAPSummary[keyof typeof EnumerationsAAPSummary];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsAdverseImpactDisplayOption = {
    ByRaceGender: 1,
    ByFavoredGroup: 2
} as const;

export type EnumerationsAdverseImpactDisplayOption = typeof EnumerationsAdverseImpactDisplayOption[keyof typeof EnumerationsAdverseImpactDisplayOption];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsAdverseImpactFilterBy = {
    AdverseIRA: 1,
    SignificantAI: 2,
    FavoredGroup: 3
} as const;

export type EnumerationsAdverseImpactFilterBy = typeof EnumerationsAdverseImpactFilterBy[keyof typeof EnumerationsAdverseImpactFilterBy];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsAdverseImpactSummaryRunReportBy = {
    AllGroups: 1,
    GroupsWithAdverseIRA: 2,
    GroupsWithStatisticallySignificantAdverseImpact: 3
} as const;

export type EnumerationsAdverseImpactSummaryRunReportBy = typeof EnumerationsAdverseImpactSummaryRunReportBy[keyof typeof EnumerationsAdverseImpactSummaryRunReportBy];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsApplicantFlowCalcType = {
    All: 1,
    Selections: 2,
    Exclusions: 3
} as const;

export type EnumerationsApplicantFlowCalcType = typeof EnumerationsApplicantFlowCalcType[keyof typeof EnumerationsApplicantFlowCalcType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsAuditResponsibility = {
    Client: 1,
    Consultant: 2,
    Shared: 3
} as const;

export type EnumerationsAuditResponsibility = typeof EnumerationsAuditResponsibility[keyof typeof EnumerationsAuditResponsibility];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsAuditStatus = {
    Active: 1,
    Expected: 2,
    Overdue: 3,
    Closed: 4
} as const;

export type EnumerationsAuditStatus = typeof EnumerationsAuditStatus[keyof typeof EnumerationsAuditStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsCalcType = {
    OneJobPos: 1,
    OneJobNeg: 2,
    InvoluntaryTerms: 3,
    TwoJobFrom: 4,
    TwoJobTo: 5,
    TwoJobToChanging: 6,
    ActionCode: 7,
    OneJobNegPool: 8,
    InvoluntaryTermsPool: 9,
    TwoJobFromPool: 10,
    TwoJobToPool: 11,
    TwoJobToChangingPool: 12,
    VoluntaryTerms: 13,
    VoluntaryTermsPool: 14,
    OneJobPositivePool: 15,
    PoolID: 16,
    TwoJobToChangingPlan: 17,
    TwoJobToChangingPlanPool: 18,
    TwoJobFromNonCompetitivePromotion: 19,
    TwoJobToNonCompetitivePromotion: 20,
    TwoJobToChangingNonCompetitivePromotion: 21,
    TowJobToChangingPlanNonCompetitivePromotion: 22,
    AllApplicant: 23,
    UnsuccessfulApplicant: 24,
    SuccessfulApplicant: 25,
    DispCodeApplicant: 26,
    HiredApplicant: 27,
    InternalSuccessfulApplicant: 28,
    OfferExtendedApplicant: 29,
    AllCompetitivePromotion: 30,
    UnsuccessfulCompetitivePromotion: 31,
    SuccessfulCompetitivePromotion: 32,
    DispCodeCompetitivePromotion: 33,
    HiredCompetitivePromotion: 34,
    InternalSuccessfulCompetitivePromotion: 35,
    OfferExtendedCompetitivePromotion: 36,
    AllHiringAnalysis: 37,
    UnsuccessfulHiringAnalysis: 38,
    SuccessfulHiringAnalysis: 39,
    DispCodeHiringAnalysis: 40,
    HiredHiringAnalysis: 41,
    InternalSuccessfulHiringAnalysis: 42,
    OfferExtendedHiringAnalysis: 43,
    IWDHiredInternalSuccessful: 44,
    IWDHiredInternalSuccessfulOfferExtended: 45,
    VetHiredInternalSuccessful: 46,
    VetHiredInternalSuccessfulOfferExtended: 47,
    ExclusionsApplicant: 48,
    ExclusionsHiringAnalysis: 49,
    ExclusionsCompetitivePromotion: 50,
    TerminationRetention: 51,
    InvoluntaryTerminationRetention: 52,
    VoluntaryTerminationRetention: 53
} as const;

export type EnumerationsCalcType = typeof EnumerationsCalcType[keyof typeof EnumerationsCalcType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsCompProfilesSortColumn = {
    AnalysisID: 1,
    DateCreated: 2,
    AnalysisName: 3
} as const;

export type EnumerationsCompProfilesSortColumn = typeof EnumerationsCompProfilesSortColumn[keyof typeof EnumerationsCompProfilesSortColumn];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsComplianceChecklistDateType = {
    NoDate: 1,
    SpecificDate: 2,
    UsePlanDate: 3,
    EveryTwoYears: 4,
    ActionPlansForSection503: 5,
    GFE: 6
} as const;

export type EnumerationsComplianceChecklistDateType = typeof EnumerationsComplianceChecklistDateType[keyof typeof EnumerationsComplianceChecklistDateType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsComplianceType = {
    EO11246: 1,
    NonDiscrimination: 2,
    IWD503VETSVEVRAALegacy: 3,
    StateandLocalReporting: 4,
    AttorneyClientPrivilege: 5,
    ProportionalAnalyses: 6,
    IWD503VETSVEVRAA2026: 7
} as const;

export type EnumerationsComplianceType = typeof EnumerationsComplianceType[keyof typeof EnumerationsComplianceType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsDataVisualizationFilterBy = {
    TotalMinorities: 1,
    IndividualRaces: 2,
    Gender: 3
} as const;

export type EnumerationsDataVisualizationFilterBy = typeof EnumerationsDataVisualizationFilterBy[keyof typeof EnumerationsDataVisualizationFilterBy];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsDataVisualizationResultsBy = {
    TotalMinorities: 1,
    IndividualRaces: 2,
    Gender: 3
} as const;

export type EnumerationsDataVisualizationResultsBy = typeof EnumerationsDataVisualizationResultsBy[keyof typeof EnumerationsDataVisualizationResultsBy];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsDataVisualizationType = {
    Overview: 1,
    Employment: 2,
    Goals: 3,
    RecruitmentAreas: 4,
    PersonnelActivity: 5,
    ApplicantFlow: 6,
    AdverseImpact: 7,
    GoalAttainment: 8,
    IWD: 9,
    ProtectedVeterans: 10,
    Custom: 11,
    WorkforceRepresentation: 12,
    SelectionRateAnalyses: 13,
    ProportionalAnalyses: 14,
    LaborMarketComparisons: 15
} as const;

export type EnumerationsDataVisualizationType = typeof EnumerationsDataVisualizationType[keyof typeof EnumerationsDataVisualizationType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsDocumentCenterSortColumn = {
    Sender: 1,
    Recipient: 2,
    Subject: 3,
    Company: 4,
    ClientAccount: 5,
    CompanyClientAccountCombo: 6,
    DateSubmitted: 7,
    ProjectName: 8,
    LocationName: 9
} as const;

export type EnumerationsDocumentCenterSortColumn = typeof EnumerationsDocumentCenterSortColumn[keyof typeof EnumerationsDocumentCenterSortColumn];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsDocumentCenterTab = {
    CurrentClient: 1,
    AllClients: 2,
    Unassigned: 3
} as const;

export type EnumerationsDocumentCenterTab = typeof EnumerationsDocumentCenterTab[keyof typeof EnumerationsDocumentCenterTab];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsDocumentCenterView = {
    All: 1,
    Inbox: 2,
    Sent: 3,
    Recipient: 4,
    Client: 5
} as const;

export type EnumerationsDocumentCenterView = typeof EnumerationsDocumentCenterView[keyof typeof EnumerationsDocumentCenterView];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsExportFormat = {
    PDF: 0,
    Excel: 1,
    Word: 2
} as const;

export type EnumerationsExportFormat = typeof EnumerationsExportFormat[keyof typeof EnumerationsExportFormat];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsExportStatus = {
    InProgress: 1,
    Cancelled: 2,
    Failed: 3,
    Completed: 4
} as const;

export type EnumerationsExportStatus = typeof EnumerationsExportStatus[keyof typeof EnumerationsExportStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsExportType = {
    IndividualFiles: 0,
    CombineAll: 1,
    CombineFilesPerPlan: 2,
    CombineFilesPerReport: 3
} as const;

export type EnumerationsExportType = typeof EnumerationsExportType[keyof typeof EnumerationsExportType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsFeature = {
    SettingsAllowTotalMinorities: 1,
    SettingsAllowHighlightProblemAreas: 2,
    SettingsAllowIncludeShortfall: 3,
    SettingsAllowPlacementGoalRow: 4,
    PlanSummaryShowAdverseImpact: 5,
    PlanSummaryShowApplicantFlow: 6,
    PlanSummaryShowEmployment: 7,
    PlanSummaryShowGoalAttainment: 8,
    PlanSummaryShowIncVsEst: 9,
    PlanSummaryShowIWD: 10,
    PlanSummaryShowPersonnelActivity: 11,
    PlanSummaryShowProtectedVeteran: 12,
    PlanSummaryShowRecruitmentAreas: 13,
    OverviewSummaryShowAdverseImpact: 14,
    OverviewSummaryShowGoalAttainment: 15,
    OverviewSummaryShowIWD: 16,
    OverviewSummaryShowProtectedVeteran: 17,
    OverviewSummaryShowUtilizationSummary: 18,
    SummariesAddGlobalCustomFooter: 19,
    DataVizOverviewShowEmployment: 20,
    DataVizOverviewShowGoals: 21,
    DataVizOverviewShowPersonnelActivity: 22,
    DataVizOverviewShowApplicantFlow: 23,
    DataVizOverviewShowAdverseImpact: 24,
    DataVizOverviewShowGoalAttainment: 25,
    DataVizOverviewShowIWD: 26,
    DataVizOverviewShowProtectedVeterans: 27,
    DataVizOverviewShowSignificantAI: 28,
    DataVizShowApplicantFlowDrilldownTiles: 29,
    DataVizShowPersonnelActivityDrilldownTIles: 30,
    DataVizShowEmploymentDrilldownTiles: 31,
    ReportsAddGlobalCustomFooter: 32,
    AllowProtectedClassHeader: 33
} as const;

export type EnumerationsFeature = typeof EnumerationsFeature[keyof typeof EnumerationsFeature];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsFileType = {
    Access: 0,
    CSV: 1,
    Word: 2,
    GIF: 3,
    JPEG: 4,
    MP4: 5,
    PDF: 6,
    PNG: 7,
    PowerPoint: 8,
    RTF: 9,
    SVG: 10,
    Text: 11,
    Excel: 12,
    Zip: 13,
    Invalid: 14,
    Xml: 15
} as const;

export type EnumerationsFileType = typeof EnumerationsFileType[keyof typeof EnumerationsFileType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsGFETargetedGroup = {
    ProtectedVeterans: 1,
    IndividualsWithDisabilities: 2,
    Male: 3,
    Female: 4,
    Asian: 5,
    Black: 6,
    Hispanic: 7,
    NativeAmerican: 8,
    PacificIslander: 9,
    TwoorMore: 10,
    White: 11
} as const;

export type EnumerationsGFETargetedGroup = typeof EnumerationsGFETargetedGroup[keyof typeof EnumerationsGFETargetedGroup];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsGoalAttainmentResultType = {
    Achieved: 1,
    NotAchieved: 2,
    Limited: 3,
    NoOpps: 4,
    PriorYearGoal: 5
} as const;

export type EnumerationsGoalAttainmentResultType = typeof EnumerationsGoalAttainmentResultType[keyof typeof EnumerationsGoalAttainmentResultType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsNotificationType = {
    Export: 0,
    PlanSummaryExport: 1,
    OverviewSummaryExport: 2,
    NewServiceDeliverableAvailable: 3,
    ServiceDeliverablePageUpdated: 4,
    FileUploadedToGeneral: 5,
    FileUploadedToYou: 6,
    FileDownloaded: 7,
    NewClientAssignment: 8,
    NewPlanAssignmentPublish: 9,
    NewPlanAssignmentUpdateUser: 10,
    RequestedAccess: 11,
    ApprovedAccess: 12,
    DeniedAccess: 13,
    AccessCancelledClient: 14,
    AccessCancelledProductSupport: 15,
    AccessRevokedClient: 16,
    AccessRevokedProductSupport: 17,
    AccessExpiredClient: 18,
    AccessExpiredProductSupport: 19,
    PasswordChanged: 20,
    AccountInfoChanged: 21,
    MFATokenUpdated: 22,
    SSOExpiring: 23,
    FileAccessGranted: 24,
    SystemAlert: 25,
    AAPSummaryExport: 26,
    DataExport: 27
} as const;

export type EnumerationsNotificationType = typeof EnumerationsNotificationType[keyof typeof EnumerationsNotificationType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsNumericDisplayOption = {
    ShowAsNumbers: 1,
    ShowAsPercentages: 2
} as const;

export type EnumerationsNumericDisplayOption = typeof EnumerationsNumericDisplayOption[keyof typeof EnumerationsNumericDisplayOption];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsOverviewSection = {
    Employment: 1,
    Goals: 2,
    PersonnelActivity: 3,
    ApplicantFlow: 4,
    AdverseImpact: 5,
    GoalAttainment: 6,
    IWD: 7,
    ProtectedVeterans: 8
} as const;

export type EnumerationsOverviewSection = typeof EnumerationsOverviewSection[keyof typeof EnumerationsOverviewSection];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsOverviewSelectedUpdatePlans = {
    NoUpdatePlans: 1,
    AllUpdatePlans: 2,
    ContainsUpdatePlans: 3
} as const;

export type EnumerationsOverviewSelectedUpdatePlans = typeof EnumerationsOverviewSelectedUpdatePlans[keyof typeof EnumerationsOverviewSelectedUpdatePlans];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsOverviewSortColumn = {
    Group: 1,
    EmploymentTotal: 2,
    EmploymentFem: 3,
    EmploymentMin: 4,
    EmploymentMal: 5,
    EmploymentUnkGender: 6,
    EmploymentAsi: 7,
    EmploymentBlk: 8,
    EmploymentHis: 9,
    EmploymentInd: 10,
    EmploymentPac: 11,
    EmploymentTwo: 12,
    EmploymentWht: 13,
    EmploymentUnkRace: 14,
    GoalsTotal: 15,
    GoalsTotalMinFem: 16,
    GoalsFem: 17,
    GoalsMin: 18,
    GoalsMal: 19,
    GoalsUnkGender: 20,
    GoalsAsi: 21,
    GoalsBlk: 22,
    GoalsHis: 23,
    GoalsInd: 24,
    GoalsPac: 25,
    GoalsTwo: 26,
    GoalsWht: 27,
    GoalsUnkRace: 28,
    PersonnelActivityTotal: 29,
    PersonnelActivityFem: 30,
    PersonnelActivityMin: 31,
    PersonnelActivityMal: 32,
    PersonnelActivityUnkGender: 33,
    PersonnelActivityAsi: 34,
    PersonnelActivityBlk: 35,
    PersonnelActivityHis: 36,
    PersonnelActivityInd: 37,
    PersonnelActivityPac: 38,
    PersonnelActivityTwo: 39,
    PersonnelActivityWht: 40,
    PersonnelActivityUnkRace: 41,
    ApplicantFlowTotalApplicantsTotal: 42,
    ApplicantFlowTotalApplicantsFem: 43,
    ApplicantFlowTotalApplicantsMin: 44,
    ApplicantFlowTotalApplicantsMal: 45,
    ApplicantFlowTotalApplicantsUnkGender: 46,
    ApplicantFlowTotalApplicantsAsi: 47,
    ApplicantFlowTotalApplicantsBlk: 48,
    ApplicantFlowTotalApplicantsHis: 49,
    ApplicantFlowTotalApplicantsInd: 50,
    ApplicantFlowTotalApplicantsPac: 51,
    ApplicantFlowTotalApplicantsTwo: 52,
    ApplicantFlowTotalApplicantsWht: 53,
    ApplicantFlowTotalApplicantsUnkRace: 54,
    ApplicantFlowTotalSelectionsTotal: 55,
    ApplicantFlowTotalSelectionsFem: 56,
    ApplicantFlowTotalSelectionsMin: 57,
    ApplicantFlowTotalSelectionsMal: 58,
    ApplicantFlowTotalSelectionsUnkGender: 59,
    ApplicantFlowTotalSelectionsAsi: 60,
    ApplicantFlowTotalSelectionsBlk: 61,
    ApplicantFlowTotalSelectionsHis: 62,
    ApplicantFlowTotalSelectionsInd: 63,
    ApplicantFlowTotalSelectionsPac: 64,
    ApplicantFlowTotalSelectionsTwo: 65,
    ApplicantFlowTotalSelectionsWht: 66,
    ApplicantFlowTotalSelectionsUnkRace: 67,
    ApplicantFlowHiringAnalysisTotal: 68,
    ApplicantFlowHiringAnalysisFem: 69,
    ApplicantFlowHiringAnalysisMin: 70,
    ApplicantFlowHiringAnalysisMal: 71,
    ApplicantFlowHiringAnalysisUnkGender: 72,
    ApplicantFlowHiringAnalysisAsi: 73,
    ApplicantFlowHiringAnalysisBlk: 74,
    ApplicantFlowHiringAnalysisHis: 75,
    ApplicantFlowHiringAnalysisInd: 76,
    ApplicantFlowHiringAnalysisPac: 77,
    ApplicantFlowHiringAnalysisTwo: 78,
    ApplicantFlowHiringAnalysisWht: 79,
    ApplicantFlowHiringAnalysisUnkRace: 80,
    ApplicantFlowCompetitivePromotionsTotal: 81,
    ApplicantFlowCompetitivePromotionsFem: 82,
    ApplicantFlowCompetitivePromotionsMin: 83,
    ApplicantFlowCompetitivePromotionsMal: 84,
    ApplicantFlowCompetitivePromotionsUnkGender: 85,
    ApplicantFlowCompetitivePromotionsAsi: 86,
    ApplicantFlowCompetitivePromotionsBlk: 87,
    ApplicantFlowCompetitivePromotionsHis: 88,
    ApplicantFlowCompetitivePromotionsInd: 89,
    ApplicantFlowCompetitivePromotionsPac: 90,
    ApplicantFlowCompetitivePromotionsTwo: 91,
    ApplicantFlowCompetitivePromotionsWht: 92,
    ApplicantFlowCompetitivePromotionsUnkRace: 93,
    GoalAttainmentAchievedTotal: 94,
    GoalAttainmentAchievedTotalMinFem: 95,
    GoalAttainmentAchievedFem: 96,
    GoalAttainmentAchievedMin: 97,
    GoalAttainmentAchievedMal: 98,
    GoalAttainmentAchievedUnkGender: 99,
    GoalAttainmentAchievedAsi: 100,
    GoalAttainmentAchievedBlk: 101,
    GoalAttainmentAchievedHis: 102,
    GoalAttainmentAchievedInd: 103,
    GoalAttainmentAchievedPac: 104,
    GoalAttainmentAchievedTwo: 105,
    GoalAttainmentAchievedWht: 106,
    GoalAttainmentAchievedUnkRace: 107,
    GoalAttainmentNotAchievedTotal: 108,
    GoalAttainmentNotAchievedTotalMinFem: 109,
    GoalAttainmentNotAchievedFem: 110,
    GoalAttainmentNotAchievedMin: 111,
    GoalAttainmentNotAchievedMal: 112,
    GoalAttainmentNotAchievedUnkGender: 113,
    GoalAttainmentNotAchievedAsi: 114,
    GoalAttainmentNotAchievedBlk: 115,
    GoalAttainmentNotAchievedHis: 116,
    GoalAttainmentNotAchievedInd: 117,
    GoalAttainmentNotAchievedPac: 118,
    GoalAttainmentNotAchievedTwo: 119,
    GoalAttainmentNotAchievedWht: 120,
    GoalAttainmentNotAchievedUnkRace: 121,
    GoalAttainmentLimitedTotal: 122,
    GoalAttainmentLimitedTotalMinFem: 123,
    GoalAttainmentLimitedFem: 124,
    GoalAttainmentLimitedMin: 125,
    GoalAttainmentLimitedMal: 126,
    GoalAttainmentLimitedUnkGender: 127,
    GoalAttainmentLimitedAsi: 128,
    GoalAttainmentLimitedBlk: 129,
    GoalAttainmentLimitedHis: 130,
    GoalAttainmentLimitedInd: 131,
    GoalAttainmentLimitedPac: 132,
    GoalAttainmentLimitedTwo: 133,
    GoalAttainmentLimitedWht: 134,
    GoalAttainmentLimitedUnkRace: 135,
    GoalAttainmentNoOppsTotal: 136,
    GoalAttainmentNoOppsTotalMinFem: 137,
    GoalAttainmentNoOppsFem: 138,
    GoalAttainmentNoOppsMin: 139,
    GoalAttainmentNoOppsMal: 140,
    GoalAttainmentNoOppsUnkGender: 141,
    GoalAttainmentNoOppsAsi: 142,
    GoalAttainmentNoOppsBlk: 143,
    GoalAttainmentNoOppsHis: 144,
    GoalAttainmentNoOppsInd: 145,
    GoalAttainmentNoOppsPac: 146,
    GoalAttainmentNoOppsTwo: 147,
    GoalAttainmentNoOppsWht: 148,
    GoalAttainmentNoOppsUnkRace: 149,
    AdverseImpactTotal: 150,
    AdverseImpactTotalMinFem: 151,
    AdverseImpactRace: 152,
    AdverseImpactMin: 153,
    AdverseImpactGender: 154,
    AdverseImpactFem: 155,
    AdverseImpactMal: 156,
    AdverseImpactUnkGender: 157,
    AdverseImpactAsi: 158,
    AdverseImpactBlk: 159,
    AdverseImpactHis: 160,
    AdverseImpactInd: 161,
    AdverseImpactPac: 162,
    AdverseImpactTwo: 163,
    AdverseImpactWht: 164,
    AdverseImpactUnkRace: 165,
    IwdMet: 166,
    VetMet: 167
} as const;

export type EnumerationsOverviewSortColumn = typeof EnumerationsOverviewSortColumn[keyof typeof EnumerationsOverviewSortColumn];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsPersonnelActivityResultsDisplayed = {
    BreakoutIndividualActions: 1,
    SummarizePositiveAndNegative: 2
} as const;

export type EnumerationsPersonnelActivityResultsDisplayed = typeof EnumerationsPersonnelActivityResultsDisplayed[keyof typeof EnumerationsPersonnelActivityResultsDisplayed];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsPlanProfilesSortColumn = {
    PlanIdentifier: 1,
    PlanDate: 2,
    PlanName: 3,
    Company: 4,
    Establishment: 5,
    PlanType: 6
} as const;

export type EnumerationsPlanProfilesSortColumn = typeof EnumerationsPlanProfilesSortColumn[keyof typeof EnumerationsPlanProfilesSortColumn];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsPlanSummaryAIShowFor = {
    AIShowAllGroups: 1,
    AIShowGroupsWithAdverseIRA: 2,
    AIShowGroupsWithSignificantAdverseIRA: 3,
    AIDoNotShowAI: 4
} as const;

export type EnumerationsPlanSummaryAIShowFor = typeof EnumerationsPlanSummaryAIShowFor[keyof typeof EnumerationsPlanSummaryAIShowFor];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsPlanSummaryIncvsEstShowFor = {
    IncvsEstShowAllGroups: 1,
    IncvsEstShowGroupsWithGoals: 2,
    IncvsEstShowGroupsWithSignificantGoals: 3
} as const;

export type EnumerationsPlanSummaryIncvsEstShowFor = typeof EnumerationsPlanSummaryIncvsEstShowFor[keyof typeof EnumerationsPlanSummaryIncvsEstShowFor];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsPlanType = {
    Regular: 0,
    Master: 1,
    Sub: 2
} as const;

export type EnumerationsPlanType = typeof EnumerationsPlanType[keyof typeof EnumerationsPlanType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsRecurringInterval = {
    Never: 1,
    Monthly: 2,
    Quarterly: 3,
    Annually: 4
} as const;

export type EnumerationsRecurringInterval = typeof EnumerationsRecurringInterval[keyof typeof EnumerationsRecurringInterval];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsRole = {
    BerkshireSystemAdmin: 1,
    BerkshireDataAdmin: 2,
    BerkshireProductSupport: 3,
    BerkshireConsultant: 4,
    Admin: 5,
    ServiceOwner: 6,
    ReportViewer: 7,
    ReportandDataVizViewer: 8,
    ReportDataVizandInsightsViewer: 9,
    BerkshirePSAdmin: 10,
    BerkshireCSLeadership: 11,
    CompetitiveConsultant: 12,
    ServiceDeliverableViewer: 13,
    NonReportsServiceOwner: 14,
    DataVizOnlyViewer: 15,
    ServiceDeliverableandDataVizViewer: 16
} as const;

export type EnumerationsRole = typeof EnumerationsRole[keyof typeof EnumerationsRole];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsRunByForProtectedClasses = {
    RunForMinFem: 1,
    RunForProtectedClassesInPlan: 2
} as const;

export type EnumerationsRunByForProtectedClasses = typeof EnumerationsRunByForProtectedClasses[keyof typeof EnumerationsRunByForProtectedClasses];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsServiceType = {
    Compliance: 0,
    Compensation: 1,
    DEI: 2,
    EEO: 3,
    Vets: 4,
    Audit: 5,
    Custom: 6,
    Tools: 7,
    WorkforceAnalytics: 8,
    GoodFaithEfforts: 9
} as const;

export type EnumerationsServiceType = typeof EnumerationsServiceType[keyof typeof EnumerationsServiceType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsSortDirection = {
    Ascending: 1,
    Descending: 2
} as const;

export type EnumerationsSortDirection = typeof EnumerationsSortDirection[keyof typeof EnumerationsSortDirection];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsSystemAlertActiveStatus = {
    Active: 1,
    Inactive: 2,
    Expired: 3
} as const;

export type EnumerationsSystemAlertActiveStatus = typeof EnumerationsSystemAlertActiveStatus[keyof typeof EnumerationsSystemAlertActiveStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsSystemAlertLabelType = {
    Single: 1,
    Multiple: 2,
    All: 3
} as const;

export type EnumerationsSystemAlertLabelType = typeof EnumerationsSystemAlertLabelType[keyof typeof EnumerationsSystemAlertLabelType];


/**
 * 
 * @export
 * @enum {string}
 */

export const EnumerationsUtilizationSummaryResultsDisplayed = {
    AllGroups: 1,
    UnderutilizedGroups: 2,
    StatisticallySignificantUnderutilizedGroups: 3
} as const;

export type EnumerationsUtilizationSummaryResultsDisplayed = typeof EnumerationsUtilizationSummaryResultsDisplayed[keyof typeof EnumerationsUtilizationSummaryResultsDisplayed];


/**
 * 
 * @export
 * @interface GFEGFECriteriaDTO
 */
export interface GFEGFECriteriaDTO {
    /**
     * 
     * @type {number}
     * @memberof GFEGFECriteriaDTO
     */
    'gfeCriteriaID': number;
    /**
     * 
     * @type {number}
     * @memberof GFEGFECriteriaDTO
     */
    'targetedGroup': number;
    /**
     * 
     * @type {string}
     * @memberof GFEGFECriteriaDTO
     */
    'criteria': string;
    /**
     * 
     * @type {boolean}
     * @memberof GFEGFECriteriaDTO
     */
    'selected': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GFEGFECriteriaDTO
     */
    'isCustom': boolean;
}
/**
 * 
 * @export
 * @interface GFEGFECustomFieldsDTO
 */
export interface GFEGFECustomFieldsDTO {
    /**
     * 
     * @type {string}
     * @memberof GFEGFECustomFieldsDTO
     */
    'fieldName': string;
    /**
     * 
     * @type {string}
     * @memberof GFEGFECustomFieldsDTO
     */
    'data': string;
}
/**
 * 
 * @export
 * @interface GFEGFEDataDTO
 */
export interface GFEGFEDataDTO {
    /**
     * 
     * @type {string}
     * @memberof GFEGFEDataDTO
     */
    'gfeid': string;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEDataDTO
     */
    'clientID': string;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEDataDTO
     */
    'location': string;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEDataDTO
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEDataDTO
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEDataDTO
     */
    'source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEDataDTO
     */
    'activity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEDataDTO
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEDataDTO
     */
    'targetedGroups': string;
    /**
     * 
     * @type {number}
     * @memberof GFEGFEDataDTO
     */
    'effectiveness': number;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEDataDTO
     */
    'evaluation': string;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEDataDTO
     */
    'user': string;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEDataDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEDataDTO
     */
    'requisitionNo': string;
    /**
     * 
     * @type {number}
     * @memberof GFEGFEDataDTO
     */
    'numberOfCandidates': number;
    /**
     * 
     * @type {number}
     * @memberof GFEGFEDataDTO
     */
    'numberOfHires': number;
    /**
     * 
     * @type {number}
     * @memberof GFEGFEDataDTO
     */
    'hoursSpent': number;
    /**
     * 
     * @type {number}
     * @memberof GFEGFEDataDTO
     */
    'cost': number;
    /**
     * 
     * @type {Array<GFEGFECustomFieldsDTO>}
     * @memberof GFEGFEDataDTO
     */
    'customFields': Array<GFEGFECustomFieldsDTO>;
    /**
     * 
     * @type {Array<EnumerationsGFETargetedGroup>}
     * @memberof GFEGFEDataDTO
     */
    'targetedGroupList': Array<EnumerationsGFETargetedGroup>;
}
/**
 * 
 * @export
 * @interface GFEGFEEffortsByActivityDTO
 */
export interface GFEGFEEffortsByActivityDTO {
    /**
     * 
     * @type {string}
     * @memberof GFEGFEEffortsByActivityDTO
     */
    'gfeid': string;
    /**
     * 
     * @type {number}
     * @memberof GFEGFEEffortsByActivityDTO
     */
    'targetedGroup': number;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEEffortsByActivityDTO
     */
    'dateRange': string;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEEffortsByActivityDTO
     */
    'source': string;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEEffortsByActivityDTO
     */
    'activity': string;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEEffortsByActivityDTO
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof GFEGFEEffortsByActivityDTO
     */
    'effectiveness': number;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEEffortsByActivityDTO
     */
    'evaluation': string;
}
/**
 * 
 * @export
 * @interface GFEGFEEffortsBySourceDTO
 */
export interface GFEGFEEffortsBySourceDTO {
    /**
     * 
     * @type {number}
     * @memberof GFEGFEEffortsBySourceDTO
     */
    'targetedGroup': number;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEEffortsBySourceDTO
     */
    'source': string;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEEffortsBySourceDTO
     */
    'activityCount': string;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEEffortsBySourceDTO
     */
    'dateRange': string;
    /**
     * 
     * @type {number}
     * @memberof GFEGFEEffortsBySourceDTO
     */
    'effectivenessAverage': number;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEEffortsBySourceDTO
     */
    'descriptionsLongString': string;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEEffortsBySourceDTO
     */
    'evaluationsLongString': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GFEGFEEffortsBySourceDTO
     */
    'descriptions': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GFEGFEEffortsBySourceDTO
     */
    'evaluationSummaries': Array<string>;
}
/**
 * 
 * @export
 * @interface GFEGFEFieldsDTO
 */
export interface GFEGFEFieldsDTO {
    /**
     * 
     * @type {number}
     * @memberof GFEGFEFieldsDTO
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEFieldsDTO
     */
    'fieldName': string;
    /**
     * 
     * @type {string}
     * @memberof GFEGFEFieldsDTO
     */
    'displayName': string;
    /**
     * 
     * @type {number}
     * @memberof GFEGFEFieldsDTO
     */
    'sortOrder': number;
    /**
     * 
     * @type {boolean}
     * @memberof GFEGFEFieldsDTO
     */
    'visible': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GFEGFEFieldsDTO
     */
    'isRequired': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GFEGFEFieldsDTO
     */
    'markedForDelete': boolean;
}
/**
 * 
 * @export
 * @interface GoalAttainmentDemographicResultCountDTO
 */
export interface GoalAttainmentDemographicResultCountDTO {
    /**
     * 
     * @type {string}
     * @memberof GoalAttainmentDemographicResultCountDTO
     */
    'demographic': string;
    /**
     * 
     * @type {Array<GoalAttainmentGoalAttainmentResultCount>}
     * @memberof GoalAttainmentDemographicResultCountDTO
     */
    'resultCounts': Array<GoalAttainmentGoalAttainmentResultCount>;
}
/**
 * 
 * @export
 * @interface GoalAttainmentGoalAttainmentResultCount
 */
export interface GoalAttainmentGoalAttainmentResultCount {
    /**
     * 
     * @type {EnumerationsGoalAttainmentResultType}
     * @memberof GoalAttainmentGoalAttainmentResultCount
     */
    'resultType': EnumerationsGoalAttainmentResultType;
    /**
     * 
     * @type {number}
     * @memberof GoalAttainmentGoalAttainmentResultCount
     */
    'count'?: number | null;
}


/**
 * 
 * @export
 * @interface GoalDemographicWithListOfLocationsDTO
 */
export interface GoalDemographicWithListOfLocationsDTO {
    /**
     * 
     * @type {string}
     * @memberof GoalDemographicWithListOfLocationsDTO
     */
    'demographic': string;
    /**
     * 
     * @type {Array<GoalLocationPercent>}
     * @memberof GoalDemographicWithListOfLocationsDTO
     */
    'locations': Array<GoalLocationPercent>;
}
/**
 * 
 * @export
 * @interface GoalEEOCodeBradyBunchResponse
 */
export interface GoalEEOCodeBradyBunchResponse {
    /**
     * 
     * @type {string}
     * @memberof GoalEEOCodeBradyBunchResponse
     */
    'eeoCode': string;
    /**
     * 
     * @type {string}
     * @memberof GoalEEOCodeBradyBunchResponse
     */
    'eeoCodeDescription': string;
    /**
     * 
     * @type {number}
     * @memberof GoalEEOCodeBradyBunchResponse
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GoalEEOCodeBradyBunchResponse
     */
    'numberOfJobGroups': number;
}
/**
 * 
 * @export
 * @interface GoalJobGroupCategory
 */
export interface GoalJobGroupCategory {
    /**
     * 
     * @type {string}
     * @memberof GoalJobGroupCategory
     */
    'category': string;
    /**
     * 
     * @type {number}
     * @memberof GoalJobGroupCategory
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface GoalLocationPercent
 */
export interface GoalLocationPercent {
    /**
     * 
     * @type {string}
     * @memberof GoalLocationPercent
     */
    'location': string;
    /**
     * 
     * @type {number}
     * @memberof GoalLocationPercent
     */
    'percent': number;
}
/**
 * 
 * @export
 * @interface GoalMiniDonutsAdverseImpactResponse
 */
export interface GoalMiniDonutsAdverseImpactResponse {
    /**
     * 
     * @type {string}
     * @memberof GoalMiniDonutsAdverseImpactResponse
     */
    'planID': string;
    /**
     * 
     * @type {string}
     * @memberof GoalMiniDonutsAdverseImpactResponse
     */
    'planIdentifier': string;
    /**
     * 
     * @type {string}
     * @memberof GoalMiniDonutsAdverseImpactResponse
     */
    'establishment': string;
    /**
     * 
     * @type {string}
     * @memberof GoalMiniDonutsAdverseImpactResponse
     */
    'planName': string;
    /**
     * 
     * @type {string}
     * @memberof GoalMiniDonutsAdverseImpactResponse
     */
    'planCode': string;
    /**
     * 
     * @type {string}
     * @memberof GoalMiniDonutsAdverseImpactResponse
     */
    'planDate': string;
    /**
     * 
     * @type {Array<GoalJobGroupCategory>}
     * @memberof GoalMiniDonutsAdverseImpactResponse
     */
    'jobGroups': Array<GoalJobGroupCategory>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof GoalMiniDonutsAdverseImpactResponse
     */
    'demographics': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {number}
     * @memberof GoalMiniDonutsAdverseImpactResponse
     */
    'centerNumber': number;
}
/**
 * 
 * @export
 * @interface GoalMiniDonutsResponse
 */
export interface GoalMiniDonutsResponse {
    /**
     * 
     * @type {string}
     * @memberof GoalMiniDonutsResponse
     */
    'planID': string;
    /**
     * 
     * @type {string}
     * @memberof GoalMiniDonutsResponse
     */
    'planIdentifier': string;
    /**
     * 
     * @type {string}
     * @memberof GoalMiniDonutsResponse
     */
    'establishment': string;
    /**
     * 
     * @type {string}
     * @memberof GoalMiniDonutsResponse
     */
    'planName': string;
    /**
     * 
     * @type {string}
     * @memberof GoalMiniDonutsResponse
     */
    'planCode': string;
    /**
     * 
     * @type {string}
     * @memberof GoalMiniDonutsResponse
     */
    'planDate': string;
    /**
     * 
     * @type {number}
     * @memberof GoalMiniDonutsResponse
     */
    'totalGoalsCount': number;
    /**
     * 
     * @type {Array<GoalJobGroupCategory>}
     * @memberof GoalMiniDonutsResponse
     */
    'jobGroups': Array<GoalJobGroupCategory>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof GoalMiniDonutsResponse
     */
    'demographics': Array<DataVizDemographicCountDTO>;
}
/**
 * 
 * @export
 * @interface GoalWordCloudDTO
 */
export interface GoalWordCloudDTO {
    /**
     * 
     * @type {string}
     * @memberof GoalWordCloudDTO
     */
    'jobTitle': string;
    /**
     * 
     * @type {number}
     * @memberof GoalWordCloudDTO
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GoalWordCloudDTO
     */
    'femaleCount': number;
    /**
     * 
     * @type {number}
     * @memberof GoalWordCloudDTO
     */
    'minorityCount': number;
}
/**
 * 
 * @export
 * @interface ModelsAdverseImpactReportSettings
 */
export interface ModelsAdverseImpactReportSettings {
    /**
     * 
     * @type {string}
     * @memberof ModelsAdverseImpactReportSettings
     */
    'planID': string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAdverseImpactReportSettings
     */
    'highlightProblemAreas': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAdverseImpactReportSettings
     */
    'filterAdverseIRAByJobGroup': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAdverseImpactReportSettings
     */
    'runAIByPoolIDWhenAvailable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAdverseImpactReportSettings
     */
    'showAdverseIRA': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAdverseImpactReportSettings
     */
    'showSelectionRatio': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAdverseImpactReportSettings
     */
    'showStatisticalValue': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAdverseImpactReportSettings
     */
    'showStatisticallySignificant': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAdverseImpactReportSettings
     */
    'showSwaps': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAdverseImpactReportSettings
     */
    'showAdjustedSelectionRatio': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAdverseImpactReportSettings
     */
    'showSwapsforSignificance': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAdverseImpactReportSettings
     */
    'showAdjustedStatisticalValue': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAdverseImpactReportSettings
     */
    'showShortfall': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAdverseImpactReportSettings
     */
    'showSelectionRate': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAdverseImpactReportSettings
     */
    'showOverallSelectionRate': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAdverseImpactReportSettings
     */
    'suppressExcludedDispositionCodeFootnotes': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAdverseImpactReportSettings
     */
    'suppressFavoredGroupInfoforDetailReports': boolean;
}
/**
 * 
 * @export
 * @interface ModelsApplicantSummaryReportSettings
 */
export interface ModelsApplicantSummaryReportSettings {
    /**
     * 
     * @type {string}
     * @memberof ModelsApplicantSummaryReportSettings
     */
    'planID': string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsApplicantSummaryReportSettings
     */
    'applicantSummaryShowOffers': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsApplicantSummaryReportSettings
     */
    'applicantSummaryShowUnsuccessful': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsApplicantSummaryReportSettings
     */
    'applicantSummaryByDispCodeRunByJobGroup': boolean;
}
/**
 * 
 * @export
 * @interface ModelsAvailabilityReportSettings
 */
export interface ModelsAvailabilityReportSettings {
    /**
     * 
     * @type {string}
     * @memberof ModelsAvailabilityReportSettings
     */
    'planID': string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAvailabilityReportSettings
     */
    'includeStatisticalValues': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAvailabilityReportSettings
     */
    'includeShortfall': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAvailabilityReportSettings
     */
    'highlightProblemAreas': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAvailabilityReportSettings
     */
    'showOnlyStaffedJobs': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAvailabilityReportSettings
     */
    'insertPageBreaksBetweenJobGroups': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAvailabilityReportSettings
     */
    'showYesNoInsteadofAvailPercent': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsAvailabilityReportSettings
     */
    'useWeights': boolean;
}
/**
 * 
 * @export
 * @interface ModelsCompensationSummaryReportSettings
 */
export interface ModelsCompensationSummaryReportSettings {
    /**
     * 
     * @type {string}
     * @memberof ModelsCompensationSummaryReportSettings
     */
    'planID': string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsCompensationSummaryReportSettings
     */
    'highlightDifferenceOfFive': boolean;
}
/**
 * 
 * @export
 * @interface ModelsDataCollectionReportSettings
 */
export interface ModelsDataCollectionReportSettings {
    /**
     * 
     * @type {string}
     * @memberof ModelsDataCollectionReportSettings
     */
    'planID': string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsDataCollectionReportSettings
     */
    'iwdRunByPlan': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsDataCollectionReportSettings
     */
    'iwdRunByJobGroup': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsDataCollectionReportSettings
     */
    'vetsRunByPlan': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsDataCollectionReportSettings
     */
    'vetsRunByJobGroup': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsDataCollectionReportSettings
     */
    'iwdGoalsShowStatValue': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsDataCollectionReportSettings
     */
    'iwdGoalsShowTotalCount': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsDataCollectionReportSettings
     */
    'iwdGoalsRunByPlan': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsDataCollectionReportSettings
     */
    'iwdGoalsRunByJobGroup': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsDataCollectionReportSettings
     */
    'iwdGoalsDetermineByRosterCount': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsDataCollectionReportSettings
     */
    'vetsHASuppressBenchmarkMet': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsDataCollectionReportSettings
     */
    'vetsHARunByPlan': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsDataCollectionReportSettings
     */
    'vetsHARunByJobGroup': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsDataCollectionReportSettings
     */
    'fiveFactorRunByPlan': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsDataCollectionReportSettings
     */
    'fiveFactorRunByJobGroup': boolean;
}
/**
 * 
 * @export
 * @interface ModelsJobGroupAnalysisReportSettings
 */
export interface ModelsJobGroupAnalysisReportSettings {
    /**
     * 
     * @type {string}
     * @memberof ModelsJobGroupAnalysisReportSettings
     */
    'planID': string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsJobGroupAnalysisReportSettings
     */
    'showPercentages': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsJobGroupAnalysisReportSettings
     */
    'includeGrade': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsJobGroupAnalysisReportSettings
     */
    'insertPageBreaksBetweenJGs': boolean;
}
/**
 * 
 * @export
 * @interface ModelsServiceDeliverablePage
 */
export interface ModelsServiceDeliverablePage {
    /**
     * 
     * @type {string}
     * @memberof ModelsServiceDeliverablePage
     */
    'pageID': string;
    /**
     * 
     * @type {string}
     * @memberof ModelsServiceDeliverablePage
     */
    'clientID': string;
    /**
     * 
     * @type {string}
     * @memberof ModelsServiceDeliverablePage
     */
    'serviceID': string;
    /**
     * 
     * @type {string}
     * @memberof ModelsServiceDeliverablePage
     */
    'pageName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ModelsServiceDeliverablePage
     */
    'displayOrder': number;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsServiceDeliverablePage
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface ModelsWorkforceAnalysisReportSettings
 */
export interface ModelsWorkforceAnalysisReportSettings {
    /**
     * 
     * @type {string}
     * @memberof ModelsWorkforceAnalysisReportSettings
     */
    'planID': string;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsWorkforceAnalysisReportSettings
     */
    'excludeHierarchyInfo': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsWorkforceAnalysisReportSettings
     */
    'insertPageBreaksBetweenDepartments': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsWorkforceAnalysisReportSettings
     */
    'orderByGrade': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsWorkforceAnalysisReportSettings
     */
    'orderBySalaryRange': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsWorkforceAnalysisReportSettings
     */
    'orderByAverageSalary': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsWorkforceAnalysisReportSettings
     */
    'showGrade': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsWorkforceAnalysisReportSettings
     */
    'showSalary': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsWorkforceAnalysisReportSettings
     */
    'showNoSalaryInfo': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsWorkforceAnalysisReportSettings
     */
    'showOnlyDeptsWithProblems': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const NetHttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    OK: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    IMUsed: 226,
    MultipleChoices: 300,
    Ambiguous: 301,
    MovedPermanently: 302,
    Moved: 303,
    Found: 304,
    Redirect: 305,
    SeeOther: 306,
    RedirectMethod: 307,
    NotModified: 308,
    UseProxy: 400,
    Unused: 401,
    TemporaryRedirect: 402,
    RedirectKeepVerb: 403,
    PermanentRedirect: 404,
    BadRequest: 405,
    Unauthorized: 406,
    PaymentRequired: 407,
    Forbidden: 408,
    NotFound: 409,
    MethodNotAllowed: 410,
    NotAcceptable: 411,
    ProxyAuthenticationRequired: 412,
    RequestTimeout: 413,
    Conflict: 414,
    Gone: 415,
    LengthRequired: 416,
    PreconditionFailed: 417,
    RequestEntityTooLarge: 421,
    RequestUriTooLong: 422,
    UnsupportedMediaType: 423,
    RequestedRangeNotSatisfiable: 424,
    ExpectationFailed: 426,
    MisdirectedRequest: 428,
    UnprocessableEntity: 429,
    UnprocessableContent: 431,
    Locked: 451,
    FailedDependency: 500,
    UpgradeRequired: 501,
    PreconditionRequired: 502,
    TooManyRequests: 503,
    RequestHeaderFieldsTooLarge: 504,
    UnavailableForLegalReasons: 505,
    InternalServerError: 506,
    NotImplemented: 507,
    BadGateway: 508,
    ServiceUnavailable: 510,
    GatewayTimeout: 511
} as const;

export type NetHttpStatusCode = typeof NetHttpStatusCode[keyof typeof NetHttpStatusCode];


/**
 * 
 * @export
 * @interface NotificationsDocumentCenterNotificationDTO
 */
export interface NotificationsDocumentCenterNotificationDTO {
    /**
     * 
     * @type {string}
     * @memberof NotificationsDocumentCenterNotificationDTO
     */
    'documentUploadID': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsDocumentCenterNotificationDTO
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsDocumentCenterNotificationDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsDocumentCenterNotificationDTO
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface NotificationsExportNotificationDTO
 */
export interface NotificationsExportNotificationDTO {
    /**
     * 
     * @type {EnumerationsServiceType}
     * @memberof NotificationsExportNotificationDTO
     */
    'serviceTypeID': EnumerationsServiceType;
    /**
     * 
     * @type {string}
     * @memberof NotificationsExportNotificationDTO
     */
    'planDate': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsExportNotificationDTO
     */
    'planIdentifier': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsExportNotificationDTO
     */
    'planName': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsExportNotificationDTO
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsExportNotificationDTO
     */
    'establishment': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsExportNotificationDTO
     */
    'planCode': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsExportNotificationDTO
     */
    'summaryName': string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationsExportNotificationDTO
     */
    'isSummaryExport': boolean;
}


/**
 * 
 * @export
 * @interface NotificationsExportProgressDTO
 */
export interface NotificationsExportProgressDTO {
    /**
     * 
     * @type {string}
     * @memberof NotificationsExportProgressDTO
     */
    'exportID': string;
    /**
     * 
     * @type {number}
     * @memberof NotificationsExportProgressDTO
     */
    'percent': number;
    /**
     * 
     * @type {number}
     * @memberof NotificationsExportProgressDTO
     */
    'currentStep': number;
    /**
     * 
     * @type {string}
     * @memberof NotificationsExportProgressDTO
     */
    'currentStepDescription': string;
    /**
     * 
     * @type {number}
     * @memberof NotificationsExportProgressDTO
     */
    'totalSteps': number;
    /**
     * 
     * @type {string}
     * @memberof NotificationsExportProgressDTO
     */
    'reportDownloadID': string;
    /**
     * 
     * @type {EnumerationsExportStatus}
     * @memberof NotificationsExportProgressDTO
     */
    'exportStatus': EnumerationsExportStatus;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationsExportProgressDTO
     */
    'isReExport': boolean;
}


/**
 * 
 * @export
 * @interface NotificationsNewClientAssignmentNotificationDTO
 */
export interface NotificationsNewClientAssignmentNotificationDTO {
    /**
     * 
     * @type {string}
     * @memberof NotificationsNewClientAssignmentNotificationDTO
     */
    'newClientID': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsNewClientAssignmentNotificationDTO
     */
    'clientName': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsNewClientAssignmentNotificationDTO
     */
    'subdomain': string;
}
/**
 * 
 * @export
 * @interface NotificationsNewPlanAssignmentNotificationDTO
 */
export interface NotificationsNewPlanAssignmentNotificationDTO {
    /**
     * 
     * @type {string}
     * @memberof NotificationsNewPlanAssignmentNotificationDTO
     */
    'newPlanID': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsNewPlanAssignmentNotificationDTO
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsNewPlanAssignmentNotificationDTO
     */
    'planName': string;
    /**
     * 
     * @type {number}
     * @memberof NotificationsNewPlanAssignmentNotificationDTO
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface NotificationsNotificationDTO
 */
export interface NotificationsNotificationDTO {
    /**
     * 
     * @type {string}
     * @memberof NotificationsNotificationDTO
     */
    'notificationID': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsNotificationDTO
     */
    'displayDate': string;
    /**
     * 
     * @type {EnumerationsNotificationType}
     * @memberof NotificationsNotificationDTO
     */
    'notificationTypeID': EnumerationsNotificationType;
    /**
     * 
     * @type {number}
     * @memberof NotificationsNotificationDTO
     */
    'serviceTypeID': number;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationsNotificationDTO
     */
    'read': boolean;
    /**
     * 
     * @type {string}
     * @memberof NotificationsNotificationDTO
     */
    'clientName': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsNotificationDTO
     */
    'subdomain': string;
    /**
     * 
     * @type {NotificationsExportNotificationDTO}
     * @memberof NotificationsNotificationDTO
     */
    'aapExportNotificationInfo': NotificationsExportNotificationDTO;
    /**
     * 
     * @type {NotificationsExportProgressDTO}
     * @memberof NotificationsNotificationDTO
     */
    'exportProgressInfo': NotificationsExportProgressDTO;
    /**
     * 
     * @type {NotificationsServiceDeliverableNotificationDTO}
     * @memberof NotificationsNotificationDTO
     */
    'serviceDeliverableNotification': NotificationsServiceDeliverableNotificationDTO;
    /**
     * 
     * @type {NotificationsDocumentCenterNotificationDTO}
     * @memberof NotificationsNotificationDTO
     */
    'documentCenterNotification': NotificationsDocumentCenterNotificationDTO;
    /**
     * 
     * @type {NotificationsNewClientAssignmentNotificationDTO}
     * @memberof NotificationsNotificationDTO
     */
    'newClientAssignmentNotification': NotificationsNewClientAssignmentNotificationDTO;
    /**
     * 
     * @type {NotificationsNewPlanAssignmentNotificationDTO}
     * @memberof NotificationsNotificationDTO
     */
    'newPlanAssignmentNotification': NotificationsNewPlanAssignmentNotificationDTO;
    /**
     * 
     * @type {NotificationsSupportAccessNotificationDTO}
     * @memberof NotificationsNotificationDTO
     */
    'supportAccessNotification': NotificationsSupportAccessNotificationDTO;
    /**
     * 
     * @type {NotificationsUserNotificationDTO}
     * @memberof NotificationsNotificationDTO
     */
    'userNotification': NotificationsUserNotificationDTO;
    /**
     * 
     * @type {NotificationsSystemAlertNotificationDTO}
     * @memberof NotificationsNotificationDTO
     */
    'systemAlertNotification': NotificationsSystemAlertNotificationDTO;
    /**
     * 
     * @type {NotificationsWFAExportNotificationDTO}
     * @memberof NotificationsNotificationDTO
     */
    'wfaExportNotificationInfo': NotificationsWFAExportNotificationDTO;
}


/**
 * 
 * @export
 * @interface NotificationsServiceDeliverableNotificationDTO
 */
export interface NotificationsServiceDeliverableNotificationDTO {
    /**
     * 
     * @type {string}
     * @memberof NotificationsServiceDeliverableNotificationDTO
     */
    'serviceLineName': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsServiceDeliverableNotificationDTO
     */
    'pageID': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsServiceDeliverableNotificationDTO
     */
    'pageName': string;
}
/**
 * 
 * @export
 * @interface NotificationsSupportAccessNotificationDTO
 */
export interface NotificationsSupportAccessNotificationDTO {
    /**
     * 
     * @type {string}
     * @memberof NotificationsSupportAccessNotificationDTO
     */
    'supportAccessID': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsSupportAccessNotificationDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsSupportAccessNotificationDTO
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsSupportAccessNotificationDTO
     */
    'clientName': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsSupportAccessNotificationDTO
     */
    'expirationDate': string;
}
/**
 * 
 * @export
 * @interface NotificationsSystemAlertNotificationDTO
 */
export interface NotificationsSystemAlertNotificationDTO {
    /**
     * 
     * @type {string}
     * @memberof NotificationsSystemAlertNotificationDTO
     */
    'systemAlertID': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsSystemAlertNotificationDTO
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsSystemAlertNotificationDTO
     */
    'viewedDate': string;
}
/**
 * 
 * @export
 * @interface NotificationsUserNotificationDTO
 */
export interface NotificationsUserNotificationDTO {
    /**
     * 
     * @type {string}
     * @memberof NotificationsUserNotificationDTO
     */
    'certificateEndDate': string;
}
/**
 * 
 * @export
 * @interface NotificationsWFAExportNotificationDTO
 */
export interface NotificationsWFAExportNotificationDTO {
    /**
     * 
     * @type {string}
     * @memberof NotificationsWFAExportNotificationDTO
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsWFAExportNotificationDTO
     */
    'companyName': string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationsWFAExportNotificationDTO
     */
    'isSummaryExport': boolean;
}
/**
 * 
 * @export
 * @interface OverviewGetOverviewListResponse
 */
export interface OverviewGetOverviewListResponse {
    /**
     * 
     * @type {Array<OverviewOverviewListItem>}
     * @memberof OverviewGetOverviewListResponse
     */
    'items': Array<OverviewOverviewListItem>;
    /**
     * 
     * @type {number}
     * @memberof OverviewGetOverviewListResponse
     */
    'itemCount': number;
    /**
     * 
     * @type {EnumerationsOverviewSelectedUpdatePlans}
     * @memberof OverviewGetOverviewListResponse
     */
    'amountOfSelectedUpdatePlans': EnumerationsOverviewSelectedUpdatePlans;
}


/**
 * 
 * @export
 * @interface OverviewOverviewListItem
 */
export interface OverviewOverviewListItem {
    /**
     * 
     * @type {string}
     * @memberof OverviewOverviewListItem
     */
    'groupLabel': string;
    /**
     * 
     * @type {OverviewTotalProtectedClassCounts}
     * @memberof OverviewOverviewListItem
     */
    'employment': OverviewTotalProtectedClassCounts;
    /**
     * 
     * @type {OverviewTotalProtectedClassNullableCounts}
     * @memberof OverviewOverviewListItem
     */
    'goals': OverviewTotalProtectedClassNullableCounts;
    /**
     * 
     * @type {Array<OverviewPersonnelActivityCount>}
     * @memberof OverviewOverviewListItem
     */
    'personnelActivities': Array<OverviewPersonnelActivityCount>;
    /**
     * 
     * @type {OverviewTotalProtectedClassCounts}
     * @memberof OverviewOverviewListItem
     */
    'applicantFlowTotalApplicants': OverviewTotalProtectedClassCounts;
    /**
     * 
     * @type {OverviewTotalProtectedClassCounts}
     * @memberof OverviewOverviewListItem
     */
    'applicantFlowTotalSelections': OverviewTotalProtectedClassCounts;
    /**
     * 
     * @type {OverviewTotalProtectedClassCounts}
     * @memberof OverviewOverviewListItem
     */
    'applicantFlowHiringAnalysis': OverviewTotalProtectedClassCounts;
    /**
     * 
     * @type {OverviewTotalProtectedClassCounts}
     * @memberof OverviewOverviewListItem
     */
    'applicantFlowCompetitivePromotions': OverviewTotalProtectedClassCounts;
    /**
     * 
     * @type {OverviewTotalProtectedClassCounts}
     * @memberof OverviewOverviewListItem
     */
    'goalAttainmentAchieved': OverviewTotalProtectedClassCounts;
    /**
     * 
     * @type {OverviewTotalProtectedClassCounts}
     * @memberof OverviewOverviewListItem
     */
    'goalAttainmentNotAchieved': OverviewTotalProtectedClassCounts;
    /**
     * 
     * @type {OverviewTotalProtectedClassCounts}
     * @memberof OverviewOverviewListItem
     */
    'goalAttainmentLimited': OverviewTotalProtectedClassCounts;
    /**
     * 
     * @type {OverviewTotalProtectedClassCounts}
     * @memberof OverviewOverviewListItem
     */
    'goalAttainmentNoOpps': OverviewTotalProtectedClassCounts;
    /**
     * 
     * @type {OverviewTotalProtectedClassCounts}
     * @memberof OverviewOverviewListItem
     */
    'adverseImpact': OverviewTotalProtectedClassCounts;
    /**
     * 
     * @type {number}
     * @memberof OverviewOverviewListItem
     */
    'iwdJobGroupsMetPercent': number;
    /**
     * 
     * @type {boolean}
     * @memberof OverviewOverviewListItem
     */
    'pvMet': boolean;
    /**
     * 
     * @type {string}
     * @memberof OverviewOverviewListItem
     */
    'planDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OverviewOverviewListItem
     */
    'updatePlan': boolean;
}
/**
 * 
 * @export
 * @interface OverviewOverviewSectionSettingsDTO
 */
export interface OverviewOverviewSectionSettingsDTO {
    /**
     * 
     * @type {EnumerationsOverviewSection}
     * @memberof OverviewOverviewSectionSettingsDTO
     */
    'overviewSectionID': EnumerationsOverviewSection;
    /**
     * 
     * @type {boolean}
     * @memberof OverviewOverviewSectionSettingsDTO
     */
    'isSelected': boolean;
}


/**
 * 
 * @export
 * @interface OverviewPersonnelActivityCount
 */
export interface OverviewPersonnelActivityCount {
    /**
     * 
     * @type {string}
     * @memberof OverviewPersonnelActivityCount
     */
    'activity': string;
    /**
     * 
     * @type {OverviewTotalProtectedClassCounts}
     * @memberof OverviewPersonnelActivityCount
     */
    'counts': OverviewTotalProtectedClassCounts;
}
/**
 * 
 * @export
 * @interface OverviewSelectedActionTypesDTO
 */
export interface OverviewSelectedActionTypesDTO {
    /**
     * 
     * @type {string}
     * @memberof OverviewSelectedActionTypesDTO
     */
    'actionTypeName': string;
    /**
     * 
     * @type {boolean}
     * @memberof OverviewSelectedActionTypesDTO
     */
    'positive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OverviewSelectedActionTypesDTO
     */
    'isSelected': boolean;
}
/**
 * 
 * @export
 * @interface OverviewTotalProtectedClassCounts
 */
export interface OverviewTotalProtectedClassCounts {
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassCounts
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassCounts
     */
    'totalMinFemCount': number;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassCounts
     */
    'raceCount': number;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassCounts
     */
    'genderCount': number;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassCounts
     */
    'femCount': number;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassCounts
     */
    'minCount': number;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassCounts
     */
    'malCount': number;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassCounts
     */
    'asiCount': number;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassCounts
     */
    'blkCount': number;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassCounts
     */
    'hisCount': number;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassCounts
     */
    'indCount': number;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassCounts
     */
    'pacCount': number;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassCounts
     */
    'twoCount': number;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassCounts
     */
    'whtCount': number;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassCounts
     */
    'unkGenderCount': number;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassCounts
     */
    'unkRaceCount': number;
}
/**
 * 
 * @export
 * @interface OverviewTotalProtectedClassNullableCounts
 */
export interface OverviewTotalProtectedClassNullableCounts {
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassNullableCounts
     */
    'totalCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassNullableCounts
     */
    'totalMinFemCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassNullableCounts
     */
    'femCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassNullableCounts
     */
    'minCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassNullableCounts
     */
    'malCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassNullableCounts
     */
    'asiCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassNullableCounts
     */
    'blkCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassNullableCounts
     */
    'hisCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassNullableCounts
     */
    'indCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassNullableCounts
     */
    'pacCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassNullableCounts
     */
    'twoCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassNullableCounts
     */
    'whtCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassNullableCounts
     */
    'unkGenderCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OverviewTotalProtectedClassNullableCounts
     */
    'unkRaceCount'?: number | null;
}
/**
 * 
 * @export
 * @interface PlansLevelOfAnalysisDTO
 */
export interface PlansLevelOfAnalysisDTO {
    /**
     * 
     * @type {string}
     * @memberof PlansLevelOfAnalysisDTO
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PlansLevelOfAnalysisDTO
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof PlansLevelOfAnalysisDTO
     */
    'updatePlan': boolean;
    /**
     * 
     * @type {EnumerationsPlanType}
     * @memberof PlansLevelOfAnalysisDTO
     */
    'planType': EnumerationsPlanType;
    /**
     * 
     * @type {Array<PlansLevelOfAnalysisDTO>}
     * @memberof PlansLevelOfAnalysisDTO
     */
    'subPlans'?: Array<PlansLevelOfAnalysisDTO> | null;
}


/**
 * 
 * @export
 * @interface QueriesAdverseImpactLevel2DemographicCount
 */
export interface QueriesAdverseImpactLevel2DemographicCount {
    /**
     * 
     * @type {string}
     * @memberof QueriesAdverseImpactLevel2DemographicCount
     */
    'demographic': string;
    /**
     * 
     * @type {number}
     * @memberof QueriesAdverseImpactLevel2DemographicCount
     */
    'selectedCount': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesAdverseImpactLevel2DemographicCount
     */
    'nonSelectedCount': number;
    /**
     * 
     * @type {string}
     * @memberof QueriesAdverseImpactLevel2DemographicCount
     */
    'selectionRatio'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesAdverseImpactLevel2DemographicCount
     */
    'favoredGroup'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesAdverseImpactLevel2DemographicCount
     */
    'hasAdverseImpact': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesAdverseImpactLevel2DemographicCount
     */
    'hasSigAdverseImpact': boolean;
}
/**
 * 
 * @export
 * @interface QueriesAdverseImpactLevel2DemograpicCountByJobTitle
 */
export interface QueriesAdverseImpactLevel2DemograpicCountByJobTitle {
    /**
     * 
     * @type {string}
     * @memberof QueriesAdverseImpactLevel2DemograpicCountByJobTitle
     */
    'jobTitle': string;
    /**
     * 
     * @type {Array<QueriesAdverseImpactLevel2DemographicCount>}
     * @memberof QueriesAdverseImpactLevel2DemograpicCountByJobTitle
     */
    'demographicCounts': Array<QueriesAdverseImpactLevel2DemographicCount>;
}
/**
 * 
 * @export
 * @interface QueriesAdverseImpactPlanDropdownData
 */
export interface QueriesAdverseImpactPlanDropdownData {
    /**
     * 
     * @type {string}
     * @memberof QueriesAdverseImpactPlanDropdownData
     */
    'planID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesAdverseImpactPlanDropdownData
     */
    'establishment': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesAdverseImpactPlanDropdownData
     */
    'actionTypes': Array<string>;
}
/**
 * 
 * @export
 * @interface QueriesAlertUnreadAlerts
 */
export interface QueriesAlertUnreadAlerts {
    /**
     * 
     * @type {string}
     * @memberof QueriesAlertUnreadAlerts
     */
    'systemAlertID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesAlertUnreadAlerts
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesAlertUnreadAlerts
     */
    'body': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesAlertUnreadAlerts
     */
    'requireAcknowledgement': boolean;
}
/**
 * 
 * @export
 * @interface QueriesCalculateJobChangesByDropdownItem
 */
export interface QueriesCalculateJobChangesByDropdownItem {
    /**
     * 
     * @type {EnumerationsCalcType}
     * @memberof QueriesCalculateJobChangesByDropdownItem
     */
    'calcType': EnumerationsCalcType;
    /**
     * 
     * @type {string}
     * @memberof QueriesCalculateJobChangesByDropdownItem
     */
    'description': string;
}


/**
 * 
 * @export
 * @interface QueriesChildNavItemDTO
 */
export interface QueriesChildNavItemDTO {
    /**
     * 
     * @type {string}
     * @memberof QueriesChildNavItemDTO
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesChildNavItemDTO
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface QueriesDataVisualizationDTO
 */
export interface QueriesDataVisualizationDTO {
    /**
     * 
     * @type {string}
     * @memberof QueriesDataVisualizationDTO
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesDataVisualizationDTO
     */
    'name': string;
    /**
     * 
     * @type {EnumerationsDataVisualizationType}
     * @memberof QueriesDataVisualizationDTO
     */
    'dataVisualizationTypeID': EnumerationsDataVisualizationType;
}


/**
 * 
 * @export
 * @interface QueriesDemographicCountByEEOCode
 */
export interface QueriesDemographicCountByEEOCode {
    /**
     * 
     * @type {string}
     * @memberof QueriesDemographicCountByEEOCode
     */
    'eeoCode': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesDemographicCountByEEOCode
     */
    'eeoCodeDescription': string;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesDemographicCountByEEOCode
     */
    'demographicCounts': Array<DataVizDemographicCountDTO>;
}
/**
 * 
 * @export
 * @interface QueriesDemographicCountByEeoCode
 */
export interface QueriesDemographicCountByEeoCode {
    /**
     * 
     * @type {string}
     * @memberof QueriesDemographicCountByEeoCode
     */
    'eeoCode': string;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesDemographicCountByEeoCode
     */
    'demographicCounts': Array<DataVizDemographicCountDTO>;
}
/**
 * 
 * @export
 * @interface QueriesDemographicCountsByEeoCodeDTO
 */
export interface QueriesDemographicCountsByEeoCodeDTO {
    /**
     * 
     * @type {string}
     * @memberof QueriesDemographicCountsByEeoCodeDTO
     */
    'eeoCode': string;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesDemographicCountsByEeoCodeDTO
     */
    'demographicCounts': Array<DataVizDemographicCountDTO>;
}
/**
 * 
 * @export
 * @interface QueriesDispositionCountsByGenderResponse
 */
export interface QueriesDispositionCountsByGenderResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesDispositionCountsByGenderResponse
     */
    'dispCode': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesDispositionCountsByGenderResponse
     */
    'description': string;
    /**
     * 
     * @type {Array<ApplicantFlowApplicantFlowResultCount>}
     * @memberof QueriesDispositionCountsByGenderResponse
     */
    'resultCounts': Array<ApplicantFlowApplicantFlowResultCount>;
}
/**
 * 
 * @export
 * @interface QueriesDispositionCountsByRaceResponse
 */
export interface QueriesDispositionCountsByRaceResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesDispositionCountsByRaceResponse
     */
    'dispCode': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesDispositionCountsByRaceResponse
     */
    'description': string;
    /**
     * 
     * @type {Array<ApplicantFlowApplicantFlowResultCount>}
     * @memberof QueriesDispositionCountsByRaceResponse
     */
    'resultCounts': Array<ApplicantFlowApplicantFlowResultCount>;
}
/**
 * 
 * @export
 * @interface QueriesEmploymentByJobGroupForEeoByGenderView
 */
export interface QueriesEmploymentByJobGroupForEeoByGenderView {
    /**
     * 
     * @type {Array<QueriesGenderDataForJobGroup>}
     * @memberof QueriesEmploymentByJobGroupForEeoByGenderView
     */
    'employmentDataByGenderByJobGroup': Array<QueriesGenderDataForJobGroup>;
    /**
     * 
     * @type {string}
     * @memberof QueriesEmploymentByJobGroupForEeoByGenderView
     */
    'highestFemaleJobGroup': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesEmploymentByJobGroupForEeoByGenderView
     */
    'highestFemaleJobGroupName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesEmploymentByJobGroupForEeoByGenderView
     */
    'lowestFemaleJobGroup': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesEmploymentByJobGroupForEeoByGenderView
     */
    'lowestFemaleJobGroupName': string;
}
/**
 * 
 * @export
 * @interface QueriesEmploymentByJobGroupForEeoByRaceView
 */
export interface QueriesEmploymentByJobGroupForEeoByRaceView {
    /**
     * 
     * @type {Array<DataVizRaceDataForJobGroup>}
     * @memberof QueriesEmploymentByJobGroupForEeoByRaceView
     */
    'employmentDataByRaceByJobGroup': Array<DataVizRaceDataForJobGroup>;
    /**
     * 
     * @type {string}
     * @memberof QueriesEmploymentByJobGroupForEeoByRaceView
     */
    'highestMinorityJobGroup': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesEmploymentByJobGroupForEeoByRaceView
     */
    'highestMinorityJobGroupName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesEmploymentByJobGroupForEeoByRaceView
     */
    'lowestMinorityJobGroup': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesEmploymentByJobGroupForEeoByRaceView
     */
    'lowestMinorityJobGroupName': string;
}
/**
 * 
 * @export
 * @interface QueriesEmploymentByJobTitleForJobGroupByGender
 */
export interface QueriesEmploymentByJobTitleForJobGroupByGender {
    /**
     * 
     * @type {Array<QueriesGenderDataForJobTitle>}
     * @memberof QueriesEmploymentByJobTitleForJobGroupByGender
     */
    'employmentDataByGenderByJobTitle': Array<QueriesGenderDataForJobTitle>;
    /**
     * 
     * @type {string}
     * @memberof QueriesEmploymentByJobTitleForJobGroupByGender
     */
    'highestFemaleJobCode': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesEmploymentByJobTitleForJobGroupByGender
     */
    'lowestFemaleJobCode': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesEmploymentByJobTitleForJobGroupByGender
     */
    'highestFemaleJobTitle': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesEmploymentByJobTitleForJobGroupByGender
     */
    'lowestFemaleJobTitle': string;
}
/**
 * 
 * @export
 * @interface QueriesEmploymentByJobTitleForJobGroupByRace
 */
export interface QueriesEmploymentByJobTitleForJobGroupByRace {
    /**
     * 
     * @type {Array<DataVizRaceDataForJobTitle>}
     * @memberof QueriesEmploymentByJobTitleForJobGroupByRace
     */
    'employmentDataByRaceByJobTitle': Array<DataVizRaceDataForJobTitle>;
    /**
     * 
     * @type {string}
     * @memberof QueriesEmploymentByJobTitleForJobGroupByRace
     */
    'highestMinorityJobCode': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesEmploymentByJobTitleForJobGroupByRace
     */
    'lowestMinorityJobCode': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesEmploymentByJobTitleForJobGroupByRace
     */
    'highestMinorityJobTitle': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesEmploymentByJobTitleForJobGroupByRace
     */
    'lowestMinorityJobTitle': string;
}
/**
 * 
 * @export
 * @interface QueriesFileHistoryRecord
 */
export interface QueriesFileHistoryRecord {
    /**
     * 
     * @type {string}
     * @memberof QueriesFileHistoryRecord
     */
    'logDate': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesFileHistoryRecord
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesFileHistoryRecord
     */
    'userEmail': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesFileHistoryRecord
     */
    'action': string;
}
/**
 * 
 * @export
 * @interface QueriesGenderDataForJobGroup
 */
export interface QueriesGenderDataForJobGroup {
    /**
     * 
     * @type {string}
     * @memberof QueriesGenderDataForJobGroup
     */
    'jobGroup': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGenderDataForJobGroup
     */
    'jobGroupName': string;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGenderDataForJobGroup
     */
    'demographicCounts': Array<DataVizDemographicCountDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGenderDataForJobTitle
 */
export interface QueriesGenderDataForJobTitle {
    /**
     * 
     * @type {string}
     * @memberof QueriesGenderDataForJobTitle
     */
    'jobCode': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGenderDataForJobTitle
     */
    'jobTitle': string;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGenderDataForJobTitle
     */
    'demographicCounts': Array<DataVizDemographicCountDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetActionOrientedProgramGoalsResponse
 */
export interface QueriesGetActionOrientedProgramGoalsResponse {
    /**
     * 
     * @type {Array<TransferObjectsActionOrientedProgramGoalsDTO>}
     * @memberof QueriesGetActionOrientedProgramGoalsResponse
     */
    'actionOrientedProgramGoals': Array<TransferObjectsActionOrientedProgramGoalsDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetActionTypesForPlanResponse
 */
export interface QueriesGetActionTypesForPlanResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetActionTypesForPlanResponse
     */
    'actionTypes': Array<string>;
}
/**
 * 
 * @export
 * @interface QueriesGetActivityByActionByDemographicResponse
 */
export interface QueriesGetActivityByActionByDemographicResponse {
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetActivityByActionByDemographicResponse
     */
    'activities': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetActivityByActionByDemographicResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetActivityByActionByDemographicResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetActivityByActionByDemographicResponse
     */
    'tile3': DataVizDrilldownTileDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetActivityByActionByJobGroupForEEOResponse
 */
export interface QueriesGetActivityByActionByJobGroupForEEOResponse {
    /**
     * 
     * @type {Array<DataVizDemographicCountByJobGroup>}
     * @memberof QueriesGetActivityByActionByJobGroupForEEOResponse
     */
    'activities': Array<DataVizDemographicCountByJobGroup>;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetActivityByActionByJobGroupForEEOResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetActivityByActionByJobGroupForEEOResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetActivityByActionByJobGroupForEEOResponse
     */
    'tile3': DataVizDrilldownTileDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetActivityByActionByJobTitleForJobGroupResponse
 */
export interface QueriesGetActivityByActionByJobTitleForJobGroupResponse {
    /**
     * 
     * @type {Array<DataVizDemographicCountByJobTitle>}
     * @memberof QueriesGetActivityByActionByJobTitleForJobGroupResponse
     */
    'activities': Array<DataVizDemographicCountByJobTitle>;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetActivityByActionByJobTitleForJobGroupResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetActivityByActionByJobTitleForJobGroupResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetActivityByActionByJobTitleForJobGroupResponse
     */
    'tile3': DataVizDrilldownTileDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetAdminSystemAlertViewResponse
 */
export interface QueriesGetAdminSystemAlertViewResponse {
    /**
     * 
     * @type {number}
     * @memberof QueriesGetAdminSystemAlertViewResponse
     */
    'rowCount': number;
    /**
     * 
     * @type {Array<SystemAlertsSystemAlertAdminViewRecord>}
     * @memberof QueriesGetAdminSystemAlertViewResponse
     */
    'rows': Array<SystemAlertsSystemAlertAdminViewRecord>;
}
/**
 * 
 * @export
 * @interface QueriesGetAdverseImpactDataVisualizationResponse
 */
export interface QueriesGetAdverseImpactDataVisualizationResponse {
    /**
     * 
     * @type {DataVizGoalCountTile}
     * @memberof QueriesGetAdverseImpactDataVisualizationResponse
     */
    'totalAdverseImpactCount': DataVizGoalCountTile;
    /**
     * 
     * @type {DataVizGoalCountTile}
     * @memberof QueriesGetAdverseImpactDataVisualizationResponse
     */
    'totalMinCount': DataVizGoalCountTile;
    /**
     * 
     * @type {DataVizGoalCountTile}
     * @memberof QueriesGetAdverseImpactDataVisualizationResponse
     */
    'totalFemCount': DataVizGoalCountTile;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetAdverseImpactDataVisualizationResponse
     */
    'significantAIByRaceDonut': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetAdverseImpactDataVisualizationResponse
     */
    'significantAIByGenderDonut': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetAdverseImpactDataVisualizationResponse
     */
    'adverseIRARaceDonut': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetAdverseImpactDataVisualizationResponse
     */
    'adverseIRAGenderDonut': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetAdverseImpactDataVisualizationResponse
     */
    'favoredGroupRaceDonut': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetAdverseImpactDataVisualizationResponse
     */
    'favoredGroupGenderDonut': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<GoalEEOCodeBradyBunchResponse>}
     * @memberof QueriesGetAdverseImpactDataVisualizationResponse
     */
    'significantAIBradyBunchByRace': Array<GoalEEOCodeBradyBunchResponse>;
    /**
     * 
     * @type {Array<GoalEEOCodeBradyBunchResponse>}
     * @memberof QueriesGetAdverseImpactDataVisualizationResponse
     */
    'significantAIBradyBunchByGender': Array<GoalEEOCodeBradyBunchResponse>;
    /**
     * 
     * @type {Array<GoalEEOCodeBradyBunchResponse>}
     * @memberof QueriesGetAdverseImpactDataVisualizationResponse
     */
    'adverseIRABradyBunchByRace': Array<GoalEEOCodeBradyBunchResponse>;
    /**
     * 
     * @type {Array<GoalEEOCodeBradyBunchResponse>}
     * @memberof QueriesGetAdverseImpactDataVisualizationResponse
     */
    'adverseIRABradyBunchByGender': Array<GoalEEOCodeBradyBunchResponse>;
    /**
     * 
     * @type {Array<QueriesDemographicCountByEeoCode>}
     * @memberof QueriesGetAdverseImpactDataVisualizationResponse
     */
    'favoredGroupByRace': Array<QueriesDemographicCountByEeoCode>;
    /**
     * 
     * @type {Array<QueriesDemographicCountByEeoCode>}
     * @memberof QueriesGetAdverseImpactDataVisualizationResponse
     */
    'favoredGroupByGender': Array<QueriesDemographicCountByEeoCode>;
    /**
     * 
     * @type {Array<GoalMiniDonutsAdverseImpactResponse>}
     * @memberof QueriesGetAdverseImpactDataVisualizationResponse
     */
    'miniDonuts'?: Array<GoalMiniDonutsAdverseImpactResponse> | null;
}
/**
 * 
 * @export
 * @interface QueriesGetAdverseImpactDonutChartDrilldownDataResponse
 */
export interface QueriesGetAdverseImpactDonutChartDrilldownDataResponse {
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetAdverseImpactDonutChartDrilldownDataResponse
     */
    'adverseImpactByProtectedClassResult': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetAdverseImpactDonutChartDrilldownDataResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetAdverseImpactDonutChartDrilldownDataResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetAdverseImpactDonutChartDrilldownDataResponse
     */
    'tile3': DataVizDrilldownTileDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetAdverseImpactDrilldownByJobGroupForEEOResponse
 */
export interface QueriesGetAdverseImpactDrilldownByJobGroupForEEOResponse {
    /**
     * 
     * @type {Array<DataVizDemographicCountByJobGroup>}
     * @memberof QueriesGetAdverseImpactDrilldownByJobGroupForEEOResponse
     */
    'adverseImpactByProtectedClassByJobGroupResult': Array<DataVizDemographicCountByJobGroup>;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetAdverseImpactDrilldownByJobGroupForEEOResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetAdverseImpactDrilldownByJobGroupForEEOResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetAdverseImpactDrilldownByJobGroupForEEOResponse
     */
    'tile3': DataVizDrilldownTileDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetAdverseImpactLevel2DrilldownResponse
 */
export interface QueriesGetAdverseImpactLevel2DrilldownResponse {
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetAdverseImpactLevel2DrilldownResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetAdverseImpactLevel2DrilldownResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetAdverseImpactLevel2DrilldownResponse
     */
    'tile3': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {Array<QueriesAdverseImpactLevel2DemograpicCountByJobTitle>}
     * @memberof QueriesGetAdverseImpactLevel2DrilldownResponse
     */
    'demographicCounts': Array<QueriesAdverseImpactLevel2DemograpicCountByJobTitle>;
}
/**
 * 
 * @export
 * @interface QueriesGetAlertDetailsForAdminResponse
 */
export interface QueriesGetAlertDetailsForAdminResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAlertDetailsForAdminResponse
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAlertDetailsForAdminResponse
     */
    'htmlBody': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAlertDetailsForAdminResponse
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAlertDetailsForAdminResponse
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {Array<SystemAlertsSystemAlertReceivingClientDTO>}
     * @memberof QueriesGetAlertDetailsForAdminResponse
     */
    'clients': Array<SystemAlertsSystemAlertReceivingClientDTO>;
    /**
     * 
     * @type {EnumerationsSystemAlertLabelType}
     * @memberof QueriesGetAlertDetailsForAdminResponse
     */
    'clientNamesLabelTypeID': EnumerationsSystemAlertLabelType;
    /**
     * 
     * @type {Array<SystemAlertsSystemAlertReceivingServiceDTO>}
     * @memberof QueriesGetAlertDetailsForAdminResponse
     */
    'serviceLines': Array<SystemAlertsSystemAlertReceivingServiceDTO>;
    /**
     * 
     * @type {EnumerationsSystemAlertLabelType}
     * @memberof QueriesGetAlertDetailsForAdminResponse
     */
    'serviceLinesLabelTypeID': EnumerationsSystemAlertLabelType;
    /**
     * 
     * @type {Array<SystemAlertsSystemAlertReceivingRoleDTO>}
     * @memberof QueriesGetAlertDetailsForAdminResponse
     */
    'roles': Array<SystemAlertsSystemAlertReceivingRoleDTO>;
    /**
     * 
     * @type {EnumerationsSystemAlertLabelType}
     * @memberof QueriesGetAlertDetailsForAdminResponse
     */
    'rolesLabelTypeID': EnumerationsSystemAlertLabelType;
    /**
     * 
     * @type {EnumerationsRecurringInterval}
     * @memberof QueriesGetAlertDetailsForAdminResponse
     */
    'recurringIntervalID': EnumerationsRecurringInterval;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetAlertDetailsForAdminResponse
     */
    'requireAcknowledgement': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetAlertDetailsForAdminResponse
     */
    'hasBeenViewed': boolean;
    /**
     * 
     * @type {EnumerationsSystemAlertActiveStatus}
     * @memberof QueriesGetAlertDetailsForAdminResponse
     */
    'activeStatus': EnumerationsSystemAlertActiveStatus;
}


/**
 * 
 * @export
 * @interface QueriesGetAlertInfoResponse
 */
export interface QueriesGetAlertInfoResponse {
    /**
     * 
     * @type {number}
     * @memberof QueriesGetAlertInfoResponse
     */
    'viewedCount': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetAlertInfoResponse
     */
    'totalUserCount': number;
    /**
     * 
     * @type {Array<SystemAlertsSystemAlertByClientCountDTO>}
     * @memberof QueriesGetAlertInfoResponse
     */
    'clients': Array<SystemAlertsSystemAlertByClientCountDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetApplicantFlowVisualizationResponse
 */
export interface QueriesGetApplicantFlowVisualizationResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'applicantReportID': string;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'totalApplicantsTile': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'totalSelectionsTile': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'totalHiresTile': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'totalExclusionsTile': number;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'totalApplicantsByRace': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'totalApplicantsByIndividualRace': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'totalApplicantsByGender': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'totalSelectionsByRace': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'totalSelectionsByIndividualRace': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'totalSelectionsByGender': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'totalExclusionsByRace': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'totalExclusionsByIndividualRace': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'totalExclusionsByGender': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<QueriesDemographicCountByEEOCode>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'applicantsByEEOByRace': Array<QueriesDemographicCountByEEOCode>;
    /**
     * 
     * @type {Array<QueriesDemographicCountByEEOCode>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'applicantsByEEOByIndividualRace': Array<QueriesDemographicCountByEEOCode>;
    /**
     * 
     * @type {Array<QueriesDemographicCountByEEOCode>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'applicantsByEEOByGender': Array<QueriesDemographicCountByEEOCode>;
    /**
     * 
     * @type {Array<QueriesDemographicCountByEEOCode>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'selectionsByEEOByRace': Array<QueriesDemographicCountByEEOCode>;
    /**
     * 
     * @type {Array<QueriesDemographicCountByEEOCode>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'selectionsByEEOByIndividualRace': Array<QueriesDemographicCountByEEOCode>;
    /**
     * 
     * @type {Array<QueriesDemographicCountByEEOCode>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'selectionsByEEOByGender': Array<QueriesDemographicCountByEEOCode>;
    /**
     * 
     * @type {Array<QueriesDemographicCountByEEOCode>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'exclusionsByEEOByRace': Array<QueriesDemographicCountByEEOCode>;
    /**
     * 
     * @type {Array<QueriesDemographicCountByEEOCode>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'exclusionsByEEOByIndividualRace': Array<QueriesDemographicCountByEEOCode>;
    /**
     * 
     * @type {Array<QueriesDemographicCountByEEOCode>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'exclusionsByEEOByGender': Array<QueriesDemographicCountByEEOCode>;
    /**
     * 
     * @type {Array<DataVizDemographicInfoByPlanDTO>}
     * @memberof QueriesGetApplicantFlowVisualizationResponse
     */
    'demographicInfoByPlanMiniDonuts': Array<DataVizDemographicInfoByPlanDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetApplicantsByDemographicDrilldownResponse
 */
export interface QueriesGetApplicantsByDemographicDrilldownResponse {
    /**
     * 
     * @type {Array<DataVizDemographicCountByCalcTypeDTO>}
     * @memberof QueriesGetApplicantsByDemographicDrilldownResponse
     */
    'demographicCounts': Array<DataVizDemographicCountByCalcTypeDTO>;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetApplicantsByDemographicDrilldownResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetApplicantsByDemographicDrilldownResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetApplicantsByDemographicDrilldownResponse
     */
    'tile3': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetApplicantsByDemographicDrilldownResponse
     */
    'totalApplicants': number;
}
/**
 * 
 * @export
 * @interface QueriesGetApplicantsByJobGroupForEEOByDemographicDrilldownResponse
 */
export interface QueriesGetApplicantsByJobGroupForEEOByDemographicDrilldownResponse {
    /**
     * 
     * @type {Array<DataVizDemographicCountByJobGroup>}
     * @memberof QueriesGetApplicantsByJobGroupForEEOByDemographicDrilldownResponse
     */
    'applicantsDrilldownCountsByJobGroupForEEO': Array<DataVizDemographicCountByJobGroup>;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetApplicantsByJobGroupForEEOByDemographicDrilldownResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetApplicantsByJobGroupForEEOByDemographicDrilldownResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetApplicantsByJobGroupForEEOByDemographicDrilldownResponse
     */
    'tile3': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetApplicantsByJobGroupForEEOByDemographicDrilldownResponse
     */
    'totalApplicantsCount': number;
}
/**
 * 
 * @export
 * @interface QueriesGetApplicantsByJobTitleForJobGroupByDemographicDrilldownResponse
 */
export interface QueriesGetApplicantsByJobTitleForJobGroupByDemographicDrilldownResponse {
    /**
     * 
     * @type {Array<DataVizDemographicCountByJobTitle>}
     * @memberof QueriesGetApplicantsByJobTitleForJobGroupByDemographicDrilldownResponse
     */
    'applicantsDrilldownCountsByJobTitleForJobGroup': Array<DataVizDemographicCountByJobTitle>;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetApplicantsByJobTitleForJobGroupByDemographicDrilldownResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetApplicantsByJobTitleForJobGroupByDemographicDrilldownResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetApplicantsByJobTitleForJobGroupByDemographicDrilldownResponse
     */
    'tile3': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetApplicantsByJobTitleForJobGroupByDemographicDrilldownResponse
     */
    'totalApplicantsCount': number;
}
/**
 * 
 * @export
 * @interface QueriesGetAuditDetailsResponse
 */
export interface QueriesGetAuditDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAuditDetailsResponse
     */
    'clientID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAuditDetailsResponse
     */
    'location': string;
    /**
     * 
     * @type {EnumerationsAuditStatus}
     * @memberof QueriesGetAuditDetailsResponse
     */
    'auditStatus': EnumerationsAuditStatus;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAuditDetailsResponse
     */
    'snapshotDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAuditDetailsResponse
     */
    'dateContactedByCO'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAuditDetailsResponse
     */
    'dateReceivedAuditLetter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAuditDetailsResponse
     */
    'dueDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAuditDetailsResponse
     */
    'coid': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAuditDetailsResponse
     */
    'ofccpOffice': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAuditDetailsResponse
     */
    'primaryContact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAuditDetailsResponse
     */
    'secondaryContact'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAuditDetailsResponse
     */
    'notes': string;
}


/**
 * 
 * @export
 * @interface QueriesGetAuditsResponse
 */
export interface QueriesGetAuditsResponse {
    /**
     * 
     * @type {Array<TransferObjectsAuditLocationsDTO>}
     * @memberof QueriesGetAuditsResponse
     */
    'audits': Array<TransferObjectsAuditLocationsDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetAuditsResponse
     */
    'activeAudits': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetAuditsResponse
     */
    'expectedAudits': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetAuditsResponse
     */
    'overdueAudits': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetAuditsResponse
     */
    'closedAudits': number;
}
/**
 * 
 * @export
 * @interface QueriesGetChecklistResponse
 */
export interface QueriesGetChecklistResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetChecklistResponse
     */
    'location': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetChecklistResponse
     */
    'dueDate'?: string | null;
    /**
     * 
     * @type {EnumerationsAuditStatus}
     * @memberof QueriesGetChecklistResponse
     */
    'auditStatusID': EnumerationsAuditStatus;
    /**
     * 
     * @type {Array<TransferObjectsAuditChecklistItemDTO>}
     * @memberof QueriesGetChecklistResponse
     */
    'checklistItems': Array<TransferObjectsAuditChecklistItemDTO>;
}


/**
 * 
 * @export
 * @interface QueriesGetChecklistsResponse
 */
export interface QueriesGetChecklistsResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetChecklistsResponse
     */
    'planDate': string;
    /**
     * 
     * @type {Array<TransferObjectsComplianceChecklistDTO>}
     * @memberof QueriesGetChecklistsResponse
     */
    'checklists': Array<TransferObjectsComplianceChecklistDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetChecklistsResponse
     */
    'totalItems': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetChecklistsResponse
     */
    'completedItems': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetChecklistsResponse
     */
    'pendingItems': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetChecklistsResponse
     */
    'proactiveItems': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetChecklistsResponse
     */
    'pastDueItems': number;
}
/**
 * 
 * @export
 * @interface QueriesGetCompProfilesResponse
 */
export interface QueriesGetCompProfilesResponse {
    /**
     * 
     * @type {number}
     * @memberof QueriesGetCompProfilesResponse
     */
    'rowCount': number;
    /**
     * 
     * @type {Array<QueriesGetCompProfilesRow>}
     * @memberof QueriesGetCompProfilesResponse
     */
    'rows': Array<QueriesGetCompProfilesRow>;
}
/**
 * 
 * @export
 * @interface QueriesGetCompProfilesRow
 */
export interface QueriesGetCompProfilesRow {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetCompProfilesRow
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetCompProfilesRow
     */
    'dateCreated': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetCompProfilesRow
     */
    'analysisName': string;
}
/**
 * 
 * @export
 * @interface QueriesGetDispositionDrilldownByGenderByJobGroupResponse
 */
export interface QueriesGetDispositionDrilldownByGenderByJobGroupResponse {
    /**
     * 
     * @type {Array<ApplicantFlowDispositionCountsByRaceGenderDTO>}
     * @memberof QueriesGetDispositionDrilldownByGenderByJobGroupResponse
     */
    'dispositionByGenderByJobGroupResult': Array<ApplicantFlowDispositionCountsByRaceGenderDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetDispositionDrilldownByGenderByJobGroupResponse
     */
    'totalGroupWithDispositionTile': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetDispositionDrilldownByGenderByJobGroupResponse
     */
    'percentOfFemApplicantsWithDisposition': number;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownByGenderByJobGroupResponse
     */
    'jobGroupWithHighestFemUseOfDispositionTile': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownByGenderByJobGroupResponse
     */
    'jobGroupDescriptionWithHighestFemUseOfDispositionTile': string;
}
/**
 * 
 * @export
 * @interface QueriesGetDispositionDrilldownByGenderByJobTitleResponse
 */
export interface QueriesGetDispositionDrilldownByGenderByJobTitleResponse {
    /**
     * 
     * @type {Array<ApplicantFlowDispositionCountsByRaceGenderDTO>}
     * @memberof QueriesGetDispositionDrilldownByGenderByJobTitleResponse
     */
    'dispositionByGenderByJobTitleResult': Array<ApplicantFlowDispositionCountsByRaceGenderDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetDispositionDrilldownByGenderByJobTitleResponse
     */
    'totalGroupWithDispositionTile': number;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownByGenderByJobTitleResponse
     */
    'groupWithDispositionUsedMostTile': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownByGenderByJobTitleResponse
     */
    'groupDescriptionWithDispositionUsedMost': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownByGenderByJobTitleResponse
     */
    'groupWithDispositionUsedLeastTile': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownByGenderByJobTitleResponse
     */
    'groupDescriptionWithDispositionUsedLeast': string;
}
/**
 * 
 * @export
 * @interface QueriesGetDispositionDrilldownByRaceByJobGroupResponse
 */
export interface QueriesGetDispositionDrilldownByRaceByJobGroupResponse {
    /**
     * 
     * @type {Array<ApplicantFlowDispositionCountsByRaceGenderDTO>}
     * @memberof QueriesGetDispositionDrilldownByRaceByJobGroupResponse
     */
    'dispositionByRaceByJobGroupResult': Array<ApplicantFlowDispositionCountsByRaceGenderDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetDispositionDrilldownByRaceByJobGroupResponse
     */
    'totalGroupWithDispositionTile': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetDispositionDrilldownByRaceByJobGroupResponse
     */
    'percentageOfMinorityAppsWithDispositionTile': number;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownByRaceByJobGroupResponse
     */
    'jobGroupWithHighestMinAppsWithDisposition': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownByRaceByJobGroupResponse
     */
    'jobGroupDescriptionWithHighestMinAppsWithDisposition': string;
}
/**
 * 
 * @export
 * @interface QueriesGetDispositionDrilldownByRaceByJobTitleResponse
 */
export interface QueriesGetDispositionDrilldownByRaceByJobTitleResponse {
    /**
     * 
     * @type {Array<ApplicantFlowDispositionCountsByRaceGenderDTO>}
     * @memberof QueriesGetDispositionDrilldownByRaceByJobTitleResponse
     */
    'dispositionByRaceByJobTitleResult': Array<ApplicantFlowDispositionCountsByRaceGenderDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetDispositionDrilldownByRaceByJobTitleResponse
     */
    'totalGroupWithDispositionTile': number;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownByRaceByJobTitleResponse
     */
    'groupWithDispositionUsedMostTile': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownByRaceByJobTitleResponse
     */
    'groupDescriptionWithDispositionUsedMost': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownByRaceByJobTitleResponse
     */
    'groupWithDispositionUsedLeastTile': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownByRaceByJobTitleResponse
     */
    'groupDescriptionWithDispositionUsedLeast': string;
}
/**
 * 
 * @export
 * @interface QueriesGetDispositionDrilldownOverallByJobGroupResponse
 */
export interface QueriesGetDispositionDrilldownOverallByJobGroupResponse {
    /**
     * 
     * @type {Array<ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO>}
     * @memberof QueriesGetDispositionDrilldownOverallByJobGroupResponse
     */
    'dispositionOverallByJobGroupResult': Array<ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetDispositionDrilldownOverallByJobGroupResponse
     */
    'totalGroupWithDispositionTile': number;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownOverallByJobGroupResponse
     */
    'groupWithDispositionUsedMostTile': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownOverallByJobGroupResponse
     */
    'groupDescriptionWithDispositionUsedMost': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownOverallByJobGroupResponse
     */
    'groupWithDispositionUsedLeastTile': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownOverallByJobGroupResponse
     */
    'groupDescriptionWithDispositionUsedLeast': string;
}
/**
 * 
 * @export
 * @interface QueriesGetDispositionDrilldownOverallByJobTitleResponse
 */
export interface QueriesGetDispositionDrilldownOverallByJobTitleResponse {
    /**
     * 
     * @type {Array<ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO>}
     * @memberof QueriesGetDispositionDrilldownOverallByJobTitleResponse
     */
    'dispositionOverallByJobTitleResult': Array<ApplicantFlowApplicantFlowOverallByGroupForDispositionDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetDispositionDrilldownOverallByJobTitleResponse
     */
    'totalGroupWithDispositionTile': number;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownOverallByJobTitleResponse
     */
    'groupWithDispositionUsedMostTile': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownOverallByJobTitleResponse
     */
    'groupDescriptionWithDispositionUsedMost': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownOverallByJobTitleResponse
     */
    'groupWithDispositionUsedLeastTile': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetDispositionDrilldownOverallByJobTitleResponse
     */
    'groupDescriptionWithDispositionUsedLeast': string;
}
/**
 * 
 * @export
 * @interface QueriesGetDocumentUploadCountsResponse
 */
export interface QueriesGetDocumentUploadCountsResponse {
    /**
     * 
     * @type {TransferObjectsDocumentUploadCountsDTO}
     * @memberof QueriesGetDocumentUploadCountsResponse
     */
    'getDocumentUploadCountsDTO': TransferObjectsDocumentUploadCountsDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetDocumentUploadsResponse
 */
export interface QueriesGetDocumentUploadsResponse {
    /**
     * 
     * @type {Array<TransferObjectsGetDocumentUploadDTO>}
     * @memberof QueriesGetDocumentUploadsResponse
     */
    'getDocumentUploadDTOs': Array<TransferObjectsGetDocumentUploadDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetEmploymentByDemographicDrilldownResponse
 */
export interface QueriesGetEmploymentByDemographicDrilldownResponse {
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetEmploymentByDemographicDrilldownResponse
     */
    'races': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetEmploymentByDemographicDrilldownResponse
     */
    'genders': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetEmploymentByDemographicDrilldownResponse
     */
    'employeeCount': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetEmploymentByDemographicDrilldownResponse
     */
    'femaleCount': number;
}
/**
 * 
 * @export
 * @interface QueriesGetEmploymentByIWDDrilldownResponse
 */
export interface QueriesGetEmploymentByIWDDrilldownResponse {
    /**
     * 
     * @type {DataVizCountPercentDTO}
     * @memberof QueriesGetEmploymentByIWDDrilldownResponse
     */
    'iwdCount': DataVizCountPercentDTO;
    /**
     * 
     * @type {DataVizCountPercentDTO}
     * @memberof QueriesGetEmploymentByIWDDrilldownResponse
     */
    'notIWDCount': DataVizCountPercentDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetEmploymentByIWDDrilldownResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetEmploymentByIWDDrilldownResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetEmploymentByIWDDrilldownResponse
     */
    'tile3': DataVizDrilldownTileDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetEmploymentByJobGroupByIWDDrilldownResponse
 */
export interface QueriesGetEmploymentByJobGroupByIWDDrilldownResponse {
    /**
     * 
     * @type {Array<DataVizNullableCountPercentByEntity>}
     * @memberof QueriesGetEmploymentByJobGroupByIWDDrilldownResponse
     */
    'iwdByJobGroups': Array<DataVizNullableCountPercentByEntity>;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetEmploymentByJobGroupByIWDDrilldownResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetEmploymentByJobGroupByIWDDrilldownResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetEmploymentByJobGroupByIWDDrilldownResponse
     */
    'tile3': DataVizDrilldownTileDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetEmploymentByJobGroupByProtectedVeteranDrilldownResponse
 */
export interface QueriesGetEmploymentByJobGroupByProtectedVeteranDrilldownResponse {
    /**
     * 
     * @type {Array<DataVizNullableCountPercentByEntity>}
     * @memberof QueriesGetEmploymentByJobGroupByProtectedVeteranDrilldownResponse
     */
    'protectedVeteranByJobGroups': Array<DataVizNullableCountPercentByEntity>;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetEmploymentByJobGroupByProtectedVeteranDrilldownResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetEmploymentByJobGroupByProtectedVeteranDrilldownResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetEmploymentByJobGroupByProtectedVeteranDrilldownResponse
     */
    'tile3': DataVizDrilldownTileDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetEmploymentByJobGroupForEeoDrilldownResponse
 */
export interface QueriesGetEmploymentByJobGroupForEeoDrilldownResponse {
    /**
     * 
     * @type {QueriesEmploymentByJobGroupForEeoByRaceView}
     * @memberof QueriesGetEmploymentByJobGroupForEeoDrilldownResponse
     */
    'employmentByRace': QueriesEmploymentByJobGroupForEeoByRaceView;
    /**
     * 
     * @type {QueriesEmploymentByJobGroupForEeoByGenderView}
     * @memberof QueriesGetEmploymentByJobGroupForEeoDrilldownResponse
     */
    'employmentByGender': QueriesEmploymentByJobGroupForEeoByGenderView;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetEmploymentByJobGroupForEeoDrilldownResponse
     */
    'numJobGroupsForEEO': number;
}
/**
 * 
 * @export
 * @interface QueriesGetEmploymentByJobTitleForJobGroupByDemographicDrilldownResponse
 */
export interface QueriesGetEmploymentByJobTitleForJobGroupByDemographicDrilldownResponse {
    /**
     * 
     * @type {QueriesEmploymentByJobTitleForJobGroupByRace}
     * @memberof QueriesGetEmploymentByJobTitleForJobGroupByDemographicDrilldownResponse
     */
    'employmentByRace': QueriesEmploymentByJobTitleForJobGroupByRace;
    /**
     * 
     * @type {QueriesEmploymentByJobTitleForJobGroupByGender}
     * @memberof QueriesGetEmploymentByJobTitleForJobGroupByDemographicDrilldownResponse
     */
    'employmentByGender': QueriesEmploymentByJobTitleForJobGroupByGender;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetEmploymentByJobTitleForJobGroupByDemographicDrilldownResponse
     */
    'jobTitleCount': number;
}
/**
 * 
 * @export
 * @interface QueriesGetEmploymentByProtectedVeteranDrilldownResponse
 */
export interface QueriesGetEmploymentByProtectedVeteranDrilldownResponse {
    /**
     * 
     * @type {DataVizCountPercentDTO}
     * @memberof QueriesGetEmploymentByProtectedVeteranDrilldownResponse
     */
    'pvCount': DataVizCountPercentDTO;
    /**
     * 
     * @type {DataVizCountPercentDTO}
     * @memberof QueriesGetEmploymentByProtectedVeteranDrilldownResponse
     */
    'notPVCount': DataVizCountPercentDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetEmploymentByProtectedVeteranDrilldownResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetEmploymentByProtectedVeteranDrilldownResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetEmploymentByProtectedVeteranDrilldownResponse
     */
    'tile3': DataVizDrilldownTileDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetEmploymentVisualizationResponse
 */
export interface QueriesGetEmploymentVisualizationResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetEmploymentVisualizationResponse
     */
    'jobAnalysisAAPReport2ClientID': string;
    /**
     * 
     * @type {DataVizGoalCountTile}
     * @memberof QueriesGetEmploymentVisualizationResponse
     */
    'totalEmployeesCountTile': DataVizGoalCountTile;
    /**
     * 
     * @type {DataVizGoalCountTile}
     * @memberof QueriesGetEmploymentVisualizationResponse
     */
    'totalMinoritiesCountTile': DataVizGoalCountTile;
    /**
     * 
     * @type {DataVizGoalCountTile}
     * @memberof QueriesGetEmploymentVisualizationResponse
     */
    'totalFemalesCountTile': DataVizGoalCountTile;
    /**
     * 
     * @type {QueriesOverallEmploymentByDemographicGraph}
     * @memberof QueriesGetEmploymentVisualizationResponse
     */
    'overallEmploymentByRaceGraph': QueriesOverallEmploymentByDemographicGraph;
    /**
     * 
     * @type {QueriesOverallEmploymentByDemographicGraph}
     * @memberof QueriesGetEmploymentVisualizationResponse
     */
    'overallEmploymentByGenderGraph': QueriesOverallEmploymentByDemographicGraph;
    /**
     * 
     * @type {QueriesOverallEmploymentByEeoByDemographicGraph}
     * @memberof QueriesGetEmploymentVisualizationResponse
     */
    'overallEmploymentByEeoByRaceGraph': QueriesOverallEmploymentByEeoByDemographicGraph;
    /**
     * 
     * @type {QueriesOverallEmploymentByEeoByDemographicGraph}
     * @memberof QueriesGetEmploymentVisualizationResponse
     */
    'overallEmploymentByEeoByGenderGraph': QueriesOverallEmploymentByEeoByDemographicGraph;
    /**
     * 
     * @type {Array<TransferObjectsDemographicByPlanDTO>}
     * @memberof QueriesGetEmploymentVisualizationResponse
     */
    'demographicByPlan': Array<TransferObjectsDemographicByPlanDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetExclusionsByDemographicDrilldownResponse
 */
export interface QueriesGetExclusionsByDemographicDrilldownResponse {
    /**
     * 
     * @type {Array<DataVizDemographicCountByCalcTypeDTO>}
     * @memberof QueriesGetExclusionsByDemographicDrilldownResponse
     */
    'demographicCounts': Array<DataVizDemographicCountByCalcTypeDTO>;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetExclusionsByDemographicDrilldownResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetExclusionsByDemographicDrilldownResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetExclusionsByDemographicDrilldownResponse
     */
    'tile3': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetExclusionsByDemographicDrilldownResponse
     */
    'totalApplicants': number;
}
/**
 * 
 * @export
 * @interface QueriesGetExportSettingsResponse
 */
export interface QueriesGetExportSettingsResponse {
    /**
     * 
     * @type {EnumerationsExportFormat}
     * @memberof QueriesGetExportSettingsResponse
     */
    'exportFormatID': EnumerationsExportFormat;
    /**
     * 
     * @type {EnumerationsExportType}
     * @memberof QueriesGetExportSettingsResponse
     */
    'exportTypeID': EnumerationsExportType;
}


/**
 * 
 * @export
 * @interface QueriesGetFileHistoryResponse
 */
export interface QueriesGetFileHistoryResponse {
    /**
     * 
     * @type {number}
     * @memberof QueriesGetFileHistoryResponse
     */
    'rowCount': number;
    /**
     * 
     * @type {Array<QueriesFileHistoryRecord>}
     * @memberof QueriesGetFileHistoryResponse
     */
    'fileHistoryRecords': Array<QueriesFileHistoryRecord>;
}
/**
 * 
 * @export
 * @interface QueriesGetGFEAssessmentData
 */
export interface QueriesGetGFEAssessmentData {
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGFEAssessmentData
     */
    'totalEntries': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGFEAssessmentData
     */
    'averageRating'?: number | null;
    /**
     * 
     * @type {Array<GFEGFECriteriaDTO>}
     * @memberof QueriesGetGFEAssessmentData
     */
    'criteria': Array<GFEGFECriteriaDTO>;
    /**
     * 
     * @type {Array<GFEGFEEffortsByActivityDTO>}
     * @memberof QueriesGetGFEAssessmentData
     */
    'effortsByActivity': Array<GFEGFEEffortsByActivityDTO>;
    /**
     * 
     * @type {Array<GFEGFEEffortsBySourceDTO>}
     * @memberof QueriesGetGFEAssessmentData
     */
    'effortsBySource': Array<GFEGFEEffortsBySourceDTO>;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetGFEAssessmentData
     */
    'evaluationDetail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetGFEAssessmentData
     */
    'actionPlan'?: string | null;
}
/**
 * 
 * @export
 * @interface QueriesGetGFEAssessmentResponse
 */
export interface QueriesGetGFEAssessmentResponse {
    /**
     * 
     * @type {QueriesGetGFEAssessmentData}
     * @memberof QueriesGetGFEAssessmentResponse
     */
    'protectedVeteranData': QueriesGetGFEAssessmentData;
    /**
     * 
     * @type {QueriesGetGFEAssessmentData}
     * @memberof QueriesGetGFEAssessmentResponse
     */
    'individualsWithDisabilitiesData': QueriesGetGFEAssessmentData;
    /**
     * 
     * @type {Array<GFEGFEFieldsDTO>}
     * @memberof QueriesGetGFEAssessmentResponse
     */
    'fields': Array<GFEGFEFieldsDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetGlobalReportSettingsResponse
 */
export interface QueriesGetGlobalReportSettingsResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetGlobalReportSettingsResponse
     */
    'planID': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetGlobalReportSettingsResponse
     */
    'suppressStatisticalSignificanceFootnotes': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetGlobalReportSettingsResponse
     */
    'includeDateFooter': boolean;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetGlobalReportSettingsResponse
     */
    'customFooter': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetGlobalReportSettingsResponse
     */
    'includePageNumbers': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetGlobalReportSettingsResponse
     */
    'includeBookmarks': boolean;
    /**
     * 
     * @type {Array<TransferObjectsFeature2ComplianceTypeDTO>}
     * @memberof QueriesGetGlobalReportSettingsResponse
     */
    'featurePermissions': Array<TransferObjectsFeature2ComplianceTypeDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetGoalAttainmentByJobGroupForEeoResponse
 */
export interface QueriesGetGoalAttainmentByJobGroupForEeoResponse {
    /**
     * 
     * @type {Array<QueriesResultCountByJobGroup>}
     * @memberof QueriesGetGoalAttainmentByJobGroupForEeoResponse
     */
    'goalAttainmentDrilldownCountsByJobGroupForEeo': Array<QueriesResultCountByJobGroup>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGoalAttainmentByJobGroupForEeoResponse
     */
    'totalAchieved': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGoalAttainmentByJobGroupForEeoResponse
     */
    'totalNotAchieved': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGoalAttainmentByJobGroupForEeoResponse
     */
    'totalLimited': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGoalAttainmentByJobGroupForEeoResponse
     */
    'totalNoOpps': number;
}
/**
 * 
 * @export
 * @interface QueriesGetGoalAttainmentByJobGroupResponse
 */
export interface QueriesGetGoalAttainmentByJobGroupResponse {
    /**
     * 
     * @type {Array<GoalAttainmentDemographicResultCountDTO>}
     * @memberof QueriesGetGoalAttainmentByJobGroupResponse
     */
    'goalAttainmentCountsByJobGroup': Array<GoalAttainmentDemographicResultCountDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGoalAttainmentByJobGroupResponse
     */
    'totalAchieved': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGoalAttainmentByJobGroupResponse
     */
    'totalNotAchieved': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGoalAttainmentByJobGroupResponse
     */
    'totalLimited': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGoalAttainmentByJobGroupResponse
     */
    'totalNoOpps': number;
}
/**
 * 
 * @export
 * @interface QueriesGetGoalAttainmentDonutChartDrilldownLevel1Response
 */
export interface QueriesGetGoalAttainmentDonutChartDrilldownLevel1Response {
    /**
     * 
     * @type {Array<GoalAttainmentGoalAttainmentResultCount>}
     * @memberof QueriesGetGoalAttainmentDonutChartDrilldownLevel1Response
     */
    'goalAttainmentDrilldownTotalGoalsTiles': Array<GoalAttainmentGoalAttainmentResultCount>;
    /**
     * 
     * @type {Array<GoalAttainmentGoalAttainmentResultCount>}
     * @memberof QueriesGetGoalAttainmentDonutChartDrilldownLevel1Response
     */
    'goalAttainmentDrilldownByTotalMinorities': Array<GoalAttainmentGoalAttainmentResultCount>;
    /**
     * 
     * @type {Array<GoalAttainmentGoalAttainmentResultCount>}
     * @memberof QueriesGetGoalAttainmentDonutChartDrilldownLevel1Response
     */
    'goalAttainmentDrilldownByGender': Array<GoalAttainmentGoalAttainmentResultCount>;
    /**
     * 
     * @type {Array<QueriesResultCountByRace>}
     * @memberof QueriesGetGoalAttainmentDonutChartDrilldownLevel1Response
     */
    'goalAttainmentDrilldownByIndividualRaces': Array<QueriesResultCountByRace>;
}
/**
 * 
 * @export
 * @interface QueriesGetGoalAttainmentVisualizationResponse
 */
export interface QueriesGetGoalAttainmentVisualizationResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetGoalAttainmentVisualizationResponse
     */
    'goalAttainmentReportID': string;
    /**
     * 
     * @type {Array<GoalAttainmentGoalAttainmentResultCount>}
     * @memberof QueriesGetGoalAttainmentVisualizationResponse
     */
    'goalAttainmentTileCountsByTotalMinorities': Array<GoalAttainmentGoalAttainmentResultCount>;
    /**
     * 
     * @type {Array<GoalAttainmentGoalAttainmentResultCount>}
     * @memberof QueriesGetGoalAttainmentVisualizationResponse
     */
    'goalAttainmentTileCountsByIndividualRaces': Array<GoalAttainmentGoalAttainmentResultCount>;
    /**
     * 
     * @type {Array<QueriesResultCountByPlan>}
     * @memberof QueriesGetGoalAttainmentVisualizationResponse
     */
    'goalAttainmentByPlanForTotalMinorities': Array<QueriesResultCountByPlan>;
    /**
     * 
     * @type {Array<QueriesResultCountByPlan>}
     * @memberof QueriesGetGoalAttainmentVisualizationResponse
     */
    'goalAttainmentByPlanForGender': Array<QueriesResultCountByPlan>;
    /**
     * 
     * @type {Array<QueriesResultCountByPlan>}
     * @memberof QueriesGetGoalAttainmentVisualizationResponse
     */
    'goalAttainmentByPlanForIndividualRaces': Array<QueriesResultCountByPlan>;
    /**
     * 
     * @type {Array<GoalAttainmentGoalAttainmentResultCount>}
     * @memberof QueriesGetGoalAttainmentVisualizationResponse
     */
    'overallGoalAttainmentForTotalMinorities': Array<GoalAttainmentGoalAttainmentResultCount>;
    /**
     * 
     * @type {Array<GoalAttainmentGoalAttainmentResultCount>}
     * @memberof QueriesGetGoalAttainmentVisualizationResponse
     */
    'overallGoalAttainmentForGender': Array<GoalAttainmentGoalAttainmentResultCount>;
    /**
     * 
     * @type {Array<GoalAttainmentGoalAttainmentResultCount>}
     * @memberof QueriesGetGoalAttainmentVisualizationResponse
     */
    'overallGoalAttainmentForIndividualRaces': Array<GoalAttainmentGoalAttainmentResultCount>;
    /**
     * 
     * @type {Array<QueriesResultCountByEEOCode>}
     * @memberof QueriesGetGoalAttainmentVisualizationResponse
     */
    'goalAttainmentForTotalMinoritiesByEEOCode': Array<QueriesResultCountByEEOCode>;
    /**
     * 
     * @type {Array<QueriesResultCountByEEOCode>}
     * @memberof QueriesGetGoalAttainmentVisualizationResponse
     */
    'goalAttainmentForGenderByEEOCode': Array<QueriesResultCountByEEOCode>;
    /**
     * 
     * @type {Array<QueriesResultCountByEEOCode>}
     * @memberof QueriesGetGoalAttainmentVisualizationResponse
     */
    'goalAttainmentForIndividualRacesByEEOCode': Array<QueriesResultCountByEEOCode>;
}
/**
 * 
 * @export
 * @interface QueriesGetGoalBradyBunchDrilldownLevel2Response
 */
export interface QueriesGetGoalBradyBunchDrilldownLevel2Response {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetGoalBradyBunchDrilldownLevel2Response
     */
    'eeoCode': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetGoalBradyBunchDrilldownLevel2Response
     */
    'jobGroup': string;
    /**
     * 
     * @type {Array<GoalDemographicWithListOfLocationsDTO>}
     * @memberof QueriesGetGoalBradyBunchDrilldownLevel2Response
     */
    'demographicCountsByJobGroups': Array<GoalDemographicWithListOfLocationsDTO>;
    /**
     * 
     * @type {Array<GoalWordCloudDTO>}
     * @memberof QueriesGetGoalBradyBunchDrilldownLevel2Response
     */
    'jobTitles': Array<GoalWordCloudDTO>;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetGoalBradyBunchDrilldownLevel2Response
     */
    'lowestMinorityPercent': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetGoalBradyBunchDrilldownLevel2Response
     */
    'lowestFemalePercent': string;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGoalBradyBunchDrilldownLevel2Response
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface QueriesGetGoalBradyBunchDrilldownResponse
 */
export interface QueriesGetGoalBradyBunchDrilldownResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetGoalBradyBunchDrilldownResponse
     */
    'eeoCode': string;
    /**
     * 
     * @type {Array<DataVizDemographicCountByJobGroup>}
     * @memberof QueriesGetGoalBradyBunchDrilldownResponse
     */
    'demographicCountsByJobGroups': Array<DataVizDemographicCountByJobGroup>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGoalBradyBunchDrilldownResponse
     */
    'minorityCount': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGoalBradyBunchDrilldownResponse
     */
    'femaleCount': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGoalBradyBunchDrilldownResponse
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface QueriesGetGoalDataVisualizationResponse
 */
export interface QueriesGetGoalDataVisualizationResponse {
    /**
     * 
     * @type {DataVizGoalCountTile}
     * @memberof QueriesGetGoalDataVisualizationResponse
     */
    'totalMinGoalsCount': DataVizGoalCountTile;
    /**
     * 
     * @type {DataVizGoalCountTile}
     * @memberof QueriesGetGoalDataVisualizationResponse
     */
    'totalFemGoalsCount': DataVizGoalCountTile;
    /**
     * 
     * @type {DataVizGoalCountTile}
     * @memberof QueriesGetGoalDataVisualizationResponse
     */
    'totalGoalsCount': DataVizGoalCountTile;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGoalDataVisualizationResponse
     */
    'percentJobGroupWithGoals': number;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetGoalDataVisualizationResponse
     */
    'placementGoalReportID': string;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetGoalDataVisualizationResponse
     */
    'mainDonut': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<GoalMiniDonutsResponse>}
     * @memberof QueriesGetGoalDataVisualizationResponse
     */
    'miniDonuts': Array<GoalMiniDonutsResponse>;
    /**
     * 
     * @type {Array<GoalEEOCodeBradyBunchResponse>}
     * @memberof QueriesGetGoalDataVisualizationResponse
     */
    'eeoCodes': Array<GoalEEOCodeBradyBunchResponse>;
}
/**
 * 
 * @export
 * @interface QueriesGetGoalDrilldownResponse
 */
export interface QueriesGetGoalDrilldownResponse {
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesGetGoalDrilldownResponse
     */
    'demographicCounts': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGoalDrilldownResponse
     */
    'minorityCount': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGoalDrilldownResponse
     */
    'femaleCount': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetGoalDrilldownResponse
     */
    'totalCount': number;
}
/**
 * 
 * @export
 * @interface QueriesGetGoodFaithEffortsResponse
 */
export interface QueriesGetGoodFaithEffortsResponse {
    /**
     * 
     * @type {Array<GFEGFEFieldsDTO>}
     * @memberof QueriesGetGoodFaithEffortsResponse
     */
    'fields': Array<GFEGFEFieldsDTO>;
    /**
     * 
     * @type {Array<GFEGFEFieldsDTO>}
     * @memberof QueriesGetGoodFaithEffortsResponse
     */
    'customFields': Array<GFEGFEFieldsDTO>;
    /**
     * 
     * @type {Array<GFEGFEDataDTO>}
     * @memberof QueriesGetGoodFaithEffortsResponse
     */
    'gfeData': Array<GFEGFEDataDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetGoodFaithEffortsResponse
     */
    'isGFEAdmin': boolean;
}
/**
 * 
 * @export
 * @interface QueriesGetHiringByIWDDrilldownResponse
 */
export interface QueriesGetHiringByIWDDrilldownResponse {
    /**
     * 
     * @type {Array<DataVizNullableCountPercentByEntity>}
     * @memberof QueriesGetHiringByIWDDrilldownResponse
     */
    'countPercents': Array<DataVizNullableCountPercentByEntity>;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetHiringByIWDDrilldownResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetHiringByIWDDrilldownResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetHiringByIWDDrilldownResponse
     */
    'tile3': DataVizDrilldownTileDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetHiringByJobGroupByIWDDrilldownResponse
 */
export interface QueriesGetHiringByJobGroupByIWDDrilldownResponse {
    /**
     * 
     * @type {Array<DataVizNullableCountPercentByEntity>}
     * @memberof QueriesGetHiringByJobGroupByIWDDrilldownResponse
     */
    'iwdByJobGroups': Array<DataVizNullableCountPercentByEntity>;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetHiringByJobGroupByIWDDrilldownResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetHiringByJobGroupByIWDDrilldownResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetHiringByJobGroupByIWDDrilldownResponse
     */
    'tile3': DataVizDrilldownTileDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetHiringByJobGroupByProtectedVeteranDrilldownResponse
 */
export interface QueriesGetHiringByJobGroupByProtectedVeteranDrilldownResponse {
    /**
     * 
     * @type {Array<DataVizNullableCountPercentByEntity>}
     * @memberof QueriesGetHiringByJobGroupByProtectedVeteranDrilldownResponse
     */
    'protectedVeteranByJobGroups': Array<DataVizNullableCountPercentByEntity>;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetHiringByJobGroupByProtectedVeteranDrilldownResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetHiringByJobGroupByProtectedVeteranDrilldownResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetHiringByJobGroupByProtectedVeteranDrilldownResponse
     */
    'tile3': DataVizDrilldownTileDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetHiringByProtectedVeteranDrilldownResponse
 */
export interface QueriesGetHiringByProtectedVeteranDrilldownResponse {
    /**
     * 
     * @type {Array<DataVizNullableCountPercentByEntity>}
     * @memberof QueriesGetHiringByProtectedVeteranDrilldownResponse
     */
    'countPercents': Array<DataVizNullableCountPercentByEntity>;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetHiringByProtectedVeteranDrilldownResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetHiringByProtectedVeteranDrilldownResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetHiringByProtectedVeteranDrilldownResponse
     */
    'tile3': DataVizDrilldownTileDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetIWDDataVisualizationResponse
 */
export interface QueriesGetIWDDataVisualizationResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetIWDDataVisualizationResponse
     */
    'utilizationGoalsReportID': string;
    /**
     * 
     * @type {QueriesIWDUtilizationGoalTile}
     * @memberof QueriesGetIWDDataVisualizationResponse
     */
    'iwdUtilizationGoalTile': QueriesIWDUtilizationGoalTile;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetIWDDataVisualizationResponse
     */
    'iwdEmploymentPercent': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetIWDDataVisualizationResponse
     */
    'totalIWDApplicants': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetIWDDataVisualizationResponse
     */
    'totalIWDHires': number;
    /**
     * 
     * @type {Array<QueriesIWDEmploymentAndJGsMetByPlan>}
     * @memberof QueriesGetIWDDataVisualizationResponse
     */
    'iwdEmploymentAndJGsMetByPlan': Array<QueriesIWDEmploymentAndJGsMetByPlan>;
    /**
     * 
     * @type {Array<DataVizCountPercentDTO>}
     * @memberof QueriesGetIWDDataVisualizationResponse
     */
    'employmentByIWDDonut': Array<DataVizCountPercentDTO>;
    /**
     * 
     * @type {Array<DataVizCountPercentDTO>}
     * @memberof QueriesGetIWDDataVisualizationResponse
     */
    'hiresByIWDDonut': Array<DataVizCountPercentDTO>;
    /**
     * 
     * @type {Array<DataVizNullableCountPercentByEntity>}
     * @memberof QueriesGetIWDDataVisualizationResponse
     */
    'employmentByEEOCategoryByIWD': Array<DataVizNullableCountPercentByEntity>;
    /**
     * 
     * @type {Array<DataVizNullableCountPercentByEntity>}
     * @memberof QueriesGetIWDDataVisualizationResponse
     */
    'hiringByEEOCategoryByIWD': Array<DataVizNullableCountPercentByEntity>;
}
/**
 * 
 * @export
 * @interface QueriesGetLeftNavMenuResponse
 */
export interface QueriesGetLeftNavMenuResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLeftNavMenuResponse
     */
    'serviceName': string;
    /**
     * 
     * @type {Array<QueriesChildNavItemDTO>}
     * @memberof QueriesGetLeftNavMenuResponse
     */
    'serviceDeliverablePages': Array<QueriesChildNavItemDTO>;
    /**
     * 
     * @type {Array<QueriesDataVisualizationDTO>}
     * @memberof QueriesGetLeftNavMenuResponse
     */
    'dataVisualizations': Array<QueriesDataVisualizationDTO>;
    /**
     * 
     * @type {Array<QueriesChildNavItemDTO>}
     * @memberof QueriesGetLeftNavMenuResponse
     */
    'tools': Array<QueriesChildNavItemDTO>;
    /**
     * 
     * @type {Array<QueriesChildNavItemDTO>}
     * @memberof QueriesGetLeftNavMenuResponse
     */
    'goodFaithEfforts': Array<QueriesChildNavItemDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetLocationsResponse
 */
export interface QueriesGetLocationsResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLocationsResponse
     */
    'documentCenterLocationID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLocationsResponse
     */
    'locationName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLocationsResponse
     */
    'urlSafeName': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetLocationsResponse
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface QueriesGetManageDeliverablesPageDetailResponse
 */
export interface QueriesGetManageDeliverablesPageDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetManageDeliverablesPageDetailResponse
     */
    'sectionID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetManageDeliverablesPageDetailResponse
     */
    'pageID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetManageDeliverablesPageDetailResponse
     */
    'sectionName': string;
    /**
     * 
     * @type {Array<QueriesServiceDeliverablesPageDetailFile>}
     * @memberof QueriesGetManageDeliverablesPageDetailResponse
     */
    'files': Array<QueriesServiceDeliverablesPageDetailFile>;
}
/**
 * 
 * @export
 * @interface QueriesGetManageDeliverablesPageListResponse
 */
export interface QueriesGetManageDeliverablesPageListResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetManageDeliverablesPageListResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetManageDeliverablesPageListResponse
     */
    'pageID': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetManageDeliverablesPageListResponse
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface QueriesGetNotificationsResponse
 */
export interface QueriesGetNotificationsResponse {
    /**
     * 
     * @type {Array<NotificationsNotificationDTO>}
     * @memberof QueriesGetNotificationsResponse
     */
    'notifications': Array<NotificationsNotificationDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetOverviewReportExportSettingsResponse
 */
export interface QueriesGetOverviewReportExportSettingsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetOverviewReportExportSettingsResponse
     */
    'includeOverview': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetOverviewReportExportSettingsResponse
     */
    'includeUtilizationSummary': boolean;
    /**
     * 
     * @type {EnumerationsUtilizationSummaryResultsDisplayed}
     * @memberof QueriesGetOverviewReportExportSettingsResponse
     */
    'utilizationSummaryResultsDisplayed': EnumerationsUtilizationSummaryResultsDisplayed;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetOverviewReportExportSettingsResponse
     */
    'includeAdverseImpactSummary': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetOverviewReportExportSettingsResponse
     */
    'adverseImpactIncludeTotalMinoritiesAndNonMinorities': boolean;
    /**
     * 
     * @type {EnumerationsAdverseImpactSummaryRunReportBy}
     * @memberof QueriesGetOverviewReportExportSettingsResponse
     */
    'adverseImpactSummaryRunReportBy': EnumerationsAdverseImpactSummaryRunReportBy;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetOverviewReportExportSettingsResponse
     */
    'includeGoalAttainmentSummary': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetOverviewReportExportSettingsResponse
     */
    'includeIWDSummary': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetOverviewReportExportSettingsResponse
     */
    'includeProtectedVeteransSummary': boolean;
    /**
     * 
     * @type {Array<OverviewSelectedActionTypesDTO>}
     * @memberof QueriesGetOverviewReportExportSettingsResponse
     */
    'adverseImpactIncludedActionTypes': Array<OverviewSelectedActionTypesDTO>;
    /**
     * 
     * @type {EnumerationsRunByForProtectedClasses}
     * @memberof QueriesGetOverviewReportExportSettingsResponse
     */
    'runByForProtectedClassesID': EnumerationsRunByForProtectedClasses;
}


/**
 * 
 * @export
 * @interface QueriesGetOverviewSettingsResponse
 */
export interface QueriesGetOverviewSettingsResponse {
    /**
     * 
     * @type {EnumerationsNumericDisplayOption}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'employmentDisplay': EnumerationsNumericDisplayOption;
    /**
     * 
     * @type {EnumerationsNumericDisplayOption}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'goalsDisplay': EnumerationsNumericDisplayOption;
    /**
     * 
     * @type {EnumerationsNumericDisplayOption}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'personnelActivityDisplay': EnumerationsNumericDisplayOption;
    /**
     * 
     * @type {EnumerationsPersonnelActivityResultsDisplayed}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'personnelActivityResults': EnumerationsPersonnelActivityResultsDisplayed;
    /**
     * 
     * @type {EnumerationsAdverseImpactDisplayOption}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'adverseImpactDisplay': EnumerationsAdverseImpactDisplayOption;
    /**
     * 
     * @type {EnumerationsNumericDisplayOption}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'applicantFlowDisplay': EnumerationsNumericDisplayOption;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'applicantFlowResultsIncludeTotalApplicants': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'applicantFlowResultsIncludeTotalSelections': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'applicantFlowResultsIncludeHiringAnalysis': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'applicantFlowResultsIncludeCompetitivePromotions': boolean;
    /**
     * 
     * @type {EnumerationsNumericDisplayOption}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'goalAttainmentDisplay': EnumerationsNumericDisplayOption;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'goalAttainmentResultsIncludeAchieved': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'goalAttainmentResultsIncludeNotAchieved': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'goalAttainmentResultsIncludeLimited': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'goalAttainmentResultsIncludeNoOpps': boolean;
    /**
     * 
     * @type {Array<OverviewOverviewSectionSettingsDTO>}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'overviewSectionSettings': Array<OverviewOverviewSectionSettingsDTO>;
    /**
     * 
     * @type {Array<OverviewSelectedActionTypesDTO>}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'adverseImpactIncludedActionTypes': Array<OverviewSelectedActionTypesDTO>;
    /**
     * 
     * @type {Array<OverviewSelectedActionTypesDTO>}
     * @memberof QueriesGetOverviewSettingsResponse
     */
    'personnelActivityIncludedActionTypes': Array<OverviewSelectedActionTypesDTO>;
}


/**
 * 
 * @export
 * @interface QueriesGetPersonnelActivityDataVisualizationResponse
 */
export interface QueriesGetPersonnelActivityDataVisualizationResponse {
    /**
     * 
     * @type {DataVizGoalCountTile}
     * @memberof QueriesGetPersonnelActivityDataVisualizationResponse
     */
    'totalHireCount': DataVizGoalCountTile;
    /**
     * 
     * @type {DataVizGoalCountTile}
     * @memberof QueriesGetPersonnelActivityDataVisualizationResponse
     */
    'totalPromotionCount': DataVizGoalCountTile;
    /**
     * 
     * @type {DataVizGoalCountTile}
     * @memberof QueriesGetPersonnelActivityDataVisualizationResponse
     */
    'totalTerminationCount': DataVizGoalCountTile;
    /**
     * 
     * @type {DataVizGoalCountTile}
     * @memberof QueriesGetPersonnelActivityDataVisualizationResponse
     */
    'totalInvoluntaryTerminationCount': DataVizGoalCountTile;
    /**
     * 
     * @type {QueriesPersonnelActivityByEeoByDemographicGraph}
     * @memberof QueriesGetPersonnelActivityDataVisualizationResponse
     */
    'personnelActivityByEeoByGenderGraph': QueriesPersonnelActivityByEeoByDemographicGraph;
    /**
     * 
     * @type {QueriesPersonnelActivityByEeoByDemographicGraph}
     * @memberof QueriesGetPersonnelActivityDataVisualizationResponse
     */
    'personnelActivityByEeoByRaceGraph': QueriesPersonnelActivityByEeoByDemographicGraph;
    /**
     * 
     * @type {QueriesPersonnelActivityByDemographic}
     * @memberof QueriesGetPersonnelActivityDataVisualizationResponse
     */
    'personnelActivityByGender': QueriesPersonnelActivityByDemographic;
    /**
     * 
     * @type {QueriesPersonnelActivityByDemographic}
     * @memberof QueriesGetPersonnelActivityDataVisualizationResponse
     */
    'personnelActivityByRace': QueriesPersonnelActivityByDemographic;
    /**
     * 
     * @type {Array<QueriesPersonnelActivityByPlan>}
     * @memberof QueriesGetPersonnelActivityDataVisualizationResponse
     */
    'demographicByPlan': Array<QueriesPersonnelActivityByPlan>;
}
/**
 * 
 * @export
 * @interface QueriesGetPlanProfilesQuery
 */
export interface QueriesGetPlanProfilesQuery {
    /**
     * 
     * @type {number}
     * @memberof QueriesGetPlanProfilesQuery
     */
    'page'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetPlanProfilesQuery
     */
    'rowsPerPage'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetPlanProfilesQuery
     */
    'searchTerm'?: string | null;
    /**
     * 
     * @type {EnumerationsPlanProfilesSortColumn}
     * @memberof QueriesGetPlanProfilesQuery
     */
    'sortColumn': EnumerationsPlanProfilesSortColumn;
    /**
     * 
     * @type {EnumerationsSortDirection}
     * @memberof QueriesGetPlanProfilesQuery
     */
    'sortDirection': EnumerationsSortDirection;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetPlanProfilesQuery
     */
    'showAnnual': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetPlanProfilesQuery
     */
    'showUpdate': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetPlanProfilesQuery
     */
    'showMaster': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetPlanProfilesQuery
     */
    'showSub': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetPlanProfilesQuery
     */
    'showRegular': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetPlanProfilesQuery
     */
    'showAudit': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetPlanProfilesQuery
     */
    'showNonAudit': boolean;
}


/**
 * 
 * @export
 * @interface QueriesGetPlanProfilesResponse
 */
export interface QueriesGetPlanProfilesResponse {
    /**
     * 
     * @type {number}
     * @memberof QueriesGetPlanProfilesResponse
     */
    'rowCount': number;
    /**
     * 
     * @type {Array<QueriesGetPlanProfilesRow>}
     * @memberof QueriesGetPlanProfilesResponse
     */
    'planProfiles': Array<QueriesGetPlanProfilesRow>;
}
/**
 * 
 * @export
 * @interface QueriesGetPlanProfilesRow
 */
export interface QueriesGetPlanProfilesRow {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetPlanProfilesRow
     */
    'planID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetPlanProfilesRow
     */
    'planIdentifier': string;
    /**
     * 
     * @type {EnumerationsPlanType}
     * @memberof QueriesGetPlanProfilesRow
     */
    'planTypeID': EnumerationsPlanType;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetPlanProfilesRow
     */
    'planDate': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetPlanProfilesRow
     */
    'planName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetPlanProfilesRow
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetPlanProfilesRow
     */
    'establishment': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetPlanProfilesRow
     */
    'subplanIDs': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetPlanProfilesRow
     */
    'aapPlanID': number;
}


/**
 * 
 * @export
 * @interface QueriesGetPlanSelectorDataForDataVizResponse
 */
export interface QueriesGetPlanSelectorDataForDataVizResponse {
    /**
     * 
     * @type {Array<TransferObjectsPlanInfo>}
     * @memberof QueriesGetPlanSelectorDataForDataVizResponse
     */
    'allPlans': Array<TransferObjectsPlanInfo>;
    /**
     * 
     * @type {Array<TransferObjectsSelectedPlanDTO>}
     * @memberof QueriesGetPlanSelectorDataForDataVizResponse
     */
    'selectedPlans': Array<TransferObjectsSelectedPlanDTO>;
    /**
     * 
     * @type {Array<TransferObjectsDropdownItem>}
     * @memberof QueriesGetPlanSelectorDataForDataVizResponse
     */
    'resultsBy': Array<TransferObjectsDropdownItem>;
    /**
     * 
     * @type {Array<PlansLevelOfAnalysisDTO>}
     * @memberof QueriesGetPlanSelectorDataForDataVizResponse
     */
    'levelofAnalysis': Array<PlansLevelOfAnalysisDTO>;
    /**
     * 
     * @type {EnumerationsDataVisualizationResultsBy}
     * @memberof QueriesGetPlanSelectorDataForDataVizResponse
     */
    'selectedResultsBy': EnumerationsDataVisualizationResultsBy;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetPlanSelectorDataForDataVizResponse
     */
    'selectedLevelOfAnalysis': string;
    /**
     * 
     * @type {EnumerationsCalcType}
     * @memberof QueriesGetPlanSelectorDataForDataVizResponse
     */
    'selectedCalcType': EnumerationsCalcType;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetPlanSelectorDataForDataVizResponse
     */
    'selectedPAActionType': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetPlanSelectorDataForDataVizResponse
     */
    'selectedAIActionType': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetPlanSelectorDataForDataVizResponse
     */
    'message': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetPlanSelectorDataForDataVizResponse
     */
    'applicantTypes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetPlanSelectorDataForDataVizResponse
     */
    'selectedApplicantTypeName': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetPlanSelectorDataForDataVizResponse
     */
    'hasUnpublishedPlan': boolean;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetPlanSelectorDataForDataVizResponse
     */
    'customFooterForMostRecentACPPlan'?: string | null;
    /**
     * 
     * @type {Array<TransferObjectsFeature2ComplianceTypeDTO>}
     * @memberof QueriesGetPlanSelectorDataForDataVizResponse
     */
    'featurePermissions': Array<TransferObjectsFeature2ComplianceTypeDTO>;
}


/**
 * 
 * @export
 * @interface QueriesGetPlanSummaryReportSettingsResponse
 */
export interface QueriesGetPlanSummaryReportSettingsResponse {
    /**
     * 
     * @type {EnumerationsRunByForProtectedClasses}
     * @memberof QueriesGetPlanSummaryReportSettingsResponse
     */
    'runByForProtectedClasses': EnumerationsRunByForProtectedClasses;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetPlanSummaryReportSettingsResponse
     */
    'includeIWDAnalysis': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetPlanSummaryReportSettingsResponse
     */
    'includeProtectedVetAnalysis': boolean;
    /**
     * 
     * @type {EnumerationsPlanSummaryIncvsEstShowFor}
     * @memberof QueriesGetPlanSummaryReportSettingsResponse
     */
    'incvsEstShowFor': EnumerationsPlanSummaryIncvsEstShowFor;
    /**
     * 
     * @type {EnumerationsPlanSummaryAIShowFor}
     * @memberof QueriesGetPlanSummaryReportSettingsResponse
     */
    'aiShowFor': EnumerationsPlanSummaryAIShowFor;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetPlanSummaryReportSettingsResponse
     */
    'hideRecruitmentAreasSection': boolean;
    /**
     * 
     * @type {Array<OverviewSelectedActionTypesDTO>}
     * @memberof QueriesGetPlanSummaryReportSettingsResponse
     */
    'actionTypes': Array<OverviewSelectedActionTypesDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetPlanSummaryReportSettingsResponse
     */
    'adverseImpactIncludeTotalMinoritiesAndNonMinorities': boolean;
}


/**
 * 
 * @export
 * @interface QueriesGetPlansResponse
 */
export interface QueriesGetPlansResponse {
    /**
     * 
     * @type {Array<TransferObjectsPlanInfo>}
     * @memberof QueriesGetPlansResponse
     */
    'allPlans': Array<TransferObjectsPlanInfo>;
    /**
     * 
     * @type {Array<TransferObjectsPlanInfo>}
     * @memberof QueriesGetPlansResponse
     */
    'mostRecentPlans': Array<TransferObjectsPlanInfo>;
    /**
     * 
     * @type {TransferObjectsPlanInfo}
     * @memberof QueriesGetPlansResponse
     */
    'mostRecentPlan': TransferObjectsPlanInfo;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetPlansResponse
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface QueriesGetProjectsResponse
 */
export interface QueriesGetProjectsResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProjectsResponse
     */
    'documentCenterProjectID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProjectsResponse
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProjectsResponse
     */
    'urlSafeName': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetProjectsResponse
     */
    'isDefault': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetProjectsResponse
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface QueriesGetProtectedVeteranDataVisualizationResponse
 */
export interface QueriesGetProtectedVeteranDataVisualizationResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProtectedVeteranDataVisualizationResponse
     */
    'benchmarkAAPReport2ClientID': string;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetProtectedVeteranDataVisualizationResponse
     */
    'pvHiringBenchmarkTile': number;
    /**
     * 
     * @type {QueriesProtectedVetHiringPercentageTile}
     * @memberof QueriesGetProtectedVeteranDataVisualizationResponse
     */
    'pvHiringBenchmarkPercentageTile': QueriesProtectedVetHiringPercentageTile;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetProtectedVeteranDataVisualizationResponse
     */
    'totalPVApplicants': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetProtectedVeteranDataVisualizationResponse
     */
    'totalPVHires': number;
    /**
     * 
     * @type {Array<QueriesProtectedVetsByPlan>}
     * @memberof QueriesGetProtectedVeteranDataVisualizationResponse
     */
    'protectedVetsByPlan': Array<QueriesProtectedVetsByPlan>;
    /**
     * 
     * @type {Array<DataVizCountPercentDTO>}
     * @memberof QueriesGetProtectedVeteranDataVisualizationResponse
     */
    'protectedVetHires': Array<DataVizCountPercentDTO>;
    /**
     * 
     * @type {Array<DataVizCountPercentDTO>}
     * @memberof QueriesGetProtectedVeteranDataVisualizationResponse
     */
    'protectedVetEmployment': Array<DataVizCountPercentDTO>;
    /**
     * 
     * @type {Array<DataVizNullableCountPercentByEntity>}
     * @memberof QueriesGetProtectedVeteranDataVisualizationResponse
     */
    'protectedVetsByEEOHires': Array<DataVizNullableCountPercentByEntity>;
    /**
     * 
     * @type {Array<DataVizNullableCountPercentByEntity>}
     * @memberof QueriesGetProtectedVeteranDataVisualizationResponse
     */
    'protectedVetsByEEOEmployment': Array<DataVizNullableCountPercentByEntity>;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProtectedVeteranDataVisualizationResponse
     */
    'benchmarkDate': string;
}
/**
 * 
 * @export
 * @interface QueriesGetReportSettingsResponse
 */
export interface QueriesGetReportSettingsResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetReportSettingsResponse
     */
    'planID': string;
    /**
     * 
     * @type {EnumerationsAAPReportSettingsCategory}
     * @memberof QueriesGetReportSettingsResponse
     */
    'aapReportSettingsCategoryID': EnumerationsAAPReportSettingsCategory;
    /**
     * 
     * @type {ModelsAvailabilityReportSettings}
     * @memberof QueriesGetReportSettingsResponse
     */
    'availabilityReportSettings': ModelsAvailabilityReportSettings;
    /**
     * 
     * @type {ModelsJobGroupAnalysisReportSettings}
     * @memberof QueriesGetReportSettingsResponse
     */
    'jobGroupAnalysisReportSettings': ModelsJobGroupAnalysisReportSettings;
    /**
     * 
     * @type {ModelsDataCollectionReportSettings}
     * @memberof QueriesGetReportSettingsResponse
     */
    'dataCollectionReportSettings': ModelsDataCollectionReportSettings;
    /**
     * 
     * @type {ModelsApplicantSummaryReportSettings}
     * @memberof QueriesGetReportSettingsResponse
     */
    'applicantSummaryReportSettings': ModelsApplicantSummaryReportSettings;
    /**
     * 
     * @type {ModelsCompensationSummaryReportSettings}
     * @memberof QueriesGetReportSettingsResponse
     */
    'compensationSummaryReportSettings': ModelsCompensationSummaryReportSettings;
    /**
     * 
     * @type {ModelsWorkforceAnalysisReportSettings}
     * @memberof QueriesGetReportSettingsResponse
     */
    'workforceAnalysisReportSettings': ModelsWorkforceAnalysisReportSettings;
    /**
     * 
     * @type {ModelsAdverseImpactReportSettings}
     * @memberof QueriesGetReportSettingsResponse
     */
    'adverseImpactReportSettings': ModelsAdverseImpactReportSettings;
    /**
     * 
     * @type {Array<TransferObjectsAdverseImpactJobGroupDTO>}
     * @memberof QueriesGetReportSettingsResponse
     */
    'adverseImpactJobGroups'?: Array<TransferObjectsAdverseImpactJobGroupDTO> | null;
}


/**
 * 
 * @export
 * @interface QueriesGetSelectAllPlanProfilesResponse
 */
export interface QueriesGetSelectAllPlanProfilesResponse {
    /**
     * 
     * @type {Array<QueriesTopPlanData>}
     * @memberof QueriesGetSelectAllPlanProfilesResponse
     */
    'topPlans': Array<QueriesTopPlanData>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetSelectAllPlanProfilesResponse
     */
    'planIDs': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetSelectAllPlanProfilesResponse
     */
    'selectedCount': number;
}
/**
 * 
 * @export
 * @interface QueriesGetSelectionsByDemographicDrilldownResponse
 */
export interface QueriesGetSelectionsByDemographicDrilldownResponse {
    /**
     * 
     * @type {Array<DataVizDemographicCountByCalcTypeDTO>}
     * @memberof QueriesGetSelectionsByDemographicDrilldownResponse
     */
    'demographicCounts': Array<DataVizDemographicCountByCalcTypeDTO>;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetSelectionsByDemographicDrilldownResponse
     */
    'tile1': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetSelectionsByDemographicDrilldownResponse
     */
    'tile2': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {DataVizDrilldownTileDTO}
     * @memberof QueriesGetSelectionsByDemographicDrilldownResponse
     */
    'tile3': DataVizDrilldownTileDTO;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetSelectionsByDemographicDrilldownResponse
     */
    'totalApplicants': number;
}
/**
 * 
 * @export
 * @interface QueriesGetServiceDeliverablesPageDetailResponse
 */
export interface QueriesGetServiceDeliverablesPageDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetServiceDeliverablesPageDetailResponse
     */
    'pageName': string;
    /**
     * 
     * @type {Array<QueriesServiceDeliverablesPageDetailSection>}
     * @memberof QueriesGetServiceDeliverablesPageDetailResponse
     */
    'sections': Array<QueriesServiceDeliverablesPageDetailSection>;
    /**
     * 
     * @type {NetHttpStatusCode}
     * @memberof QueriesGetServiceDeliverablesPageDetailResponse
     */
    'status': NetHttpStatusCode;
}


/**
 * 
 * @export
 * @interface QueriesGetTemplateImportFileResponse
 */
export interface QueriesGetTemplateImportFileResponse {
    /**
     * 
     * @type {File}
     * @memberof QueriesGetTemplateImportFileResponse
     */
    'templateFile'?: File | null;
}
/**
 * 
 * @export
 * @interface QueriesGetTop5DispositionByGenderDonutDrilldownByJobGroupResponse
 */
export interface QueriesGetTop5DispositionByGenderDonutDrilldownByJobGroupResponse {
    /**
     * 
     * @type {Array<ApplicantFlowTop5DispositionCountsByJobGroupDTO>}
     * @memberof QueriesGetTop5DispositionByGenderDonutDrilldownByJobGroupResponse
     */
    'top5DispositionCountsByJobGroup': Array<ApplicantFlowTop5DispositionCountsByJobGroupDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetTop5DispositionByGenderDonutDrilldownByJobGroupResponse
     */
    'totalDispositionCodeUsedTile': number;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetTop5DispositionByGenderDonutDrilldownByJobGroupResponse
     */
    'percentOfFemApplicantsWithTop5DispositionsTile': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetTop5DispositionByGenderDonutDrilldownByJobGroupResponse
     */
    'percentOfFemApplicantsWithOtherDispositionsTile': string;
}
/**
 * 
 * @export
 * @interface QueriesGetTop5DispositionByGenderResponse
 */
export interface QueriesGetTop5DispositionByGenderResponse {
    /**
     * 
     * @type {Array<QueriesDispositionCountsByGenderResponse>}
     * @memberof QueriesGetTop5DispositionByGenderResponse
     */
    'top5DispositionByGenderByGroupResult': Array<QueriesDispositionCountsByGenderResponse>;
    /**
     * 
     * @type {Array<ApplicantFlowDispositionCountsOverallDTO>}
     * @memberof QueriesGetTop5DispositionByGenderResponse
     */
    'top5DispositionMinorityResult': Array<ApplicantFlowDispositionCountsOverallDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetTop5DispositionByRaceDonutDrilldownByJobGroupResponse
 */
export interface QueriesGetTop5DispositionByRaceDonutDrilldownByJobGroupResponse {
    /**
     * 
     * @type {Array<ApplicantFlowTop5DispositionCountsByJobGroupDTO>}
     * @memberof QueriesGetTop5DispositionByRaceDonutDrilldownByJobGroupResponse
     */
    'top5DispositionCountsByJobGroup': Array<ApplicantFlowTop5DispositionCountsByJobGroupDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetTop5DispositionByRaceDonutDrilldownByJobGroupResponse
     */
    'totalDispositionCodeUsedTile': number;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetTop5DispositionByRaceDonutDrilldownByJobGroupResponse
     */
    'percentOfMinApplicantsWithTop5DispositionsTile': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetTop5DispositionByRaceDonutDrilldownByJobGroupResponse
     */
    'percentOfMinApplicantsWithOtherDispositionsTile': string;
}
/**
 * 
 * @export
 * @interface QueriesGetTop5DispositionByRaceResponse
 */
export interface QueriesGetTop5DispositionByRaceResponse {
    /**
     * 
     * @type {Array<QueriesDispositionCountsByRaceResponse>}
     * @memberof QueriesGetTop5DispositionByRaceResponse
     */
    'top5DispositionByRaceByGroupResult': Array<QueriesDispositionCountsByRaceResponse>;
    /**
     * 
     * @type {Array<ApplicantFlowDispositionCountsOverallDTO>}
     * @memberof QueriesGetTop5DispositionByRaceResponse
     */
    'top5DispositionMinorityResult': Array<ApplicantFlowDispositionCountsOverallDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetTop5DispositionOverallDonutDrilldownByJobGroupResponse
 */
export interface QueriesGetTop5DispositionOverallDonutDrilldownByJobGroupResponse {
    /**
     * 
     * @type {Array<ApplicantFlowTop5DispositionCountsByJobGroupDTO>}
     * @memberof QueriesGetTop5DispositionOverallDonutDrilldownByJobGroupResponse
     */
    'top5DispositionCountsByJobGroup': Array<ApplicantFlowTop5DispositionCountsByJobGroupDTO>;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetTop5DispositionOverallDonutDrilldownByJobGroupResponse
     */
    'totalDispositionCodeUsedTile': number;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetTop5DispositionOverallDonutDrilldownByJobGroupResponse
     */
    'percentOfApplicantsWithTop5DispositionsTile': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetTop5DispositionOverallDonutDrilldownByJobGroupResponse
     */
    'percentOfApplicantsWithOtherDispositionsTile': string;
}
/**
 * 
 * @export
 * @interface QueriesGetTop5DispositionOverallResponse
 */
export interface QueriesGetTop5DispositionOverallResponse {
    /**
     * 
     * @type {Array<ApplicantFlowDispositionCountsOverallDTO>}
     * @memberof QueriesGetTop5DispositionOverallResponse
     */
    'top5DispositionOverallByGroupResult': Array<ApplicantFlowDispositionCountsOverallDTO>;
    /**
     * 
     * @type {Array<ApplicantFlowDispositionCountsOverallDTO>}
     * @memberof QueriesGetTop5DispositionOverallResponse
     */
    'top5DispositionOverallResult': Array<ApplicantFlowDispositionCountsOverallDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetTotalAndSearchDataResponse
 */
export interface QueriesGetTotalAndSearchDataResponse {
    /**
     * 
     * @type {DataVizGoalCountTile}
     * @memberof QueriesGetTotalAndSearchDataResponse
     */
    'goalCountTile': DataVizGoalCountTile;
    /**
     * 
     * @type {DataVizGoalCountTile}
     * @memberof QueriesGetTotalAndSearchDataResponse
     */
    'significantAdverseImpactCountTile': DataVizGoalCountTile;
    /**
     * 
     * @type {DataVizGoalCountTile}
     * @memberof QueriesGetTotalAndSearchDataResponse
     */
    'goalsAchievedCountTile': DataVizGoalCountTile;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetTotalAndSearchDataResponse
     */
    'byPlanSearchTypeAheadItems': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetTotalAndSearchDataResponse
     */
    'byJobGroupSearchTypeAheadItems': Array<string>;
}
/**
 * 
 * @export
 * @interface QueriesGetUnreadAlertsResponse
 */
export interface QueriesGetUnreadAlertsResponse {
    /**
     * 
     * @type {Array<QueriesAlertUnreadAlerts>}
     * @memberof QueriesGetUnreadAlertsResponse
     */
    'unreadAlerts': Array<QueriesAlertUnreadAlerts>;
}
/**
 * 
 * @export
 * @interface QueriesIWDEmploymentAndJGsMetByPlan
 */
export interface QueriesIWDEmploymentAndJGsMetByPlan {
    /**
     * 
     * @type {string}
     * @memberof QueriesIWDEmploymentAndJGsMetByPlan
     */
    'planID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesIWDEmploymentAndJGsMetByPlan
     */
    'location': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesIWDEmploymentAndJGsMetByPlan
     */
    'planIdentifier': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesIWDEmploymentAndJGsMetByPlan
     */
    'planDate': string;
    /**
     * 
     * @type {Array<DataVizCountPercentByEntity>}
     * @memberof QueriesIWDEmploymentAndJGsMetByPlan
     */
    'donutData': Array<DataVizCountPercentByEntity>;
}
/**
 * 
 * @export
 * @interface QueriesIWDUtilizationGoalTile
 */
export interface QueriesIWDUtilizationGoalTile {
    /**
     * 
     * @type {string}
     * @memberof QueriesIWDUtilizationGoalTile
     */
    'goalDate': string;
    /**
     * 
     * @type {number}
     * @memberof QueriesIWDUtilizationGoalTile
     */
    'goalPercent': number;
}
/**
 * 
 * @export
 * @interface QueriesOverallEmploymentByDemographicGraph
 */
export interface QueriesOverallEmploymentByDemographicGraph {
    /**
     * 
     * @type {Array<DataVizDemographicPercentDTO>}
     * @memberof QueriesOverallEmploymentByDemographicGraph
     */
    'demographicPercents': Array<DataVizDemographicPercentDTO>;
}
/**
 * 
 * @export
 * @interface QueriesOverallEmploymentByEeoByDemographicGraph
 */
export interface QueriesOverallEmploymentByEeoByDemographicGraph {
    /**
     * 
     * @type {Array<QueriesDemographicCountByEeoCode>}
     * @memberof QueriesOverallEmploymentByEeoByDemographicGraph
     */
    'demographicCountsByEeoCodes': Array<QueriesDemographicCountByEeoCode>;
}
/**
 * 
 * @export
 * @interface QueriesPersonnelActivityByDemographic
 */
export interface QueriesPersonnelActivityByDemographic {
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesPersonnelActivityByDemographic
     */
    'positiveActivities': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesPersonnelActivityByDemographic
     */
    'negativeActivities': Array<DataVizDemographicCountDTO>;
}
/**
 * 
 * @export
 * @interface QueriesPersonnelActivityByEeoByDemographicGraph
 */
export interface QueriesPersonnelActivityByEeoByDemographicGraph {
    /**
     * 
     * @type {Array<QueriesDemographicCountsByEeoCodeDTO>}
     * @memberof QueriesPersonnelActivityByEeoByDemographicGraph
     */
    'positiveActivities': Array<QueriesDemographicCountsByEeoCodeDTO>;
    /**
     * 
     * @type {Array<QueriesDemographicCountsByEeoCodeDTO>}
     * @memberof QueriesPersonnelActivityByEeoByDemographicGraph
     */
    'negativeActivities': Array<QueriesDemographicCountsByEeoCodeDTO>;
}
/**
 * 
 * @export
 * @interface QueriesPersonnelActivityByPlan
 */
export interface QueriesPersonnelActivityByPlan {
    /**
     * 
     * @type {string}
     * @memberof QueriesPersonnelActivityByPlan
     */
    'planID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesPersonnelActivityByPlan
     */
    'planName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesPersonnelActivityByPlan
     */
    'establishment': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesPersonnelActivityByPlan
     */
    'planDate': string;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesPersonnelActivityByPlan
     */
    'positiveRaceCounts': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesPersonnelActivityByPlan
     */
    'negativeRaceCounts': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesPersonnelActivityByPlan
     */
    'positiveGenderCounts': Array<DataVizDemographicCountDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicCountDTO>}
     * @memberof QueriesPersonnelActivityByPlan
     */
    'negativeGenderCounts': Array<DataVizDemographicCountDTO>;
}
/**
 * 
 * @export
 * @interface QueriesProtectedVetHiringPercentageTile
 */
export interface QueriesProtectedVetHiringPercentageTile {
    /**
     * 
     * @type {number}
     * @memberof QueriesProtectedVetHiringPercentageTile
     */
    'pvHiringPercentage': number;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesProtectedVetHiringPercentageTile
     */
    'goalMet': boolean;
}
/**
 * 
 * @export
 * @interface QueriesProtectedVetsByPlan
 */
export interface QueriesProtectedVetsByPlan {
    /**
     * 
     * @type {string}
     * @memberof QueriesProtectedVetsByPlan
     */
    'planID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesProtectedVetsByPlan
     */
    'planIdentifier': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesProtectedVetsByPlan
     */
    'establishment': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesProtectedVetsByPlan
     */
    'planDate': string;
    /**
     * 
     * @type {Array<DataVizCountPercentByEntity>}
     * @memberof QueriesProtectedVetsByPlan
     */
    'donutData': Array<DataVizCountPercentByEntity>;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesProtectedVetsByPlan
     */
    'goalMet': boolean;
}
/**
 * 
 * @export
 * @interface QueriesResourceFile
 */
export interface QueriesResourceFile {
    /**
     * 
     * @type {string}
     * @memberof QueriesResourceFile
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesResourceFile
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesResourceFile
     */
    'shortFileName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesResourceFile
     */
    'extension': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesResourceFile
     */
    'path': string;
}
/**
 * 
 * @export
 * @interface QueriesResourceFolder
 */
export interface QueriesResourceFolder {
    /**
     * 
     * @type {string}
     * @memberof QueriesResourceFolder
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesResourceFolder
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface QueriesResourceItem
 */
export interface QueriesResourceItem {
    /**
     * 
     * @type {QueriesResourceFile}
     * @memberof QueriesResourceItem
     */
    'file': QueriesResourceFile;
    /**
     * 
     * @type {QueriesResourceFolder}
     * @memberof QueriesResourceItem
     */
    'folder': QueriesResourceFolder;
    /**
     * 
     * @type {QueriesResourceServiceLine}
     * @memberof QueriesResourceItem
     */
    'serviceLine': QueriesResourceServiceLine;
}
/**
 * 
 * @export
 * @interface QueriesResourceServiceLine
 */
export interface QueriesResourceServiceLine {
    /**
     * 
     * @type {string}
     * @memberof QueriesResourceServiceLine
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface QueriesResultCountByEEOCode
 */
export interface QueriesResultCountByEEOCode {
    /**
     * 
     * @type {string}
     * @memberof QueriesResultCountByEEOCode
     */
    'eeoCode': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesResultCountByEEOCode
     */
    'eeoCodeDescription': string;
    /**
     * 
     * @type {Array<GoalAttainmentGoalAttainmentResultCount>}
     * @memberof QueriesResultCountByEEOCode
     */
    'resultCounts': Array<GoalAttainmentGoalAttainmentResultCount>;
}
/**
 * 
 * @export
 * @interface QueriesResultCountByJobGroup
 */
export interface QueriesResultCountByJobGroup {
    /**
     * 
     * @type {string}
     * @memberof QueriesResultCountByJobGroup
     */
    'jobGroup': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesResultCountByJobGroup
     */
    'jobGroupName': string;
    /**
     * 
     * @type {Array<GoalAttainmentGoalAttainmentResultCount>}
     * @memberof QueriesResultCountByJobGroup
     */
    'resultCounts': Array<GoalAttainmentGoalAttainmentResultCount>;
}
/**
 * 
 * @export
 * @interface QueriesResultCountByPlan
 */
export interface QueriesResultCountByPlan {
    /**
     * 
     * @type {string}
     * @memberof QueriesResultCountByPlan
     */
    'planID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesResultCountByPlan
     */
    'planIdentifier': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesResultCountByPlan
     */
    'establishment': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesResultCountByPlan
     */
    'planDate': string;
    /**
     * 
     * @type {Array<GoalAttainmentGoalAttainmentResultCount>}
     * @memberof QueriesResultCountByPlan
     */
    'resultCounts': Array<GoalAttainmentGoalAttainmentResultCount>;
}
/**
 * 
 * @export
 * @interface QueriesResultCountByRace
 */
export interface QueriesResultCountByRace {
    /**
     * 
     * @type {string}
     * @memberof QueriesResultCountByRace
     */
    'race': string;
    /**
     * 
     * @type {Array<GoalAttainmentGoalAttainmentResultCount>}
     * @memberof QueriesResultCountByRace
     */
    'resultCounts': Array<GoalAttainmentGoalAttainmentResultCount>;
}
/**
 * 
 * @export
 * @interface QueriesServiceDeliverablesPageDetailFile
 */
export interface QueriesServiceDeliverablesPageDetailFile {
    /**
     * 
     * @type {string}
     * @memberof QueriesServiceDeliverablesPageDetailFile
     */
    'fileID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesServiceDeliverablesPageDetailFile
     */
    'fileName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesServiceDeliverablesPageDetailFile
     */
    'fileSize': string;
    /**
     * 
     * @type {EnumerationsFileType}
     * @memberof QueriesServiceDeliverablesPageDetailFile
     */
    'fileType': EnumerationsFileType;
    /**
     * 
     * @type {string}
     * @memberof QueriesServiceDeliverablesPageDetailFile
     */
    'lastViewed'?: string | null;
}


/**
 * 
 * @export
 * @interface QueriesServiceDeliverablesPageDetailSection
 */
export interface QueriesServiceDeliverablesPageDetailSection {
    /**
     * 
     * @type {string}
     * @memberof QueriesServiceDeliverablesPageDetailSection
     */
    'sectionID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesServiceDeliverablesPageDetailSection
     */
    'sectionName': string;
    /**
     * 
     * @type {Array<QueriesServiceDeliverablesPageDetailFile>}
     * @memberof QueriesServiceDeliverablesPageDetailSection
     */
    'files': Array<QueriesServiceDeliverablesPageDetailFile>;
}
/**
 * 
 * @export
 * @interface QueriesTopPlanData
 */
export interface QueriesTopPlanData {
    /**
     * 
     * @type {string}
     * @memberof QueriesTopPlanData
     */
    'planID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesTopPlanData
     */
    'planIdentifier': string;
    /**
     * 
     * @type {EnumerationsPlanType}
     * @memberof QueriesTopPlanData
     */
    'planTypeID': EnumerationsPlanType;
    /**
     * 
     * @type {string}
     * @memberof QueriesTopPlanData
     */
    'planDate': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesTopPlanData
     */
    'planName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesTopPlanData
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesTopPlanData
     */
    'establishment': string;
}


/**
 * 
 * @export
 * @interface QueriesValidateUploadURLQuery
 */
export interface QueriesValidateUploadURLQuery {
    /**
     * 
     * @type {string}
     * @memberof QueriesValidateUploadURLQuery
     */
    'dropboxName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesValidateUploadURLQuery
     */
    'projectName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesValidateUploadURLQuery
     */
    'locationName'?: string | null;
}
/**
 * 
 * @export
 * @interface QueriesValidateUploadURLResponse
 */
export interface QueriesValidateUploadURLResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesValidateUploadURLResponse
     */
    'userID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesValidateUploadURLResponse
     */
    'initials': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesValidateUploadURLResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesValidateUploadURLResponse
     */
    'projectID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesValidateUploadURLResponse
     */
    'projectName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesValidateUploadURLResponse
     */
    'locationID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesValidateUploadURLResponse
     */
    'locationName'?: string | null;
}
/**
 * 
 * @export
 * @interface SystemAlertsSystemAlertAdminViewRecord
 */
export interface SystemAlertsSystemAlertAdminViewRecord {
    /**
     * 
     * @type {string}
     * @memberof SystemAlertsSystemAlertAdminViewRecord
     */
    'systemAlertID': string;
    /**
     * 
     * @type {string}
     * @memberof SystemAlertsSystemAlertAdminViewRecord
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SystemAlertsSystemAlertAdminViewRecord
     */
    'startDate': string;
    /**
     * 
     * @type {string}
     * @memberof SystemAlertsSystemAlertAdminViewRecord
     */
    'endDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SystemAlertsSystemAlertAdminViewRecord
     */
    'clientNames': string;
    /**
     * 
     * @type {string}
     * @memberof SystemAlertsSystemAlertAdminViewRecord
     */
    'serviceLines': string;
    /**
     * 
     * @type {string}
     * @memberof SystemAlertsSystemAlertAdminViewRecord
     */
    'roles': string;
    /**
     * 
     * @type {EnumerationsRecurringInterval}
     * @memberof SystemAlertsSystemAlertAdminViewRecord
     */
    'recurringIntervalID': EnumerationsRecurringInterval;
    /**
     * 
     * @type {number}
     * @memberof SystemAlertsSystemAlertAdminViewRecord
     */
    'rowCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof SystemAlertsSystemAlertAdminViewRecord
     */
    'markedInactive': boolean;
    /**
     * 
     * @type {EnumerationsSystemAlertActiveStatus}
     * @memberof SystemAlertsSystemAlertAdminViewRecord
     */
    'activeStatus': EnumerationsSystemAlertActiveStatus;
}


/**
 * 
 * @export
 * @interface SystemAlertsSystemAlertByClientCountDTO
 */
export interface SystemAlertsSystemAlertByClientCountDTO {
    /**
     * 
     * @type {string}
     * @memberof SystemAlertsSystemAlertByClientCountDTO
     */
    'clientID': string;
    /**
     * 
     * @type {string}
     * @memberof SystemAlertsSystemAlertByClientCountDTO
     */
    'clientName': string;
    /**
     * 
     * @type {number}
     * @memberof SystemAlertsSystemAlertByClientCountDTO
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof SystemAlertsSystemAlertByClientCountDTO
     */
    'viewedCount': number;
}
/**
 * 
 * @export
 * @interface SystemAlertsSystemAlertDetailsForUser
 */
export interface SystemAlertsSystemAlertDetailsForUser {
    /**
     * 
     * @type {string}
     * @memberof SystemAlertsSystemAlertDetailsForUser
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof SystemAlertsSystemAlertDetailsForUser
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof SystemAlertsSystemAlertDetailsForUser
     */
    'acknowledgedDate'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SystemAlertsSystemAlertDetailsForUser
     */
    'requireAcknowledgement': boolean;
}
/**
 * 
 * @export
 * @interface SystemAlertsSystemAlertReceivingClientDTO
 */
export interface SystemAlertsSystemAlertReceivingClientDTO {
    /**
     * 
     * @type {string}
     * @memberof SystemAlertsSystemAlertReceivingClientDTO
     */
    'clientID': string;
    /**
     * 
     * @type {string}
     * @memberof SystemAlertsSystemAlertReceivingClientDTO
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface SystemAlertsSystemAlertReceivingRoleDTO
 */
export interface SystemAlertsSystemAlertReceivingRoleDTO {
    /**
     * 
     * @type {EnumerationsRole}
     * @memberof SystemAlertsSystemAlertReceivingRoleDTO
     */
    'roleID': EnumerationsRole;
    /**
     * 
     * @type {string}
     * @memberof SystemAlertsSystemAlertReceivingRoleDTO
     */
    'description': string;
}


/**
 * 
 * @export
 * @interface SystemAlertsSystemAlertReceivingServiceDTO
 */
export interface SystemAlertsSystemAlertReceivingServiceDTO {
    /**
     * 
     * @type {EnumerationsServiceType}
     * @memberof SystemAlertsSystemAlertReceivingServiceDTO
     */
    'serviceTypeID': EnumerationsServiceType;
    /**
     * 
     * @type {string}
     * @memberof SystemAlertsSystemAlertReceivingServiceDTO
     */
    'description': string;
}


/**
 * 
 * @export
 * @interface TransferObjectsActionOrientedProgramGoalsDTO
 */
export interface TransferObjectsActionOrientedProgramGoalsDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsActionOrientedProgramGoalsDTO
     */
    'actionOrientedProgramGoalsID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsActionOrientedProgramGoalsDTO
     */
    'establishment': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsActionOrientedProgramGoalsDTO
     */
    'jobGroup': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsActionOrientedProgramGoalsDTO
     */
    'impactedGroup': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsActionOrientedProgramGoalsDTO
     */
    'priorYearGoal': boolean;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsActionOrientedProgramGoalsDTO
     */
    'priorYearImpactedIncumbency': number;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsActionOrientedProgramGoalsDTO
     */
    'currentImpactedIncumbency': number;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsActionOrientedProgramGoalsDTO
     */
    'opportunities': number;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsActionOrientedProgramGoalsDTO
     */
    'analysis': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsActionOrientedProgramGoalsDTO
     */
    'actionOrientedProgram': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsActionOrientedProgramGoalsDTO
     */
    'personResponsible': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsActionOrientedProgramGoalsDTO
     */
    'targetCompletionDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsActionOrientedProgramGoalsDTO
     */
    'notes': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsAdverseImpactJobGroupDTO
 */
export interface TransferObjectsAdverseImpactJobGroupDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAdverseImpactJobGroupDTO
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAdverseImpactJobGroupDTO
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsAdverseImpactJobGroupDTO
     */
    'selected': boolean;
}
/**
 * 
 * @export
 * @interface TransferObjectsAudit2AuditItem2NoteDTO
 */
export interface TransferObjectsAudit2AuditItem2NoteDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAudit2AuditItem2NoteDTO
     */
    'audit2AuditItem2NoteID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAudit2AuditItem2NoteDTO
     */
    'note': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAudit2AuditItem2NoteDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAudit2AuditItem2NoteDTO
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAudit2AuditItem2NoteDTO
     */
    'dateCreated': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsAuditAttachmentDTO
 */
export interface TransferObjectsAuditAttachmentDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAuditAttachmentDTO
     */
    'auditAttachmentID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAuditAttachmentDTO
     */
    'fileName': string;
    /**
     * 
     * @type {EnumerationsFileType}
     * @memberof TransferObjectsAuditAttachmentDTO
     */
    'fileTypeID': EnumerationsFileType;
}


/**
 * 
 * @export
 * @interface TransferObjectsAuditChecklistItemDTO
 */
export interface TransferObjectsAuditChecklistItemDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAuditChecklistItemDTO
     */
    'audit2AuditItemID': string;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsAuditChecklistItemDTO
     */
    'auditItemID': number;
    /**
     * 
     * @type {EnumerationsAuditResponsibility}
     * @memberof TransferObjectsAuditChecklistItemDTO
     */
    'auditResponsibilityID': EnumerationsAuditResponsibility;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAuditChecklistItemDTO
     */
    'itemName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAuditChecklistItemDTO
     */
    'tooltip': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAuditChecklistItemDTO
     */
    'itemDescription': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAuditChecklistItemDTO
     */
    'instructions': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsAuditChecklistItemDTO
     */
    'isCompleted': boolean;
    /**
     * 
     * @type {Array<TransferObjectsAudit2AuditItem2NoteDTO>}
     * @memberof TransferObjectsAuditChecklistItemDTO
     */
    'notes': Array<TransferObjectsAudit2AuditItem2NoteDTO>;
    /**
     * 
     * @type {Array<TransferObjectsAuditAttachmentDTO>}
     * @memberof TransferObjectsAuditChecklistItemDTO
     */
    'attachments': Array<TransferObjectsAuditAttachmentDTO>;
}


/**
 * 
 * @export
 * @interface TransferObjectsAuditLocationsDTO
 */
export interface TransferObjectsAuditLocationsDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAuditLocationsDTO
     */
    'auditID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAuditLocationsDTO
     */
    'location': string;
    /**
     * 
     * @type {EnumerationsAuditStatus}
     * @memberof TransferObjectsAuditLocationsDTO
     */
    'auditStatusID': EnumerationsAuditStatus;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAuditLocationsDTO
     */
    'dueDate': string;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsAuditLocationsDTO
     */
    'progress': number;
}


/**
 * 
 * @export
 * @interface TransferObjectsChecklistTasks
 */
export interface TransferObjectsChecklistTasks {
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsChecklistTasks
     */
    'complianceChecklistItemID': number;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsChecklistTasks
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsChecklistTasks
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsChecklistTasks
     */
    'dueDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsChecklistTasks
     */
    'infoLink': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsChecklistTasks
     */
    'isRegulatory': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsChecklistTasks
     */
    'isFederal': boolean;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsChecklistTasks
     */
    'year': number;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsChecklistTasks
     */
    'sortOrder': number;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsChecklistTasks
     */
    'complianceChecklist2ComplianceChecklistItemID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsChecklistTasks
     */
    'complianceChecklistID': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsChecklistTasks
     */
    'isNA': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsChecklistTasks
     */
    'isCompleted': boolean;
    /**
     * 
     * @type {EnumerationsComplianceChecklistDateType}
     * @memberof TransferObjectsChecklistTasks
     */
    'complianceChecklistDateTypeID': EnumerationsComplianceChecklistDateType;
}


/**
 * 
 * @export
 * @interface TransferObjectsComplianceChecklistDTO
 */
export interface TransferObjectsComplianceChecklistDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsComplianceChecklistDTO
     */
    'complianceChecklistID': string;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsComplianceChecklistDTO
     */
    'checklistYear': number;
    /**
     * 
     * @type {Array<TransferObjectsChecklistTasks>}
     * @memberof TransferObjectsComplianceChecklistDTO
     */
    'federalRegulatoryTasks': Array<TransferObjectsChecklistTasks>;
    /**
     * 
     * @type {Array<TransferObjectsChecklistTasks>}
     * @memberof TransferObjectsComplianceChecklistDTO
     */
    'stateRegulatoryTasks': Array<TransferObjectsChecklistTasks>;
    /**
     * 
     * @type {Array<TransferObjectsChecklistTasks>}
     * @memberof TransferObjectsComplianceChecklistDTO
     */
    'proactiveTasks': Array<TransferObjectsChecklistTasks>;
}
/**
 * 
 * @export
 * @interface TransferObjectsDemographicByPlanDTO
 */
export interface TransferObjectsDemographicByPlanDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsDemographicByPlanDTO
     */
    'planID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsDemographicByPlanDTO
     */
    'planIdentifier': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsDemographicByPlanDTO
     */
    'planName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsDemographicByPlanDTO
     */
    'establishment': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsDemographicByPlanDTO
     */
    'planDate': string;
    /**
     * 
     * @type {Array<DataVizDemographicPercentDTO>}
     * @memberof TransferObjectsDemographicByPlanDTO
     */
    'races': Array<DataVizDemographicPercentDTO>;
    /**
     * 
     * @type {Array<DataVizDemographicPercentDTO>}
     * @memberof TransferObjectsDemographicByPlanDTO
     */
    'genders': Array<DataVizDemographicPercentDTO>;
}
/**
 * 
 * @export
 * @interface TransferObjectsDocumentUploadCountsDTO
 */
export interface TransferObjectsDocumentUploadCountsDTO {
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsDocumentUploadCountsDTO
     */
    'allCount': number;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsDocumentUploadCountsDTO
     */
    'inboxCount': number;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsDocumentUploadCountsDTO
     */
    'sentCount': number;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsDocumentUploadCountsDTO
     */
    'noRecipientCount': number;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsDocumentUploadCountsDTO
     */
    'noClientCount': number;
}
/**
 * 
 * @export
 * @interface TransferObjectsDocumentUploadRecipientDTO
 */
export interface TransferObjectsDocumentUploadRecipientDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsDocumentUploadRecipientDTO
     */
    'recipientName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsDocumentUploadRecipientDTO
     */
    'recipientEmail': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsDropdownItem
 */
export interface TransferObjectsDropdownItem {
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsDropdownItem
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsDropdownItem
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsExportAAPReportRequest
 */
export interface TransferObjectsExportAAPReportRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof TransferObjectsExportAAPReportRequest
     */
    'aapReport2ClientIDs': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransferObjectsExportAAPReportRequest
     */
    'planIDs': Array<string>;
    /**
     * 
     * @type {EnumerationsExportFormat}
     * @memberof TransferObjectsExportAAPReportRequest
     */
    'format': EnumerationsExportFormat;
    /**
     * 
     * @type {EnumerationsExportType}
     * @memberof TransferObjectsExportAAPReportRequest
     */
    'type': EnumerationsExportType;
}


/**
 * 
 * @export
 * @interface TransferObjectsExportAAPSummariesRequest
 */
export interface TransferObjectsExportAAPSummariesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof TransferObjectsExportAAPSummariesRequest
     */
    'planIDs': Array<string>;
    /**
     * 
     * @type {Array<EnumerationsAAPSummary>}
     * @memberof TransferObjectsExportAAPSummariesRequest
     */
    'summaries': Array<EnumerationsAAPSummary>;
}
/**
 * 
 * @export
 * @interface TransferObjectsFeature2ComplianceTypeDTO
 */
export interface TransferObjectsFeature2ComplianceTypeDTO {
    /**
     * 
     * @type {EnumerationsFeature}
     * @memberof TransferObjectsFeature2ComplianceTypeDTO
     */
    'featureID': EnumerationsFeature;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsFeature2ComplianceTypeDTO
     */
    'permitted': boolean;
}


/**
 * 
 * @export
 * @interface TransferObjectsFileZipResponse
 */
export interface TransferObjectsFileZipResponse {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsFileZipResponse
     */
    'name': string;
    /**
     * 
     * @type {EnumerationsFileType}
     * @memberof TransferObjectsFileZipResponse
     */
    'fileType': EnumerationsFileType;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransferObjectsFileZipResponse
     */
    'errors': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsFileZipResponse
     */
    'filePath': string;
}


/**
 * 
 * @export
 * @interface TransferObjectsGetAvailableReportResponse
 */
export interface TransferObjectsGetAvailableReportResponse {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetAvailableReportResponse
     */
    'aapReport2ClientID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetAvailableReportResponse
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetAvailableReportResponse
     */
    'reportCode': string;
    /**
     * 
     * @type {EnumerationsAAPReportClassification}
     * @memberof TransferObjectsGetAvailableReportResponse
     */
    'aapReportClassificationID': EnumerationsAAPReportClassification;
    /**
     * 
     * @type {EnumerationsAAPReportSettingsCategory}
     * @memberof TransferObjectsGetAvailableReportResponse
     */
    'aapReportSettingsCategoryID': EnumerationsAAPReportSettingsCategory;
    /**
     * 
     * @type {EnumerationsAAPReportCategory}
     * @memberof TransferObjectsGetAvailableReportResponse
     */
    'aapReportCategoryID': EnumerationsAAPReportCategory;
    /**
     * 
     * @type {Array<EnumerationsRole>}
     * @memberof TransferObjectsGetAvailableReportResponse
     */
    'rolePermissions': Array<EnumerationsRole>;
    /**
     * 
     * @type {Array<TransferObjectsReportGroupsResponse>}
     * @memberof TransferObjectsGetAvailableReportResponse
     */
    'reportGroups': Array<TransferObjectsReportGroupsResponse>;
}


/**
 * 
 * @export
 * @interface TransferObjectsGetDocumentDetailsResponseDTO
 */
export interface TransferObjectsGetDocumentDetailsResponseDTO {
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsGetDocumentDetailsResponseDTO
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetDocumentDetailsResponseDTO
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetDocumentDetailsResponseDTO
     */
    'clientID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetDocumentDetailsResponseDTO
     */
    'subject': string;
    /**
     * 
     * @type {Array<TransferObjectsUserWithAccess>}
     * @memberof TransferObjectsGetDocumentDetailsResponseDTO
     */
    'usersWithAccess': Array<TransferObjectsUserWithAccess>;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetDocumentDetailsResponseDTO
     */
    'documentMessage': string;
    /**
     * 
     * @type {Array<ClientDataModelsDocumentUploadFile>}
     * @memberof TransferObjectsGetDocumentDetailsResponseDTO
     */
    'fileAttachments': Array<ClientDataModelsDocumentUploadFile>;
    /**
     * 
     * @type {Array<TransferObjectsHistoryWithName>}
     * @memberof TransferObjectsGetDocumentDetailsResponseDTO
     */
    'history': Array<TransferObjectsHistoryWithName>;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsGetDocumentDetailsResponseDTO
     */
    'canUpdate': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetDocumentDetailsResponseDTO
     */
    'projectID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetDocumentDetailsResponseDTO
     */
    'projectName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetDocumentDetailsResponseDTO
     */
    'locationID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetDocumentDetailsResponseDTO
     */
    'locationName'?: string | null;
}
/**
 * 
 * @export
 * @interface TransferObjectsGetDocumentUploadDTO
 */
export interface TransferObjectsGetDocumentUploadDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetDocumentUploadDTO
     */
    'documentUploadID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetDocumentUploadDTO
     */
    'senderName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetDocumentUploadDTO
     */
    'senderEmail': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetDocumentUploadDTO
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetDocumentUploadDTO
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetDocumentUploadDTO
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetDocumentUploadDTO
     */
    'locationName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetDocumentUploadDTO
     */
    'dateSubmitted': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetDocumentUploadDTO
     */
    'clientAccount': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsGetDocumentUploadDTO
     */
    'read': boolean;
    /**
     * 
     * @type {Array<TransferObjectsDocumentUploadRecipientDTO>}
     * @memberof TransferObjectsGetDocumentUploadDTO
     */
    'recipients': Array<TransferObjectsDocumentUploadRecipientDTO>;
}
/**
 * 
 * @export
 * @interface TransferObjectsGetReportGroupsResponseDTO
 */
export interface TransferObjectsGetReportGroupsResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetReportGroupsResponseDTO
     */
    'reportGroupID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetReportGroupsResponseDTO
     */
    'groupName': string;
    /**
     * 
     * @type {Array<TransferObjectsGetReportsResponseDTO>}
     * @memberof TransferObjectsGetReportGroupsResponseDTO
     */
    'reports': Array<TransferObjectsGetReportsResponseDTO>;
}
/**
 * 
 * @export
 * @interface TransferObjectsGetReportsResponseDTO
 */
export interface TransferObjectsGetReportsResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetReportsResponseDTO
     */
    'aapReport2ClientID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetReportsResponseDTO
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGetReportsResponseDTO
     */
    'reportCode': string;
    /**
     * 
     * @type {EnumerationsAAPReportClassification}
     * @memberof TransferObjectsGetReportsResponseDTO
     */
    'aapReportClassificationID': EnumerationsAAPReportClassification;
    /**
     * 
     * @type {EnumerationsAAPReportCategory}
     * @memberof TransferObjectsGetReportsResponseDTO
     */
    'aapReportCategoryID': EnumerationsAAPReportCategory;
    /**
     * 
     * @type {EnumerationsAAPReportSettingsCategory}
     * @memberof TransferObjectsGetReportsResponseDTO
     */
    'aapReportSettingsCategoryID': EnumerationsAAPReportSettingsCategory;
}


/**
 * 
 * @export
 * @interface TransferObjectsHistoryWithName
 */
export interface TransferObjectsHistoryWithName {
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsHistoryWithName
     */
    'documentHistoryID': number;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsHistoryWithName
     */
    'documentUploadID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsHistoryWithName
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsHistoryWithName
     */
    'notes'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsHistoryWithName
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsHistoryWithName
     */
    'ipAddress'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsHistoryWithName
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsHistoryWithName
     */
    'lastName': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsPlanInfo
 */
export interface TransferObjectsPlanInfo {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'planID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'planIdentifier': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'planDate': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'planName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'establishment': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'planCode': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'publishDate': string;
    /**
     * 
     * @type {EnumerationsPlanType}
     * @memberof TransferObjectsPlanInfo
     */
    'planType': EnumerationsPlanType;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsPlanInfo
     */
    'updatePlan': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'reportLastAccessed'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsPlanInfo
     */
    'ipedsSchedule': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsPlanInfo
     */
    'isPublished': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsPlanInfo
     */
    'underAudit': boolean;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsPlanInfo
     */
    'aapPlanID': number;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'actionOrientedProgramLastAccessed'?: string | null;
    /**
     * 
     * @type {EnumerationsComplianceType}
     * @memberof TransferObjectsPlanInfo
     */
    'complianceTypeID': EnumerationsComplianceType;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsPlanInfo
     */
    'gfeAssessmentLastAccessed'?: string | null;
}


/**
 * 
 * @export
 * @interface TransferObjectsReadZipResponse
 */
export interface TransferObjectsReadZipResponse {
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsReadZipResponse
     */
    'errorCount': number;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsReadZipResponse
     */
    'fileCount': number;
    /**
     * 
     * @type {Array<TransferObjectsSectionZipResponse>}
     * @memberof TransferObjectsReadZipResponse
     */
    'sections': Array<TransferObjectsSectionZipResponse>;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsReadZipResponse
     */
    'zipName': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsReadZipResponse
     */
    'hasNestedFolders': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsReadZipResponse
     */
    'batchID': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsReportGroupsResponse
 */
export interface TransferObjectsReportGroupsResponse {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsReportGroupsResponse
     */
    'reportGroupID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsReportGroupsResponse
     */
    'groupName': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsResponseDTO
 */
export interface TransferObjectsResponseDTO {
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsResponseDTO
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsResponseDTO
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsSectionZipResponse
 */
export interface TransferObjectsSectionZipResponse {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSectionZipResponse
     */
    'name': string;
    /**
     * 
     * @type {Array<TransferObjectsFileZipResponse>}
     * @memberof TransferObjectsSectionZipResponse
     */
    'files': Array<TransferObjectsFileZipResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransferObjectsSectionZipResponse
     */
    'errors': Array<string>;
}
/**
 * 
 * @export
 * @interface TransferObjectsSelectedPlanDTO
 */
export interface TransferObjectsSelectedPlanDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedPlanDTO
     */
    'planID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedPlanDTO
     */
    'planIdentifier': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedPlanDTO
     */
    'planDate': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedPlanDTO
     */
    'planName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedPlanDTO
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedPlanDTO
     */
    'establishment': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedPlanDTO
     */
    'planCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsSelectedPlanDTO
     */
    'isPublished': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedPlanDTO
     */
    'publishDate': string;
    /**
     * 
     * @type {EnumerationsPlanType}
     * @memberof TransferObjectsSelectedPlanDTO
     */
    'planType': EnumerationsPlanType;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsSelectedPlanDTO
     */
    'updatePlan': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedPlanDTO
     */
    'masterPlanID'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsSelectedPlanDTO
     */
    'selected': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsSelectedPlanDTO
     */
    'ipedsSchedule': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsSelectedPlanDTO
     */
    'underAudit': boolean;
    /**
     * 
     * @type {EnumerationsComplianceType}
     * @memberof TransferObjectsSelectedPlanDTO
     */
    'complianceTypeID': EnumerationsComplianceType;
}


/**
 * 
 * @export
 * @interface TransferObjectsStatusCodeResponseDTO
 */
export interface TransferObjectsStatusCodeResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsStatusCodeResponseDTO
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsSubPlanResponseDTO
 */
export interface TransferObjectsSubPlanResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSubPlanResponseDTO
     */
    'planID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSubPlanResponseDTO
     */
    'clientID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSubPlanResponseDTO
     */
    'planIdentifier': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSubPlanResponseDTO
     */
    'establishment': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSubPlanResponseDTO
     */
    'planCode': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSubPlanResponseDTO
     */
    'company': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsSubPlanResponseDTO
     */
    'selected': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSubPlanResponseDTO
     */
    'planDate': string;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSubPlanResponseDTO
     */
    'aapPlanID': number;
}
/**
 * 
 * @export
 * @interface TransferObjectsUpdateUnassignedDocumentDTO
 */
export interface TransferObjectsUpdateUnassignedDocumentDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsUpdateUnassignedDocumentDTO
     */
    'documentUploadID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsUpdateUnassignedDocumentDTO
     */
    'clientID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsUpdateUnassignedDocumentDTO
     */
    'userID'?: string | null;
}
/**
 * 
 * @export
 * @interface TransferObjectsUserWithAccess
 */
export interface TransferObjectsUserWithAccess {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsUserWithAccess
     */
    'userID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsUserWithAccess
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsUserWithAccess
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsUserWithAccess
     */
    'email': string;
}

/**
 * AAPReportsApi - axios parameter creator
 * @export
 */
export const AAPReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} aapReport2ClientID 
         * @param {Array<EnumerationsRole>} [enumerationsRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsAapReport2ClientIDReportExclusionsPost: async (aapReport2ClientID: string, enumerationsRole?: Array<EnumerationsRole>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'aapReport2ClientID' is not null or undefined
            assertParamExists('apiAAPReportsAapReport2ClientIDReportExclusionsPost', 'aapReport2ClientID', aapReport2ClientID)
            const localVarPath = `/api/AAPReports/{aapReport2ClientID}/report-exclusions`
                .replace(`{${"aapReport2ClientID"}}`, encodeURIComponent(String(aapReport2ClientID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enumerationsRole, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsAvailableReportsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AAPReports/available-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} exportNotificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsExportNotificationIDRetryPost: async (exportNotificationID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'exportNotificationID' is not null or undefined
            assertParamExists('apiAAPReportsExportNotificationIDRetryPost', 'exportNotificationID', exportNotificationID)
            const localVarPath = `/api/AAPReports/{exportNotificationID}/retry`
                .replace(`{${"exportNotificationID"}}`, encodeURIComponent(String(exportNotificationID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferObjectsExportAAPReportRequest} [transferObjectsExportAAPReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsExportPost: async (transferObjectsExportAAPReportRequest?: TransferObjectsExportAAPReportRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AAPReports/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferObjectsExportAAPReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsExportSettingsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AAPReports/export-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferObjectsExportAAPSummariesRequest} [transferObjectsExportAAPSummariesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsExportSummariesPost: async (transferObjectsExportAAPSummariesRequest?: TransferObjectsExportAAPSummariesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AAPReports/export-summaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferObjectsExportAAPSummariesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsManageReportGroupsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AAPReports/manage-report-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsNotificationIDCancelExportPost: async (notificationID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationID' is not null or undefined
            assertParamExists('apiAAPReportsNotificationIDCancelExportPost', 'notificationID', notificationID)
            const localVarPath = `/api/AAPReports/{notificationID}/cancel-export`
                .replace(`{${"notificationID"}}`, encodeURIComponent(String(notificationID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsPlanPlanIDReportGroupsGet: async (planID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('apiAAPReportsPlanPlanIDReportGroupsGet', 'planID', planID)
            const localVarPath = `/api/AAPReports/plan/{planID}/report-groups`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsExportSettingsCommand} [commandsExportSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsPost: async (commandsExportSettingsCommand?: CommandsExportSettingsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AAPReports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsExportSettingsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} previewID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsPreviewIDPost: async (previewID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'previewID' is not null or undefined
            assertParamExists('apiAAPReportsPreviewIDPost', 'previewID', previewID)
            const localVarPath = `/api/AAPReports/{previewID}`
                .replace(`{${"previewID"}}`, encodeURIComponent(String(previewID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreatePreviewIDRequest} [commandsCreatePreviewIDRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsPreviewIDPost_1: async (commandsCreatePreviewIDRequest?: CommandsCreatePreviewIDRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AAPReports/previewID`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreatePreviewIDRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} reportDownloadID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsReportDownloadIDDownloadGet: async (reportDownloadID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportDownloadID' is not null or undefined
            assertParamExists('apiAAPReportsReportDownloadIDDownloadGet', 'reportDownloadID', reportDownloadID)
            const localVarPath = `/api/AAPReports/{reportDownloadID}/download`
                .replace(`{${"reportDownloadID"}}`, encodeURIComponent(String(reportDownloadID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsSaveReportGroupsCommand} [commandsSaveReportGroupsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsReportGroupsPost: async (commandsSaveReportGroupsCommand?: CommandsSaveReportGroupsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AAPReports/report-groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsSaveReportGroupsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} isBerkshireWest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsRevertToDefaultIsBerkshireWestPost: async (isBerkshireWest: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'isBerkshireWest' is not null or undefined
            assertParamExists('apiAAPReportsRevertToDefaultIsBerkshireWestPost', 'isBerkshireWest', isBerkshireWest)
            const localVarPath = `/api/AAPReports/revert-to-default/{isBerkshireWest}`
                .replace(`{${"isBerkshireWest"}}`, encodeURIComponent(String(isBerkshireWest)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} masterPlanID 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsSubplansMasterPlanIDPost: async (masterPlanID: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'masterPlanID' is not null or undefined
            assertParamExists('apiAAPReportsSubplansMasterPlanIDPost', 'masterPlanID', masterPlanID)
            const localVarPath = `/api/AAPReports/subplans/{masterPlanID}`
                .replace(`{${"masterPlanID"}}`, encodeURIComponent(String(masterPlanID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AAPReportsApi - functional programming interface
 * @export
 */
export const AAPReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AAPReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} aapReport2ClientID 
         * @param {Array<EnumerationsRole>} [enumerationsRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAAPReportsAapReport2ClientIDReportExclusionsPost(aapReport2ClientID: string, enumerationsRole?: Array<EnumerationsRole>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAAPReportsAapReport2ClientIDReportExclusionsPost(aapReport2ClientID, enumerationsRole, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AAPReportsApi.apiAAPReportsAapReport2ClientIDReportExclusionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAAPReportsAvailableReportsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransferObjectsGetAvailableReportResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAAPReportsAvailableReportsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AAPReportsApi.apiAAPReportsAvailableReportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} exportNotificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAAPReportsExportNotificationIDRetryPost(exportNotificationID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAAPReportsExportNotificationIDRetryPost(exportNotificationID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AAPReportsApi.apiAAPReportsExportNotificationIDRetryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TransferObjectsExportAAPReportRequest} [transferObjectsExportAAPReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAAPReportsExportPost(transferObjectsExportAAPReportRequest?: TransferObjectsExportAAPReportRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAAPReportsExportPost(transferObjectsExportAAPReportRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AAPReportsApi.apiAAPReportsExportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAAPReportsExportSettingsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetExportSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAAPReportsExportSettingsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AAPReportsApi.apiAAPReportsExportSettingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TransferObjectsExportAAPSummariesRequest} [transferObjectsExportAAPSummariesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAAPReportsExportSummariesPost(transferObjectsExportAAPSummariesRequest?: TransferObjectsExportAAPSummariesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAAPReportsExportSummariesPost(transferObjectsExportAAPSummariesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AAPReportsApi.apiAAPReportsExportSummariesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAAPReportsManageReportGroupsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransferObjectsGetReportGroupsResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAAPReportsManageReportGroupsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AAPReportsApi.apiAAPReportsManageReportGroupsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAAPReportsNotificationIDCancelExportPost(notificationID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAAPReportsNotificationIDCancelExportPost(notificationID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AAPReportsApi.apiAAPReportsNotificationIDCancelExportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} planID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAAPReportsPlanPlanIDReportGroupsGet(planID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransferObjectsGetReportGroupsResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAAPReportsPlanPlanIDReportGroupsGet(planID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AAPReportsApi.apiAAPReportsPlanPlanIDReportGroupsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsExportSettingsCommand} [commandsExportSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAAPReportsPost(commandsExportSettingsCommand?: CommandsExportSettingsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAAPReportsPost(commandsExportSettingsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AAPReportsApi.apiAAPReportsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} previewID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAAPReportsPreviewIDPost(previewID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsGeneratePreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAAPReportsPreviewIDPost(previewID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AAPReportsApi.apiAAPReportsPreviewIDPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreatePreviewIDRequest} [commandsCreatePreviewIDRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAAPReportsPreviewIDPost_1(commandsCreatePreviewIDRequest?: CommandsCreatePreviewIDRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsCreatePreviewIDResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAAPReportsPreviewIDPost_1(commandsCreatePreviewIDRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AAPReportsApi.apiAAPReportsPreviewIDPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} reportDownloadID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAAPReportsReportDownloadIDDownloadGet(reportDownloadID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAAPReportsReportDownloadIDDownloadGet(reportDownloadID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AAPReportsApi.apiAAPReportsReportDownloadIDDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsSaveReportGroupsCommand} [commandsSaveReportGroupsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAAPReportsReportGroupsPost(commandsSaveReportGroupsCommand?: CommandsSaveReportGroupsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAAPReportsReportGroupsPost(commandsSaveReportGroupsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AAPReportsApi.apiAAPReportsReportGroupsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} isBerkshireWest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAAPReportsRevertToDefaultIsBerkshireWestPost(isBerkshireWest: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAAPReportsRevertToDefaultIsBerkshireWestPost(isBerkshireWest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AAPReportsApi.apiAAPReportsRevertToDefaultIsBerkshireWestPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} masterPlanID 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAAPReportsSubplansMasterPlanIDPost(masterPlanID: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAAPReportsSubplansMasterPlanIDPost(masterPlanID, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AAPReportsApi.apiAAPReportsSubplansMasterPlanIDPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AAPReportsApi - factory interface
 * @export
 */
export const AAPReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AAPReportsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} aapReport2ClientID 
         * @param {Array<EnumerationsRole>} [enumerationsRole] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsAapReport2ClientIDReportExclusionsPost(aapReport2ClientID: string, enumerationsRole?: Array<EnumerationsRole>, options?: any): AxiosPromise<File> {
            return localVarFp.apiAAPReportsAapReport2ClientIDReportExclusionsPost(aapReport2ClientID, enumerationsRole, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsAvailableReportsGet(options?: any): AxiosPromise<Array<TransferObjectsGetAvailableReportResponse>> {
            return localVarFp.apiAAPReportsAvailableReportsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} exportNotificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsExportNotificationIDRetryPost(exportNotificationID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiAAPReportsExportNotificationIDRetryPost(exportNotificationID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferObjectsExportAAPReportRequest} [transferObjectsExportAAPReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsExportPost(transferObjectsExportAAPReportRequest?: TransferObjectsExportAAPReportRequest, options?: any): AxiosPromise<string> {
            return localVarFp.apiAAPReportsExportPost(transferObjectsExportAAPReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsExportSettingsGet(options?: any): AxiosPromise<QueriesGetExportSettingsResponse> {
            return localVarFp.apiAAPReportsExportSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferObjectsExportAAPSummariesRequest} [transferObjectsExportAAPSummariesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsExportSummariesPost(transferObjectsExportAAPSummariesRequest?: TransferObjectsExportAAPSummariesRequest, options?: any): AxiosPromise<string> {
            return localVarFp.apiAAPReportsExportSummariesPost(transferObjectsExportAAPSummariesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsManageReportGroupsGet(options?: any): AxiosPromise<Array<TransferObjectsGetReportGroupsResponseDTO>> {
            return localVarFp.apiAAPReportsManageReportGroupsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsNotificationIDCancelExportPost(notificationID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiAAPReportsNotificationIDCancelExportPost(notificationID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsPlanPlanIDReportGroupsGet(planID: string, options?: any): AxiosPromise<Array<TransferObjectsGetReportGroupsResponseDTO>> {
            return localVarFp.apiAAPReportsPlanPlanIDReportGroupsGet(planID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsExportSettingsCommand} [commandsExportSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsPost(commandsExportSettingsCommand?: CommandsExportSettingsCommand, options?: any): AxiosPromise<File> {
            return localVarFp.apiAAPReportsPost(commandsExportSettingsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} previewID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsPreviewIDPost(previewID: string, options?: any): AxiosPromise<CommandsGeneratePreviewResponse> {
            return localVarFp.apiAAPReportsPreviewIDPost(previewID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreatePreviewIDRequest} [commandsCreatePreviewIDRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsPreviewIDPost_1(commandsCreatePreviewIDRequest?: CommandsCreatePreviewIDRequest, options?: any): AxiosPromise<CommandsCreatePreviewIDResponse> {
            return localVarFp.apiAAPReportsPreviewIDPost_1(commandsCreatePreviewIDRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} reportDownloadID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsReportDownloadIDDownloadGet(reportDownloadID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiAAPReportsReportDownloadIDDownloadGet(reportDownloadID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsSaveReportGroupsCommand} [commandsSaveReportGroupsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsReportGroupsPost(commandsSaveReportGroupsCommand?: CommandsSaveReportGroupsCommand, options?: any): AxiosPromise<File> {
            return localVarFp.apiAAPReportsReportGroupsPost(commandsSaveReportGroupsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} isBerkshireWest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsRevertToDefaultIsBerkshireWestPost(isBerkshireWest: boolean, options?: any): AxiosPromise<File> {
            return localVarFp.apiAAPReportsRevertToDefaultIsBerkshireWestPost(isBerkshireWest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} masterPlanID 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAAPReportsSubplansMasterPlanIDPost(masterPlanID: string, requestBody?: Array<string>, options?: any): AxiosPromise<File> {
            return localVarFp.apiAAPReportsSubplansMasterPlanIDPost(masterPlanID, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AAPReportsApi - object-oriented interface
 * @export
 * @class AAPReportsApi
 * @extends {BaseAPI}
 */
export class AAPReportsApi extends BaseAPI {
    /**
     * 
     * @param {string} aapReport2ClientID 
     * @param {Array<EnumerationsRole>} [enumerationsRole] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AAPReportsApi
     */
    public apiAAPReportsAapReport2ClientIDReportExclusionsPost(aapReport2ClientID: string, enumerationsRole?: Array<EnumerationsRole>, options?: RawAxiosRequestConfig) {
        return AAPReportsApiFp(this.configuration).apiAAPReportsAapReport2ClientIDReportExclusionsPost(aapReport2ClientID, enumerationsRole, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AAPReportsApi
     */
    public apiAAPReportsAvailableReportsGet(options?: RawAxiosRequestConfig) {
        return AAPReportsApiFp(this.configuration).apiAAPReportsAvailableReportsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} exportNotificationID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AAPReportsApi
     */
    public apiAAPReportsExportNotificationIDRetryPost(exportNotificationID: string, options?: RawAxiosRequestConfig) {
        return AAPReportsApiFp(this.configuration).apiAAPReportsExportNotificationIDRetryPost(exportNotificationID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferObjectsExportAAPReportRequest} [transferObjectsExportAAPReportRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AAPReportsApi
     */
    public apiAAPReportsExportPost(transferObjectsExportAAPReportRequest?: TransferObjectsExportAAPReportRequest, options?: RawAxiosRequestConfig) {
        return AAPReportsApiFp(this.configuration).apiAAPReportsExportPost(transferObjectsExportAAPReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AAPReportsApi
     */
    public apiAAPReportsExportSettingsGet(options?: RawAxiosRequestConfig) {
        return AAPReportsApiFp(this.configuration).apiAAPReportsExportSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferObjectsExportAAPSummariesRequest} [transferObjectsExportAAPSummariesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AAPReportsApi
     */
    public apiAAPReportsExportSummariesPost(transferObjectsExportAAPSummariesRequest?: TransferObjectsExportAAPSummariesRequest, options?: RawAxiosRequestConfig) {
        return AAPReportsApiFp(this.configuration).apiAAPReportsExportSummariesPost(transferObjectsExportAAPSummariesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AAPReportsApi
     */
    public apiAAPReportsManageReportGroupsGet(options?: RawAxiosRequestConfig) {
        return AAPReportsApiFp(this.configuration).apiAAPReportsManageReportGroupsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} notificationID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AAPReportsApi
     */
    public apiAAPReportsNotificationIDCancelExportPost(notificationID: string, options?: RawAxiosRequestConfig) {
        return AAPReportsApiFp(this.configuration).apiAAPReportsNotificationIDCancelExportPost(notificationID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AAPReportsApi
     */
    public apiAAPReportsPlanPlanIDReportGroupsGet(planID: string, options?: RawAxiosRequestConfig) {
        return AAPReportsApiFp(this.configuration).apiAAPReportsPlanPlanIDReportGroupsGet(planID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsExportSettingsCommand} [commandsExportSettingsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AAPReportsApi
     */
    public apiAAPReportsPost(commandsExportSettingsCommand?: CommandsExportSettingsCommand, options?: RawAxiosRequestConfig) {
        return AAPReportsApiFp(this.configuration).apiAAPReportsPost(commandsExportSettingsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} previewID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AAPReportsApi
     */
    public apiAAPReportsPreviewIDPost(previewID: string, options?: RawAxiosRequestConfig) {
        return AAPReportsApiFp(this.configuration).apiAAPReportsPreviewIDPost(previewID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreatePreviewIDRequest} [commandsCreatePreviewIDRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AAPReportsApi
     */
    public apiAAPReportsPreviewIDPost_1(commandsCreatePreviewIDRequest?: CommandsCreatePreviewIDRequest, options?: RawAxiosRequestConfig) {
        return AAPReportsApiFp(this.configuration).apiAAPReportsPreviewIDPost_1(commandsCreatePreviewIDRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} reportDownloadID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AAPReportsApi
     */
    public apiAAPReportsReportDownloadIDDownloadGet(reportDownloadID: string, options?: RawAxiosRequestConfig) {
        return AAPReportsApiFp(this.configuration).apiAAPReportsReportDownloadIDDownloadGet(reportDownloadID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsSaveReportGroupsCommand} [commandsSaveReportGroupsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AAPReportsApi
     */
    public apiAAPReportsReportGroupsPost(commandsSaveReportGroupsCommand?: CommandsSaveReportGroupsCommand, options?: RawAxiosRequestConfig) {
        return AAPReportsApiFp(this.configuration).apiAAPReportsReportGroupsPost(commandsSaveReportGroupsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} isBerkshireWest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AAPReportsApi
     */
    public apiAAPReportsRevertToDefaultIsBerkshireWestPost(isBerkshireWest: boolean, options?: RawAxiosRequestConfig) {
        return AAPReportsApiFp(this.configuration).apiAAPReportsRevertToDefaultIsBerkshireWestPost(isBerkshireWest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} masterPlanID 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AAPReportsApi
     */
    public apiAAPReportsSubplansMasterPlanIDPost(masterPlanID: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return AAPReportsApiFp(this.configuration).apiAAPReportsSubplansMasterPlanIDPost(masterPlanID, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ActionOrientedProgramsApi - axios parameter creator
 * @export
 */
export const ActionOrientedProgramsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CommandsUpdateActionOrientedProgramGoalsRequest} [commandsUpdateActionOrientedProgramGoalsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActionOrientedProgramsEditPut: async (commandsUpdateActionOrientedProgramGoalsRequest?: CommandsUpdateActionOrientedProgramGoalsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ActionOrientedPrograms/edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateActionOrientedProgramGoalsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActionOrientedProgramsPlanIDGet: async (planID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('apiActionOrientedProgramsPlanIDGet', 'planID', planID)
            const localVarPath = `/api/ActionOrientedPrograms/{planID}`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActionOrientedProgramsApi - functional programming interface
 * @export
 */
export const ActionOrientedProgramsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActionOrientedProgramsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CommandsUpdateActionOrientedProgramGoalsRequest} [commandsUpdateActionOrientedProgramGoalsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiActionOrientedProgramsEditPut(commandsUpdateActionOrientedProgramGoalsRequest?: CommandsUpdateActionOrientedProgramGoalsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiActionOrientedProgramsEditPut(commandsUpdateActionOrientedProgramGoalsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionOrientedProgramsApi.apiActionOrientedProgramsEditPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} planID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiActionOrientedProgramsPlanIDGet(planID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetActionOrientedProgramGoalsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiActionOrientedProgramsPlanIDGet(planID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionOrientedProgramsApi.apiActionOrientedProgramsPlanIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActionOrientedProgramsApi - factory interface
 * @export
 */
export const ActionOrientedProgramsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActionOrientedProgramsApiFp(configuration)
    return {
        /**
         * 
         * @param {CommandsUpdateActionOrientedProgramGoalsRequest} [commandsUpdateActionOrientedProgramGoalsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActionOrientedProgramsEditPut(commandsUpdateActionOrientedProgramGoalsRequest?: CommandsUpdateActionOrientedProgramGoalsRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiActionOrientedProgramsEditPut(commandsUpdateActionOrientedProgramGoalsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiActionOrientedProgramsPlanIDGet(planID: string, options?: any): AxiosPromise<QueriesGetActionOrientedProgramGoalsResponse> {
            return localVarFp.apiActionOrientedProgramsPlanIDGet(planID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActionOrientedProgramsApi - object-oriented interface
 * @export
 * @class ActionOrientedProgramsApi
 * @extends {BaseAPI}
 */
export class ActionOrientedProgramsApi extends BaseAPI {
    /**
     * 
     * @param {CommandsUpdateActionOrientedProgramGoalsRequest} [commandsUpdateActionOrientedProgramGoalsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionOrientedProgramsApi
     */
    public apiActionOrientedProgramsEditPut(commandsUpdateActionOrientedProgramGoalsRequest?: CommandsUpdateActionOrientedProgramGoalsRequest, options?: RawAxiosRequestConfig) {
        return ActionOrientedProgramsApiFp(this.configuration).apiActionOrientedProgramsEditPut(commandsUpdateActionOrientedProgramGoalsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionOrientedProgramsApi
     */
    public apiActionOrientedProgramsPlanIDGet(planID: string, options?: RawAxiosRequestConfig) {
        return ActionOrientedProgramsApiFp(this.configuration).apiActionOrientedProgramsPlanIDGet(planID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdverseImpactDataVisualizationsApi - axios parameter creator
 * @export
 */
export const AdverseImpactDataVisualizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsActionTypesAllGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AdverseImpactDataVisualizations/action-types/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsActionTypesDropdownGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AdverseImpactDataVisualizations/action-types/dropdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsActionTypesPut: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AdverseImpactDataVisualizations/action-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planID 
         * @param {string} jobGroup 
         * @param {boolean} isSignificant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsActionTypesRefreshLevel2PlanPlanIDJobGroupJobGroupSignificantIsSignificantGet: async (planID: string, jobGroup: string, isSignificant: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('apiAdverseImpactDataVisualizationsActionTypesRefreshLevel2PlanPlanIDJobGroupJobGroupSignificantIsSignificantGet', 'planID', planID)
            // verify required parameter 'jobGroup' is not null or undefined
            assertParamExists('apiAdverseImpactDataVisualizationsActionTypesRefreshLevel2PlanPlanIDJobGroupJobGroupSignificantIsSignificantGet', 'jobGroup', jobGroup)
            // verify required parameter 'isSignificant' is not null or undefined
            assertParamExists('apiAdverseImpactDataVisualizationsActionTypesRefreshLevel2PlanPlanIDJobGroupJobGroupSignificantIsSignificantGet', 'isSignificant', isSignificant)
            const localVarPath = `/api/AdverseImpactDataVisualizations/action-types-refresh-level2/plan/{planID}/job-group/{jobGroup}/significant/{isSignificant}`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"jobGroup"}}`, encodeURIComponent(String(jobGroup)))
                .replace(`{${"isSignificant"}}`, encodeURIComponent(String(isSignificant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsAdverseImpactFilterBy} [adverseImpactFilterBy] 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [actionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsAiDonutChartDrilldownGet: async (adverseImpactFilterBy?: EnumerationsAdverseImpactFilterBy, filterBy?: EnumerationsDataVisualizationFilterBy, actionType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AdverseImpactDataVisualizations/ai-donut-chart-drilldown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adverseImpactFilterBy !== undefined) {
                localVarQueryParameter['adverseImpactFilterBy'] = adverseImpactFilterBy;
            }

            if (filterBy !== undefined) {
                localVarQueryParameter['filterBy'] = filterBy;
            }

            if (actionType !== undefined) {
                localVarQueryParameter['actionType'] = actionType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsAdverseImpactFilterBy} [adverseImpactFilterBy] 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [eeoCode] 
         * @param {string} [actionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsAiDrilldownByJobGroupForEeoGet: async (adverseImpactFilterBy?: EnumerationsAdverseImpactFilterBy, filterBy?: EnumerationsDataVisualizationFilterBy, eeoCode?: string, actionType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AdverseImpactDataVisualizations/ai-drilldown-by-job-group-for-eeo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adverseImpactFilterBy !== undefined) {
                localVarQueryParameter['adverseImpactFilterBy'] = adverseImpactFilterBy;
            }

            if (filterBy !== undefined) {
                localVarQueryParameter['filterBy'] = filterBy;
            }

            if (eeoCode !== undefined) {
                localVarQueryParameter['eeoCode'] = eeoCode;
            }

            if (actionType !== undefined) {
                localVarQueryParameter['actionType'] = actionType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [planID] 
         * @param {string} [actionType] 
         * @param {string} [jobGroup] 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {boolean} [isSignificant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsByJobTitleForJobGroupDrilldownGet: async (planID?: string, actionType?: string, jobGroup?: string, filterBy?: EnumerationsDataVisualizationFilterBy, isSignificant?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AdverseImpactDataVisualizations/by-job-title-for-job-group-drilldown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (planID !== undefined) {
                localVarQueryParameter['planID'] = planID;
            }

            if (actionType !== undefined) {
                localVarQueryParameter['actionType'] = actionType;
            }

            if (jobGroup !== undefined) {
                localVarQueryParameter['jobGroup'] = jobGroup;
            }

            if (filterBy !== undefined) {
                localVarQueryParameter['filterBy'] = filterBy;
            }

            if (isSignificant !== undefined) {
                localVarQueryParameter['isSignificant'] = isSignificant;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobGroup 
         * @param {boolean} isSignificant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsDropdownDefaultsLevel2JobGroupJobGroupSignificantIsSignificantGet: async (jobGroup: string, isSignificant: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobGroup' is not null or undefined
            assertParamExists('apiAdverseImpactDataVisualizationsDropdownDefaultsLevel2JobGroupJobGroupSignificantIsSignificantGet', 'jobGroup', jobGroup)
            // verify required parameter 'isSignificant' is not null or undefined
            assertParamExists('apiAdverseImpactDataVisualizationsDropdownDefaultsLevel2JobGroupJobGroupSignificantIsSignificantGet', 'isSignificant', isSignificant)
            const localVarPath = `/api/AdverseImpactDataVisualizations/dropdown-defaults-level2/job-group/{jobGroup}/significant/{isSignificant}`
                .replace(`{${"jobGroup"}}`, encodeURIComponent(String(jobGroup)))
                .replace(`{${"isSignificant"}}`, encodeURIComponent(String(isSignificant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationResultsBy} [resultsBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsGet: async (resultsBy?: EnumerationsDataVisualizationResultsBy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AdverseImpactDataVisualizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resultsBy !== undefined) {
                localVarQueryParameter['resultsBy'] = resultsBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdverseImpactDataVisualizationsApi - functional programming interface
 * @export
 */
export const AdverseImpactDataVisualizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdverseImpactDataVisualizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdverseImpactDataVisualizationsActionTypesAllGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataVizGetAllActionTypesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdverseImpactDataVisualizationsActionTypesAllGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdverseImpactDataVisualizationsApi.apiAdverseImpactDataVisualizationsActionTypesAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdverseImpactDataVisualizationsActionTypesDropdownGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataVizActionTypeDropdownItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdverseImpactDataVisualizationsActionTypesDropdownGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdverseImpactDataVisualizationsApi.apiAdverseImpactDataVisualizationsActionTypesDropdownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdverseImpactDataVisualizationsActionTypesPut(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdverseImpactDataVisualizationsActionTypesPut(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdverseImpactDataVisualizationsApi.apiAdverseImpactDataVisualizationsActionTypesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} planID 
         * @param {string} jobGroup 
         * @param {boolean} isSignificant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdverseImpactDataVisualizationsActionTypesRefreshLevel2PlanPlanIDJobGroupJobGroupSignificantIsSignificantGet(planID: string, jobGroup: string, isSignificant: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetActionTypesForPlanResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdverseImpactDataVisualizationsActionTypesRefreshLevel2PlanPlanIDJobGroupJobGroupSignificantIsSignificantGet(planID, jobGroup, isSignificant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdverseImpactDataVisualizationsApi.apiAdverseImpactDataVisualizationsActionTypesRefreshLevel2PlanPlanIDJobGroupJobGroupSignificantIsSignificantGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsAdverseImpactFilterBy} [adverseImpactFilterBy] 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [actionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdverseImpactDataVisualizationsAiDonutChartDrilldownGet(adverseImpactFilterBy?: EnumerationsAdverseImpactFilterBy, filterBy?: EnumerationsDataVisualizationFilterBy, actionType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetAdverseImpactDonutChartDrilldownDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdverseImpactDataVisualizationsAiDonutChartDrilldownGet(adverseImpactFilterBy, filterBy, actionType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdverseImpactDataVisualizationsApi.apiAdverseImpactDataVisualizationsAiDonutChartDrilldownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsAdverseImpactFilterBy} [adverseImpactFilterBy] 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [eeoCode] 
         * @param {string} [actionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdverseImpactDataVisualizationsAiDrilldownByJobGroupForEeoGet(adverseImpactFilterBy?: EnumerationsAdverseImpactFilterBy, filterBy?: EnumerationsDataVisualizationFilterBy, eeoCode?: string, actionType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetAdverseImpactDrilldownByJobGroupForEEOResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdverseImpactDataVisualizationsAiDrilldownByJobGroupForEeoGet(adverseImpactFilterBy, filterBy, eeoCode, actionType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdverseImpactDataVisualizationsApi.apiAdverseImpactDataVisualizationsAiDrilldownByJobGroupForEeoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [planID] 
         * @param {string} [actionType] 
         * @param {string} [jobGroup] 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {boolean} [isSignificant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdverseImpactDataVisualizationsByJobTitleForJobGroupDrilldownGet(planID?: string, actionType?: string, jobGroup?: string, filterBy?: EnumerationsDataVisualizationFilterBy, isSignificant?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetAdverseImpactLevel2DrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdverseImpactDataVisualizationsByJobTitleForJobGroupDrilldownGet(planID, actionType, jobGroup, filterBy, isSignificant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdverseImpactDataVisualizationsApi.apiAdverseImpactDataVisualizationsByJobTitleForJobGroupDrilldownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobGroup 
         * @param {boolean} isSignificant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdverseImpactDataVisualizationsDropdownDefaultsLevel2JobGroupJobGroupSignificantIsSignificantGet(jobGroup: string, isSignificant: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueriesAdverseImpactPlanDropdownData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdverseImpactDataVisualizationsDropdownDefaultsLevel2JobGroupJobGroupSignificantIsSignificantGet(jobGroup, isSignificant, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdverseImpactDataVisualizationsApi.apiAdverseImpactDataVisualizationsDropdownDefaultsLevel2JobGroupJobGroupSignificantIsSignificantGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationResultsBy} [resultsBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdverseImpactDataVisualizationsGet(resultsBy?: EnumerationsDataVisualizationResultsBy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetAdverseImpactDataVisualizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdverseImpactDataVisualizationsGet(resultsBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdverseImpactDataVisualizationsApi.apiAdverseImpactDataVisualizationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdverseImpactDataVisualizationsApi - factory interface
 * @export
 */
export const AdverseImpactDataVisualizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdverseImpactDataVisualizationsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsActionTypesAllGet(options?: any): AxiosPromise<DataVizGetAllActionTypesResponse> {
            return localVarFp.apiAdverseImpactDataVisualizationsActionTypesAllGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsActionTypesDropdownGet(options?: any): AxiosPromise<Array<DataVizActionTypeDropdownItem>> {
            return localVarFp.apiAdverseImpactDataVisualizationsActionTypesDropdownGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsActionTypesPut(requestBody?: Array<string>, options?: any): AxiosPromise<File> {
            return localVarFp.apiAdverseImpactDataVisualizationsActionTypesPut(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planID 
         * @param {string} jobGroup 
         * @param {boolean} isSignificant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsActionTypesRefreshLevel2PlanPlanIDJobGroupJobGroupSignificantIsSignificantGet(planID: string, jobGroup: string, isSignificant: boolean, options?: any): AxiosPromise<QueriesGetActionTypesForPlanResponse> {
            return localVarFp.apiAdverseImpactDataVisualizationsActionTypesRefreshLevel2PlanPlanIDJobGroupJobGroupSignificantIsSignificantGet(planID, jobGroup, isSignificant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsAdverseImpactFilterBy} [adverseImpactFilterBy] 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [actionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsAiDonutChartDrilldownGet(adverseImpactFilterBy?: EnumerationsAdverseImpactFilterBy, filterBy?: EnumerationsDataVisualizationFilterBy, actionType?: string, options?: any): AxiosPromise<QueriesGetAdverseImpactDonutChartDrilldownDataResponse> {
            return localVarFp.apiAdverseImpactDataVisualizationsAiDonutChartDrilldownGet(adverseImpactFilterBy, filterBy, actionType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsAdverseImpactFilterBy} [adverseImpactFilterBy] 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [eeoCode] 
         * @param {string} [actionType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsAiDrilldownByJobGroupForEeoGet(adverseImpactFilterBy?: EnumerationsAdverseImpactFilterBy, filterBy?: EnumerationsDataVisualizationFilterBy, eeoCode?: string, actionType?: string, options?: any): AxiosPromise<QueriesGetAdverseImpactDrilldownByJobGroupForEEOResponse> {
            return localVarFp.apiAdverseImpactDataVisualizationsAiDrilldownByJobGroupForEeoGet(adverseImpactFilterBy, filterBy, eeoCode, actionType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [planID] 
         * @param {string} [actionType] 
         * @param {string} [jobGroup] 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {boolean} [isSignificant] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsByJobTitleForJobGroupDrilldownGet(planID?: string, actionType?: string, jobGroup?: string, filterBy?: EnumerationsDataVisualizationFilterBy, isSignificant?: boolean, options?: any): AxiosPromise<QueriesGetAdverseImpactLevel2DrilldownResponse> {
            return localVarFp.apiAdverseImpactDataVisualizationsByJobTitleForJobGroupDrilldownGet(planID, actionType, jobGroup, filterBy, isSignificant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} jobGroup 
         * @param {boolean} isSignificant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsDropdownDefaultsLevel2JobGroupJobGroupSignificantIsSignificantGet(jobGroup: string, isSignificant: boolean, options?: any): AxiosPromise<Array<QueriesAdverseImpactPlanDropdownData>> {
            return localVarFp.apiAdverseImpactDataVisualizationsDropdownDefaultsLevel2JobGroupJobGroupSignificantIsSignificantGet(jobGroup, isSignificant, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationResultsBy} [resultsBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdverseImpactDataVisualizationsGet(resultsBy?: EnumerationsDataVisualizationResultsBy, options?: any): AxiosPromise<QueriesGetAdverseImpactDataVisualizationResponse> {
            return localVarFp.apiAdverseImpactDataVisualizationsGet(resultsBy, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdverseImpactDataVisualizationsApi - object-oriented interface
 * @export
 * @class AdverseImpactDataVisualizationsApi
 * @extends {BaseAPI}
 */
export class AdverseImpactDataVisualizationsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdverseImpactDataVisualizationsApi
     */
    public apiAdverseImpactDataVisualizationsActionTypesAllGet(options?: RawAxiosRequestConfig) {
        return AdverseImpactDataVisualizationsApiFp(this.configuration).apiAdverseImpactDataVisualizationsActionTypesAllGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdverseImpactDataVisualizationsApi
     */
    public apiAdverseImpactDataVisualizationsActionTypesDropdownGet(options?: RawAxiosRequestConfig) {
        return AdverseImpactDataVisualizationsApiFp(this.configuration).apiAdverseImpactDataVisualizationsActionTypesDropdownGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdverseImpactDataVisualizationsApi
     */
    public apiAdverseImpactDataVisualizationsActionTypesPut(requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return AdverseImpactDataVisualizationsApiFp(this.configuration).apiAdverseImpactDataVisualizationsActionTypesPut(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planID 
     * @param {string} jobGroup 
     * @param {boolean} isSignificant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdverseImpactDataVisualizationsApi
     */
    public apiAdverseImpactDataVisualizationsActionTypesRefreshLevel2PlanPlanIDJobGroupJobGroupSignificantIsSignificantGet(planID: string, jobGroup: string, isSignificant: boolean, options?: RawAxiosRequestConfig) {
        return AdverseImpactDataVisualizationsApiFp(this.configuration).apiAdverseImpactDataVisualizationsActionTypesRefreshLevel2PlanPlanIDJobGroupJobGroupSignificantIsSignificantGet(planID, jobGroup, isSignificant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsAdverseImpactFilterBy} [adverseImpactFilterBy] 
     * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
     * @param {string} [actionType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdverseImpactDataVisualizationsApi
     */
    public apiAdverseImpactDataVisualizationsAiDonutChartDrilldownGet(adverseImpactFilterBy?: EnumerationsAdverseImpactFilterBy, filterBy?: EnumerationsDataVisualizationFilterBy, actionType?: string, options?: RawAxiosRequestConfig) {
        return AdverseImpactDataVisualizationsApiFp(this.configuration).apiAdverseImpactDataVisualizationsAiDonutChartDrilldownGet(adverseImpactFilterBy, filterBy, actionType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsAdverseImpactFilterBy} [adverseImpactFilterBy] 
     * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
     * @param {string} [eeoCode] 
     * @param {string} [actionType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdverseImpactDataVisualizationsApi
     */
    public apiAdverseImpactDataVisualizationsAiDrilldownByJobGroupForEeoGet(adverseImpactFilterBy?: EnumerationsAdverseImpactFilterBy, filterBy?: EnumerationsDataVisualizationFilterBy, eeoCode?: string, actionType?: string, options?: RawAxiosRequestConfig) {
        return AdverseImpactDataVisualizationsApiFp(this.configuration).apiAdverseImpactDataVisualizationsAiDrilldownByJobGroupForEeoGet(adverseImpactFilterBy, filterBy, eeoCode, actionType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [planID] 
     * @param {string} [actionType] 
     * @param {string} [jobGroup] 
     * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
     * @param {boolean} [isSignificant] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdverseImpactDataVisualizationsApi
     */
    public apiAdverseImpactDataVisualizationsByJobTitleForJobGroupDrilldownGet(planID?: string, actionType?: string, jobGroup?: string, filterBy?: EnumerationsDataVisualizationFilterBy, isSignificant?: boolean, options?: RawAxiosRequestConfig) {
        return AdverseImpactDataVisualizationsApiFp(this.configuration).apiAdverseImpactDataVisualizationsByJobTitleForJobGroupDrilldownGet(planID, actionType, jobGroup, filterBy, isSignificant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} jobGroup 
     * @param {boolean} isSignificant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdverseImpactDataVisualizationsApi
     */
    public apiAdverseImpactDataVisualizationsDropdownDefaultsLevel2JobGroupJobGroupSignificantIsSignificantGet(jobGroup: string, isSignificant: boolean, options?: RawAxiosRequestConfig) {
        return AdverseImpactDataVisualizationsApiFp(this.configuration).apiAdverseImpactDataVisualizationsDropdownDefaultsLevel2JobGroupJobGroupSignificantIsSignificantGet(jobGroup, isSignificant, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsDataVisualizationResultsBy} [resultsBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdverseImpactDataVisualizationsApi
     */
    public apiAdverseImpactDataVisualizationsGet(resultsBy?: EnumerationsDataVisualizationResultsBy, options?: RawAxiosRequestConfig) {
        return AdverseImpactDataVisualizationsApiFp(this.configuration).apiAdverseImpactDataVisualizationsGet(resultsBy, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ApplicantFlowDataVisualizationsApi - axios parameter creator
 * @export
 */
export const ApplicantFlowDataVisualizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsApplicantTypeFilterDropdownGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/applicant-type-filter-dropdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsApplicantTypeFilterSettingsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/applicant-type-filter-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [applicantTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsApplicantTypeFilterSettingsPut: async (applicantTypes?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/applicant-type-filter-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (applicantTypes) {
                localVarQueryParameter['applicantTypes'] = applicantTypes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsApplicantsByDemographicDrilldownGet: async (filterBy?: EnumerationsDataVisualizationFilterBy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/applicants-by-demographic-drilldown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterBy !== undefined) {
                localVarQueryParameter['filterBy'] = filterBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsApplicantFlowCalcType} [applicantFlowCalcType] 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [eeoCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsApplicantsByJobGroupForEeoDrilldownGet: async (applicantFlowCalcType?: EnumerationsApplicantFlowCalcType, filterBy?: EnumerationsDataVisualizationFilterBy, eeoCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/applicants-by-job-group-for-eeo-drilldown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (applicantFlowCalcType !== undefined) {
                localVarQueryParameter['applicantFlowCalcType'] = applicantFlowCalcType;
            }

            if (filterBy !== undefined) {
                localVarQueryParameter['filterBy'] = filterBy;
            }

            if (eeoCode !== undefined) {
                localVarQueryParameter['eeoCode'] = eeoCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsApplicantFlowCalcType} [applicantFlowCalcType] 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [eeoCode] 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsApplicantsByJobTitleForJobGroupDrilldownGet: async (applicantFlowCalcType?: EnumerationsApplicantFlowCalcType, filterBy?: EnumerationsDataVisualizationFilterBy, eeoCode?: string, jobGroup?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/applicants-by-job-title-for-job-group-drilldown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (applicantFlowCalcType !== undefined) {
                localVarQueryParameter['applicantFlowCalcType'] = applicantFlowCalcType;
            }

            if (filterBy !== undefined) {
                localVarQueryParameter['filterBy'] = filterBy;
            }

            if (eeoCode !== undefined) {
                localVarQueryParameter['eeoCode'] = eeoCode;
            }

            if (jobGroup !== undefined) {
                localVarQueryParameter['jobGroup'] = jobGroup;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [disposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsDispositionByGenderByJobGroupGet: async (disposition?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/disposition-by-gender-by-job-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (disposition !== undefined) {
                localVarQueryParameter['disposition'] = disposition;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [disposition] 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsDispositionByGenderByJobTitleGet: async (disposition?: string, jobGroup?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/disposition-by-gender-by-job-title`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (disposition !== undefined) {
                localVarQueryParameter['disposition'] = disposition;
            }

            if (jobGroup !== undefined) {
                localVarQueryParameter['jobGroup'] = jobGroup;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [disposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsDispositionByRaceByJobGroupGet: async (filterBy?: EnumerationsDataVisualizationFilterBy, disposition?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/disposition-by-race-by-job-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterBy !== undefined) {
                localVarQueryParameter['filterBy'] = filterBy;
            }

            if (disposition !== undefined) {
                localVarQueryParameter['disposition'] = disposition;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [disposition] 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsDispositionByRaceByJobTitleGet: async (filterBy?: EnumerationsDataVisualizationFilterBy, disposition?: string, jobGroup?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/disposition-by-race-by-job-title`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterBy !== undefined) {
                localVarQueryParameter['filterBy'] = filterBy;
            }

            if (disposition !== undefined) {
                localVarQueryParameter['disposition'] = disposition;
            }

            if (jobGroup !== undefined) {
                localVarQueryParameter['jobGroup'] = jobGroup;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [disposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsDispositionOverallByJobGroupGet: async (disposition?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/disposition-overall-by-job-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (disposition !== undefined) {
                localVarQueryParameter['disposition'] = disposition;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [disposition] 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsDispositionOverallByJobTitleGet: async (disposition?: string, jobGroup?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/disposition-overall-by-job-title`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (disposition !== undefined) {
                localVarQueryParameter['disposition'] = disposition;
            }

            if (jobGroup !== undefined) {
                localVarQueryParameter['jobGroup'] = jobGroup;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsExclusionsByDemographicDrilldownGet: async (filterBy?: EnumerationsDataVisualizationFilterBy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/exclusions-by-demographic-drilldown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterBy !== undefined) {
                localVarQueryParameter['filterBy'] = filterBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsSelectionsByDemographicDrilldownGet: async (filterBy?: EnumerationsDataVisualizationFilterBy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/selections-by-demographic-drilldown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterBy !== undefined) {
                localVarQueryParameter['filterBy'] = filterBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsTop5DispositionByGenderDonutDrilldownByJobGroupGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/top-5-disposition-by-gender-donut-drilldown-by-job-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [jobGroup] 
         * @param {string} [jobGroupName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsTop5DispositionByGenderGet: async (jobGroup?: string, jobGroupName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/top-5-disposition-by-gender`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (jobGroup !== undefined) {
                localVarQueryParameter['jobGroup'] = jobGroup;
            }

            if (jobGroupName !== undefined) {
                localVarQueryParameter['jobGroupName'] = jobGroupName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsTop5DispositionByRaceDonutDrilldownByJobGroupGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/top-5-disposition-by-race-donut-drilldown-by-job-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [jobGroup] 
         * @param {string} [jobGroupName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsTop5DispositionByRaceGet: async (filterBy?: EnumerationsDataVisualizationFilterBy, jobGroup?: string, jobGroupName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/top-5-disposition-by-race`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterBy !== undefined) {
                localVarQueryParameter['filterBy'] = filterBy;
            }

            if (jobGroup !== undefined) {
                localVarQueryParameter['jobGroup'] = jobGroup;
            }

            if (jobGroupName !== undefined) {
                localVarQueryParameter['jobGroupName'] = jobGroupName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsTop5DispositionOverallDonutDrilldownByJobGroupGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/top-5-disposition-overall-donut-drilldown-by-job-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [jobGroup] 
         * @param {string} [jobGroupName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsTop5DispositionOverallGet: async (jobGroup?: string, jobGroupName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ApplicantFlowDataVisualizations/top-5-disposition-overall`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (jobGroup !== undefined) {
                localVarQueryParameter['jobGroup'] = jobGroup;
            }

            if (jobGroupName !== undefined) {
                localVarQueryParameter['jobGroupName'] = jobGroupName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplicantFlowDataVisualizationsApi - functional programming interface
 * @export
 */
export const ApplicantFlowDataVisualizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApplicantFlowDataVisualizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsApplicantTypeFilterDropdownGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicantFlowApplicantFlowTypeSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsApplicantTypeFilterDropdownGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsApplicantTypeFilterDropdownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsApplicantTypeFilterSettingsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApplicantFlowApplicantFlowTypeSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsApplicantTypeFilterSettingsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsApplicantTypeFilterSettingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [applicantTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsApplicantTypeFilterSettingsPut(applicantTypes?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsApplicantTypeFilterSettingsPut(applicantTypes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsApplicantTypeFilterSettingsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsApplicantsByDemographicDrilldownGet(filterBy?: EnumerationsDataVisualizationFilterBy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetApplicantsByDemographicDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsApplicantsByDemographicDrilldownGet(filterBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsApplicantsByDemographicDrilldownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsApplicantFlowCalcType} [applicantFlowCalcType] 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [eeoCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsApplicantsByJobGroupForEeoDrilldownGet(applicantFlowCalcType?: EnumerationsApplicantFlowCalcType, filterBy?: EnumerationsDataVisualizationFilterBy, eeoCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetApplicantsByJobGroupForEEOByDemographicDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsApplicantsByJobGroupForEeoDrilldownGet(applicantFlowCalcType, filterBy, eeoCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsApplicantsByJobGroupForEeoDrilldownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsApplicantFlowCalcType} [applicantFlowCalcType] 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [eeoCode] 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsApplicantsByJobTitleForJobGroupDrilldownGet(applicantFlowCalcType?: EnumerationsApplicantFlowCalcType, filterBy?: EnumerationsDataVisualizationFilterBy, eeoCode?: string, jobGroup?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetApplicantsByJobTitleForJobGroupByDemographicDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsApplicantsByJobTitleForJobGroupDrilldownGet(applicantFlowCalcType, filterBy, eeoCode, jobGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsApplicantsByJobTitleForJobGroupDrilldownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [disposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsDispositionByGenderByJobGroupGet(disposition?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetDispositionDrilldownByGenderByJobGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsDispositionByGenderByJobGroupGet(disposition, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsDispositionByGenderByJobGroupGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [disposition] 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsDispositionByGenderByJobTitleGet(disposition?: string, jobGroup?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetDispositionDrilldownByGenderByJobTitleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsDispositionByGenderByJobTitleGet(disposition, jobGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsDispositionByGenderByJobTitleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [disposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsDispositionByRaceByJobGroupGet(filterBy?: EnumerationsDataVisualizationFilterBy, disposition?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetDispositionDrilldownByRaceByJobGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsDispositionByRaceByJobGroupGet(filterBy, disposition, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsDispositionByRaceByJobGroupGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [disposition] 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsDispositionByRaceByJobTitleGet(filterBy?: EnumerationsDataVisualizationFilterBy, disposition?: string, jobGroup?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetDispositionDrilldownByRaceByJobTitleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsDispositionByRaceByJobTitleGet(filterBy, disposition, jobGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsDispositionByRaceByJobTitleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [disposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsDispositionOverallByJobGroupGet(disposition?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetDispositionDrilldownOverallByJobGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsDispositionOverallByJobGroupGet(disposition, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsDispositionOverallByJobGroupGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [disposition] 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsDispositionOverallByJobTitleGet(disposition?: string, jobGroup?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetDispositionDrilldownOverallByJobTitleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsDispositionOverallByJobTitleGet(disposition, jobGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsDispositionOverallByJobTitleGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsExclusionsByDemographicDrilldownGet(filterBy?: EnumerationsDataVisualizationFilterBy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetExclusionsByDemographicDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsExclusionsByDemographicDrilldownGet(filterBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsExclusionsByDemographicDrilldownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetApplicantFlowVisualizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsSelectionsByDemographicDrilldownGet(filterBy?: EnumerationsDataVisualizationFilterBy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetSelectionsByDemographicDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsSelectionsByDemographicDrilldownGet(filterBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsSelectionsByDemographicDrilldownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsTop5DispositionByGenderDonutDrilldownByJobGroupGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetTop5DispositionByGenderDonutDrilldownByJobGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsTop5DispositionByGenderDonutDrilldownByJobGroupGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsTop5DispositionByGenderDonutDrilldownByJobGroupGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [jobGroup] 
         * @param {string} [jobGroupName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsTop5DispositionByGenderGet(jobGroup?: string, jobGroupName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetTop5DispositionByGenderResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsTop5DispositionByGenderGet(jobGroup, jobGroupName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsTop5DispositionByGenderGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsTop5DispositionByRaceDonutDrilldownByJobGroupGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetTop5DispositionByRaceDonutDrilldownByJobGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsTop5DispositionByRaceDonutDrilldownByJobGroupGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsTop5DispositionByRaceDonutDrilldownByJobGroupGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [jobGroup] 
         * @param {string} [jobGroupName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsTop5DispositionByRaceGet(filterBy?: EnumerationsDataVisualizationFilterBy, jobGroup?: string, jobGroupName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetTop5DispositionByRaceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsTop5DispositionByRaceGet(filterBy, jobGroup, jobGroupName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsTop5DispositionByRaceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsTop5DispositionOverallDonutDrilldownByJobGroupGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetTop5DispositionOverallDonutDrilldownByJobGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsTop5DispositionOverallDonutDrilldownByJobGroupGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsTop5DispositionOverallDonutDrilldownByJobGroupGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [jobGroup] 
         * @param {string} [jobGroupName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiApplicantFlowDataVisualizationsTop5DispositionOverallGet(jobGroup?: string, jobGroupName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetTop5DispositionOverallResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiApplicantFlowDataVisualizationsTop5DispositionOverallGet(jobGroup, jobGroupName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApplicantFlowDataVisualizationsApi.apiApplicantFlowDataVisualizationsTop5DispositionOverallGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ApplicantFlowDataVisualizationsApi - factory interface
 * @export
 */
export const ApplicantFlowDataVisualizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApplicantFlowDataVisualizationsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsApplicantTypeFilterDropdownGet(options?: any): AxiosPromise<ApplicantFlowApplicantFlowTypeSettingsResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsApplicantTypeFilterDropdownGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsApplicantTypeFilterSettingsGet(options?: any): AxiosPromise<ApplicantFlowApplicantFlowTypeSettingsResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsApplicantTypeFilterSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [applicantTypes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsApplicantTypeFilterSettingsPut(applicantTypes?: Array<string>, options?: any): AxiosPromise<File> {
            return localVarFp.apiApplicantFlowDataVisualizationsApplicantTypeFilterSettingsPut(applicantTypes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsApplicantsByDemographicDrilldownGet(filterBy?: EnumerationsDataVisualizationFilterBy, options?: any): AxiosPromise<QueriesGetApplicantsByDemographicDrilldownResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsApplicantsByDemographicDrilldownGet(filterBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsApplicantFlowCalcType} [applicantFlowCalcType] 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [eeoCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsApplicantsByJobGroupForEeoDrilldownGet(applicantFlowCalcType?: EnumerationsApplicantFlowCalcType, filterBy?: EnumerationsDataVisualizationFilterBy, eeoCode?: string, options?: any): AxiosPromise<QueriesGetApplicantsByJobGroupForEEOByDemographicDrilldownResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsApplicantsByJobGroupForEeoDrilldownGet(applicantFlowCalcType, filterBy, eeoCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsApplicantFlowCalcType} [applicantFlowCalcType] 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [eeoCode] 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsApplicantsByJobTitleForJobGroupDrilldownGet(applicantFlowCalcType?: EnumerationsApplicantFlowCalcType, filterBy?: EnumerationsDataVisualizationFilterBy, eeoCode?: string, jobGroup?: string, options?: any): AxiosPromise<QueriesGetApplicantsByJobTitleForJobGroupByDemographicDrilldownResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsApplicantsByJobTitleForJobGroupDrilldownGet(applicantFlowCalcType, filterBy, eeoCode, jobGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [disposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsDispositionByGenderByJobGroupGet(disposition?: string, options?: any): AxiosPromise<QueriesGetDispositionDrilldownByGenderByJobGroupResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsDispositionByGenderByJobGroupGet(disposition, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [disposition] 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsDispositionByGenderByJobTitleGet(disposition?: string, jobGroup?: string, options?: any): AxiosPromise<QueriesGetDispositionDrilldownByGenderByJobTitleResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsDispositionByGenderByJobTitleGet(disposition, jobGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [disposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsDispositionByRaceByJobGroupGet(filterBy?: EnumerationsDataVisualizationFilterBy, disposition?: string, options?: any): AxiosPromise<QueriesGetDispositionDrilldownByRaceByJobGroupResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsDispositionByRaceByJobGroupGet(filterBy, disposition, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [disposition] 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsDispositionByRaceByJobTitleGet(filterBy?: EnumerationsDataVisualizationFilterBy, disposition?: string, jobGroup?: string, options?: any): AxiosPromise<QueriesGetDispositionDrilldownByRaceByJobTitleResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsDispositionByRaceByJobTitleGet(filterBy, disposition, jobGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [disposition] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsDispositionOverallByJobGroupGet(disposition?: string, options?: any): AxiosPromise<QueriesGetDispositionDrilldownOverallByJobGroupResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsDispositionOverallByJobGroupGet(disposition, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [disposition] 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsDispositionOverallByJobTitleGet(disposition?: string, jobGroup?: string, options?: any): AxiosPromise<QueriesGetDispositionDrilldownOverallByJobTitleResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsDispositionOverallByJobTitleGet(disposition, jobGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsExclusionsByDemographicDrilldownGet(filterBy?: EnumerationsDataVisualizationFilterBy, options?: any): AxiosPromise<QueriesGetExclusionsByDemographicDrilldownResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsExclusionsByDemographicDrilldownGet(filterBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsGet(options?: any): AxiosPromise<QueriesGetApplicantFlowVisualizationResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsSelectionsByDemographicDrilldownGet(filterBy?: EnumerationsDataVisualizationFilterBy, options?: any): AxiosPromise<QueriesGetSelectionsByDemographicDrilldownResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsSelectionsByDemographicDrilldownGet(filterBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsTop5DispositionByGenderDonutDrilldownByJobGroupGet(options?: any): AxiosPromise<QueriesGetTop5DispositionByGenderDonutDrilldownByJobGroupResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsTop5DispositionByGenderDonutDrilldownByJobGroupGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [jobGroup] 
         * @param {string} [jobGroupName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsTop5DispositionByGenderGet(jobGroup?: string, jobGroupName?: string, options?: any): AxiosPromise<QueriesGetTop5DispositionByGenderResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsTop5DispositionByGenderGet(jobGroup, jobGroupName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsTop5DispositionByRaceDonutDrilldownByJobGroupGet(options?: any): AxiosPromise<QueriesGetTop5DispositionByRaceDonutDrilldownByJobGroupResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsTop5DispositionByRaceDonutDrilldownByJobGroupGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
         * @param {string} [jobGroup] 
         * @param {string} [jobGroupName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsTop5DispositionByRaceGet(filterBy?: EnumerationsDataVisualizationFilterBy, jobGroup?: string, jobGroupName?: string, options?: any): AxiosPromise<QueriesGetTop5DispositionByRaceResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsTop5DispositionByRaceGet(filterBy, jobGroup, jobGroupName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsTop5DispositionOverallDonutDrilldownByJobGroupGet(options?: any): AxiosPromise<QueriesGetTop5DispositionOverallDonutDrilldownByJobGroupResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsTop5DispositionOverallDonutDrilldownByJobGroupGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [jobGroup] 
         * @param {string} [jobGroupName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiApplicantFlowDataVisualizationsTop5DispositionOverallGet(jobGroup?: string, jobGroupName?: string, options?: any): AxiosPromise<QueriesGetTop5DispositionOverallResponse> {
            return localVarFp.apiApplicantFlowDataVisualizationsTop5DispositionOverallGet(jobGroup, jobGroupName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApplicantFlowDataVisualizationsApi - object-oriented interface
 * @export
 * @class ApplicantFlowDataVisualizationsApi
 * @extends {BaseAPI}
 */
export class ApplicantFlowDataVisualizationsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsApplicantTypeFilterDropdownGet(options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsApplicantTypeFilterDropdownGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsApplicantTypeFilterSettingsGet(options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsApplicantTypeFilterSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [applicantTypes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsApplicantTypeFilterSettingsPut(applicantTypes?: Array<string>, options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsApplicantTypeFilterSettingsPut(applicantTypes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsApplicantsByDemographicDrilldownGet(filterBy?: EnumerationsDataVisualizationFilterBy, options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsApplicantsByDemographicDrilldownGet(filterBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsApplicantFlowCalcType} [applicantFlowCalcType] 
     * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
     * @param {string} [eeoCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsApplicantsByJobGroupForEeoDrilldownGet(applicantFlowCalcType?: EnumerationsApplicantFlowCalcType, filterBy?: EnumerationsDataVisualizationFilterBy, eeoCode?: string, options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsApplicantsByJobGroupForEeoDrilldownGet(applicantFlowCalcType, filterBy, eeoCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsApplicantFlowCalcType} [applicantFlowCalcType] 
     * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
     * @param {string} [eeoCode] 
     * @param {string} [jobGroup] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsApplicantsByJobTitleForJobGroupDrilldownGet(applicantFlowCalcType?: EnumerationsApplicantFlowCalcType, filterBy?: EnumerationsDataVisualizationFilterBy, eeoCode?: string, jobGroup?: string, options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsApplicantsByJobTitleForJobGroupDrilldownGet(applicantFlowCalcType, filterBy, eeoCode, jobGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [disposition] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsDispositionByGenderByJobGroupGet(disposition?: string, options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsDispositionByGenderByJobGroupGet(disposition, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [disposition] 
     * @param {string} [jobGroup] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsDispositionByGenderByJobTitleGet(disposition?: string, jobGroup?: string, options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsDispositionByGenderByJobTitleGet(disposition, jobGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
     * @param {string} [disposition] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsDispositionByRaceByJobGroupGet(filterBy?: EnumerationsDataVisualizationFilterBy, disposition?: string, options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsDispositionByRaceByJobGroupGet(filterBy, disposition, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
     * @param {string} [disposition] 
     * @param {string} [jobGroup] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsDispositionByRaceByJobTitleGet(filterBy?: EnumerationsDataVisualizationFilterBy, disposition?: string, jobGroup?: string, options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsDispositionByRaceByJobTitleGet(filterBy, disposition, jobGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [disposition] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsDispositionOverallByJobGroupGet(disposition?: string, options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsDispositionOverallByJobGroupGet(disposition, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [disposition] 
     * @param {string} [jobGroup] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsDispositionOverallByJobTitleGet(disposition?: string, jobGroup?: string, options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsDispositionOverallByJobTitleGet(disposition, jobGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsExclusionsByDemographicDrilldownGet(filterBy?: EnumerationsDataVisualizationFilterBy, options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsExclusionsByDemographicDrilldownGet(filterBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsGet(options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsSelectionsByDemographicDrilldownGet(filterBy?: EnumerationsDataVisualizationFilterBy, options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsSelectionsByDemographicDrilldownGet(filterBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsTop5DispositionByGenderDonutDrilldownByJobGroupGet(options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsTop5DispositionByGenderDonutDrilldownByJobGroupGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [jobGroup] 
     * @param {string} [jobGroupName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsTop5DispositionByGenderGet(jobGroup?: string, jobGroupName?: string, options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsTop5DispositionByGenderGet(jobGroup, jobGroupName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsTop5DispositionByRaceDonutDrilldownByJobGroupGet(options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsTop5DispositionByRaceDonutDrilldownByJobGroupGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsDataVisualizationFilterBy} [filterBy] 
     * @param {string} [jobGroup] 
     * @param {string} [jobGroupName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsTop5DispositionByRaceGet(filterBy?: EnumerationsDataVisualizationFilterBy, jobGroup?: string, jobGroupName?: string, options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsTop5DispositionByRaceGet(filterBy, jobGroup, jobGroupName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsTop5DispositionOverallDonutDrilldownByJobGroupGet(options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsTop5DispositionOverallDonutDrilldownByJobGroupGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [jobGroup] 
     * @param {string} [jobGroupName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicantFlowDataVisualizationsApi
     */
    public apiApplicantFlowDataVisualizationsTop5DispositionOverallGet(jobGroup?: string, jobGroupName?: string, options?: RawAxiosRequestConfig) {
        return ApplicantFlowDataVisualizationsApiFp(this.configuration).apiApplicantFlowDataVisualizationsTop5DispositionOverallGet(jobGroup, jobGroupName, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuditCenterApi - axios parameter creator
 * @export
 */
export const AuditCenterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} audit2AuditItemID 
         * @param {string} auditAttachmentID 
         * @param {string} filename 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAudit2AuditItemIDAuditAttachmentIDFilenameDeleteGet: async (audit2AuditItemID: string, auditAttachmentID: string, filename: string, auditID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'audit2AuditItemID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDAuditAttachmentIDFilenameDeleteGet', 'audit2AuditItemID', audit2AuditItemID)
            // verify required parameter 'auditAttachmentID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDAuditAttachmentIDFilenameDeleteGet', 'auditAttachmentID', auditAttachmentID)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDAuditAttachmentIDFilenameDeleteGet', 'filename', filename)
            // verify required parameter 'auditID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDAuditAttachmentIDFilenameDeleteGet', 'auditID', auditID)
            const localVarPath = `/api/AuditCenter/{auditID}/{audit2AuditItemID}/{auditAttachmentID}/{filename}/delete`
                .replace(`{${"audit2AuditItemID"}}`, encodeURIComponent(String(audit2AuditItemID)))
                .replace(`{${"auditAttachmentID"}}`, encodeURIComponent(String(auditAttachmentID)))
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)))
                .replace(`{${"auditID"}}`, encodeURIComponent(String(auditID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} auditID 
         * @param {string} audit2AuditItemID 
         * @param {string} [batchID] 
         * @param {number} [sequenceID] 
         * @param {number} [uploadSize] 
         * @param {boolean} [isEndOfFile] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAudit2AuditItemIDChunkPost: async (auditID: string, audit2AuditItemID: string, batchID?: string, sequenceID?: number, uploadSize?: number, isEndOfFile?: boolean, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDChunkPost', 'auditID', auditID)
            // verify required parameter 'audit2AuditItemID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDChunkPost', 'audit2AuditItemID', audit2AuditItemID)
            const localVarPath = `/api/AuditCenter/{auditID}/{audit2AuditItemID}/chunk`
                .replace(`{${"auditID"}}`, encodeURIComponent(String(auditID)))
                .replace(`{${"audit2AuditItemID"}}`, encodeURIComponent(String(audit2AuditItemID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (batchID !== undefined) {
                localVarQueryParameter['batchID'] = batchID;
            }

            if (sequenceID !== undefined) {
                localVarQueryParameter['sequenceID'] = sequenceID;
            }

            if (uploadSize !== undefined) {
                localVarQueryParameter['uploadSize'] = uploadSize;
            }

            if (isEndOfFile !== undefined) {
                localVarQueryParameter['isEndOfFile'] = isEndOfFile;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} audit2AuditItemID 
         * @param {string} filename 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAudit2AuditItemIDFilenameDownloadGet: async (audit2AuditItemID: string, filename: string, auditID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'audit2AuditItemID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDFilenameDownloadGet', 'audit2AuditItemID', audit2AuditItemID)
            // verify required parameter 'filename' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDFilenameDownloadGet', 'filename', filename)
            // verify required parameter 'auditID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDFilenameDownloadGet', 'auditID', auditID)
            const localVarPath = `/api/AuditCenter/{auditID}/{audit2AuditItemID}/{filename}/download`
                .replace(`{${"audit2AuditItemID"}}`, encodeURIComponent(String(audit2AuditItemID)))
                .replace(`{${"filename"}}`, encodeURIComponent(String(filename)))
                .replace(`{${"auditID"}}`, encodeURIComponent(String(auditID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} noteID 
         * @param {string} auditID 
         * @param {string} audit2AuditItemID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDDelete: async (noteID: string, auditID: string, audit2AuditItemID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDDelete', 'noteID', noteID)
            // verify required parameter 'auditID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDDelete', 'auditID', auditID)
            // verify required parameter 'audit2AuditItemID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDDelete', 'audit2AuditItemID', audit2AuditItemID)
            const localVarPath = `/api/AuditCenter/{auditID}/{audit2AuditItemID}/notes/{noteID}`
                .replace(`{${"noteID"}}`, encodeURIComponent(String(noteID)))
                .replace(`{${"auditID"}}`, encodeURIComponent(String(auditID)))
                .replace(`{${"audit2AuditItemID"}}`, encodeURIComponent(String(audit2AuditItemID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} noteID 
         * @param {string} auditID 
         * @param {string} audit2AuditItemID 
         * @param {CommandsUpdateAuditItemNoteCommand} [commandsUpdateAuditItemNoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDPut: async (noteID: string, auditID: string, audit2AuditItemID: string, commandsUpdateAuditItemNoteCommand?: CommandsUpdateAuditItemNoteCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'noteID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDPut', 'noteID', noteID)
            // verify required parameter 'auditID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDPut', 'auditID', auditID)
            // verify required parameter 'audit2AuditItemID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDPut', 'audit2AuditItemID', audit2AuditItemID)
            const localVarPath = `/api/AuditCenter/{auditID}/{audit2AuditItemID}/notes/{noteID}`
                .replace(`{${"noteID"}}`, encodeURIComponent(String(noteID)))
                .replace(`{${"auditID"}}`, encodeURIComponent(String(auditID)))
                .replace(`{${"audit2AuditItemID"}}`, encodeURIComponent(String(audit2AuditItemID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateAuditItemNoteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} audit2AuditItemID 
         * @param {string} auditID 
         * @param {CommandsCreateAuditItemNoteCommand} [commandsCreateAuditItemNoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAudit2AuditItemIDNotesPost: async (audit2AuditItemID: string, auditID: string, commandsCreateAuditItemNoteCommand?: CommandsCreateAuditItemNoteCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'audit2AuditItemID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDNotesPost', 'audit2AuditItemID', audit2AuditItemID)
            // verify required parameter 'auditID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDNotesPost', 'auditID', auditID)
            const localVarPath = `/api/AuditCenter/{auditID}/{audit2AuditItemID}/notes`
                .replace(`{${"audit2AuditItemID"}}`, encodeURIComponent(String(audit2AuditItemID)))
                .replace(`{${"auditID"}}`, encodeURIComponent(String(auditID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateAuditItemNoteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} audit2AuditItemID 
         * @param {string} auditID 
         * @param {CommandsUpdateAuditItemCommand} [commandsUpdateAuditItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAudit2AuditItemIDPut: async (audit2AuditItemID: string, auditID: string, commandsUpdateAuditItemCommand?: CommandsUpdateAuditItemCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'audit2AuditItemID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDPut', 'audit2AuditItemID', audit2AuditItemID)
            // verify required parameter 'auditID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDPut', 'auditID', auditID)
            const localVarPath = `/api/AuditCenter/{auditID}/{audit2AuditItemID}`
                .replace(`{${"audit2AuditItemID"}}`, encodeURIComponent(String(audit2AuditItemID)))
                .replace(`{${"auditID"}}`, encodeURIComponent(String(auditID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateAuditItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} audit2AuditItemID 
         * @param {string} auditID 
         * @param {CommandsUploadAuditAttachmentCommand} [commandsUploadAuditAttachmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAudit2AuditItemIDUploadAttachmentsPost: async (audit2AuditItemID: string, auditID: string, commandsUploadAuditAttachmentCommand?: CommandsUploadAuditAttachmentCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'audit2AuditItemID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDUploadAttachmentsPost', 'audit2AuditItemID', audit2AuditItemID)
            // verify required parameter 'auditID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAudit2AuditItemIDUploadAttachmentsPost', 'auditID', auditID)
            const localVarPath = `/api/AuditCenter/{auditID}/{audit2AuditItemID}/uploadAttachments`
                .replace(`{${"audit2AuditItemID"}}`, encodeURIComponent(String(audit2AuditItemID)))
                .replace(`{${"auditID"}}`, encodeURIComponent(String(auditID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUploadAuditAttachmentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} auditItemID 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAuditItemIDGet: async (auditItemID: number, auditID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditItemID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAuditItemIDGet', 'auditItemID', auditItemID)
            // verify required parameter 'auditID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDAuditItemIDGet', 'auditID', auditID)
            const localVarPath = `/api/AuditCenter/{auditID}/{auditItemID}`
                .replace(`{${"auditItemID"}}`, encodeURIComponent(String(auditItemID)))
                .replace(`{${"auditID"}}`, encodeURIComponent(String(auditID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDChecklistGet: async (auditID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDChecklistGet', 'auditID', auditID)
            const localVarPath = `/api/AuditCenter/{auditID}/checklist`
                .replace(`{${"auditID"}}`, encodeURIComponent(String(auditID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDDetailsGet: async (auditID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDDetailsGet', 'auditID', auditID)
            const localVarPath = `/api/AuditCenter/{auditID}/details`
                .replace(`{${"auditID"}}`, encodeURIComponent(String(auditID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDDownloadGet: async (auditID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDDownloadGet', 'auditID', auditID)
            const localVarPath = `/api/AuditCenter/{auditID}/download`
                .replace(`{${"auditID"}}`, encodeURIComponent(String(auditID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} auditID 
         * @param {CommandsUpdateAuditCommand} [commandsUpdateAuditCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDEditPut: async (auditID: string, commandsUpdateAuditCommand?: CommandsUpdateAuditCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'auditID' is not null or undefined
            assertParamExists('apiAuditCenterAuditIDEditPut', 'auditID', auditID)
            const localVarPath = `/api/AuditCenter/{auditID}/edit`
                .replace(`{${"auditID"}}`, encodeURIComponent(String(auditID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateAuditCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditsCONamesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AuditCenter/audits/CONames`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AuditCenter/audits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateAuditCommand} [commandsCreateAuditCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterPost: async (commandsCreateAuditCommand?: CommandsCreateAuditCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/AuditCenter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateAuditCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuditCenterApi - functional programming interface
 * @export
 */
export const AuditCenterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuditCenterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} audit2AuditItemID 
         * @param {string} auditAttachmentID 
         * @param {string} filename 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditCenterAuditIDAudit2AuditItemIDAuditAttachmentIDFilenameDeleteGet(audit2AuditItemID: string, auditAttachmentID: string, filename: string, auditID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditCenterAuditIDAudit2AuditItemIDAuditAttachmentIDFilenameDeleteGet(audit2AuditItemID, auditAttachmentID, filename, auditID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditCenterApi.apiAuditCenterAuditIDAudit2AuditItemIDAuditAttachmentIDFilenameDeleteGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} auditID 
         * @param {string} audit2AuditItemID 
         * @param {string} [batchID] 
         * @param {number} [sequenceID] 
         * @param {number} [uploadSize] 
         * @param {boolean} [isEndOfFile] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditCenterAuditIDAudit2AuditItemIDChunkPost(auditID: string, audit2AuditItemID: string, batchID?: string, sequenceID?: number, uploadSize?: number, isEndOfFile?: boolean, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditCenterAuditIDAudit2AuditItemIDChunkPost(auditID, audit2AuditItemID, batchID, sequenceID, uploadSize, isEndOfFile, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditCenterApi.apiAuditCenterAuditIDAudit2AuditItemIDChunkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} audit2AuditItemID 
         * @param {string} filename 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditCenterAuditIDAudit2AuditItemIDFilenameDownloadGet(audit2AuditItemID: string, filename: string, auditID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditCenterAuditIDAudit2AuditItemIDFilenameDownloadGet(audit2AuditItemID, filename, auditID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditCenterApi.apiAuditCenterAuditIDAudit2AuditItemIDFilenameDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} noteID 
         * @param {string} auditID 
         * @param {string} audit2AuditItemID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDDelete(noteID: string, auditID: string, audit2AuditItemID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDDelete(noteID, auditID, audit2AuditItemID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditCenterApi.apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} noteID 
         * @param {string} auditID 
         * @param {string} audit2AuditItemID 
         * @param {CommandsUpdateAuditItemNoteCommand} [commandsUpdateAuditItemNoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDPut(noteID: string, auditID: string, audit2AuditItemID: string, commandsUpdateAuditItemNoteCommand?: CommandsUpdateAuditItemNoteCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDPut(noteID, auditID, audit2AuditItemID, commandsUpdateAuditItemNoteCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditCenterApi.apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} audit2AuditItemID 
         * @param {string} auditID 
         * @param {CommandsCreateAuditItemNoteCommand} [commandsCreateAuditItemNoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditCenterAuditIDAudit2AuditItemIDNotesPost(audit2AuditItemID: string, auditID: string, commandsCreateAuditItemNoteCommand?: CommandsCreateAuditItemNoteCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditCenterAuditIDAudit2AuditItemIDNotesPost(audit2AuditItemID, auditID, commandsCreateAuditItemNoteCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditCenterApi.apiAuditCenterAuditIDAudit2AuditItemIDNotesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} audit2AuditItemID 
         * @param {string} auditID 
         * @param {CommandsUpdateAuditItemCommand} [commandsUpdateAuditItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditCenterAuditIDAudit2AuditItemIDPut(audit2AuditItemID: string, auditID: string, commandsUpdateAuditItemCommand?: CommandsUpdateAuditItemCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditCenterAuditIDAudit2AuditItemIDPut(audit2AuditItemID, auditID, commandsUpdateAuditItemCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditCenterApi.apiAuditCenterAuditIDAudit2AuditItemIDPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} audit2AuditItemID 
         * @param {string} auditID 
         * @param {CommandsUploadAuditAttachmentCommand} [commandsUploadAuditAttachmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditCenterAuditIDAudit2AuditItemIDUploadAttachmentsPost(audit2AuditItemID: string, auditID: string, commandsUploadAuditAttachmentCommand?: CommandsUploadAuditAttachmentCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditCenterAuditIDAudit2AuditItemIDUploadAttachmentsPost(audit2AuditItemID, auditID, commandsUploadAuditAttachmentCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditCenterApi.apiAuditCenterAuditIDAudit2AuditItemIDUploadAttachmentsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} auditItemID 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditCenterAuditIDAuditItemIDGet(auditItemID: number, auditID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditCenterAuditIDAuditItemIDGet(auditItemID, auditID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditCenterApi.apiAuditCenterAuditIDAuditItemIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditCenterAuditIDChecklistGet(auditID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetChecklistResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditCenterAuditIDChecklistGet(auditID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditCenterApi.apiAuditCenterAuditIDChecklistGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditCenterAuditIDDetailsGet(auditID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetAuditDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditCenterAuditIDDetailsGet(auditID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditCenterApi.apiAuditCenterAuditIDDetailsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditCenterAuditIDDownloadGet(auditID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditCenterAuditIDDownloadGet(auditID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditCenterApi.apiAuditCenterAuditIDDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} auditID 
         * @param {CommandsUpdateAuditCommand} [commandsUpdateAuditCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditCenterAuditIDEditPut(auditID: string, commandsUpdateAuditCommand?: CommandsUpdateAuditCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditCenterAuditIDEditPut(auditID, commandsUpdateAuditCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditCenterApi.apiAuditCenterAuditIDEditPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditCenterAuditsCONamesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditCenterAuditsCONamesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditCenterApi.apiAuditCenterAuditsCONamesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditCenterAuditsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetAuditsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditCenterAuditsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditCenterApi.apiAuditCenterAuditsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateAuditCommand} [commandsCreateAuditCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuditCenterPost(commandsCreateAuditCommand?: CommandsCreateAuditCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuditCenterPost(commandsCreateAuditCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuditCenterApi.apiAuditCenterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuditCenterApi - factory interface
 * @export
 */
export const AuditCenterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuditCenterApiFp(configuration)
    return {
        /**
         * 
         * @param {string} audit2AuditItemID 
         * @param {string} auditAttachmentID 
         * @param {string} filename 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAudit2AuditItemIDAuditAttachmentIDFilenameDeleteGet(audit2AuditItemID: string, auditAttachmentID: string, filename: string, auditID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiAuditCenterAuditIDAudit2AuditItemIDAuditAttachmentIDFilenameDeleteGet(audit2AuditItemID, auditAttachmentID, filename, auditID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} auditID 
         * @param {string} audit2AuditItemID 
         * @param {string} [batchID] 
         * @param {number} [sequenceID] 
         * @param {number} [uploadSize] 
         * @param {boolean} [isEndOfFile] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAudit2AuditItemIDChunkPost(auditID: string, audit2AuditItemID: string, batchID?: string, sequenceID?: number, uploadSize?: number, isEndOfFile?: boolean, file?: File, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiAuditCenterAuditIDAudit2AuditItemIDChunkPost(auditID, audit2AuditItemID, batchID, sequenceID, uploadSize, isEndOfFile, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} audit2AuditItemID 
         * @param {string} filename 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAudit2AuditItemIDFilenameDownloadGet(audit2AuditItemID: string, filename: string, auditID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiAuditCenterAuditIDAudit2AuditItemIDFilenameDownloadGet(audit2AuditItemID, filename, auditID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} noteID 
         * @param {string} auditID 
         * @param {string} audit2AuditItemID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDDelete(noteID: string, auditID: string, audit2AuditItemID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDDelete(noteID, auditID, audit2AuditItemID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} noteID 
         * @param {string} auditID 
         * @param {string} audit2AuditItemID 
         * @param {CommandsUpdateAuditItemNoteCommand} [commandsUpdateAuditItemNoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDPut(noteID: string, auditID: string, audit2AuditItemID: string, commandsUpdateAuditItemNoteCommand?: CommandsUpdateAuditItemNoteCommand, options?: any): AxiosPromise<File> {
            return localVarFp.apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDPut(noteID, auditID, audit2AuditItemID, commandsUpdateAuditItemNoteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} audit2AuditItemID 
         * @param {string} auditID 
         * @param {CommandsCreateAuditItemNoteCommand} [commandsCreateAuditItemNoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAudit2AuditItemIDNotesPost(audit2AuditItemID: string, auditID: string, commandsCreateAuditItemNoteCommand?: CommandsCreateAuditItemNoteCommand, options?: any): AxiosPromise<string> {
            return localVarFp.apiAuditCenterAuditIDAudit2AuditItemIDNotesPost(audit2AuditItemID, auditID, commandsCreateAuditItemNoteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} audit2AuditItemID 
         * @param {string} auditID 
         * @param {CommandsUpdateAuditItemCommand} [commandsUpdateAuditItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAudit2AuditItemIDPut(audit2AuditItemID: string, auditID: string, commandsUpdateAuditItemCommand?: CommandsUpdateAuditItemCommand, options?: any): AxiosPromise<File> {
            return localVarFp.apiAuditCenterAuditIDAudit2AuditItemIDPut(audit2AuditItemID, auditID, commandsUpdateAuditItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} audit2AuditItemID 
         * @param {string} auditID 
         * @param {CommandsUploadAuditAttachmentCommand} [commandsUploadAuditAttachmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAudit2AuditItemIDUploadAttachmentsPost(audit2AuditItemID: string, auditID: string, commandsUploadAuditAttachmentCommand?: CommandsUploadAuditAttachmentCommand, options?: any): AxiosPromise<File> {
            return localVarFp.apiAuditCenterAuditIDAudit2AuditItemIDUploadAttachmentsPost(audit2AuditItemID, auditID, commandsUploadAuditAttachmentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} auditItemID 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDAuditItemIDGet(auditItemID: number, auditID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiAuditCenterAuditIDAuditItemIDGet(auditItemID, auditID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDChecklistGet(auditID: string, options?: any): AxiosPromise<QueriesGetChecklistResponse> {
            return localVarFp.apiAuditCenterAuditIDChecklistGet(auditID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDDetailsGet(auditID: string, options?: any): AxiosPromise<QueriesGetAuditDetailsResponse> {
            return localVarFp.apiAuditCenterAuditIDDetailsGet(auditID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} auditID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDDownloadGet(auditID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiAuditCenterAuditIDDownloadGet(auditID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} auditID 
         * @param {CommandsUpdateAuditCommand} [commandsUpdateAuditCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditIDEditPut(auditID: string, commandsUpdateAuditCommand?: CommandsUpdateAuditCommand, options?: any): AxiosPromise<File> {
            return localVarFp.apiAuditCenterAuditIDEditPut(auditID, commandsUpdateAuditCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditsCONamesGet(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiAuditCenterAuditsCONamesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterAuditsGet(options?: any): AxiosPromise<QueriesGetAuditsResponse> {
            return localVarFp.apiAuditCenterAuditsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateAuditCommand} [commandsCreateAuditCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuditCenterPost(commandsCreateAuditCommand?: CommandsCreateAuditCommand, options?: any): AxiosPromise<string> {
            return localVarFp.apiAuditCenterPost(commandsCreateAuditCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuditCenterApi - object-oriented interface
 * @export
 * @class AuditCenterApi
 * @extends {BaseAPI}
 */
export class AuditCenterApi extends BaseAPI {
    /**
     * 
     * @param {string} audit2AuditItemID 
     * @param {string} auditAttachmentID 
     * @param {string} filename 
     * @param {string} auditID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditCenterApi
     */
    public apiAuditCenterAuditIDAudit2AuditItemIDAuditAttachmentIDFilenameDeleteGet(audit2AuditItemID: string, auditAttachmentID: string, filename: string, auditID: string, options?: RawAxiosRequestConfig) {
        return AuditCenterApiFp(this.configuration).apiAuditCenterAuditIDAudit2AuditItemIDAuditAttachmentIDFilenameDeleteGet(audit2AuditItemID, auditAttachmentID, filename, auditID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} auditID 
     * @param {string} audit2AuditItemID 
     * @param {string} [batchID] 
     * @param {number} [sequenceID] 
     * @param {number} [uploadSize] 
     * @param {boolean} [isEndOfFile] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditCenterApi
     */
    public apiAuditCenterAuditIDAudit2AuditItemIDChunkPost(auditID: string, audit2AuditItemID: string, batchID?: string, sequenceID?: number, uploadSize?: number, isEndOfFile?: boolean, file?: File, options?: RawAxiosRequestConfig) {
        return AuditCenterApiFp(this.configuration).apiAuditCenterAuditIDAudit2AuditItemIDChunkPost(auditID, audit2AuditItemID, batchID, sequenceID, uploadSize, isEndOfFile, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} audit2AuditItemID 
     * @param {string} filename 
     * @param {string} auditID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditCenterApi
     */
    public apiAuditCenterAuditIDAudit2AuditItemIDFilenameDownloadGet(audit2AuditItemID: string, filename: string, auditID: string, options?: RawAxiosRequestConfig) {
        return AuditCenterApiFp(this.configuration).apiAuditCenterAuditIDAudit2AuditItemIDFilenameDownloadGet(audit2AuditItemID, filename, auditID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} noteID 
     * @param {string} auditID 
     * @param {string} audit2AuditItemID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditCenterApi
     */
    public apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDDelete(noteID: string, auditID: string, audit2AuditItemID: string, options?: RawAxiosRequestConfig) {
        return AuditCenterApiFp(this.configuration).apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDDelete(noteID, auditID, audit2AuditItemID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} noteID 
     * @param {string} auditID 
     * @param {string} audit2AuditItemID 
     * @param {CommandsUpdateAuditItemNoteCommand} [commandsUpdateAuditItemNoteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditCenterApi
     */
    public apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDPut(noteID: string, auditID: string, audit2AuditItemID: string, commandsUpdateAuditItemNoteCommand?: CommandsUpdateAuditItemNoteCommand, options?: RawAxiosRequestConfig) {
        return AuditCenterApiFp(this.configuration).apiAuditCenterAuditIDAudit2AuditItemIDNotesNoteIDPut(noteID, auditID, audit2AuditItemID, commandsUpdateAuditItemNoteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} audit2AuditItemID 
     * @param {string} auditID 
     * @param {CommandsCreateAuditItemNoteCommand} [commandsCreateAuditItemNoteCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditCenterApi
     */
    public apiAuditCenterAuditIDAudit2AuditItemIDNotesPost(audit2AuditItemID: string, auditID: string, commandsCreateAuditItemNoteCommand?: CommandsCreateAuditItemNoteCommand, options?: RawAxiosRequestConfig) {
        return AuditCenterApiFp(this.configuration).apiAuditCenterAuditIDAudit2AuditItemIDNotesPost(audit2AuditItemID, auditID, commandsCreateAuditItemNoteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} audit2AuditItemID 
     * @param {string} auditID 
     * @param {CommandsUpdateAuditItemCommand} [commandsUpdateAuditItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditCenterApi
     */
    public apiAuditCenterAuditIDAudit2AuditItemIDPut(audit2AuditItemID: string, auditID: string, commandsUpdateAuditItemCommand?: CommandsUpdateAuditItemCommand, options?: RawAxiosRequestConfig) {
        return AuditCenterApiFp(this.configuration).apiAuditCenterAuditIDAudit2AuditItemIDPut(audit2AuditItemID, auditID, commandsUpdateAuditItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} audit2AuditItemID 
     * @param {string} auditID 
     * @param {CommandsUploadAuditAttachmentCommand} [commandsUploadAuditAttachmentCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditCenterApi
     */
    public apiAuditCenterAuditIDAudit2AuditItemIDUploadAttachmentsPost(audit2AuditItemID: string, auditID: string, commandsUploadAuditAttachmentCommand?: CommandsUploadAuditAttachmentCommand, options?: RawAxiosRequestConfig) {
        return AuditCenterApiFp(this.configuration).apiAuditCenterAuditIDAudit2AuditItemIDUploadAttachmentsPost(audit2AuditItemID, auditID, commandsUploadAuditAttachmentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} auditItemID 
     * @param {string} auditID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditCenterApi
     */
    public apiAuditCenterAuditIDAuditItemIDGet(auditItemID: number, auditID: string, options?: RawAxiosRequestConfig) {
        return AuditCenterApiFp(this.configuration).apiAuditCenterAuditIDAuditItemIDGet(auditItemID, auditID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} auditID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditCenterApi
     */
    public apiAuditCenterAuditIDChecklistGet(auditID: string, options?: RawAxiosRequestConfig) {
        return AuditCenterApiFp(this.configuration).apiAuditCenterAuditIDChecklistGet(auditID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} auditID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditCenterApi
     */
    public apiAuditCenterAuditIDDetailsGet(auditID: string, options?: RawAxiosRequestConfig) {
        return AuditCenterApiFp(this.configuration).apiAuditCenterAuditIDDetailsGet(auditID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} auditID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditCenterApi
     */
    public apiAuditCenterAuditIDDownloadGet(auditID: string, options?: RawAxiosRequestConfig) {
        return AuditCenterApiFp(this.configuration).apiAuditCenterAuditIDDownloadGet(auditID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} auditID 
     * @param {CommandsUpdateAuditCommand} [commandsUpdateAuditCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditCenterApi
     */
    public apiAuditCenterAuditIDEditPut(auditID: string, commandsUpdateAuditCommand?: CommandsUpdateAuditCommand, options?: RawAxiosRequestConfig) {
        return AuditCenterApiFp(this.configuration).apiAuditCenterAuditIDEditPut(auditID, commandsUpdateAuditCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditCenterApi
     */
    public apiAuditCenterAuditsCONamesGet(options?: RawAxiosRequestConfig) {
        return AuditCenterApiFp(this.configuration).apiAuditCenterAuditsCONamesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditCenterApi
     */
    public apiAuditCenterAuditsGet(options?: RawAxiosRequestConfig) {
        return AuditCenterApiFp(this.configuration).apiAuditCenterAuditsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateAuditCommand} [commandsCreateAuditCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuditCenterApi
     */
    public apiAuditCenterPost(commandsCreateAuditCommand?: CommandsCreateAuditCommand, options?: RawAxiosRequestConfig) {
        return AuditCenterApiFp(this.configuration).apiAuditCenterPost(commandsCreateAuditCommand, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CompensationApi - axios parameter creator
 * @export
 */
export const CompensationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {EnumerationsCompProfilesSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompensationProfilesGet: async (searchTerm?: string, sortColumn?: EnumerationsCompProfilesSortColumn, sortDirection?: EnumerationsSortDirection, page?: number, rowsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Compensation/profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (rowsPerPage !== undefined) {
                localVarQueryParameter['rowsPerPage'] = rowsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompensationApi - functional programming interface
 * @export
 */
export const CompensationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompensationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {EnumerationsCompProfilesSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCompensationProfilesGet(searchTerm?: string, sortColumn?: EnumerationsCompProfilesSortColumn, sortDirection?: EnumerationsSortDirection, page?: number, rowsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetCompProfilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCompensationProfilesGet(searchTerm, sortColumn, sortDirection, page, rowsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompensationApi.apiCompensationProfilesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompensationApi - factory interface
 * @export
 */
export const CompensationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompensationApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {EnumerationsCompProfilesSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCompensationProfilesGet(searchTerm?: string, sortColumn?: EnumerationsCompProfilesSortColumn, sortDirection?: EnumerationsSortDirection, page?: number, rowsPerPage?: number, options?: any): AxiosPromise<QueriesGetCompProfilesResponse> {
            return localVarFp.apiCompensationProfilesGet(searchTerm, sortColumn, sortDirection, page, rowsPerPage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompensationApi - object-oriented interface
 * @export
 * @class CompensationApi
 * @extends {BaseAPI}
 */
export class CompensationApi extends BaseAPI {
    /**
     * 
     * @param {string} [searchTerm] 
     * @param {EnumerationsCompProfilesSortColumn} [sortColumn] 
     * @param {EnumerationsSortDirection} [sortDirection] 
     * @param {number} [page] 
     * @param {number} [rowsPerPage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompensationApi
     */
    public apiCompensationProfilesGet(searchTerm?: string, sortColumn?: EnumerationsCompProfilesSortColumn, sortDirection?: EnumerationsSortDirection, page?: number, rowsPerPage?: number, options?: RawAxiosRequestConfig) {
        return CompensationApiFp(this.configuration).apiCompensationProfilesGet(searchTerm, sortColumn, sortDirection, page, rowsPerPage, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ComplianceChecklistApi - axios parameter creator
 * @export
 */
export const ComplianceChecklistApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} complianceChecklist2ComplianceChecklistItemID 
         * @param {CommandsUpdateChecklistCommand} [commandsUpdateChecklistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiComplianceChecklistComplianceChecklist2ComplianceChecklistItemIDPut: async (complianceChecklist2ComplianceChecklistItemID: string, commandsUpdateChecklistCommand?: CommandsUpdateChecklistCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'complianceChecklist2ComplianceChecklistItemID' is not null or undefined
            assertParamExists('apiComplianceChecklistComplianceChecklist2ComplianceChecklistItemIDPut', 'complianceChecklist2ComplianceChecklistItemID', complianceChecklist2ComplianceChecklistItemID)
            const localVarPath = `/api/ComplianceChecklist/{complianceChecklist2ComplianceChecklistItemID}`
                .replace(`{${"complianceChecklist2ComplianceChecklistItemID"}}`, encodeURIComponent(String(complianceChecklist2ComplianceChecklistItemID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateChecklistCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiComplianceChecklistGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ComplianceChecklist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsUpdatePlanDateCommand} [commandsUpdatePlanDateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiComplianceChecklistPlanDatePut: async (commandsUpdatePlanDateCommand?: CommandsUpdatePlanDateCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ComplianceChecklist/plan-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdatePlanDateCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComplianceChecklistApi - functional programming interface
 * @export
 */
export const ComplianceChecklistApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComplianceChecklistApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} complianceChecklist2ComplianceChecklistItemID 
         * @param {CommandsUpdateChecklistCommand} [commandsUpdateChecklistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiComplianceChecklistComplianceChecklist2ComplianceChecklistItemIDPut(complianceChecklist2ComplianceChecklistItemID: string, commandsUpdateChecklistCommand?: CommandsUpdateChecklistCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiComplianceChecklistComplianceChecklist2ComplianceChecklistItemIDPut(complianceChecklist2ComplianceChecklistItemID, commandsUpdateChecklistCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComplianceChecklistApi.apiComplianceChecklistComplianceChecklist2ComplianceChecklistItemIDPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiComplianceChecklistGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetChecklistsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiComplianceChecklistGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComplianceChecklistApi.apiComplianceChecklistGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsUpdatePlanDateCommand} [commandsUpdatePlanDateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiComplianceChecklistPlanDatePut(commandsUpdatePlanDateCommand?: CommandsUpdatePlanDateCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiComplianceChecklistPlanDatePut(commandsUpdatePlanDateCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ComplianceChecklistApi.apiComplianceChecklistPlanDatePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ComplianceChecklistApi - factory interface
 * @export
 */
export const ComplianceChecklistApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComplianceChecklistApiFp(configuration)
    return {
        /**
         * 
         * @param {string} complianceChecklist2ComplianceChecklistItemID 
         * @param {CommandsUpdateChecklistCommand} [commandsUpdateChecklistCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiComplianceChecklistComplianceChecklist2ComplianceChecklistItemIDPut(complianceChecklist2ComplianceChecklistItemID: string, commandsUpdateChecklistCommand?: CommandsUpdateChecklistCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiComplianceChecklistComplianceChecklist2ComplianceChecklistItemIDPut(complianceChecklist2ComplianceChecklistItemID, commandsUpdateChecklistCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiComplianceChecklistGet(options?: any): AxiosPromise<QueriesGetChecklistsResponse> {
            return localVarFp.apiComplianceChecklistGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsUpdatePlanDateCommand} [commandsUpdatePlanDateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiComplianceChecklistPlanDatePut(commandsUpdatePlanDateCommand?: CommandsUpdatePlanDateCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiComplianceChecklistPlanDatePut(commandsUpdatePlanDateCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComplianceChecklistApi - object-oriented interface
 * @export
 * @class ComplianceChecklistApi
 * @extends {BaseAPI}
 */
export class ComplianceChecklistApi extends BaseAPI {
    /**
     * 
     * @param {string} complianceChecklist2ComplianceChecklistItemID 
     * @param {CommandsUpdateChecklistCommand} [commandsUpdateChecklistCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceChecklistApi
     */
    public apiComplianceChecklistComplianceChecklist2ComplianceChecklistItemIDPut(complianceChecklist2ComplianceChecklistItemID: string, commandsUpdateChecklistCommand?: CommandsUpdateChecklistCommand, options?: RawAxiosRequestConfig) {
        return ComplianceChecklistApiFp(this.configuration).apiComplianceChecklistComplianceChecklist2ComplianceChecklistItemIDPut(complianceChecklist2ComplianceChecklistItemID, commandsUpdateChecklistCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceChecklistApi
     */
    public apiComplianceChecklistGet(options?: RawAxiosRequestConfig) {
        return ComplianceChecklistApiFp(this.configuration).apiComplianceChecklistGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsUpdatePlanDateCommand} [commandsUpdatePlanDateCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComplianceChecklistApi
     */
    public apiComplianceChecklistPlanDatePut(commandsUpdatePlanDateCommand?: CommandsUpdatePlanDateCommand, options?: RawAxiosRequestConfig) {
        return ComplianceChecklistApiFp(this.configuration).apiComplianceChecklistPlanDatePut(commandsUpdatePlanDateCommand, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DataExportApi - axios parameter creator
 * @export
 */
export const DataExportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} planID 
         * @param {Array<DataExportDataExportTables>} [dataExportDataExportTables] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataExportExportPlanIDPost: async (planID: string, dataExportDataExportTables?: Array<DataExportDataExportTables>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('apiDataExportExportPlanIDPost', 'planID', planID)
            const localVarPath = `/api/DataExport/export/{planID}`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataExportDataExportTables, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataExportTablesPlanIDGet: async (planID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('apiDataExportTablesPlanIDGet', 'planID', planID)
            const localVarPath = `/api/DataExport/tables/{planID}`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataExportApi - functional programming interface
 * @export
 */
export const DataExportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataExportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} planID 
         * @param {Array<DataExportDataExportTables>} [dataExportDataExportTables] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataExportExportPlanIDPost(planID: string, dataExportDataExportTables?: Array<DataExportDataExportTables>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataExportExportPlanIDPost(planID, dataExportDataExportTables, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataExportApi.apiDataExportExportPlanIDPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} planID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataExportTablesPlanIDGet(planID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataExportDataExportTables>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataExportTablesPlanIDGet(planID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataExportApi.apiDataExportTablesPlanIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataExportApi - factory interface
 * @export
 */
export const DataExportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataExportApiFp(configuration)
    return {
        /**
         * 
         * @param {string} planID 
         * @param {Array<DataExportDataExportTables>} [dataExportDataExportTables] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataExportExportPlanIDPost(planID: string, dataExportDataExportTables?: Array<DataExportDataExportTables>, options?: any): AxiosPromise<string> {
            return localVarFp.apiDataExportExportPlanIDPost(planID, dataExportDataExportTables, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataExportTablesPlanIDGet(planID: string, options?: any): AxiosPromise<Array<DataExportDataExportTables>> {
            return localVarFp.apiDataExportTablesPlanIDGet(planID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataExportApi - object-oriented interface
 * @export
 * @class DataExportApi
 * @extends {BaseAPI}
 */
export class DataExportApi extends BaseAPI {
    /**
     * 
     * @param {string} planID 
     * @param {Array<DataExportDataExportTables>} [dataExportDataExportTables] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExportApi
     */
    public apiDataExportExportPlanIDPost(planID: string, dataExportDataExportTables?: Array<DataExportDataExportTables>, options?: RawAxiosRequestConfig) {
        return DataExportApiFp(this.configuration).apiDataExportExportPlanIDPost(planID, dataExportDataExportTables, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataExportApi
     */
    public apiDataExportTablesPlanIDGet(planID: string, options?: RawAxiosRequestConfig) {
        return DataExportApiFp(this.configuration).apiDataExportTablesPlanIDGet(planID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DataVisualizationsApi - axios parameter creator
 * @export
 */
export const DataVisualizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsDatavizJobGroupListGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DataVisualizations/dataviz-job-group-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsEmploymentByDemographicDrilldownGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DataVisualizations/employment-by-demographic-drilldown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [eeocode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsEmploymentByJobGroupForEeoDrilldownGet: async (eeocode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DataVisualizations/employment-by-job-group-for-eeo-drilldown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eeocode !== undefined) {
                localVarQueryParameter['eeocode'] = eeocode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [eeoCode] 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsEmploymentByJobTitleForJobGroupDemographicDrilldownGet: async (eeoCode?: string, jobGroup?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DataVisualizations/employment-by-job-title-for-job-group-demographic-drilldown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eeoCode !== undefined) {
                localVarQueryParameter['eeoCode'] = eeoCode;
            }

            if (jobGroup !== undefined) {
                localVarQueryParameter['jobGroup'] = jobGroup;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsEmploymentGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DataVisualizations/employment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [resultsBy] 
         * @param {string} [eeoCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsGoalAttainmentByJobgroupForEeoGet: async (resultsBy?: EnumerationsDataVisualizationFilterBy, eeoCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DataVisualizations/goal-attainment-by-jobgroup-for-eeo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resultsBy !== undefined) {
                localVarQueryParameter['resultsBy'] = resultsBy;
            }

            if (eeoCode !== undefined) {
                localVarQueryParameter['eeoCode'] = eeoCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsGoalAttainmentByJobgroupGet: async (jobGroup?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DataVisualizations/goal-attainment-by-jobgroup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (jobGroup !== undefined) {
                localVarQueryParameter['jobGroup'] = jobGroup;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [resultsBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsGoalAttainmentDonutChartDrilldownGet: async (resultsBy?: EnumerationsDataVisualizationFilterBy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DataVisualizations/goal-attainment-donut-chart-drilldown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resultsBy !== undefined) {
                localVarQueryParameter['resultsBy'] = resultsBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsGoalAttainmentGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DataVisualizations/goal-attainment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataVisualizationsApi - functional programming interface
 * @export
 */
export const DataVisualizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataVisualizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataVisualizationsDatavizJobGroupListGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonGetJobGroupsForPlansResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataVisualizationsDatavizJobGroupListGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiDataVisualizationsDatavizJobGroupListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataVisualizationsEmploymentByDemographicDrilldownGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetEmploymentByDemographicDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataVisualizationsEmploymentByDemographicDrilldownGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiDataVisualizationsEmploymentByDemographicDrilldownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [eeocode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataVisualizationsEmploymentByJobGroupForEeoDrilldownGet(eeocode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetEmploymentByJobGroupForEeoDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataVisualizationsEmploymentByJobGroupForEeoDrilldownGet(eeocode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiDataVisualizationsEmploymentByJobGroupForEeoDrilldownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [eeoCode] 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataVisualizationsEmploymentByJobTitleForJobGroupDemographicDrilldownGet(eeoCode?: string, jobGroup?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetEmploymentByJobTitleForJobGroupByDemographicDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataVisualizationsEmploymentByJobTitleForJobGroupDemographicDrilldownGet(eeoCode, jobGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiDataVisualizationsEmploymentByJobTitleForJobGroupDemographicDrilldownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataVisualizationsEmploymentGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetEmploymentVisualizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataVisualizationsEmploymentGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiDataVisualizationsEmploymentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [resultsBy] 
         * @param {string} [eeoCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataVisualizationsGoalAttainmentByJobgroupForEeoGet(resultsBy?: EnumerationsDataVisualizationFilterBy, eeoCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetGoalAttainmentByJobGroupForEeoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataVisualizationsGoalAttainmentByJobgroupForEeoGet(resultsBy, eeoCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiDataVisualizationsGoalAttainmentByJobgroupForEeoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataVisualizationsGoalAttainmentByJobgroupGet(jobGroup?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetGoalAttainmentByJobGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataVisualizationsGoalAttainmentByJobgroupGet(jobGroup, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiDataVisualizationsGoalAttainmentByJobgroupGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [resultsBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataVisualizationsGoalAttainmentDonutChartDrilldownGet(resultsBy?: EnumerationsDataVisualizationFilterBy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetGoalAttainmentDonutChartDrilldownLevel1Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataVisualizationsGoalAttainmentDonutChartDrilldownGet(resultsBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiDataVisualizationsGoalAttainmentDonutChartDrilldownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDataVisualizationsGoalAttainmentGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetGoalAttainmentVisualizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDataVisualizationsGoalAttainmentGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiDataVisualizationsGoalAttainmentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataVisualizationsApi - factory interface
 * @export
 */
export const DataVisualizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataVisualizationsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsDatavizJobGroupListGet(options?: any): AxiosPromise<CommonGetJobGroupsForPlansResponse> {
            return localVarFp.apiDataVisualizationsDatavizJobGroupListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsEmploymentByDemographicDrilldownGet(options?: any): AxiosPromise<QueriesGetEmploymentByDemographicDrilldownResponse> {
            return localVarFp.apiDataVisualizationsEmploymentByDemographicDrilldownGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [eeocode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsEmploymentByJobGroupForEeoDrilldownGet(eeocode?: string, options?: any): AxiosPromise<QueriesGetEmploymentByJobGroupForEeoDrilldownResponse> {
            return localVarFp.apiDataVisualizationsEmploymentByJobGroupForEeoDrilldownGet(eeocode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [eeoCode] 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsEmploymentByJobTitleForJobGroupDemographicDrilldownGet(eeoCode?: string, jobGroup?: string, options?: any): AxiosPromise<QueriesGetEmploymentByJobTitleForJobGroupByDemographicDrilldownResponse> {
            return localVarFp.apiDataVisualizationsEmploymentByJobTitleForJobGroupDemographicDrilldownGet(eeoCode, jobGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsEmploymentGet(options?: any): AxiosPromise<QueriesGetEmploymentVisualizationResponse> {
            return localVarFp.apiDataVisualizationsEmploymentGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [resultsBy] 
         * @param {string} [eeoCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsGoalAttainmentByJobgroupForEeoGet(resultsBy?: EnumerationsDataVisualizationFilterBy, eeoCode?: string, options?: any): AxiosPromise<QueriesGetGoalAttainmentByJobGroupForEeoResponse> {
            return localVarFp.apiDataVisualizationsGoalAttainmentByJobgroupForEeoGet(resultsBy, eeoCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [jobGroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsGoalAttainmentByJobgroupGet(jobGroup?: string, options?: any): AxiosPromise<QueriesGetGoalAttainmentByJobGroupResponse> {
            return localVarFp.apiDataVisualizationsGoalAttainmentByJobgroupGet(jobGroup, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationFilterBy} [resultsBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsGoalAttainmentDonutChartDrilldownGet(resultsBy?: EnumerationsDataVisualizationFilterBy, options?: any): AxiosPromise<QueriesGetGoalAttainmentDonutChartDrilldownLevel1Response> {
            return localVarFp.apiDataVisualizationsGoalAttainmentDonutChartDrilldownGet(resultsBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDataVisualizationsGoalAttainmentGet(options?: any): AxiosPromise<QueriesGetGoalAttainmentVisualizationResponse> {
            return localVarFp.apiDataVisualizationsGoalAttainmentGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataVisualizationsApi - object-oriented interface
 * @export
 * @class DataVisualizationsApi
 * @extends {BaseAPI}
 */
export class DataVisualizationsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiDataVisualizationsDatavizJobGroupListGet(options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiDataVisualizationsDatavizJobGroupListGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiDataVisualizationsEmploymentByDemographicDrilldownGet(options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiDataVisualizationsEmploymentByDemographicDrilldownGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [eeocode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiDataVisualizationsEmploymentByJobGroupForEeoDrilldownGet(eeocode?: string, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiDataVisualizationsEmploymentByJobGroupForEeoDrilldownGet(eeocode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [eeoCode] 
     * @param {string} [jobGroup] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiDataVisualizationsEmploymentByJobTitleForJobGroupDemographicDrilldownGet(eeoCode?: string, jobGroup?: string, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiDataVisualizationsEmploymentByJobTitleForJobGroupDemographicDrilldownGet(eeoCode, jobGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiDataVisualizationsEmploymentGet(options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiDataVisualizationsEmploymentGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsDataVisualizationFilterBy} [resultsBy] 
     * @param {string} [eeoCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiDataVisualizationsGoalAttainmentByJobgroupForEeoGet(resultsBy?: EnumerationsDataVisualizationFilterBy, eeoCode?: string, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiDataVisualizationsGoalAttainmentByJobgroupForEeoGet(resultsBy, eeoCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [jobGroup] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiDataVisualizationsGoalAttainmentByJobgroupGet(jobGroup?: string, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiDataVisualizationsGoalAttainmentByJobgroupGet(jobGroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsDataVisualizationFilterBy} [resultsBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiDataVisualizationsGoalAttainmentDonutChartDrilldownGet(resultsBy?: EnumerationsDataVisualizationFilterBy, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiDataVisualizationsGoalAttainmentDonutChartDrilldownGet(resultsBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiDataVisualizationsGoalAttainmentGet(options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiDataVisualizationsGoalAttainmentGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DocumentCenterApi - axios parameter creator
 * @export
 */
export const DocumentCenterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CommandsSelectAllAssignDocumentsToUserCommand} [commandsSelectAllAssignDocumentsToUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterAssignAllDocumentsToUsersPut: async (commandsSelectAllAssignDocumentsToUserCommand?: CommandsSelectAllAssignDocumentsToUserCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocumentCenter/assign-all-documents-to-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsSelectAllAssignDocumentsToUserCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommonAssignDocumentsToUserCommand} [commonAssignDocumentsToUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterAssignDocumentsToUsersPut: async (commonAssignDocumentsToUserCommand?: CommonAssignDocumentsToUserCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocumentCenter/assign-documents-to-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commonAssignDocumentsToUserCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCopyLocationsCommand} [commandsCopyLocationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterCopyLocationsPost: async (commandsCopyLocationsCommand?: CommandsCopyLocationsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocumentCenter/copy-locations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCopyLocationsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDelete: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocumentCenter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentUploadID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDocumentDocumentUploadIDGet: async (documentUploadID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentUploadID' is not null or undefined
            assertParamExists('apiDocumentCenterDocumentDocumentUploadIDGet', 'documentUploadID', documentUploadID)
            const localVarPath = `/api/DocumentCenter/document/{documentUploadID}`
                .replace(`{${"documentUploadID"}}`, encodeURIComponent(String(documentUploadID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentUploadID 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDocumentDocumentUploadIDManageAccessPost: async (documentUploadID: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentUploadID' is not null or undefined
            assertParamExists('apiDocumentCenterDocumentDocumentUploadIDManageAccessPost', 'documentUploadID', documentUploadID)
            const localVarPath = `/api/DocumentCenter/document/{documentUploadID}/manage-access`
                .replace(`{${"documentUploadID"}}`, encodeURIComponent(String(documentUploadID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userID 
         * @param {string} documentUploadID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDocumentDocumentUploadIDResendDocumentAccessNotificationUserIDPost: async (userID: string, documentUploadID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userID' is not null or undefined
            assertParamExists('apiDocumentCenterDocumentDocumentUploadIDResendDocumentAccessNotificationUserIDPost', 'userID', userID)
            // verify required parameter 'documentUploadID' is not null or undefined
            assertParamExists('apiDocumentCenterDocumentDocumentUploadIDResendDocumentAccessNotificationUserIDPost', 'documentUploadID', documentUploadID)
            const localVarPath = `/api/DocumentCenter/document/{documentUploadID}/resend-document-access-notification/{userID}`
                .replace(`{${"userID"}}`, encodeURIComponent(String(userID)))
                .replace(`{${"documentUploadID"}}`, encodeURIComponent(String(documentUploadID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentUploadID 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDocumentUploadIDChangeClientClientIDPut: async (documentUploadID: string, clientID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentUploadID' is not null or undefined
            assertParamExists('apiDocumentCenterDocumentUploadIDChangeClientClientIDPut', 'documentUploadID', documentUploadID)
            // verify required parameter 'clientID' is not null or undefined
            assertParamExists('apiDocumentCenterDocumentUploadIDChangeClientClientIDPut', 'clientID', clientID)
            const localVarPath = `/api/DocumentCenter/{documentUploadID}/change-client/{clientID}`
                .replace(`{${"documentUploadID"}}`, encodeURIComponent(String(documentUploadID)))
                .replace(`{${"clientID"}}`, encodeURIComponent(String(clientID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} documentUploadID 
         * @param {string} [projectID] 
         * @param {string} [locationID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDocumentUploadIDUpdateProjectLocationPut: async (documentUploadID: string, projectID?: string, locationID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentUploadID' is not null or undefined
            assertParamExists('apiDocumentCenterDocumentUploadIDUpdateProjectLocationPut', 'documentUploadID', documentUploadID)
            const localVarPath = `/api/DocumentCenter/{documentUploadID}/update-project-location`
                .replace(`{${"documentUploadID"}}`, encodeURIComponent(String(documentUploadID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (projectID !== undefined) {
                localVarQueryParameter['projectID'] = projectID;
            }

            if (locationID !== undefined) {
                localVarQueryParameter['locationID'] = locationID;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsDocumentCenterTab} [tab] 
         * @param {EnumerationsDocumentCenterView} [view] 
         * @param {string} [searchTerm] 
         * @param {string} [uploadID] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDocumentsAllDelete: async (tab?: EnumerationsDocumentCenterTab, view?: EnumerationsDocumentCenterView, searchTerm?: string, uploadID?: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocumentCenter/documents/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tab !== undefined) {
                localVarQueryParameter['tab'] = tab;
            }

            if (view !== undefined) {
                localVarQueryParameter['view'] = view;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (uploadID !== undefined) {
                localVarQueryParameter['uploadID'] = uploadID;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsDocumentCenterTab} [tab] 
         * @param {EnumerationsDocumentCenterView} [view] 
         * @param {string} [searchTerm] 
         * @param {string} [uploadID] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDownloadAllPost: async (tab?: EnumerationsDocumentCenterTab, view?: EnumerationsDocumentCenterView, searchTerm?: string, uploadID?: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocumentCenter/download-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tab !== undefined) {
                localVarQueryParameter['tab'] = tab;
            }

            if (view !== undefined) {
                localVarQueryParameter['view'] = view;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (uploadID !== undefined) {
                localVarQueryParameter['uploadID'] = uploadID;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDownloadByUploadIdPost: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocumentCenter/download-by-upload-id`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDownloadPost: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocumentCenter/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsDocumentCenterTab} [tab] 
         * @param {EnumerationsDocumentCenterView} [view] 
         * @param {string} [searchTerm] 
         * @param {EnumerationsDocumentCenterSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {string} [uploadID] 
         * @param {string} [projectID] 
         * @param {string} [locationID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterGet: async (tab?: EnumerationsDocumentCenterTab, view?: EnumerationsDocumentCenterView, searchTerm?: string, sortColumn?: EnumerationsDocumentCenterSortColumn, sortDirection?: EnumerationsSortDirection, page?: number, rowsPerPage?: number, uploadID?: string, projectID?: string, locationID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocumentCenter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tab !== undefined) {
                localVarQueryParameter['tab'] = tab;
            }

            if (view !== undefined) {
                localVarQueryParameter['view'] = view;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (rowsPerPage !== undefined) {
                localVarQueryParameter['rowsPerPage'] = rowsPerPage;
            }

            if (uploadID !== undefined) {
                localVarQueryParameter['uploadID'] = uploadID;
            }

            if (projectID !== undefined) {
                localVarQueryParameter['projectID'] = projectID;
            }

            if (locationID !== undefined) {
                localVarQueryParameter['locationID'] = locationID;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectID 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterProjectIDImportLocationsPost: async (projectID: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectID' is not null or undefined
            assertParamExists('apiDocumentCenterProjectIDImportLocationsPost', 'projectID', projectID)
            const localVarPath = `/api/DocumentCenter/{projectID}/import-locations`
                .replace(`{${"projectID"}}`, encodeURIComponent(String(projectID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectID 
         * @param {string} locationID 
         * @param {CommandsUpdateLocationRequest} [commandsUpdateLocationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterProjectIDLocationLocationIDPut: async (projectID: string, locationID: string, commandsUpdateLocationRequest?: CommandsUpdateLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectID' is not null or undefined
            assertParamExists('apiDocumentCenterProjectIDLocationLocationIDPut', 'projectID', projectID)
            // verify required parameter 'locationID' is not null or undefined
            assertParamExists('apiDocumentCenterProjectIDLocationLocationIDPut', 'locationID', locationID)
            const localVarPath = `/api/DocumentCenter/{projectID}/location/{locationID}`
                .replace(`{${"projectID"}}`, encodeURIComponent(String(projectID)))
                .replace(`{${"locationID"}}`, encodeURIComponent(String(locationID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectID 
         * @param {CommandsCreateLocationRequest} [commandsCreateLocationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterProjectIDLocationPost: async (projectID: string, commandsCreateLocationRequest?: CommandsCreateLocationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectID' is not null or undefined
            assertParamExists('apiDocumentCenterProjectIDLocationPost', 'projectID', projectID)
            const localVarPath = `/api/DocumentCenter/{projectID}/location`
                .replace(`{${"projectID"}}`, encodeURIComponent(String(projectID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateLocationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterProjectIDLocationsGet: async (projectID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectID' is not null or undefined
            assertParamExists('apiDocumentCenterProjectIDLocationsGet', 'projectID', projectID)
            const localVarPath = `/api/DocumentCenter/{projectID}/locations`
                .replace(`{${"projectID"}}`, encodeURIComponent(String(projectID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateProjectRequest} [commandsCreateProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterProjectPost: async (commandsCreateProjectRequest?: CommandsCreateProjectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocumentCenter/project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateProjectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectID 
         * @param {CommandsUpdateProjectRequest} [commandsUpdateProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterProjectProjectIDPut: async (projectID: string, commandsUpdateProjectRequest?: CommandsUpdateProjectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectID' is not null or undefined
            assertParamExists('apiDocumentCenterProjectProjectIDPut', 'projectID', projectID)
            const localVarPath = `/api/DocumentCenter/project/{projectID}`
                .replace(`{${"projectID"}}`, encodeURIComponent(String(projectID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateProjectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterProjectsClientIDGet: async (clientID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientID' is not null or undefined
            assertParamExists('apiDocumentCenterProjectsClientIDGet', 'clientID', clientID)
            const localVarPath = `/api/DocumentCenter/projects/{clientID}`
                .replace(`{${"clientID"}}`, encodeURIComponent(String(clientID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<TransferObjectsUpdateUnassignedDocumentDTO>} [transferObjectsUpdateUnassignedDocumentDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterPut: async (transferObjectsUpdateUnassignedDocumentDTO?: Array<TransferObjectsUpdateUnassignedDocumentDTO>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocumentCenter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferObjectsUpdateUnassignedDocumentDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsUpdateReadStatusRequest} [commandsUpdateReadStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterReadPut: async (commandsUpdateReadStatusRequest?: CommandsUpdateReadStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocumentCenter/read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateReadStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsSelectAllUpdateReadStatusRequest} [commandsSelectAllUpdateReadStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterSelectAllReadPut: async (commandsSelectAllUpdateReadStatusRequest?: CommandsSelectAllUpdateReadStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocumentCenter/select-all-read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsSelectAllUpdateReadStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} batchID 
         * @param {number} [sequenceID] 
         * @param {number} [uploadSize] 
         * @param {boolean} [isEndOfFile] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterUploadBatchIDChunkPost: async (batchID: string, sequenceID?: number, uploadSize?: number, isEndOfFile?: boolean, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'batchID' is not null or undefined
            assertParamExists('apiDocumentCenterUploadBatchIDChunkPost', 'batchID', batchID)
            const localVarPath = `/api/DocumentCenter/upload/{batchID}/chunk`
                .replace(`{${"batchID"}}`, encodeURIComponent(String(batchID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (sequenceID !== undefined) {
                localVarQueryParameter['sequenceID'] = sequenceID;
            }

            if (uploadSize !== undefined) {
                localVarQueryParameter['uploadSize'] = uploadSize;
            }

            if (isEndOfFile !== undefined) {
                localVarQueryParameter['isEndOfFile'] = isEndOfFile;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsInitiateExternalFileUploadRequest} [commandsInitiateExternalFileUploadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterUploadExternalPost: async (commandsInitiateExternalFileUploadRequest?: CommandsInitiateExternalFileUploadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocumentCenter/upload/external`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsInitiateExternalFileUploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsInitiateInternalFileUploadRequest} [commandsInitiateInternalFileUploadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterUploadInternalPost: async (commandsInitiateInternalFileUploadRequest?: CommandsInitiateInternalFileUploadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocumentCenter/upload/internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsInitiateInternalFileUploadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueriesValidateUploadURLQuery} [queriesValidateUploadURLQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterValidateURLPost: async (queriesValidateUploadURLQuery?: QueriesValidateUploadURLQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocumentCenter/validate-URL`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesValidateUploadURLQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsDocumentCenterTab} [tab] 
         * @param {string} [searchTerm] 
         * @param {string} [uploadID] 
         * @param {string} [projectID] 
         * @param {string} [locationID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterViewCountsGet: async (tab?: EnumerationsDocumentCenterTab, searchTerm?: string, uploadID?: string, projectID?: string, locationID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/DocumentCenter/view-counts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tab !== undefined) {
                localVarQueryParameter['tab'] = tab;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (uploadID !== undefined) {
                localVarQueryParameter['uploadID'] = uploadID;
            }

            if (projectID !== undefined) {
                localVarQueryParameter['projectID'] = projectID;
            }

            if (locationID !== undefined) {
                localVarQueryParameter['locationID'] = locationID;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentCenterApi - functional programming interface
 * @export
 */
export const DocumentCenterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentCenterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CommandsSelectAllAssignDocumentsToUserCommand} [commandsSelectAllAssignDocumentsToUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterAssignAllDocumentsToUsersPut(commandsSelectAllAssignDocumentsToUserCommand?: CommandsSelectAllAssignDocumentsToUserCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterAssignAllDocumentsToUsersPut(commandsSelectAllAssignDocumentsToUserCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterAssignAllDocumentsToUsersPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommonAssignDocumentsToUserCommand} [commonAssignDocumentsToUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterAssignDocumentsToUsersPut(commonAssignDocumentsToUserCommand?: CommonAssignDocumentsToUserCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterAssignDocumentsToUsersPut(commonAssignDocumentsToUserCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterAssignDocumentsToUsersPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCopyLocationsCommand} [commandsCopyLocationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterCopyLocationsPost(commandsCopyLocationsCommand?: CommandsCopyLocationsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueriesGetLocationsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterCopyLocationsPost(commandsCopyLocationsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterCopyLocationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterDelete(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterDelete(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentUploadID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterDocumentDocumentUploadIDGet(documentUploadID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsGetDocumentDetailsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterDocumentDocumentUploadIDGet(documentUploadID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterDocumentDocumentUploadIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentUploadID 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterDocumentDocumentUploadIDManageAccessPost(documentUploadID: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterDocumentDocumentUploadIDManageAccessPost(documentUploadID, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterDocumentDocumentUploadIDManageAccessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userID 
         * @param {string} documentUploadID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterDocumentDocumentUploadIDResendDocumentAccessNotificationUserIDPost(userID: string, documentUploadID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterDocumentDocumentUploadIDResendDocumentAccessNotificationUserIDPost(userID, documentUploadID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterDocumentDocumentUploadIDResendDocumentAccessNotificationUserIDPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentUploadID 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterDocumentUploadIDChangeClientClientIDPut(documentUploadID: string, clientID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterDocumentUploadIDChangeClientClientIDPut(documentUploadID, clientID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterDocumentUploadIDChangeClientClientIDPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} documentUploadID 
         * @param {string} [projectID] 
         * @param {string} [locationID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterDocumentUploadIDUpdateProjectLocationPut(documentUploadID: string, projectID?: string, locationID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterDocumentUploadIDUpdateProjectLocationPut(documentUploadID, projectID, locationID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterDocumentUploadIDUpdateProjectLocationPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsDocumentCenterTab} [tab] 
         * @param {EnumerationsDocumentCenterView} [view] 
         * @param {string} [searchTerm] 
         * @param {string} [uploadID] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterDocumentsAllDelete(tab?: EnumerationsDocumentCenterTab, view?: EnumerationsDocumentCenterView, searchTerm?: string, uploadID?: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterDocumentsAllDelete(tab, view, searchTerm, uploadID, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterDocumentsAllDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsDocumentCenterTab} [tab] 
         * @param {EnumerationsDocumentCenterView} [view] 
         * @param {string} [searchTerm] 
         * @param {string} [uploadID] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterDownloadAllPost(tab?: EnumerationsDocumentCenterTab, view?: EnumerationsDocumentCenterView, searchTerm?: string, uploadID?: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterDownloadAllPost(tab, view, searchTerm, uploadID, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterDownloadAllPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterDownloadByUploadIdPost(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterDownloadByUploadIdPost(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterDownloadByUploadIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterDownloadPost(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterDownloadPost(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterDownloadPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsDocumentCenterTab} [tab] 
         * @param {EnumerationsDocumentCenterView} [view] 
         * @param {string} [searchTerm] 
         * @param {EnumerationsDocumentCenterSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {string} [uploadID] 
         * @param {string} [projectID] 
         * @param {string} [locationID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterGet(tab?: EnumerationsDocumentCenterTab, view?: EnumerationsDocumentCenterView, searchTerm?: string, sortColumn?: EnumerationsDocumentCenterSortColumn, sortDirection?: EnumerationsSortDirection, page?: number, rowsPerPage?: number, uploadID?: string, projectID?: string, locationID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetDocumentUploadsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterGet(tab, view, searchTerm, sortColumn, sortDirection, page, rowsPerPage, uploadID, projectID, locationID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectID 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterProjectIDImportLocationsPost(projectID: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueriesGetLocationsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterProjectIDImportLocationsPost(projectID, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterProjectIDImportLocationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectID 
         * @param {string} locationID 
         * @param {CommandsUpdateLocationRequest} [commandsUpdateLocationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterProjectIDLocationLocationIDPut(projectID: string, locationID: string, commandsUpdateLocationRequest?: CommandsUpdateLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterProjectIDLocationLocationIDPut(projectID, locationID, commandsUpdateLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterProjectIDLocationLocationIDPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectID 
         * @param {CommandsCreateLocationRequest} [commandsCreateLocationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterProjectIDLocationPost(projectID: string, commandsCreateLocationRequest?: CommandsCreateLocationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterProjectIDLocationPost(projectID, commandsCreateLocationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterProjectIDLocationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterProjectIDLocationsGet(projectID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueriesGetLocationsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterProjectIDLocationsGet(projectID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterProjectIDLocationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateProjectRequest} [commandsCreateProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterProjectPost(commandsCreateProjectRequest?: CommandsCreateProjectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterProjectPost(commandsCreateProjectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterProjectPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectID 
         * @param {CommandsUpdateProjectRequest} [commandsUpdateProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterProjectProjectIDPut(projectID: string, commandsUpdateProjectRequest?: CommandsUpdateProjectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterProjectProjectIDPut(projectID, commandsUpdateProjectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterProjectProjectIDPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterProjectsClientIDGet(clientID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueriesGetProjectsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterProjectsClientIDGet(clientID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterProjectsClientIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<TransferObjectsUpdateUnassignedDocumentDTO>} [transferObjectsUpdateUnassignedDocumentDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterPut(transferObjectsUpdateUnassignedDocumentDTO?: Array<TransferObjectsUpdateUnassignedDocumentDTO>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterPut(transferObjectsUpdateUnassignedDocumentDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsUpdateReadStatusRequest} [commandsUpdateReadStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterReadPut(commandsUpdateReadStatusRequest?: CommandsUpdateReadStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterReadPut(commandsUpdateReadStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterReadPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsSelectAllUpdateReadStatusRequest} [commandsSelectAllUpdateReadStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterSelectAllReadPut(commandsSelectAllUpdateReadStatusRequest?: CommandsSelectAllUpdateReadStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterSelectAllReadPut(commandsSelectAllUpdateReadStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterSelectAllReadPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} batchID 
         * @param {number} [sequenceID] 
         * @param {number} [uploadSize] 
         * @param {boolean} [isEndOfFile] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterUploadBatchIDChunkPost(batchID: string, sequenceID?: number, uploadSize?: number, isEndOfFile?: boolean, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterUploadBatchIDChunkPost(batchID, sequenceID, uploadSize, isEndOfFile, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterUploadBatchIDChunkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsInitiateExternalFileUploadRequest} [commandsInitiateExternalFileUploadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterUploadExternalPost(commandsInitiateExternalFileUploadRequest?: CommandsInitiateExternalFileUploadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterUploadExternalPost(commandsInitiateExternalFileUploadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterUploadExternalPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsInitiateInternalFileUploadRequest} [commandsInitiateInternalFileUploadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterUploadInternalPost(commandsInitiateInternalFileUploadRequest?: CommandsInitiateInternalFileUploadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterUploadInternalPost(commandsInitiateInternalFileUploadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterUploadInternalPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueriesValidateUploadURLQuery} [queriesValidateUploadURLQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterValidateURLPost(queriesValidateUploadURLQuery?: QueriesValidateUploadURLQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesValidateUploadURLResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterValidateURLPost(queriesValidateUploadURLQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterValidateURLPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsDocumentCenterTab} [tab] 
         * @param {string} [searchTerm] 
         * @param {string} [uploadID] 
         * @param {string} [projectID] 
         * @param {string} [locationID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentCenterViewCountsGet(tab?: EnumerationsDocumentCenterTab, searchTerm?: string, uploadID?: string, projectID?: string, locationID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetDocumentUploadCountsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentCenterViewCountsGet(tab, searchTerm, uploadID, projectID, locationID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentCenterApi.apiDocumentCenterViewCountsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentCenterApi - factory interface
 * @export
 */
export const DocumentCenterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentCenterApiFp(configuration)
    return {
        /**
         * 
         * @param {CommandsSelectAllAssignDocumentsToUserCommand} [commandsSelectAllAssignDocumentsToUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterAssignAllDocumentsToUsersPut(commandsSelectAllAssignDocumentsToUserCommand?: CommandsSelectAllAssignDocumentsToUserCommand, options?: any): AxiosPromise<File> {
            return localVarFp.apiDocumentCenterAssignAllDocumentsToUsersPut(commandsSelectAllAssignDocumentsToUserCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommonAssignDocumentsToUserCommand} [commonAssignDocumentsToUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterAssignDocumentsToUsersPut(commonAssignDocumentsToUserCommand?: CommonAssignDocumentsToUserCommand, options?: any): AxiosPromise<File> {
            return localVarFp.apiDocumentCenterAssignDocumentsToUsersPut(commonAssignDocumentsToUserCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCopyLocationsCommand} [commandsCopyLocationsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterCopyLocationsPost(commandsCopyLocationsCommand?: CommandsCopyLocationsCommand, options?: any): AxiosPromise<Array<QueriesGetLocationsResponse>> {
            return localVarFp.apiDocumentCenterCopyLocationsPost(commandsCopyLocationsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDelete(requestBody?: Array<string>, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiDocumentCenterDelete(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} documentUploadID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDocumentDocumentUploadIDGet(documentUploadID: string, options?: any): AxiosPromise<TransferObjectsGetDocumentDetailsResponseDTO> {
            return localVarFp.apiDocumentCenterDocumentDocumentUploadIDGet(documentUploadID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} documentUploadID 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDocumentDocumentUploadIDManageAccessPost(documentUploadID: string, requestBody?: Array<string>, options?: any): AxiosPromise<File> {
            return localVarFp.apiDocumentCenterDocumentDocumentUploadIDManageAccessPost(documentUploadID, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} userID 
         * @param {string} documentUploadID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDocumentDocumentUploadIDResendDocumentAccessNotificationUserIDPost(userID: string, documentUploadID: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDocumentCenterDocumentDocumentUploadIDResendDocumentAccessNotificationUserIDPost(userID, documentUploadID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} documentUploadID 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDocumentUploadIDChangeClientClientIDPut(documentUploadID: string, clientID: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiDocumentCenterDocumentUploadIDChangeClientClientIDPut(documentUploadID, clientID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} documentUploadID 
         * @param {string} [projectID] 
         * @param {string} [locationID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDocumentUploadIDUpdateProjectLocationPut(documentUploadID: string, projectID?: string, locationID?: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiDocumentCenterDocumentUploadIDUpdateProjectLocationPut(documentUploadID, projectID, locationID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsDocumentCenterTab} [tab] 
         * @param {EnumerationsDocumentCenterView} [view] 
         * @param {string} [searchTerm] 
         * @param {string} [uploadID] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDocumentsAllDelete(tab?: EnumerationsDocumentCenterTab, view?: EnumerationsDocumentCenterView, searchTerm?: string, uploadID?: string, requestBody?: Array<string>, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiDocumentCenterDocumentsAllDelete(tab, view, searchTerm, uploadID, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsDocumentCenterTab} [tab] 
         * @param {EnumerationsDocumentCenterView} [view] 
         * @param {string} [searchTerm] 
         * @param {string} [uploadID] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDownloadAllPost(tab?: EnumerationsDocumentCenterTab, view?: EnumerationsDocumentCenterView, searchTerm?: string, uploadID?: string, requestBody?: Array<string>, options?: any): AxiosPromise<File> {
            return localVarFp.apiDocumentCenterDownloadAllPost(tab, view, searchTerm, uploadID, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDownloadByUploadIdPost(requestBody?: Array<string>, options?: any): AxiosPromise<File> {
            return localVarFp.apiDocumentCenterDownloadByUploadIdPost(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterDownloadPost(requestBody?: Array<string>, options?: any): AxiosPromise<File> {
            return localVarFp.apiDocumentCenterDownloadPost(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsDocumentCenterTab} [tab] 
         * @param {EnumerationsDocumentCenterView} [view] 
         * @param {string} [searchTerm] 
         * @param {EnumerationsDocumentCenterSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {string} [uploadID] 
         * @param {string} [projectID] 
         * @param {string} [locationID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterGet(tab?: EnumerationsDocumentCenterTab, view?: EnumerationsDocumentCenterView, searchTerm?: string, sortColumn?: EnumerationsDocumentCenterSortColumn, sortDirection?: EnumerationsSortDirection, page?: number, rowsPerPage?: number, uploadID?: string, projectID?: string, locationID?: string, options?: any): AxiosPromise<QueriesGetDocumentUploadsResponse> {
            return localVarFp.apiDocumentCenterGet(tab, view, searchTerm, sortColumn, sortDirection, page, rowsPerPage, uploadID, projectID, locationID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectID 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterProjectIDImportLocationsPost(projectID: string, file?: File, options?: any): AxiosPromise<Array<QueriesGetLocationsResponse>> {
            return localVarFp.apiDocumentCenterProjectIDImportLocationsPost(projectID, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectID 
         * @param {string} locationID 
         * @param {CommandsUpdateLocationRequest} [commandsUpdateLocationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterProjectIDLocationLocationIDPut(projectID: string, locationID: string, commandsUpdateLocationRequest?: CommandsUpdateLocationRequest, options?: any): AxiosPromise<File> {
            return localVarFp.apiDocumentCenterProjectIDLocationLocationIDPut(projectID, locationID, commandsUpdateLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectID 
         * @param {CommandsCreateLocationRequest} [commandsCreateLocationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterProjectIDLocationPost(projectID: string, commandsCreateLocationRequest?: CommandsCreateLocationRequest, options?: any): AxiosPromise<File> {
            return localVarFp.apiDocumentCenterProjectIDLocationPost(projectID, commandsCreateLocationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterProjectIDLocationsGet(projectID: string, options?: any): AxiosPromise<Array<QueriesGetLocationsResponse>> {
            return localVarFp.apiDocumentCenterProjectIDLocationsGet(projectID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateProjectRequest} [commandsCreateProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterProjectPost(commandsCreateProjectRequest?: CommandsCreateProjectRequest, options?: any): AxiosPromise<File> {
            return localVarFp.apiDocumentCenterProjectPost(commandsCreateProjectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectID 
         * @param {CommandsUpdateProjectRequest} [commandsUpdateProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterProjectProjectIDPut(projectID: string, commandsUpdateProjectRequest?: CommandsUpdateProjectRequest, options?: any): AxiosPromise<File> {
            return localVarFp.apiDocumentCenterProjectProjectIDPut(projectID, commandsUpdateProjectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} clientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterProjectsClientIDGet(clientID: string, options?: any): AxiosPromise<Array<QueriesGetProjectsResponse>> {
            return localVarFp.apiDocumentCenterProjectsClientIDGet(clientID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<TransferObjectsUpdateUnassignedDocumentDTO>} [transferObjectsUpdateUnassignedDocumentDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterPut(transferObjectsUpdateUnassignedDocumentDTO?: Array<TransferObjectsUpdateUnassignedDocumentDTO>, options?: any): AxiosPromise<void> {
            return localVarFp.apiDocumentCenterPut(transferObjectsUpdateUnassignedDocumentDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsUpdateReadStatusRequest} [commandsUpdateReadStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterReadPut(commandsUpdateReadStatusRequest?: CommandsUpdateReadStatusRequest, options?: any): AxiosPromise<File> {
            return localVarFp.apiDocumentCenterReadPut(commandsUpdateReadStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsSelectAllUpdateReadStatusRequest} [commandsSelectAllUpdateReadStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterSelectAllReadPut(commandsSelectAllUpdateReadStatusRequest?: CommandsSelectAllUpdateReadStatusRequest, options?: any): AxiosPromise<File> {
            return localVarFp.apiDocumentCenterSelectAllReadPut(commandsSelectAllUpdateReadStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} batchID 
         * @param {number} [sequenceID] 
         * @param {number} [uploadSize] 
         * @param {boolean} [isEndOfFile] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterUploadBatchIDChunkPost(batchID: string, sequenceID?: number, uploadSize?: number, isEndOfFile?: boolean, file?: File, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiDocumentCenterUploadBatchIDChunkPost(batchID, sequenceID, uploadSize, isEndOfFile, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsInitiateExternalFileUploadRequest} [commandsInitiateExternalFileUploadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterUploadExternalPost(commandsInitiateExternalFileUploadRequest?: CommandsInitiateExternalFileUploadRequest, options?: any): AxiosPromise<string> {
            return localVarFp.apiDocumentCenterUploadExternalPost(commandsInitiateExternalFileUploadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsInitiateInternalFileUploadRequest} [commandsInitiateInternalFileUploadRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterUploadInternalPost(commandsInitiateInternalFileUploadRequest?: CommandsInitiateInternalFileUploadRequest, options?: any): AxiosPromise<string> {
            return localVarFp.apiDocumentCenterUploadInternalPost(commandsInitiateInternalFileUploadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueriesValidateUploadURLQuery} [queriesValidateUploadURLQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterValidateURLPost(queriesValidateUploadURLQuery?: QueriesValidateUploadURLQuery, options?: any): AxiosPromise<QueriesValidateUploadURLResponse> {
            return localVarFp.apiDocumentCenterValidateURLPost(queriesValidateUploadURLQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsDocumentCenterTab} [tab] 
         * @param {string} [searchTerm] 
         * @param {string} [uploadID] 
         * @param {string} [projectID] 
         * @param {string} [locationID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentCenterViewCountsGet(tab?: EnumerationsDocumentCenterTab, searchTerm?: string, uploadID?: string, projectID?: string, locationID?: string, options?: any): AxiosPromise<QueriesGetDocumentUploadCountsResponse> {
            return localVarFp.apiDocumentCenterViewCountsGet(tab, searchTerm, uploadID, projectID, locationID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentCenterApi - object-oriented interface
 * @export
 * @class DocumentCenterApi
 * @extends {BaseAPI}
 */
export class DocumentCenterApi extends BaseAPI {
    /**
     * 
     * @param {CommandsSelectAllAssignDocumentsToUserCommand} [commandsSelectAllAssignDocumentsToUserCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterAssignAllDocumentsToUsersPut(commandsSelectAllAssignDocumentsToUserCommand?: CommandsSelectAllAssignDocumentsToUserCommand, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterAssignAllDocumentsToUsersPut(commandsSelectAllAssignDocumentsToUserCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommonAssignDocumentsToUserCommand} [commonAssignDocumentsToUserCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterAssignDocumentsToUsersPut(commonAssignDocumentsToUserCommand?: CommonAssignDocumentsToUserCommand, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterAssignDocumentsToUsersPut(commonAssignDocumentsToUserCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCopyLocationsCommand} [commandsCopyLocationsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterCopyLocationsPost(commandsCopyLocationsCommand?: CommandsCopyLocationsCommand, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterCopyLocationsPost(commandsCopyLocationsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterDelete(requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterDelete(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} documentUploadID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterDocumentDocumentUploadIDGet(documentUploadID: string, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterDocumentDocumentUploadIDGet(documentUploadID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} documentUploadID 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterDocumentDocumentUploadIDManageAccessPost(documentUploadID: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterDocumentDocumentUploadIDManageAccessPost(documentUploadID, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} userID 
     * @param {string} documentUploadID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterDocumentDocumentUploadIDResendDocumentAccessNotificationUserIDPost(userID: string, documentUploadID: string, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterDocumentDocumentUploadIDResendDocumentAccessNotificationUserIDPost(userID, documentUploadID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} documentUploadID 
     * @param {string} clientID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterDocumentUploadIDChangeClientClientIDPut(documentUploadID: string, clientID: string, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterDocumentUploadIDChangeClientClientIDPut(documentUploadID, clientID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} documentUploadID 
     * @param {string} [projectID] 
     * @param {string} [locationID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterDocumentUploadIDUpdateProjectLocationPut(documentUploadID: string, projectID?: string, locationID?: string, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterDocumentUploadIDUpdateProjectLocationPut(documentUploadID, projectID, locationID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsDocumentCenterTab} [tab] 
     * @param {EnumerationsDocumentCenterView} [view] 
     * @param {string} [searchTerm] 
     * @param {string} [uploadID] 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterDocumentsAllDelete(tab?: EnumerationsDocumentCenterTab, view?: EnumerationsDocumentCenterView, searchTerm?: string, uploadID?: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterDocumentsAllDelete(tab, view, searchTerm, uploadID, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsDocumentCenterTab} [tab] 
     * @param {EnumerationsDocumentCenterView} [view] 
     * @param {string} [searchTerm] 
     * @param {string} [uploadID] 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterDownloadAllPost(tab?: EnumerationsDocumentCenterTab, view?: EnumerationsDocumentCenterView, searchTerm?: string, uploadID?: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterDownloadAllPost(tab, view, searchTerm, uploadID, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterDownloadByUploadIdPost(requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterDownloadByUploadIdPost(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterDownloadPost(requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterDownloadPost(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsDocumentCenterTab} [tab] 
     * @param {EnumerationsDocumentCenterView} [view] 
     * @param {string} [searchTerm] 
     * @param {EnumerationsDocumentCenterSortColumn} [sortColumn] 
     * @param {EnumerationsSortDirection} [sortDirection] 
     * @param {number} [page] 
     * @param {number} [rowsPerPage] 
     * @param {string} [uploadID] 
     * @param {string} [projectID] 
     * @param {string} [locationID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterGet(tab?: EnumerationsDocumentCenterTab, view?: EnumerationsDocumentCenterView, searchTerm?: string, sortColumn?: EnumerationsDocumentCenterSortColumn, sortDirection?: EnumerationsSortDirection, page?: number, rowsPerPage?: number, uploadID?: string, projectID?: string, locationID?: string, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterGet(tab, view, searchTerm, sortColumn, sortDirection, page, rowsPerPage, uploadID, projectID, locationID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectID 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterProjectIDImportLocationsPost(projectID: string, file?: File, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterProjectIDImportLocationsPost(projectID, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectID 
     * @param {string} locationID 
     * @param {CommandsUpdateLocationRequest} [commandsUpdateLocationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterProjectIDLocationLocationIDPut(projectID: string, locationID: string, commandsUpdateLocationRequest?: CommandsUpdateLocationRequest, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterProjectIDLocationLocationIDPut(projectID, locationID, commandsUpdateLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectID 
     * @param {CommandsCreateLocationRequest} [commandsCreateLocationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterProjectIDLocationPost(projectID: string, commandsCreateLocationRequest?: CommandsCreateLocationRequest, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterProjectIDLocationPost(projectID, commandsCreateLocationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterProjectIDLocationsGet(projectID: string, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterProjectIDLocationsGet(projectID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateProjectRequest} [commandsCreateProjectRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterProjectPost(commandsCreateProjectRequest?: CommandsCreateProjectRequest, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterProjectPost(commandsCreateProjectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectID 
     * @param {CommandsUpdateProjectRequest} [commandsUpdateProjectRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterProjectProjectIDPut(projectID: string, commandsUpdateProjectRequest?: CommandsUpdateProjectRequest, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterProjectProjectIDPut(projectID, commandsUpdateProjectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} clientID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterProjectsClientIDGet(clientID: string, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterProjectsClientIDGet(clientID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<TransferObjectsUpdateUnassignedDocumentDTO>} [transferObjectsUpdateUnassignedDocumentDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterPut(transferObjectsUpdateUnassignedDocumentDTO?: Array<TransferObjectsUpdateUnassignedDocumentDTO>, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterPut(transferObjectsUpdateUnassignedDocumentDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsUpdateReadStatusRequest} [commandsUpdateReadStatusRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterReadPut(commandsUpdateReadStatusRequest?: CommandsUpdateReadStatusRequest, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterReadPut(commandsUpdateReadStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsSelectAllUpdateReadStatusRequest} [commandsSelectAllUpdateReadStatusRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterSelectAllReadPut(commandsSelectAllUpdateReadStatusRequest?: CommandsSelectAllUpdateReadStatusRequest, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterSelectAllReadPut(commandsSelectAllUpdateReadStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} batchID 
     * @param {number} [sequenceID] 
     * @param {number} [uploadSize] 
     * @param {boolean} [isEndOfFile] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterUploadBatchIDChunkPost(batchID: string, sequenceID?: number, uploadSize?: number, isEndOfFile?: boolean, file?: File, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterUploadBatchIDChunkPost(batchID, sequenceID, uploadSize, isEndOfFile, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsInitiateExternalFileUploadRequest} [commandsInitiateExternalFileUploadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterUploadExternalPost(commandsInitiateExternalFileUploadRequest?: CommandsInitiateExternalFileUploadRequest, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterUploadExternalPost(commandsInitiateExternalFileUploadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsInitiateInternalFileUploadRequest} [commandsInitiateInternalFileUploadRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterUploadInternalPost(commandsInitiateInternalFileUploadRequest?: CommandsInitiateInternalFileUploadRequest, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterUploadInternalPost(commandsInitiateInternalFileUploadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueriesValidateUploadURLQuery} [queriesValidateUploadURLQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterValidateURLPost(queriesValidateUploadURLQuery?: QueriesValidateUploadURLQuery, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterValidateURLPost(queriesValidateUploadURLQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsDocumentCenterTab} [tab] 
     * @param {string} [searchTerm] 
     * @param {string} [uploadID] 
     * @param {string} [projectID] 
     * @param {string} [locationID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentCenterApi
     */
    public apiDocumentCenterViewCountsGet(tab?: EnumerationsDocumentCenterTab, searchTerm?: string, uploadID?: string, projectID?: string, locationID?: string, options?: RawAxiosRequestConfig) {
        return DocumentCenterApiFp(this.configuration).apiDocumentCenterViewCountsGet(tab, searchTerm, uploadID, projectID, locationID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GoalDataVisualizationsApi - axios parameter creator
 * @export
 */
export const GoalDataVisualizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} eeoCode 
         * @param {number} [resultsBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoalDataVisualizationsEeoCodeEeoCodeGoalBradyBrunchDrilldownGet: async (eeoCode: string, resultsBy?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeoCode' is not null or undefined
            assertParamExists('apiGoalDataVisualizationsEeoCodeEeoCodeGoalBradyBrunchDrilldownGet', 'eeoCode', eeoCode)
            const localVarPath = `/api/GoalDataVisualizations/eeo-code/{eeoCode}/goal-brady-brunch-drilldown`
                .replace(`{${"eeoCode"}}`, encodeURIComponent(String(eeoCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resultsBy !== undefined) {
                localVarQueryParameter['resultsBy'] = resultsBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eeoCode 
         * @param {string} jobGroup 
         * @param {EnumerationsDataVisualizationResultsBy} [resultsBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoalDataVisualizationsEeoCodeEeoCodeJobGroupJobGroupGoalBradyBrunchDrilldownLevel2Get: async (eeoCode: string, jobGroup: string, resultsBy?: EnumerationsDataVisualizationResultsBy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeoCode' is not null or undefined
            assertParamExists('apiGoalDataVisualizationsEeoCodeEeoCodeJobGroupJobGroupGoalBradyBrunchDrilldownLevel2Get', 'eeoCode', eeoCode)
            // verify required parameter 'jobGroup' is not null or undefined
            assertParamExists('apiGoalDataVisualizationsEeoCodeEeoCodeJobGroupJobGroupGoalBradyBrunchDrilldownLevel2Get', 'jobGroup', jobGroup)
            const localVarPath = `/api/GoalDataVisualizations/eeo-code/{eeoCode}/job-group/{jobGroup}/goal-brady-brunch-drilldown-level-2`
                .replace(`{${"eeoCode"}}`, encodeURIComponent(String(eeoCode)))
                .replace(`{${"jobGroup"}}`, encodeURIComponent(String(jobGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resultsBy !== undefined) {
                localVarQueryParameter['resultsBy'] = resultsBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoalDataVisualizationsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/GoalDataVisualizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationResultsBy} [resultsBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoalDataVisualizationsGoalDrilldownGet: async (resultsBy?: EnumerationsDataVisualizationResultsBy, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/GoalDataVisualizations/goal-drilldown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resultsBy !== undefined) {
                localVarQueryParameter['resultsBy'] = resultsBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GoalDataVisualizationsApi - functional programming interface
 * @export
 */
export const GoalDataVisualizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GoalDataVisualizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} eeoCode 
         * @param {number} [resultsBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGoalDataVisualizationsEeoCodeEeoCodeGoalBradyBrunchDrilldownGet(eeoCode: string, resultsBy?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetGoalBradyBunchDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGoalDataVisualizationsEeoCodeEeoCodeGoalBradyBrunchDrilldownGet(eeoCode, resultsBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoalDataVisualizationsApi.apiGoalDataVisualizationsEeoCodeEeoCodeGoalBradyBrunchDrilldownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} eeoCode 
         * @param {string} jobGroup 
         * @param {EnumerationsDataVisualizationResultsBy} [resultsBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGoalDataVisualizationsEeoCodeEeoCodeJobGroupJobGroupGoalBradyBrunchDrilldownLevel2Get(eeoCode: string, jobGroup: string, resultsBy?: EnumerationsDataVisualizationResultsBy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetGoalBradyBunchDrilldownLevel2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGoalDataVisualizationsEeoCodeEeoCodeJobGroupJobGroupGoalBradyBrunchDrilldownLevel2Get(eeoCode, jobGroup, resultsBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoalDataVisualizationsApi.apiGoalDataVisualizationsEeoCodeEeoCodeJobGroupJobGroupGoalBradyBrunchDrilldownLevel2Get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGoalDataVisualizationsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetGoalDataVisualizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGoalDataVisualizationsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoalDataVisualizationsApi.apiGoalDataVisualizationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationResultsBy} [resultsBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGoalDataVisualizationsGoalDrilldownGet(resultsBy?: EnumerationsDataVisualizationResultsBy, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetGoalDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGoalDataVisualizationsGoalDrilldownGet(resultsBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoalDataVisualizationsApi.apiGoalDataVisualizationsGoalDrilldownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GoalDataVisualizationsApi - factory interface
 * @export
 */
export const GoalDataVisualizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GoalDataVisualizationsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} eeoCode 
         * @param {number} [resultsBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoalDataVisualizationsEeoCodeEeoCodeGoalBradyBrunchDrilldownGet(eeoCode: string, resultsBy?: number, options?: any): AxiosPromise<QueriesGetGoalBradyBunchDrilldownResponse> {
            return localVarFp.apiGoalDataVisualizationsEeoCodeEeoCodeGoalBradyBrunchDrilldownGet(eeoCode, resultsBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} eeoCode 
         * @param {string} jobGroup 
         * @param {EnumerationsDataVisualizationResultsBy} [resultsBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoalDataVisualizationsEeoCodeEeoCodeJobGroupJobGroupGoalBradyBrunchDrilldownLevel2Get(eeoCode: string, jobGroup: string, resultsBy?: EnumerationsDataVisualizationResultsBy, options?: any): AxiosPromise<QueriesGetGoalBradyBunchDrilldownLevel2Response> {
            return localVarFp.apiGoalDataVisualizationsEeoCodeEeoCodeJobGroupJobGroupGoalBradyBrunchDrilldownLevel2Get(eeoCode, jobGroup, resultsBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoalDataVisualizationsGet(options?: any): AxiosPromise<QueriesGetGoalDataVisualizationResponse> {
            return localVarFp.apiGoalDataVisualizationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationResultsBy} [resultsBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoalDataVisualizationsGoalDrilldownGet(resultsBy?: EnumerationsDataVisualizationResultsBy, options?: any): AxiosPromise<QueriesGetGoalDrilldownResponse> {
            return localVarFp.apiGoalDataVisualizationsGoalDrilldownGet(resultsBy, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GoalDataVisualizationsApi - object-oriented interface
 * @export
 * @class GoalDataVisualizationsApi
 * @extends {BaseAPI}
 */
export class GoalDataVisualizationsApi extends BaseAPI {
    /**
     * 
     * @param {string} eeoCode 
     * @param {number} [resultsBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoalDataVisualizationsApi
     */
    public apiGoalDataVisualizationsEeoCodeEeoCodeGoalBradyBrunchDrilldownGet(eeoCode: string, resultsBy?: number, options?: RawAxiosRequestConfig) {
        return GoalDataVisualizationsApiFp(this.configuration).apiGoalDataVisualizationsEeoCodeEeoCodeGoalBradyBrunchDrilldownGet(eeoCode, resultsBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} eeoCode 
     * @param {string} jobGroup 
     * @param {EnumerationsDataVisualizationResultsBy} [resultsBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoalDataVisualizationsApi
     */
    public apiGoalDataVisualizationsEeoCodeEeoCodeJobGroupJobGroupGoalBradyBrunchDrilldownLevel2Get(eeoCode: string, jobGroup: string, resultsBy?: EnumerationsDataVisualizationResultsBy, options?: RawAxiosRequestConfig) {
        return GoalDataVisualizationsApiFp(this.configuration).apiGoalDataVisualizationsEeoCodeEeoCodeJobGroupJobGroupGoalBradyBrunchDrilldownLevel2Get(eeoCode, jobGroup, resultsBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoalDataVisualizationsApi
     */
    public apiGoalDataVisualizationsGet(options?: RawAxiosRequestConfig) {
        return GoalDataVisualizationsApiFp(this.configuration).apiGoalDataVisualizationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsDataVisualizationResultsBy} [resultsBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoalDataVisualizationsApi
     */
    public apiGoalDataVisualizationsGoalDrilldownGet(resultsBy?: EnumerationsDataVisualizationResultsBy, options?: RawAxiosRequestConfig) {
        return GoalDataVisualizationsApiFp(this.configuration).apiGoalDataVisualizationsGoalDrilldownGet(resultsBy, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GoodFaithEffortsApi - axios parameter creator
 * @export
 */
export const GoodFaithEffortsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [planID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsAssessmentGet: async (planID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/GoodFaithEfforts/assessment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (planID !== undefined) {
                localVarQueryParameter['planID'] = planID;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsSaveGFEAssessmentCommand} [commandsSaveGFEAssessmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsAssessmentSettingsPost: async (commandsSaveGFEAssessmentCommand?: CommandsSaveGFEAssessmentCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/GoodFaithEfforts/assessment-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsSaveGFEAssessmentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<GFEGFEFieldsDTO>} [gFEGFEFieldsDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsColumnsPut: async (gFEGFEFieldsDTO?: Array<GFEGFEFieldsDTO>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/GoodFaithEfforts/columns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gFEGFEFieldsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsDownloadImportTemplateGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/GoodFaithEfforts/download-import-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsExportPost: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/GoodFaithEfforts/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsGenerateAssessmentRequest} [commandsGenerateAssessmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsGenerateAssessmentPost: async (commandsGenerateAssessmentRequest?: CommandsGenerateAssessmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/GoodFaithEfforts/generate-assessment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsGenerateAssessmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsGfeGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/GoodFaithEfforts/gfe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gfeID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsGfeIDDelete: async (gfeID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gfeID' is not null or undefined
            assertParamExists('apiGoodFaithEffortsGfeIDDelete', 'gfeID', gfeID)
            const localVarPath = `/api/GoodFaithEfforts/{gfeID}`
                .replace(`{${"gfeID"}}`, encodeURIComponent(String(gfeID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} gfeID 
         * @param {CommandsUpdateGFEDataCommand} [commandsUpdateGFEDataCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsGfeIDPut: async (gfeID: string, commandsUpdateGFEDataCommand?: CommandsUpdateGFEDataCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gfeID' is not null or undefined
            assertParamExists('apiGoodFaithEffortsGfeIDPut', 'gfeID', gfeID)
            const localVarPath = `/api/GoodFaithEfforts/{gfeID}`
                .replace(`{${"gfeID"}}`, encodeURIComponent(String(gfeID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateGFEDataCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsImportPost: async (file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/GoodFaithEfforts/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateGFEDataCommand} [commandsCreateGFEDataCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsPost: async (commandsCreateGFEDataCommand?: CommandsCreateGFEDataCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/GoodFaithEfforts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateGFEDataCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsSettingsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/GoodFaithEfforts/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GoodFaithEffortsApi - functional programming interface
 * @export
 */
export const GoodFaithEffortsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GoodFaithEffortsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [planID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGoodFaithEffortsAssessmentGet(planID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetGFEAssessmentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGoodFaithEffortsAssessmentGet(planID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoodFaithEffortsApi.apiGoodFaithEffortsAssessmentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsSaveGFEAssessmentCommand} [commandsSaveGFEAssessmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGoodFaithEffortsAssessmentSettingsPost(commandsSaveGFEAssessmentCommand?: CommandsSaveGFEAssessmentCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGoodFaithEffortsAssessmentSettingsPost(commandsSaveGFEAssessmentCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoodFaithEffortsApi.apiGoodFaithEffortsAssessmentSettingsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<GFEGFEFieldsDTO>} [gFEGFEFieldsDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGoodFaithEffortsColumnsPut(gFEGFEFieldsDTO?: Array<GFEGFEFieldsDTO>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGoodFaithEffortsColumnsPut(gFEGFEFieldsDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoodFaithEffortsApi.apiGoodFaithEffortsColumnsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGoodFaithEffortsDownloadImportTemplateGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetTemplateImportFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGoodFaithEffortsDownloadImportTemplateGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoodFaithEffortsApi.apiGoodFaithEffortsDownloadImportTemplateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGoodFaithEffortsExportPost(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGoodFaithEffortsExportPost(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoodFaithEffortsApi.apiGoodFaithEffortsExportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsGenerateAssessmentRequest} [commandsGenerateAssessmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGoodFaithEffortsGenerateAssessmentPost(commandsGenerateAssessmentRequest?: CommandsGenerateAssessmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGoodFaithEffortsGenerateAssessmentPost(commandsGenerateAssessmentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoodFaithEffortsApi.apiGoodFaithEffortsGenerateAssessmentPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGoodFaithEffortsGfeGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetGoodFaithEffortsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGoodFaithEffortsGfeGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoodFaithEffortsApi.apiGoodFaithEffortsGfeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gfeID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGoodFaithEffortsGfeIDDelete(gfeID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGoodFaithEffortsGfeIDDelete(gfeID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoodFaithEffortsApi.apiGoodFaithEffortsGfeIDDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} gfeID 
         * @param {CommandsUpdateGFEDataCommand} [commandsUpdateGFEDataCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGoodFaithEffortsGfeIDPut(gfeID: string, commandsUpdateGFEDataCommand?: CommandsUpdateGFEDataCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGoodFaithEffortsGfeIDPut(gfeID, commandsUpdateGFEDataCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoodFaithEffortsApi.apiGoodFaithEffortsGfeIDPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGoodFaithEffortsImportPost(file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsImportGoodFaithEffortsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGoodFaithEffortsImportPost(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoodFaithEffortsApi.apiGoodFaithEffortsImportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateGFEDataCommand} [commandsCreateGFEDataCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGoodFaithEffortsPost(commandsCreateGFEDataCommand?: CommandsCreateGFEDataCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGoodFaithEffortsPost(commandsCreateGFEDataCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoodFaithEffortsApi.apiGoodFaithEffortsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiGoodFaithEffortsSettingsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GFEGFEFieldsDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiGoodFaithEffortsSettingsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GoodFaithEffortsApi.apiGoodFaithEffortsSettingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GoodFaithEffortsApi - factory interface
 * @export
 */
export const GoodFaithEffortsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GoodFaithEffortsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [planID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsAssessmentGet(planID?: string, options?: any): AxiosPromise<QueriesGetGFEAssessmentResponse> {
            return localVarFp.apiGoodFaithEffortsAssessmentGet(planID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsSaveGFEAssessmentCommand} [commandsSaveGFEAssessmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsAssessmentSettingsPost(commandsSaveGFEAssessmentCommand?: CommandsSaveGFEAssessmentCommand, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiGoodFaithEffortsAssessmentSettingsPost(commandsSaveGFEAssessmentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<GFEGFEFieldsDTO>} [gFEGFEFieldsDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsColumnsPut(gFEGFEFieldsDTO?: Array<GFEGFEFieldsDTO>, options?: any): AxiosPromise<File> {
            return localVarFp.apiGoodFaithEffortsColumnsPut(gFEGFEFieldsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsDownloadImportTemplateGet(options?: any): AxiosPromise<QueriesGetTemplateImportFileResponse> {
            return localVarFp.apiGoodFaithEffortsDownloadImportTemplateGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsExportPost(requestBody?: Array<string>, options?: any): AxiosPromise<string> {
            return localVarFp.apiGoodFaithEffortsExportPost(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsGenerateAssessmentRequest} [commandsGenerateAssessmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsGenerateAssessmentPost(commandsGenerateAssessmentRequest?: CommandsGenerateAssessmentRequest, options?: any): AxiosPromise<string> {
            return localVarFp.apiGoodFaithEffortsGenerateAssessmentPost(commandsGenerateAssessmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsGfeGet(options?: any): AxiosPromise<QueriesGetGoodFaithEffortsResponse> {
            return localVarFp.apiGoodFaithEffortsGfeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} gfeID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsGfeIDDelete(gfeID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiGoodFaithEffortsGfeIDDelete(gfeID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} gfeID 
         * @param {CommandsUpdateGFEDataCommand} [commandsUpdateGFEDataCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsGfeIDPut(gfeID: string, commandsUpdateGFEDataCommand?: CommandsUpdateGFEDataCommand, options?: any): AxiosPromise<File> {
            return localVarFp.apiGoodFaithEffortsGfeIDPut(gfeID, commandsUpdateGFEDataCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsImportPost(file?: File, options?: any): AxiosPromise<CommandsImportGoodFaithEffortsResponse> {
            return localVarFp.apiGoodFaithEffortsImportPost(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateGFEDataCommand} [commandsCreateGFEDataCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsPost(commandsCreateGFEDataCommand?: CommandsCreateGFEDataCommand, options?: any): AxiosPromise<File> {
            return localVarFp.apiGoodFaithEffortsPost(commandsCreateGFEDataCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiGoodFaithEffortsSettingsGet(options?: any): AxiosPromise<Array<GFEGFEFieldsDTO>> {
            return localVarFp.apiGoodFaithEffortsSettingsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GoodFaithEffortsApi - object-oriented interface
 * @export
 * @class GoodFaithEffortsApi
 * @extends {BaseAPI}
 */
export class GoodFaithEffortsApi extends BaseAPI {
    /**
     * 
     * @param {string} [planID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodFaithEffortsApi
     */
    public apiGoodFaithEffortsAssessmentGet(planID?: string, options?: RawAxiosRequestConfig) {
        return GoodFaithEffortsApiFp(this.configuration).apiGoodFaithEffortsAssessmentGet(planID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsSaveGFEAssessmentCommand} [commandsSaveGFEAssessmentCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodFaithEffortsApi
     */
    public apiGoodFaithEffortsAssessmentSettingsPost(commandsSaveGFEAssessmentCommand?: CommandsSaveGFEAssessmentCommand, options?: RawAxiosRequestConfig) {
        return GoodFaithEffortsApiFp(this.configuration).apiGoodFaithEffortsAssessmentSettingsPost(commandsSaveGFEAssessmentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<GFEGFEFieldsDTO>} [gFEGFEFieldsDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodFaithEffortsApi
     */
    public apiGoodFaithEffortsColumnsPut(gFEGFEFieldsDTO?: Array<GFEGFEFieldsDTO>, options?: RawAxiosRequestConfig) {
        return GoodFaithEffortsApiFp(this.configuration).apiGoodFaithEffortsColumnsPut(gFEGFEFieldsDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodFaithEffortsApi
     */
    public apiGoodFaithEffortsDownloadImportTemplateGet(options?: RawAxiosRequestConfig) {
        return GoodFaithEffortsApiFp(this.configuration).apiGoodFaithEffortsDownloadImportTemplateGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodFaithEffortsApi
     */
    public apiGoodFaithEffortsExportPost(requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return GoodFaithEffortsApiFp(this.configuration).apiGoodFaithEffortsExportPost(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsGenerateAssessmentRequest} [commandsGenerateAssessmentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodFaithEffortsApi
     */
    public apiGoodFaithEffortsGenerateAssessmentPost(commandsGenerateAssessmentRequest?: CommandsGenerateAssessmentRequest, options?: RawAxiosRequestConfig) {
        return GoodFaithEffortsApiFp(this.configuration).apiGoodFaithEffortsGenerateAssessmentPost(commandsGenerateAssessmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodFaithEffortsApi
     */
    public apiGoodFaithEffortsGfeGet(options?: RawAxiosRequestConfig) {
        return GoodFaithEffortsApiFp(this.configuration).apiGoodFaithEffortsGfeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} gfeID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodFaithEffortsApi
     */
    public apiGoodFaithEffortsGfeIDDelete(gfeID: string, options?: RawAxiosRequestConfig) {
        return GoodFaithEffortsApiFp(this.configuration).apiGoodFaithEffortsGfeIDDelete(gfeID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} gfeID 
     * @param {CommandsUpdateGFEDataCommand} [commandsUpdateGFEDataCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodFaithEffortsApi
     */
    public apiGoodFaithEffortsGfeIDPut(gfeID: string, commandsUpdateGFEDataCommand?: CommandsUpdateGFEDataCommand, options?: RawAxiosRequestConfig) {
        return GoodFaithEffortsApiFp(this.configuration).apiGoodFaithEffortsGfeIDPut(gfeID, commandsUpdateGFEDataCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodFaithEffortsApi
     */
    public apiGoodFaithEffortsImportPost(file?: File, options?: RawAxiosRequestConfig) {
        return GoodFaithEffortsApiFp(this.configuration).apiGoodFaithEffortsImportPost(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateGFEDataCommand} [commandsCreateGFEDataCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodFaithEffortsApi
     */
    public apiGoodFaithEffortsPost(commandsCreateGFEDataCommand?: CommandsCreateGFEDataCommand, options?: RawAxiosRequestConfig) {
        return GoodFaithEffortsApiFp(this.configuration).apiGoodFaithEffortsPost(commandsCreateGFEDataCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GoodFaithEffortsApi
     */
    public apiGoodFaithEffortsSettingsGet(options?: RawAxiosRequestConfig) {
        return GoodFaithEffortsApiFp(this.configuration).apiGoodFaithEffortsSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IWDDataVisualizationsApi - axios parameter creator
 * @export
 */
export const IWDDataVisualizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} eeoCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIWDDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet: async (eeoCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeoCode' is not null or undefined
            assertParamExists('apiIWDDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet', 'eeoCode', eeoCode)
            const localVarPath = `/api/IWDDataVisualizations/eeo/{eeoCode}/employment-by-job-group`
                .replace(`{${"eeoCode"}}`, encodeURIComponent(String(eeoCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eeoCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIWDDataVisualizationsEeoEeoCodeHiringByJobGroupGet: async (eeoCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeoCode' is not null or undefined
            assertParamExists('apiIWDDataVisualizationsEeoEeoCodeHiringByJobGroupGet', 'eeoCode', eeoCode)
            const localVarPath = `/api/IWDDataVisualizations/eeo/{eeoCode}/hiring-by-job-group`
                .replace(`{${"eeoCode"}}`, encodeURIComponent(String(eeoCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIWDDataVisualizationsEmploymentGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/IWDDataVisualizations/employment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIWDDataVisualizationsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/IWDDataVisualizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIWDDataVisualizationsHiringGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/IWDDataVisualizations/hiring`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IWDDataVisualizationsApi - functional programming interface
 * @export
 */
export const IWDDataVisualizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IWDDataVisualizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} eeoCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIWDDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet(eeoCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetEmploymentByJobGroupByIWDDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIWDDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet(eeoCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IWDDataVisualizationsApi.apiIWDDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} eeoCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIWDDataVisualizationsEeoEeoCodeHiringByJobGroupGet(eeoCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetHiringByJobGroupByIWDDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIWDDataVisualizationsEeoEeoCodeHiringByJobGroupGet(eeoCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IWDDataVisualizationsApi.apiIWDDataVisualizationsEeoEeoCodeHiringByJobGroupGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIWDDataVisualizationsEmploymentGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetEmploymentByIWDDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIWDDataVisualizationsEmploymentGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IWDDataVisualizationsApi.apiIWDDataVisualizationsEmploymentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIWDDataVisualizationsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetIWDDataVisualizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIWDDataVisualizationsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IWDDataVisualizationsApi.apiIWDDataVisualizationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIWDDataVisualizationsHiringGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetHiringByIWDDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIWDDataVisualizationsHiringGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IWDDataVisualizationsApi.apiIWDDataVisualizationsHiringGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IWDDataVisualizationsApi - factory interface
 * @export
 */
export const IWDDataVisualizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IWDDataVisualizationsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} eeoCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIWDDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet(eeoCode: string, options?: any): AxiosPromise<QueriesGetEmploymentByJobGroupByIWDDrilldownResponse> {
            return localVarFp.apiIWDDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet(eeoCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} eeoCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIWDDataVisualizationsEeoEeoCodeHiringByJobGroupGet(eeoCode: string, options?: any): AxiosPromise<QueriesGetHiringByJobGroupByIWDDrilldownResponse> {
            return localVarFp.apiIWDDataVisualizationsEeoEeoCodeHiringByJobGroupGet(eeoCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIWDDataVisualizationsEmploymentGet(options?: any): AxiosPromise<QueriesGetEmploymentByIWDDrilldownResponse> {
            return localVarFp.apiIWDDataVisualizationsEmploymentGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIWDDataVisualizationsGet(options?: any): AxiosPromise<QueriesGetIWDDataVisualizationResponse> {
            return localVarFp.apiIWDDataVisualizationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIWDDataVisualizationsHiringGet(options?: any): AxiosPromise<QueriesGetHiringByIWDDrilldownResponse> {
            return localVarFp.apiIWDDataVisualizationsHiringGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IWDDataVisualizationsApi - object-oriented interface
 * @export
 * @class IWDDataVisualizationsApi
 * @extends {BaseAPI}
 */
export class IWDDataVisualizationsApi extends BaseAPI {
    /**
     * 
     * @param {string} eeoCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IWDDataVisualizationsApi
     */
    public apiIWDDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet(eeoCode: string, options?: RawAxiosRequestConfig) {
        return IWDDataVisualizationsApiFp(this.configuration).apiIWDDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet(eeoCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} eeoCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IWDDataVisualizationsApi
     */
    public apiIWDDataVisualizationsEeoEeoCodeHiringByJobGroupGet(eeoCode: string, options?: RawAxiosRequestConfig) {
        return IWDDataVisualizationsApiFp(this.configuration).apiIWDDataVisualizationsEeoEeoCodeHiringByJobGroupGet(eeoCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IWDDataVisualizationsApi
     */
    public apiIWDDataVisualizationsEmploymentGet(options?: RawAxiosRequestConfig) {
        return IWDDataVisualizationsApiFp(this.configuration).apiIWDDataVisualizationsEmploymentGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IWDDataVisualizationsApi
     */
    public apiIWDDataVisualizationsGet(options?: RawAxiosRequestConfig) {
        return IWDDataVisualizationsApiFp(this.configuration).apiIWDDataVisualizationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IWDDataVisualizationsApi
     */
    public apiIWDDataVisualizationsHiringGet(options?: RawAxiosRequestConfig) {
        return IWDDataVisualizationsApiFp(this.configuration).apiIWDDataVisualizationsHiringGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsGet: async (page?: number, rowsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (rowsPerPage !== undefined) {
                localVarQueryParameter['rowsPerPage'] = rowsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsNotificationIDReadPut: async (notificationID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationID' is not null or undefined
            assertParamExists('apiNotificationsNotificationIDReadPut', 'notificationID', notificationID)
            const localVarPath = `/api/Notifications/{notificationID}/read`
                .replace(`{${"notificationID"}}`, encodeURIComponent(String(notificationID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsReadPut: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Notifications/read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsViewedPut: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Notifications/viewed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsGet(page?: number, rowsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetNotificationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsGet(page, rowsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsNotificationIDReadPut(notificationID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsNotificationIDReadPut(notificationID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsNotificationIDReadPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsReadPut(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsReadPut(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsReadPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsViewedPut(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsViewedPut(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.apiNotificationsViewedPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsGet(page?: number, rowsPerPage?: number, options?: any): AxiosPromise<QueriesGetNotificationsResponse> {
            return localVarFp.apiNotificationsGet(page, rowsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsNotificationIDReadPut(notificationID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiNotificationsNotificationIDReadPut(notificationID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsReadPut(options?: any): AxiosPromise<File> {
            return localVarFp.apiNotificationsReadPut(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsViewedPut(options?: any): AxiosPromise<File> {
            return localVarFp.apiNotificationsViewedPut(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @param {number} [page] 
     * @param {number} [rowsPerPage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiNotificationsGet(page?: number, rowsPerPage?: number, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsGet(page, rowsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} notificationID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiNotificationsNotificationIDReadPut(notificationID: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsNotificationIDReadPut(notificationID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiNotificationsReadPut(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsReadPut(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiNotificationsViewedPut(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).apiNotificationsViewedPut(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OverviewDataVisualizationsApi - axios parameter creator
 * @export
 */
export const OverviewDataVisualizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {boolean} [displayAll] 
         * @param {string} [searchTerm] 
         * @param {EnumerationsOverviewSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {string} [paActionTypeForSort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewDataVisualizationsJobGroupListGet: async (displayAll?: boolean, searchTerm?: string, sortColumn?: EnumerationsOverviewSortColumn, sortDirection?: EnumerationsSortDirection, paActionTypeForSort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OverviewDataVisualizations/job-group-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (displayAll !== undefined) {
                localVarQueryParameter['displayAll'] = displayAll;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (paActionTypeForSort !== undefined) {
                localVarQueryParameter['paActionTypeForSort'] = paActionTypeForSort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [displayAll] 
         * @param {string} [searchTerm] 
         * @param {EnumerationsOverviewSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {string} [paActionTypeForSort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewDataVisualizationsPlanListGet: async (displayAll?: boolean, searchTerm?: string, sortColumn?: EnumerationsOverviewSortColumn, sortDirection?: EnumerationsSortDirection, paActionTypeForSort?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OverviewDataVisualizations/plan-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (displayAll !== undefined) {
                localVarQueryParameter['displayAll'] = displayAll;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (paActionTypeForSort !== undefined) {
                localVarQueryParameter['paActionTypeForSort'] = paActionTypeForSort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsUpdateOverviewSettingsCommand} [commandsUpdateOverviewSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewDataVisualizationsPut: async (commandsUpdateOverviewSettingsCommand?: CommandsUpdateOverviewSettingsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OverviewDataVisualizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateOverviewSettingsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewDataVisualizationsReportExportSettingsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OverviewDataVisualizations/report-export-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsUpdateOverviewReportExportSettingsCommand} [commandsUpdateOverviewReportExportSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewDataVisualizationsReportExportSettingsPut: async (commandsUpdateOverviewReportExportSettingsCommand?: CommandsUpdateOverviewReportExportSettingsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OverviewDataVisualizations/report-export-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateOverviewReportExportSettingsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewDataVisualizationsSettingsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OverviewDataVisualizations/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewDataVisualizationsTotalAndSearchDataGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OverviewDataVisualizations/total-and-search-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OverviewDataVisualizationsApi - functional programming interface
 * @export
 */
export const OverviewDataVisualizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OverviewDataVisualizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {boolean} [displayAll] 
         * @param {string} [searchTerm] 
         * @param {EnumerationsOverviewSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {string} [paActionTypeForSort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOverviewDataVisualizationsJobGroupListGet(displayAll?: boolean, searchTerm?: string, sortColumn?: EnumerationsOverviewSortColumn, sortDirection?: EnumerationsSortDirection, paActionTypeForSort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OverviewGetOverviewListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOverviewDataVisualizationsJobGroupListGet(displayAll, searchTerm, sortColumn, sortDirection, paActionTypeForSort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OverviewDataVisualizationsApi.apiOverviewDataVisualizationsJobGroupListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [displayAll] 
         * @param {string} [searchTerm] 
         * @param {EnumerationsOverviewSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {string} [paActionTypeForSort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOverviewDataVisualizationsPlanListGet(displayAll?: boolean, searchTerm?: string, sortColumn?: EnumerationsOverviewSortColumn, sortDirection?: EnumerationsSortDirection, paActionTypeForSort?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OverviewGetOverviewListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOverviewDataVisualizationsPlanListGet(displayAll, searchTerm, sortColumn, sortDirection, paActionTypeForSort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OverviewDataVisualizationsApi.apiOverviewDataVisualizationsPlanListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsUpdateOverviewSettingsCommand} [commandsUpdateOverviewSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOverviewDataVisualizationsPut(commandsUpdateOverviewSettingsCommand?: CommandsUpdateOverviewSettingsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOverviewDataVisualizationsPut(commandsUpdateOverviewSettingsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OverviewDataVisualizationsApi.apiOverviewDataVisualizationsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOverviewDataVisualizationsReportExportSettingsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetOverviewReportExportSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOverviewDataVisualizationsReportExportSettingsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OverviewDataVisualizationsApi.apiOverviewDataVisualizationsReportExportSettingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsUpdateOverviewReportExportSettingsCommand} [commandsUpdateOverviewReportExportSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOverviewDataVisualizationsReportExportSettingsPut(commandsUpdateOverviewReportExportSettingsCommand?: CommandsUpdateOverviewReportExportSettingsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOverviewDataVisualizationsReportExportSettingsPut(commandsUpdateOverviewReportExportSettingsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OverviewDataVisualizationsApi.apiOverviewDataVisualizationsReportExportSettingsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOverviewDataVisualizationsSettingsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetOverviewSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOverviewDataVisualizationsSettingsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OverviewDataVisualizationsApi.apiOverviewDataVisualizationsSettingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOverviewDataVisualizationsTotalAndSearchDataGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetTotalAndSearchDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOverviewDataVisualizationsTotalAndSearchDataGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OverviewDataVisualizationsApi.apiOverviewDataVisualizationsTotalAndSearchDataGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OverviewDataVisualizationsApi - factory interface
 * @export
 */
export const OverviewDataVisualizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OverviewDataVisualizationsApiFp(configuration)
    return {
        /**
         * 
         * @param {boolean} [displayAll] 
         * @param {string} [searchTerm] 
         * @param {EnumerationsOverviewSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {string} [paActionTypeForSort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewDataVisualizationsJobGroupListGet(displayAll?: boolean, searchTerm?: string, sortColumn?: EnumerationsOverviewSortColumn, sortDirection?: EnumerationsSortDirection, paActionTypeForSort?: string, options?: any): AxiosPromise<OverviewGetOverviewListResponse> {
            return localVarFp.apiOverviewDataVisualizationsJobGroupListGet(displayAll, searchTerm, sortColumn, sortDirection, paActionTypeForSort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [displayAll] 
         * @param {string} [searchTerm] 
         * @param {EnumerationsOverviewSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {string} [paActionTypeForSort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewDataVisualizationsPlanListGet(displayAll?: boolean, searchTerm?: string, sortColumn?: EnumerationsOverviewSortColumn, sortDirection?: EnumerationsSortDirection, paActionTypeForSort?: string, options?: any): AxiosPromise<OverviewGetOverviewListResponse> {
            return localVarFp.apiOverviewDataVisualizationsPlanListGet(displayAll, searchTerm, sortColumn, sortDirection, paActionTypeForSort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsUpdateOverviewSettingsCommand} [commandsUpdateOverviewSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewDataVisualizationsPut(commandsUpdateOverviewSettingsCommand?: CommandsUpdateOverviewSettingsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiOverviewDataVisualizationsPut(commandsUpdateOverviewSettingsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewDataVisualizationsReportExportSettingsGet(options?: any): AxiosPromise<QueriesGetOverviewReportExportSettingsResponse> {
            return localVarFp.apiOverviewDataVisualizationsReportExportSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsUpdateOverviewReportExportSettingsCommand} [commandsUpdateOverviewReportExportSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewDataVisualizationsReportExportSettingsPut(commandsUpdateOverviewReportExportSettingsCommand?: CommandsUpdateOverviewReportExportSettingsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiOverviewDataVisualizationsReportExportSettingsPut(commandsUpdateOverviewReportExportSettingsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewDataVisualizationsSettingsGet(options?: any): AxiosPromise<QueriesGetOverviewSettingsResponse> {
            return localVarFp.apiOverviewDataVisualizationsSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewDataVisualizationsTotalAndSearchDataGet(options?: any): AxiosPromise<QueriesGetTotalAndSearchDataResponse> {
            return localVarFp.apiOverviewDataVisualizationsTotalAndSearchDataGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OverviewDataVisualizationsApi - object-oriented interface
 * @export
 * @class OverviewDataVisualizationsApi
 * @extends {BaseAPI}
 */
export class OverviewDataVisualizationsApi extends BaseAPI {
    /**
     * 
     * @param {boolean} [displayAll] 
     * @param {string} [searchTerm] 
     * @param {EnumerationsOverviewSortColumn} [sortColumn] 
     * @param {EnumerationsSortDirection} [sortDirection] 
     * @param {string} [paActionTypeForSort] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverviewDataVisualizationsApi
     */
    public apiOverviewDataVisualizationsJobGroupListGet(displayAll?: boolean, searchTerm?: string, sortColumn?: EnumerationsOverviewSortColumn, sortDirection?: EnumerationsSortDirection, paActionTypeForSort?: string, options?: RawAxiosRequestConfig) {
        return OverviewDataVisualizationsApiFp(this.configuration).apiOverviewDataVisualizationsJobGroupListGet(displayAll, searchTerm, sortColumn, sortDirection, paActionTypeForSort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [displayAll] 
     * @param {string} [searchTerm] 
     * @param {EnumerationsOverviewSortColumn} [sortColumn] 
     * @param {EnumerationsSortDirection} [sortDirection] 
     * @param {string} [paActionTypeForSort] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverviewDataVisualizationsApi
     */
    public apiOverviewDataVisualizationsPlanListGet(displayAll?: boolean, searchTerm?: string, sortColumn?: EnumerationsOverviewSortColumn, sortDirection?: EnumerationsSortDirection, paActionTypeForSort?: string, options?: RawAxiosRequestConfig) {
        return OverviewDataVisualizationsApiFp(this.configuration).apiOverviewDataVisualizationsPlanListGet(displayAll, searchTerm, sortColumn, sortDirection, paActionTypeForSort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsUpdateOverviewSettingsCommand} [commandsUpdateOverviewSettingsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverviewDataVisualizationsApi
     */
    public apiOverviewDataVisualizationsPut(commandsUpdateOverviewSettingsCommand?: CommandsUpdateOverviewSettingsCommand, options?: RawAxiosRequestConfig) {
        return OverviewDataVisualizationsApiFp(this.configuration).apiOverviewDataVisualizationsPut(commandsUpdateOverviewSettingsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverviewDataVisualizationsApi
     */
    public apiOverviewDataVisualizationsReportExportSettingsGet(options?: RawAxiosRequestConfig) {
        return OverviewDataVisualizationsApiFp(this.configuration).apiOverviewDataVisualizationsReportExportSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsUpdateOverviewReportExportSettingsCommand} [commandsUpdateOverviewReportExportSettingsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverviewDataVisualizationsApi
     */
    public apiOverviewDataVisualizationsReportExportSettingsPut(commandsUpdateOverviewReportExportSettingsCommand?: CommandsUpdateOverviewReportExportSettingsCommand, options?: RawAxiosRequestConfig) {
        return OverviewDataVisualizationsApiFp(this.configuration).apiOverviewDataVisualizationsReportExportSettingsPut(commandsUpdateOverviewReportExportSettingsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverviewDataVisualizationsApi
     */
    public apiOverviewDataVisualizationsSettingsGet(options?: RawAxiosRequestConfig) {
        return OverviewDataVisualizationsApiFp(this.configuration).apiOverviewDataVisualizationsSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverviewDataVisualizationsApi
     */
    public apiOverviewDataVisualizationsTotalAndSearchDataGet(options?: RawAxiosRequestConfig) {
        return OverviewDataVisualizationsApiFp(this.configuration).apiOverviewDataVisualizationsTotalAndSearchDataGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OverviewSummaryApi - axios parameter creator
 * @export
 */
export const OverviewSummaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewSummaryExportAdverseImpactPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OverviewSummary/export/adverse-impact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewSummaryExportDataVizPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/OverviewSummary/export/data-viz`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OverviewSummaryApi - functional programming interface
 * @export
 */
export const OverviewSummaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OverviewSummaryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOverviewSummaryExportAdverseImpactPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOverviewSummaryExportAdverseImpactPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OverviewSummaryApi.apiOverviewSummaryExportAdverseImpactPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOverviewSummaryExportDataVizPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOverviewSummaryExportDataVizPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OverviewSummaryApi.apiOverviewSummaryExportDataVizPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OverviewSummaryApi - factory interface
 * @export
 */
export const OverviewSummaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OverviewSummaryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewSummaryExportAdverseImpactPost(options?: any): AxiosPromise<string> {
            return localVarFp.apiOverviewSummaryExportAdverseImpactPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOverviewSummaryExportDataVizPost(options?: any): AxiosPromise<string> {
            return localVarFp.apiOverviewSummaryExportDataVizPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OverviewSummaryApi - object-oriented interface
 * @export
 * @class OverviewSummaryApi
 * @extends {BaseAPI}
 */
export class OverviewSummaryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverviewSummaryApi
     */
    public apiOverviewSummaryExportAdverseImpactPost(options?: RawAxiosRequestConfig) {
        return OverviewSummaryApiFp(this.configuration).apiOverviewSummaryExportAdverseImpactPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OverviewSummaryApi
     */
    public apiOverviewSummaryExportDataVizPost(options?: RawAxiosRequestConfig) {
        return OverviewSummaryApiFp(this.configuration).apiOverviewSummaryExportDataVizPost(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PersonnelActivityDataVisualizationsApi - axios parameter creator
 * @export
 */
export const PersonnelActivityDataVisualizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {EnumerationsDataVisualizationResultsBy} resultsBy 
         * @param {boolean} [isPositiveAction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonnelActivityDataVisualizationsActionDemographicResultsByGet: async (resultsBy: EnumerationsDataVisualizationResultsBy, isPositiveAction?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resultsBy' is not null or undefined
            assertParamExists('apiPersonnelActivityDataVisualizationsActionDemographicResultsByGet', 'resultsBy', resultsBy)
            const localVarPath = `/api/PersonnelActivityDataVisualizations/action/demographic/{resultsBy}`
                .replace(`{${"resultsBy"}}`, encodeURIComponent(String(resultsBy)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isPositiveAction !== undefined) {
                localVarQueryParameter['isPositiveAction'] = isPositiveAction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationResultsBy} resultsBy 
         * @param {string} eeoCode 
         * @param {boolean} [isPositiveAction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonnelActivityDataVisualizationsActionEeoEeoCodeJobGroupResultsByResultsByGet: async (resultsBy: EnumerationsDataVisualizationResultsBy, eeoCode: string, isPositiveAction?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resultsBy' is not null or undefined
            assertParamExists('apiPersonnelActivityDataVisualizationsActionEeoEeoCodeJobGroupResultsByResultsByGet', 'resultsBy', resultsBy)
            // verify required parameter 'eeoCode' is not null or undefined
            assertParamExists('apiPersonnelActivityDataVisualizationsActionEeoEeoCodeJobGroupResultsByResultsByGet', 'eeoCode', eeoCode)
            const localVarPath = `/api/PersonnelActivityDataVisualizations/action/eeo/{eeoCode}/job-group/results-by/{resultsBy}`
                .replace(`{${"resultsBy"}}`, encodeURIComponent(String(resultsBy)))
                .replace(`{${"eeoCode"}}`, encodeURIComponent(String(eeoCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isPositiveAction !== undefined) {
                localVarQueryParameter['isPositiveAction'] = isPositiveAction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationResultsBy} resultsBy 
         * @param {string} jobGroup 
         * @param {boolean} [isPositiveAction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonnelActivityDataVisualizationsActionJobGroupJobGroupJobTitleResultsByResultsByGet: async (resultsBy: EnumerationsDataVisualizationResultsBy, jobGroup: string, isPositiveAction?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resultsBy' is not null or undefined
            assertParamExists('apiPersonnelActivityDataVisualizationsActionJobGroupJobGroupJobTitleResultsByResultsByGet', 'resultsBy', resultsBy)
            // verify required parameter 'jobGroup' is not null or undefined
            assertParamExists('apiPersonnelActivityDataVisualizationsActionJobGroupJobGroupJobTitleResultsByResultsByGet', 'jobGroup', jobGroup)
            const localVarPath = `/api/PersonnelActivityDataVisualizations/action/job-group/{jobGroup}/job-title/results-by/{resultsBy}`
                .replace(`{${"resultsBy"}}`, encodeURIComponent(String(resultsBy)))
                .replace(`{${"jobGroup"}}`, encodeURIComponent(String(jobGroup)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isPositiveAction !== undefined) {
                localVarQueryParameter['isPositiveAction'] = isPositiveAction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonnelActivityDataVisualizationsActionTypesAllGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PersonnelActivityDataVisualizations/action-types/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonnelActivityDataVisualizationsActionTypesDropdownGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PersonnelActivityDataVisualizations/action-types/dropdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonnelActivityDataVisualizationsActionTypesPut: async (requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PersonnelActivityDataVisualizations/action-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonnelActivityDataVisualizationsCalculateJobChangesByDropdownGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PersonnelActivityDataVisualizations/calculate-job-changes-by-dropdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonnelActivityDataVisualizationsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PersonnelActivityDataVisualizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PersonnelActivityDataVisualizationsApi - functional programming interface
 * @export
 */
export const PersonnelActivityDataVisualizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PersonnelActivityDataVisualizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {EnumerationsDataVisualizationResultsBy} resultsBy 
         * @param {boolean} [isPositiveAction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonnelActivityDataVisualizationsActionDemographicResultsByGet(resultsBy: EnumerationsDataVisualizationResultsBy, isPositiveAction?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetActivityByActionByDemographicResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonnelActivityDataVisualizationsActionDemographicResultsByGet(resultsBy, isPositiveAction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonnelActivityDataVisualizationsApi.apiPersonnelActivityDataVisualizationsActionDemographicResultsByGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationResultsBy} resultsBy 
         * @param {string} eeoCode 
         * @param {boolean} [isPositiveAction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonnelActivityDataVisualizationsActionEeoEeoCodeJobGroupResultsByResultsByGet(resultsBy: EnumerationsDataVisualizationResultsBy, eeoCode: string, isPositiveAction?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetActivityByActionByJobGroupForEEOResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonnelActivityDataVisualizationsActionEeoEeoCodeJobGroupResultsByResultsByGet(resultsBy, eeoCode, isPositiveAction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonnelActivityDataVisualizationsApi.apiPersonnelActivityDataVisualizationsActionEeoEeoCodeJobGroupResultsByResultsByGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationResultsBy} resultsBy 
         * @param {string} jobGroup 
         * @param {boolean} [isPositiveAction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonnelActivityDataVisualizationsActionJobGroupJobGroupJobTitleResultsByResultsByGet(resultsBy: EnumerationsDataVisualizationResultsBy, jobGroup: string, isPositiveAction?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetActivityByActionByJobTitleForJobGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonnelActivityDataVisualizationsActionJobGroupJobGroupJobTitleResultsByResultsByGet(resultsBy, jobGroup, isPositiveAction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonnelActivityDataVisualizationsApi.apiPersonnelActivityDataVisualizationsActionJobGroupJobGroupJobTitleResultsByResultsByGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonnelActivityDataVisualizationsActionTypesAllGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataVizGetAllActionTypesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonnelActivityDataVisualizationsActionTypesAllGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonnelActivityDataVisualizationsApi.apiPersonnelActivityDataVisualizationsActionTypesAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonnelActivityDataVisualizationsActionTypesDropdownGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataVizActionTypeDropdownItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonnelActivityDataVisualizationsActionTypesDropdownGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonnelActivityDataVisualizationsApi.apiPersonnelActivityDataVisualizationsActionTypesDropdownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonnelActivityDataVisualizationsActionTypesPut(requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonnelActivityDataVisualizationsActionTypesPut(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonnelActivityDataVisualizationsApi.apiPersonnelActivityDataVisualizationsActionTypesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonnelActivityDataVisualizationsCalculateJobChangesByDropdownGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueriesCalculateJobChangesByDropdownItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonnelActivityDataVisualizationsCalculateJobChangesByDropdownGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonnelActivityDataVisualizationsApi.apiPersonnelActivityDataVisualizationsCalculateJobChangesByDropdownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonnelActivityDataVisualizationsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetPersonnelActivityDataVisualizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonnelActivityDataVisualizationsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PersonnelActivityDataVisualizationsApi.apiPersonnelActivityDataVisualizationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PersonnelActivityDataVisualizationsApi - factory interface
 * @export
 */
export const PersonnelActivityDataVisualizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PersonnelActivityDataVisualizationsApiFp(configuration)
    return {
        /**
         * 
         * @param {EnumerationsDataVisualizationResultsBy} resultsBy 
         * @param {boolean} [isPositiveAction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonnelActivityDataVisualizationsActionDemographicResultsByGet(resultsBy: EnumerationsDataVisualizationResultsBy, isPositiveAction?: boolean, options?: any): AxiosPromise<QueriesGetActivityByActionByDemographicResponse> {
            return localVarFp.apiPersonnelActivityDataVisualizationsActionDemographicResultsByGet(resultsBy, isPositiveAction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationResultsBy} resultsBy 
         * @param {string} eeoCode 
         * @param {boolean} [isPositiveAction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonnelActivityDataVisualizationsActionEeoEeoCodeJobGroupResultsByResultsByGet(resultsBy: EnumerationsDataVisualizationResultsBy, eeoCode: string, isPositiveAction?: boolean, options?: any): AxiosPromise<QueriesGetActivityByActionByJobGroupForEEOResponse> {
            return localVarFp.apiPersonnelActivityDataVisualizationsActionEeoEeoCodeJobGroupResultsByResultsByGet(resultsBy, eeoCode, isPositiveAction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EnumerationsDataVisualizationResultsBy} resultsBy 
         * @param {string} jobGroup 
         * @param {boolean} [isPositiveAction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonnelActivityDataVisualizationsActionJobGroupJobGroupJobTitleResultsByResultsByGet(resultsBy: EnumerationsDataVisualizationResultsBy, jobGroup: string, isPositiveAction?: boolean, options?: any): AxiosPromise<QueriesGetActivityByActionByJobTitleForJobGroupResponse> {
            return localVarFp.apiPersonnelActivityDataVisualizationsActionJobGroupJobGroupJobTitleResultsByResultsByGet(resultsBy, jobGroup, isPositiveAction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonnelActivityDataVisualizationsActionTypesAllGet(options?: any): AxiosPromise<DataVizGetAllActionTypesResponse> {
            return localVarFp.apiPersonnelActivityDataVisualizationsActionTypesAllGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonnelActivityDataVisualizationsActionTypesDropdownGet(options?: any): AxiosPromise<Array<DataVizActionTypeDropdownItem>> {
            return localVarFp.apiPersonnelActivityDataVisualizationsActionTypesDropdownGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonnelActivityDataVisualizationsActionTypesPut(requestBody?: Array<string>, options?: any): AxiosPromise<File> {
            return localVarFp.apiPersonnelActivityDataVisualizationsActionTypesPut(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonnelActivityDataVisualizationsCalculateJobChangesByDropdownGet(options?: any): AxiosPromise<Array<QueriesCalculateJobChangesByDropdownItem>> {
            return localVarFp.apiPersonnelActivityDataVisualizationsCalculateJobChangesByDropdownGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonnelActivityDataVisualizationsGet(options?: any): AxiosPromise<QueriesGetPersonnelActivityDataVisualizationResponse> {
            return localVarFp.apiPersonnelActivityDataVisualizationsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PersonnelActivityDataVisualizationsApi - object-oriented interface
 * @export
 * @class PersonnelActivityDataVisualizationsApi
 * @extends {BaseAPI}
 */
export class PersonnelActivityDataVisualizationsApi extends BaseAPI {
    /**
     * 
     * @param {EnumerationsDataVisualizationResultsBy} resultsBy 
     * @param {boolean} [isPositiveAction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnelActivityDataVisualizationsApi
     */
    public apiPersonnelActivityDataVisualizationsActionDemographicResultsByGet(resultsBy: EnumerationsDataVisualizationResultsBy, isPositiveAction?: boolean, options?: RawAxiosRequestConfig) {
        return PersonnelActivityDataVisualizationsApiFp(this.configuration).apiPersonnelActivityDataVisualizationsActionDemographicResultsByGet(resultsBy, isPositiveAction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsDataVisualizationResultsBy} resultsBy 
     * @param {string} eeoCode 
     * @param {boolean} [isPositiveAction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnelActivityDataVisualizationsApi
     */
    public apiPersonnelActivityDataVisualizationsActionEeoEeoCodeJobGroupResultsByResultsByGet(resultsBy: EnumerationsDataVisualizationResultsBy, eeoCode: string, isPositiveAction?: boolean, options?: RawAxiosRequestConfig) {
        return PersonnelActivityDataVisualizationsApiFp(this.configuration).apiPersonnelActivityDataVisualizationsActionEeoEeoCodeJobGroupResultsByResultsByGet(resultsBy, eeoCode, isPositiveAction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EnumerationsDataVisualizationResultsBy} resultsBy 
     * @param {string} jobGroup 
     * @param {boolean} [isPositiveAction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnelActivityDataVisualizationsApi
     */
    public apiPersonnelActivityDataVisualizationsActionJobGroupJobGroupJobTitleResultsByResultsByGet(resultsBy: EnumerationsDataVisualizationResultsBy, jobGroup: string, isPositiveAction?: boolean, options?: RawAxiosRequestConfig) {
        return PersonnelActivityDataVisualizationsApiFp(this.configuration).apiPersonnelActivityDataVisualizationsActionJobGroupJobGroupJobTitleResultsByResultsByGet(resultsBy, jobGroup, isPositiveAction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnelActivityDataVisualizationsApi
     */
    public apiPersonnelActivityDataVisualizationsActionTypesAllGet(options?: RawAxiosRequestConfig) {
        return PersonnelActivityDataVisualizationsApiFp(this.configuration).apiPersonnelActivityDataVisualizationsActionTypesAllGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnelActivityDataVisualizationsApi
     */
    public apiPersonnelActivityDataVisualizationsActionTypesDropdownGet(options?: RawAxiosRequestConfig) {
        return PersonnelActivityDataVisualizationsApiFp(this.configuration).apiPersonnelActivityDataVisualizationsActionTypesDropdownGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnelActivityDataVisualizationsApi
     */
    public apiPersonnelActivityDataVisualizationsActionTypesPut(requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return PersonnelActivityDataVisualizationsApiFp(this.configuration).apiPersonnelActivityDataVisualizationsActionTypesPut(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnelActivityDataVisualizationsApi
     */
    public apiPersonnelActivityDataVisualizationsCalculateJobChangesByDropdownGet(options?: RawAxiosRequestConfig) {
        return PersonnelActivityDataVisualizationsApiFp(this.configuration).apiPersonnelActivityDataVisualizationsCalculateJobChangesByDropdownGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonnelActivityDataVisualizationsApi
     */
    public apiPersonnelActivityDataVisualizationsGet(options?: RawAxiosRequestConfig) {
        return PersonnelActivityDataVisualizationsApiFp(this.configuration).apiPersonnelActivityDataVisualizationsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PingdomApi - axios parameter creator
 * @export
 */
export const PingdomApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPingdomTestConnectionsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Pingdom/test-connections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PingdomApi - functional programming interface
 * @export
 */
export const PingdomApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PingdomApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPingdomTestConnectionsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPingdomTestConnectionsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PingdomApi.apiPingdomTestConnectionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PingdomApi - factory interface
 * @export
 */
export const PingdomApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PingdomApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPingdomTestConnectionsGet(options?: any): AxiosPromise<File> {
            return localVarFp.apiPingdomTestConnectionsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PingdomApi - object-oriented interface
 * @export
 * @class PingdomApi
 * @extends {BaseAPI}
 */
export class PingdomApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PingdomApi
     */
    public apiPingdomTestConnectionsGet(options?: RawAxiosRequestConfig) {
        return PingdomApiFp(this.configuration).apiPingdomTestConnectionsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlanSummaryApi - axios parameter creator
 * @export
 */
export const PlanSummaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanSummaryExportDataVizPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PlanSummary/export/data-viz`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanSummaryReportSettingsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PlanSummary/report-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsUpdatePlanSummaryReportSettingsCommand} [commandsUpdatePlanSummaryReportSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanSummaryReportSettingsPut: async (commandsUpdatePlanSummaryReportSettingsCommand?: CommandsUpdatePlanSummaryReportSettingsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/PlanSummary/report-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdatePlanSummaryReportSettingsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlanSummaryApi - functional programming interface
 * @export
 */
export const PlanSummaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlanSummaryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlanSummaryExportDataVizPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlanSummaryExportDataVizPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSummaryApi.apiPlanSummaryExportDataVizPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlanSummaryReportSettingsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetPlanSummaryReportSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlanSummaryReportSettingsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSummaryApi.apiPlanSummaryReportSettingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsUpdatePlanSummaryReportSettingsCommand} [commandsUpdatePlanSummaryReportSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlanSummaryReportSettingsPut(commandsUpdatePlanSummaryReportSettingsCommand?: CommandsUpdatePlanSummaryReportSettingsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlanSummaryReportSettingsPut(commandsUpdatePlanSummaryReportSettingsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlanSummaryApi.apiPlanSummaryReportSettingsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlanSummaryApi - factory interface
 * @export
 */
export const PlanSummaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlanSummaryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanSummaryExportDataVizPost(options?: any): AxiosPromise<string> {
            return localVarFp.apiPlanSummaryExportDataVizPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanSummaryReportSettingsGet(options?: any): AxiosPromise<QueriesGetPlanSummaryReportSettingsResponse> {
            return localVarFp.apiPlanSummaryReportSettingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsUpdatePlanSummaryReportSettingsCommand} [commandsUpdatePlanSummaryReportSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlanSummaryReportSettingsPut(commandsUpdatePlanSummaryReportSettingsCommand?: CommandsUpdatePlanSummaryReportSettingsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiPlanSummaryReportSettingsPut(commandsUpdatePlanSummaryReportSettingsCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlanSummaryApi - object-oriented interface
 * @export
 * @class PlanSummaryApi
 * @extends {BaseAPI}
 */
export class PlanSummaryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanSummaryApi
     */
    public apiPlanSummaryExportDataVizPost(options?: RawAxiosRequestConfig) {
        return PlanSummaryApiFp(this.configuration).apiPlanSummaryExportDataVizPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanSummaryApi
     */
    public apiPlanSummaryReportSettingsGet(options?: RawAxiosRequestConfig) {
        return PlanSummaryApiFp(this.configuration).apiPlanSummaryReportSettingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsUpdatePlanSummaryReportSettingsCommand} [commandsUpdatePlanSummaryReportSettingsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlanSummaryApi
     */
    public apiPlanSummaryReportSettingsPut(commandsUpdatePlanSummaryReportSettingsCommand?: CommandsUpdatePlanSummaryReportSettingsCommand, options?: RawAxiosRequestConfig) {
        return PlanSummaryApiFp(this.configuration).apiPlanSummaryReportSettingsPut(commandsUpdatePlanSummaryReportSettingsCommand, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PlansApi - axios parameter creator
 * @export
 */
export const PlansApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CommandsUpdatePlanActionOrientedProgramLastAccessedDateRequest} [commandsUpdatePlanActionOrientedProgramLastAccessedDateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansActionOrientedProgramLastAccessedDatePut: async (commandsUpdatePlanActionOrientedProgramLastAccessedDateRequest?: CommandsUpdatePlanActionOrientedProgramLastAccessedDateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Plans/action-oriented-program-last-accessed-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdatePlanActionOrientedProgramLastAccessedDateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansActionOrientedProgramsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Plans/action-oriented-programs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {boolean} [isAdverseImpact] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansDataVizGet: async (isAdverseImpact?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Plans/data-viz`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (isAdverseImpact !== undefined) {
                localVarQueryParameter['isAdverseImpact'] = isAdverseImpact;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} [planIDs] 
         * @param {string} [levelOfAnalysis] 
         * @param {EnumerationsDataVisualizationResultsBy} [resultsBy] 
         * @param {EnumerationsCalcType} [calcType] 
         * @param {string} [aiActionType] 
         * @param {string} [paActionType] 
         * @param {string} [applicantType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansDataVizSelectionsPost: async (planIDs?: Array<string>, levelOfAnalysis?: string, resultsBy?: EnumerationsDataVisualizationResultsBy, calcType?: EnumerationsCalcType, aiActionType?: string, paActionType?: string, applicantType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Plans/data-viz-selections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (planIDs) {
                localVarQueryParameter['planIDs'] = planIDs;
            }

            if (levelOfAnalysis !== undefined) {
                localVarQueryParameter['levelOfAnalysis'] = levelOfAnalysis;
            }

            if (resultsBy !== undefined) {
                localVarQueryParameter['resultsBy'] = resultsBy;
            }

            if (calcType !== undefined) {
                localVarQueryParameter['calcType'] = calcType;
            }

            if (aiActionType !== undefined) {
                localVarQueryParameter['aiActionType'] = aiActionType;
            }

            if (paActionType !== undefined) {
                localVarQueryParameter['paActionType'] = paActionType;
            }

            if (applicantType !== undefined) {
                localVarQueryParameter['applicantType'] = applicantType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansGfeAssessmentGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Plans/gfe-assessment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsUpdatePlanGFEAssessmentLastAccessedDateRequest} [commandsUpdatePlanGFEAssessmentLastAccessedDateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansGfeAssessmentLastAccessedDatePut: async (commandsUpdatePlanGFEAssessmentLastAccessedDateRequest?: CommandsUpdatePlanGFEAssessmentLastAccessedDateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Plans/gfe-assessment-last-accessed-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdatePlanGFEAssessmentLastAccessedDateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueriesGetPlanProfilesQuery} [queriesGetPlanProfilesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansPlansProfilesPost: async (queriesGetPlanProfilesQuery?: QueriesGetPlanProfilesQuery, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Plans/plans-profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesGetPlanProfilesQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {EnumerationsPlanProfilesSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {boolean} [showAnnual] 
         * @param {boolean} [showUpdate] 
         * @param {boolean} [showMaster] 
         * @param {boolean} [showSub] 
         * @param {boolean} [showRegular] 
         * @param {boolean} [showAudit] 
         * @param {boolean} [showNonAudit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansPlansSelectAllGet: async (searchTerm?: string, sortColumn?: EnumerationsPlanProfilesSortColumn, sortDirection?: EnumerationsSortDirection, showAnnual?: boolean, showUpdate?: boolean, showMaster?: boolean, showSub?: boolean, showRegular?: boolean, showAudit?: boolean, showNonAudit?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Plans/plans/select-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (showAnnual !== undefined) {
                localVarQueryParameter['showAnnual'] = showAnnual;
            }

            if (showUpdate !== undefined) {
                localVarQueryParameter['showUpdate'] = showUpdate;
            }

            if (showMaster !== undefined) {
                localVarQueryParameter['showMaster'] = showMaster;
            }

            if (showSub !== undefined) {
                localVarQueryParameter['showSub'] = showSub;
            }

            if (showRegular !== undefined) {
                localVarQueryParameter['showRegular'] = showRegular;
            }

            if (showAudit !== undefined) {
                localVarQueryParameter['showAudit'] = showAudit;
            }

            if (showNonAudit !== undefined) {
                localVarQueryParameter['showNonAudit'] = showNonAudit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsUpdatePlanReportLastAccessedDateCommand} [commandsUpdatePlanReportLastAccessedDateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansReportLastAccessedDatePut: async (commandsUpdatePlanReportLastAccessedDateCommand?: CommandsUpdatePlanReportLastAccessedDateCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Plans/report-last-accessed-date`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdatePlanReportLastAccessedDateCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} masterPlanID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansSubplansMasterPlanIDGet: async (masterPlanID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'masterPlanID' is not null or undefined
            assertParamExists('apiPlansSubplansMasterPlanIDGet', 'masterPlanID', masterPlanID)
            const localVarPath = `/api/Plans/subplans/{masterPlanID}`
                .replace(`{${"masterPlanID"}}`, encodeURIComponent(String(masterPlanID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlansApi - functional programming interface
 * @export
 */
export const PlansApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlansApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CommandsUpdatePlanActionOrientedProgramLastAccessedDateRequest} [commandsUpdatePlanActionOrientedProgramLastAccessedDateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlansActionOrientedProgramLastAccessedDatePut(commandsUpdatePlanActionOrientedProgramLastAccessedDateRequest?: CommandsUpdatePlanActionOrientedProgramLastAccessedDateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlansActionOrientedProgramLastAccessedDatePut(commandsUpdatePlanActionOrientedProgramLastAccessedDateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.apiPlansActionOrientedProgramLastAccessedDatePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlansActionOrientedProgramsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetPlansResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlansActionOrientedProgramsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.apiPlansActionOrientedProgramsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {boolean} [isAdverseImpact] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlansDataVizGet(isAdverseImpact?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetPlanSelectorDataForDataVizResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlansDataVizGet(isAdverseImpact, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.apiPlansDataVizGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} [planIDs] 
         * @param {string} [levelOfAnalysis] 
         * @param {EnumerationsDataVisualizationResultsBy} [resultsBy] 
         * @param {EnumerationsCalcType} [calcType] 
         * @param {string} [aiActionType] 
         * @param {string} [paActionType] 
         * @param {string} [applicantType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlansDataVizSelectionsPost(planIDs?: Array<string>, levelOfAnalysis?: string, resultsBy?: EnumerationsDataVisualizationResultsBy, calcType?: EnumerationsCalcType, aiActionType?: string, paActionType?: string, applicantType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlansDataVizSelectionsPost(planIDs, levelOfAnalysis, resultsBy, calcType, aiActionType, paActionType, applicantType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.apiPlansDataVizSelectionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlansGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetPlansResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlansGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.apiPlansGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlansGfeAssessmentGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetPlansResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlansGfeAssessmentGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.apiPlansGfeAssessmentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsUpdatePlanGFEAssessmentLastAccessedDateRequest} [commandsUpdatePlanGFEAssessmentLastAccessedDateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlansGfeAssessmentLastAccessedDatePut(commandsUpdatePlanGFEAssessmentLastAccessedDateRequest?: CommandsUpdatePlanGFEAssessmentLastAccessedDateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlansGfeAssessmentLastAccessedDatePut(commandsUpdatePlanGFEAssessmentLastAccessedDateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.apiPlansGfeAssessmentLastAccessedDatePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueriesGetPlanProfilesQuery} [queriesGetPlanProfilesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlansPlansProfilesPost(queriesGetPlanProfilesQuery?: QueriesGetPlanProfilesQuery, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetPlanProfilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlansPlansProfilesPost(queriesGetPlanProfilesQuery, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.apiPlansPlansProfilesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {EnumerationsPlanProfilesSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {boolean} [showAnnual] 
         * @param {boolean} [showUpdate] 
         * @param {boolean} [showMaster] 
         * @param {boolean} [showSub] 
         * @param {boolean} [showRegular] 
         * @param {boolean} [showAudit] 
         * @param {boolean} [showNonAudit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlansPlansSelectAllGet(searchTerm?: string, sortColumn?: EnumerationsPlanProfilesSortColumn, sortDirection?: EnumerationsSortDirection, showAnnual?: boolean, showUpdate?: boolean, showMaster?: boolean, showSub?: boolean, showRegular?: boolean, showAudit?: boolean, showNonAudit?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetSelectAllPlanProfilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlansPlansSelectAllGet(searchTerm, sortColumn, sortDirection, showAnnual, showUpdate, showMaster, showSub, showRegular, showAudit, showNonAudit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.apiPlansPlansSelectAllGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsUpdatePlanReportLastAccessedDateCommand} [commandsUpdatePlanReportLastAccessedDateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlansReportLastAccessedDatePut(commandsUpdatePlanReportLastAccessedDateCommand?: CommandsUpdatePlanReportLastAccessedDateCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlansReportLastAccessedDatePut(commandsUpdatePlanReportLastAccessedDateCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.apiPlansReportLastAccessedDatePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} masterPlanID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPlansSubplansMasterPlanIDGet(masterPlanID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransferObjectsSubPlanResponseDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPlansSubplansMasterPlanIDGet(masterPlanID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlansApi.apiPlansSubplansMasterPlanIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlansApi - factory interface
 * @export
 */
export const PlansApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlansApiFp(configuration)
    return {
        /**
         * 
         * @param {CommandsUpdatePlanActionOrientedProgramLastAccessedDateRequest} [commandsUpdatePlanActionOrientedProgramLastAccessedDateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansActionOrientedProgramLastAccessedDatePut(commandsUpdatePlanActionOrientedProgramLastAccessedDateRequest?: CommandsUpdatePlanActionOrientedProgramLastAccessedDateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiPlansActionOrientedProgramLastAccessedDatePut(commandsUpdatePlanActionOrientedProgramLastAccessedDateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansActionOrientedProgramsGet(options?: any): AxiosPromise<QueriesGetPlansResponse> {
            return localVarFp.apiPlansActionOrientedProgramsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {boolean} [isAdverseImpact] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansDataVizGet(isAdverseImpact?: boolean, options?: any): AxiosPromise<QueriesGetPlanSelectorDataForDataVizResponse> {
            return localVarFp.apiPlansDataVizGet(isAdverseImpact, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} [planIDs] 
         * @param {string} [levelOfAnalysis] 
         * @param {EnumerationsDataVisualizationResultsBy} [resultsBy] 
         * @param {EnumerationsCalcType} [calcType] 
         * @param {string} [aiActionType] 
         * @param {string} [paActionType] 
         * @param {string} [applicantType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansDataVizSelectionsPost(planIDs?: Array<string>, levelOfAnalysis?: string, resultsBy?: EnumerationsDataVisualizationResultsBy, calcType?: EnumerationsCalcType, aiActionType?: string, paActionType?: string, applicantType?: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiPlansDataVizSelectionsPost(planIDs, levelOfAnalysis, resultsBy, calcType, aiActionType, paActionType, applicantType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansGet(options?: any): AxiosPromise<QueriesGetPlansResponse> {
            return localVarFp.apiPlansGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansGfeAssessmentGet(options?: any): AxiosPromise<QueriesGetPlansResponse> {
            return localVarFp.apiPlansGfeAssessmentGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsUpdatePlanGFEAssessmentLastAccessedDateRequest} [commandsUpdatePlanGFEAssessmentLastAccessedDateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansGfeAssessmentLastAccessedDatePut(commandsUpdatePlanGFEAssessmentLastAccessedDateRequest?: CommandsUpdatePlanGFEAssessmentLastAccessedDateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiPlansGfeAssessmentLastAccessedDatePut(commandsUpdatePlanGFEAssessmentLastAccessedDateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueriesGetPlanProfilesQuery} [queriesGetPlanProfilesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansPlansProfilesPost(queriesGetPlanProfilesQuery?: QueriesGetPlanProfilesQuery, options?: any): AxiosPromise<QueriesGetPlanProfilesResponse> {
            return localVarFp.apiPlansPlansProfilesPost(queriesGetPlanProfilesQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [searchTerm] 
         * @param {EnumerationsPlanProfilesSortColumn} [sortColumn] 
         * @param {EnumerationsSortDirection} [sortDirection] 
         * @param {boolean} [showAnnual] 
         * @param {boolean} [showUpdate] 
         * @param {boolean} [showMaster] 
         * @param {boolean} [showSub] 
         * @param {boolean} [showRegular] 
         * @param {boolean} [showAudit] 
         * @param {boolean} [showNonAudit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansPlansSelectAllGet(searchTerm?: string, sortColumn?: EnumerationsPlanProfilesSortColumn, sortDirection?: EnumerationsSortDirection, showAnnual?: boolean, showUpdate?: boolean, showMaster?: boolean, showSub?: boolean, showRegular?: boolean, showAudit?: boolean, showNonAudit?: boolean, options?: any): AxiosPromise<QueriesGetSelectAllPlanProfilesResponse> {
            return localVarFp.apiPlansPlansSelectAllGet(searchTerm, sortColumn, sortDirection, showAnnual, showUpdate, showMaster, showSub, showRegular, showAudit, showNonAudit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsUpdatePlanReportLastAccessedDateCommand} [commandsUpdatePlanReportLastAccessedDateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansReportLastAccessedDatePut(commandsUpdatePlanReportLastAccessedDateCommand?: CommandsUpdatePlanReportLastAccessedDateCommand, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiPlansReportLastAccessedDatePut(commandsUpdatePlanReportLastAccessedDateCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} masterPlanID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPlansSubplansMasterPlanIDGet(masterPlanID: string, options?: any): AxiosPromise<Array<TransferObjectsSubPlanResponseDTO>> {
            return localVarFp.apiPlansSubplansMasterPlanIDGet(masterPlanID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlansApi - object-oriented interface
 * @export
 * @class PlansApi
 * @extends {BaseAPI}
 */
export class PlansApi extends BaseAPI {
    /**
     * 
     * @param {CommandsUpdatePlanActionOrientedProgramLastAccessedDateRequest} [commandsUpdatePlanActionOrientedProgramLastAccessedDateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public apiPlansActionOrientedProgramLastAccessedDatePut(commandsUpdatePlanActionOrientedProgramLastAccessedDateRequest?: CommandsUpdatePlanActionOrientedProgramLastAccessedDateRequest, options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).apiPlansActionOrientedProgramLastAccessedDatePut(commandsUpdatePlanActionOrientedProgramLastAccessedDateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public apiPlansActionOrientedProgramsGet(options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).apiPlansActionOrientedProgramsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {boolean} [isAdverseImpact] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public apiPlansDataVizGet(isAdverseImpact?: boolean, options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).apiPlansDataVizGet(isAdverseImpact, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} [planIDs] 
     * @param {string} [levelOfAnalysis] 
     * @param {EnumerationsDataVisualizationResultsBy} [resultsBy] 
     * @param {EnumerationsCalcType} [calcType] 
     * @param {string} [aiActionType] 
     * @param {string} [paActionType] 
     * @param {string} [applicantType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public apiPlansDataVizSelectionsPost(planIDs?: Array<string>, levelOfAnalysis?: string, resultsBy?: EnumerationsDataVisualizationResultsBy, calcType?: EnumerationsCalcType, aiActionType?: string, paActionType?: string, applicantType?: string, options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).apiPlansDataVizSelectionsPost(planIDs, levelOfAnalysis, resultsBy, calcType, aiActionType, paActionType, applicantType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public apiPlansGet(options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).apiPlansGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public apiPlansGfeAssessmentGet(options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).apiPlansGfeAssessmentGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsUpdatePlanGFEAssessmentLastAccessedDateRequest} [commandsUpdatePlanGFEAssessmentLastAccessedDateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public apiPlansGfeAssessmentLastAccessedDatePut(commandsUpdatePlanGFEAssessmentLastAccessedDateRequest?: CommandsUpdatePlanGFEAssessmentLastAccessedDateRequest, options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).apiPlansGfeAssessmentLastAccessedDatePut(commandsUpdatePlanGFEAssessmentLastAccessedDateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueriesGetPlanProfilesQuery} [queriesGetPlanProfilesQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public apiPlansPlansProfilesPost(queriesGetPlanProfilesQuery?: QueriesGetPlanProfilesQuery, options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).apiPlansPlansProfilesPost(queriesGetPlanProfilesQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [searchTerm] 
     * @param {EnumerationsPlanProfilesSortColumn} [sortColumn] 
     * @param {EnumerationsSortDirection} [sortDirection] 
     * @param {boolean} [showAnnual] 
     * @param {boolean} [showUpdate] 
     * @param {boolean} [showMaster] 
     * @param {boolean} [showSub] 
     * @param {boolean} [showRegular] 
     * @param {boolean} [showAudit] 
     * @param {boolean} [showNonAudit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public apiPlansPlansSelectAllGet(searchTerm?: string, sortColumn?: EnumerationsPlanProfilesSortColumn, sortDirection?: EnumerationsSortDirection, showAnnual?: boolean, showUpdate?: boolean, showMaster?: boolean, showSub?: boolean, showRegular?: boolean, showAudit?: boolean, showNonAudit?: boolean, options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).apiPlansPlansSelectAllGet(searchTerm, sortColumn, sortDirection, showAnnual, showUpdate, showMaster, showSub, showRegular, showAudit, showNonAudit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsUpdatePlanReportLastAccessedDateCommand} [commandsUpdatePlanReportLastAccessedDateCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public apiPlansReportLastAccessedDatePut(commandsUpdatePlanReportLastAccessedDateCommand?: CommandsUpdatePlanReportLastAccessedDateCommand, options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).apiPlansReportLastAccessedDatePut(commandsUpdatePlanReportLastAccessedDateCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} masterPlanID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlansApi
     */
    public apiPlansSubplansMasterPlanIDGet(masterPlanID: string, options?: RawAxiosRequestConfig) {
        return PlansApiFp(this.configuration).apiPlansSubplansMasterPlanIDGet(masterPlanID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProtectedVeteranDataVisualizationsApi - axios parameter creator
 * @export
 */
export const ProtectedVeteranDataVisualizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} eeoCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProtectedVeteranDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet: async (eeoCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeoCode' is not null or undefined
            assertParamExists('apiProtectedVeteranDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet', 'eeoCode', eeoCode)
            const localVarPath = `/api/ProtectedVeteranDataVisualizations/eeo/{eeoCode}/employment-by-job-group`
                .replace(`{${"eeoCode"}}`, encodeURIComponent(String(eeoCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} eeoCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProtectedVeteranDataVisualizationsEeoEeoCodeHiringByJobGroupGet: async (eeoCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eeoCode' is not null or undefined
            assertParamExists('apiProtectedVeteranDataVisualizationsEeoEeoCodeHiringByJobGroupGet', 'eeoCode', eeoCode)
            const localVarPath = `/api/ProtectedVeteranDataVisualizations/eeo/{eeoCode}/hiring-by-job-group`
                .replace(`{${"eeoCode"}}`, encodeURIComponent(String(eeoCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProtectedVeteranDataVisualizationsEmploymentGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProtectedVeteranDataVisualizations/employment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProtectedVeteranDataVisualizationsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProtectedVeteranDataVisualizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProtectedVeteranDataVisualizationsHiringGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProtectedVeteranDataVisualizations/hiring`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProtectedVeteranDataVisualizationsApi - functional programming interface
 * @export
 */
export const ProtectedVeteranDataVisualizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProtectedVeteranDataVisualizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} eeoCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProtectedVeteranDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet(eeoCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetEmploymentByJobGroupByProtectedVeteranDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProtectedVeteranDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet(eeoCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedVeteranDataVisualizationsApi.apiProtectedVeteranDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} eeoCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProtectedVeteranDataVisualizationsEeoEeoCodeHiringByJobGroupGet(eeoCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetHiringByJobGroupByProtectedVeteranDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProtectedVeteranDataVisualizationsEeoEeoCodeHiringByJobGroupGet(eeoCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedVeteranDataVisualizationsApi.apiProtectedVeteranDataVisualizationsEeoEeoCodeHiringByJobGroupGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProtectedVeteranDataVisualizationsEmploymentGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetEmploymentByProtectedVeteranDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProtectedVeteranDataVisualizationsEmploymentGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedVeteranDataVisualizationsApi.apiProtectedVeteranDataVisualizationsEmploymentGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProtectedVeteranDataVisualizationsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetProtectedVeteranDataVisualizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProtectedVeteranDataVisualizationsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedVeteranDataVisualizationsApi.apiProtectedVeteranDataVisualizationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProtectedVeteranDataVisualizationsHiringGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetHiringByProtectedVeteranDrilldownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProtectedVeteranDataVisualizationsHiringGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedVeteranDataVisualizationsApi.apiProtectedVeteranDataVisualizationsHiringGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProtectedVeteranDataVisualizationsApi - factory interface
 * @export
 */
export const ProtectedVeteranDataVisualizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProtectedVeteranDataVisualizationsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} eeoCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProtectedVeteranDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet(eeoCode: string, options?: any): AxiosPromise<QueriesGetEmploymentByJobGroupByProtectedVeteranDrilldownResponse> {
            return localVarFp.apiProtectedVeteranDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet(eeoCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} eeoCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProtectedVeteranDataVisualizationsEeoEeoCodeHiringByJobGroupGet(eeoCode: string, options?: any): AxiosPromise<QueriesGetHiringByJobGroupByProtectedVeteranDrilldownResponse> {
            return localVarFp.apiProtectedVeteranDataVisualizationsEeoEeoCodeHiringByJobGroupGet(eeoCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProtectedVeteranDataVisualizationsEmploymentGet(options?: any): AxiosPromise<QueriesGetEmploymentByProtectedVeteranDrilldownResponse> {
            return localVarFp.apiProtectedVeteranDataVisualizationsEmploymentGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProtectedVeteranDataVisualizationsGet(options?: any): AxiosPromise<QueriesGetProtectedVeteranDataVisualizationResponse> {
            return localVarFp.apiProtectedVeteranDataVisualizationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProtectedVeteranDataVisualizationsHiringGet(options?: any): AxiosPromise<QueriesGetHiringByProtectedVeteranDrilldownResponse> {
            return localVarFp.apiProtectedVeteranDataVisualizationsHiringGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProtectedVeteranDataVisualizationsApi - object-oriented interface
 * @export
 * @class ProtectedVeteranDataVisualizationsApi
 * @extends {BaseAPI}
 */
export class ProtectedVeteranDataVisualizationsApi extends BaseAPI {
    /**
     * 
     * @param {string} eeoCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedVeteranDataVisualizationsApi
     */
    public apiProtectedVeteranDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet(eeoCode: string, options?: RawAxiosRequestConfig) {
        return ProtectedVeteranDataVisualizationsApiFp(this.configuration).apiProtectedVeteranDataVisualizationsEeoEeoCodeEmploymentByJobGroupGet(eeoCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} eeoCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedVeteranDataVisualizationsApi
     */
    public apiProtectedVeteranDataVisualizationsEeoEeoCodeHiringByJobGroupGet(eeoCode: string, options?: RawAxiosRequestConfig) {
        return ProtectedVeteranDataVisualizationsApiFp(this.configuration).apiProtectedVeteranDataVisualizationsEeoEeoCodeHiringByJobGroupGet(eeoCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedVeteranDataVisualizationsApi
     */
    public apiProtectedVeteranDataVisualizationsEmploymentGet(options?: RawAxiosRequestConfig) {
        return ProtectedVeteranDataVisualizationsApiFp(this.configuration).apiProtectedVeteranDataVisualizationsEmploymentGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedVeteranDataVisualizationsApi
     */
    public apiProtectedVeteranDataVisualizationsGet(options?: RawAxiosRequestConfig) {
        return ProtectedVeteranDataVisualizationsApiFp(this.configuration).apiProtectedVeteranDataVisualizationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedVeteranDataVisualizationsApi
     */
    public apiProtectedVeteranDataVisualizationsHiringGet(options?: RawAxiosRequestConfig) {
        return ProtectedVeteranDataVisualizationsApiFp(this.configuration).apiProtectedVeteranDataVisualizationsHiringGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RedirectApi - axios parameter creator
 * @export
 */
export const RedirectApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [redirectID] 
         * @param {string} [userID] 
         * @param {string} [signature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRedirectGet: async (redirectID?: string, userID?: string, signature?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Redirect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (redirectID !== undefined) {
                localVarQueryParameter['redirectID'] = redirectID;
            }

            if (userID !== undefined) {
                localVarQueryParameter['userID'] = userID;
            }

            if (signature !== undefined) {
                localVarQueryParameter['signature'] = signature;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [u] 
         * @param {string} [r] 
         * @param {string} [s] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRedirectToGet: async (u?: string, r?: string, s?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Redirect/to`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (u !== undefined) {
                localVarQueryParameter['u'] = u;
            }

            if (r !== undefined) {
                localVarQueryParameter['r'] = r;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RedirectApi - functional programming interface
 * @export
 */
export const RedirectApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RedirectApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [redirectID] 
         * @param {string} [userID] 
         * @param {string} [signature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedirectGet(redirectID?: string, userID?: string, signature?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRedirectGet(redirectID, userID, signature, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RedirectApi.apiRedirectGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [u] 
         * @param {string} [r] 
         * @param {string} [s] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiRedirectToGet(u?: string, r?: string, s?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiRedirectToGet(u, r, s, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RedirectApi.apiRedirectToGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RedirectApi - factory interface
 * @export
 */
export const RedirectApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RedirectApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [redirectID] 
         * @param {string} [userID] 
         * @param {string} [signature] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRedirectGet(redirectID?: string, userID?: string, signature?: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiRedirectGet(redirectID, userID, signature, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [u] 
         * @param {string} [r] 
         * @param {string} [s] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiRedirectToGet(u?: string, r?: string, s?: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiRedirectToGet(u, r, s, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RedirectApi - object-oriented interface
 * @export
 * @class RedirectApi
 * @extends {BaseAPI}
 */
export class RedirectApi extends BaseAPI {
    /**
     * 
     * @param {string} [redirectID] 
     * @param {string} [userID] 
     * @param {string} [signature] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedirectApi
     */
    public apiRedirectGet(redirectID?: string, userID?: string, signature?: string, options?: RawAxiosRequestConfig) {
        return RedirectApiFp(this.configuration).apiRedirectGet(redirectID, userID, signature, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [u] 
     * @param {string} [r] 
     * @param {string} [s] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RedirectApi
     */
    public apiRedirectToGet(u?: string, r?: string, s?: string, options?: RawAxiosRequestConfig) {
        return RedirectApiFp(this.configuration).apiRedirectToGet(u, r, s, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportSettingsApi - axios parameter creator
 * @export
 */
export const ReportSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CommandsUpdateGlobalReportSettingsCommand} [commandsUpdateGlobalReportSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportSettingsGlobalPut: async (commandsUpdateGlobalReportSettingsCommand?: CommandsUpdateGlobalReportSettingsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ReportSettings/global`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateGlobalReportSettingsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportSettingsPlanPlanIDGet: async (planID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('apiReportSettingsPlanPlanIDGet', 'planID', planID)
            const localVarPath = `/api/ReportSettings/plan/{planID}`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsUpdateReportSettingsCommand} [commandsUpdateReportSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportSettingsPut: async (commandsUpdateReportSettingsCommand?: CommandsUpdateReportSettingsCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ReportSettings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateReportSettingsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planID 
         * @param {string} aapReport2ClientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportSettingsReportAapReport2ClientIDPlanPlanIDGet: async (planID: string, aapReport2ClientID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planID' is not null or undefined
            assertParamExists('apiReportSettingsReportAapReport2ClientIDPlanPlanIDGet', 'planID', planID)
            // verify required parameter 'aapReport2ClientID' is not null or undefined
            assertParamExists('apiReportSettingsReportAapReport2ClientIDPlanPlanIDGet', 'aapReport2ClientID', aapReport2ClientID)
            const localVarPath = `/api/ReportSettings/report/{aapReport2ClientID}/plan/{planID}`
                .replace(`{${"planID"}}`, encodeURIComponent(String(planID)))
                .replace(`{${"aapReport2ClientID"}}`, encodeURIComponent(String(aapReport2ClientID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportSettingsApi - functional programming interface
 * @export
 */
export const ReportSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CommandsUpdateGlobalReportSettingsCommand} [commandsUpdateGlobalReportSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportSettingsGlobalPut(commandsUpdateGlobalReportSettingsCommand?: CommandsUpdateGlobalReportSettingsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportSettingsGlobalPut(commandsUpdateGlobalReportSettingsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportSettingsApi.apiReportSettingsGlobalPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} planID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportSettingsPlanPlanIDGet(planID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetGlobalReportSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportSettingsPlanPlanIDGet(planID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportSettingsApi.apiReportSettingsPlanPlanIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsUpdateReportSettingsCommand} [commandsUpdateReportSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportSettingsPut(commandsUpdateReportSettingsCommand?: CommandsUpdateReportSettingsCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportSettingsPut(commandsUpdateReportSettingsCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportSettingsApi.apiReportSettingsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} planID 
         * @param {string} aapReport2ClientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportSettingsReportAapReport2ClientIDPlanPlanIDGet(planID: string, aapReport2ClientID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetReportSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportSettingsReportAapReport2ClientIDPlanPlanIDGet(planID, aapReport2ClientID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportSettingsApi.apiReportSettingsReportAapReport2ClientIDPlanPlanIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportSettingsApi - factory interface
 * @export
 */
export const ReportSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportSettingsApiFp(configuration)
    return {
        /**
         * 
         * @param {CommandsUpdateGlobalReportSettingsCommand} [commandsUpdateGlobalReportSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportSettingsGlobalPut(commandsUpdateGlobalReportSettingsCommand?: CommandsUpdateGlobalReportSettingsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiReportSettingsGlobalPut(commandsUpdateGlobalReportSettingsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportSettingsPlanPlanIDGet(planID: string, options?: any): AxiosPromise<QueriesGetGlobalReportSettingsResponse> {
            return localVarFp.apiReportSettingsPlanPlanIDGet(planID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsUpdateReportSettingsCommand} [commandsUpdateReportSettingsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportSettingsPut(commandsUpdateReportSettingsCommand?: CommandsUpdateReportSettingsCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiReportSettingsPut(commandsUpdateReportSettingsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planID 
         * @param {string} aapReport2ClientID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportSettingsReportAapReport2ClientIDPlanPlanIDGet(planID: string, aapReport2ClientID: string, options?: any): AxiosPromise<QueriesGetReportSettingsResponse> {
            return localVarFp.apiReportSettingsReportAapReport2ClientIDPlanPlanIDGet(planID, aapReport2ClientID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportSettingsApi - object-oriented interface
 * @export
 * @class ReportSettingsApi
 * @extends {BaseAPI}
 */
export class ReportSettingsApi extends BaseAPI {
    /**
     * 
     * @param {CommandsUpdateGlobalReportSettingsCommand} [commandsUpdateGlobalReportSettingsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportSettingsApi
     */
    public apiReportSettingsGlobalPut(commandsUpdateGlobalReportSettingsCommand?: CommandsUpdateGlobalReportSettingsCommand, options?: RawAxiosRequestConfig) {
        return ReportSettingsApiFp(this.configuration).apiReportSettingsGlobalPut(commandsUpdateGlobalReportSettingsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportSettingsApi
     */
    public apiReportSettingsPlanPlanIDGet(planID: string, options?: RawAxiosRequestConfig) {
        return ReportSettingsApiFp(this.configuration).apiReportSettingsPlanPlanIDGet(planID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsUpdateReportSettingsCommand} [commandsUpdateReportSettingsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportSettingsApi
     */
    public apiReportSettingsPut(commandsUpdateReportSettingsCommand?: CommandsUpdateReportSettingsCommand, options?: RawAxiosRequestConfig) {
        return ReportSettingsApiFp(this.configuration).apiReportSettingsPut(commandsUpdateReportSettingsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planID 
     * @param {string} aapReport2ClientID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportSettingsApi
     */
    public apiReportSettingsReportAapReport2ClientIDPlanPlanIDGet(planID: string, aapReport2ClientID: string, options?: RawAxiosRequestConfig) {
        return ReportSettingsApiFp(this.configuration).apiReportSettingsReportAapReport2ClientIDPlanPlanIDGet(planID, aapReport2ClientID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ResourceLibraryApi - axios parameter creator
 * @export
 */
export const ResourceLibraryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiResourceLibraryGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ResourceLibrary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serviceName 
         * @param {string} subfolderName 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiResourceLibraryServiceNameSubfolderNameFileNameGet: async (serviceName: string, subfolderName: string, fileName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceName' is not null or undefined
            assertParamExists('apiResourceLibraryServiceNameSubfolderNameFileNameGet', 'serviceName', serviceName)
            // verify required parameter 'subfolderName' is not null or undefined
            assertParamExists('apiResourceLibraryServiceNameSubfolderNameFileNameGet', 'subfolderName', subfolderName)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('apiResourceLibraryServiceNameSubfolderNameFileNameGet', 'fileName', fileName)
            const localVarPath = `/api/ResourceLibrary/{serviceName}/{subfolderName}/{fileName}`
                .replace(`{${"serviceName"}}`, encodeURIComponent(String(serviceName)))
                .replace(`{${"subfolderName"}}`, encodeURIComponent(String(subfolderName)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResourceLibraryApi - functional programming interface
 * @export
 */
export const ResourceLibraryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResourceLibraryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiResourceLibraryGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueriesResourceItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiResourceLibraryGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ResourceLibraryApi.apiResourceLibraryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} serviceName 
         * @param {string} subfolderName 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiResourceLibraryServiceNameSubfolderNameFileNameGet(serviceName: string, subfolderName: string, fileName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiResourceLibraryServiceNameSubfolderNameFileNameGet(serviceName, subfolderName, fileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ResourceLibraryApi.apiResourceLibraryServiceNameSubfolderNameFileNameGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ResourceLibraryApi - factory interface
 * @export
 */
export const ResourceLibraryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResourceLibraryApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiResourceLibraryGet(options?: any): AxiosPromise<Array<QueriesResourceItem>> {
            return localVarFp.apiResourceLibraryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} serviceName 
         * @param {string} subfolderName 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiResourceLibraryServiceNameSubfolderNameFileNameGet(serviceName: string, subfolderName: string, fileName: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiResourceLibraryServiceNameSubfolderNameFileNameGet(serviceName, subfolderName, fileName, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResourceLibraryApi - object-oriented interface
 * @export
 * @class ResourceLibraryApi
 * @extends {BaseAPI}
 */
export class ResourceLibraryApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceLibraryApi
     */
    public apiResourceLibraryGet(options?: RawAxiosRequestConfig) {
        return ResourceLibraryApiFp(this.configuration).apiResourceLibraryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} serviceName 
     * @param {string} subfolderName 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResourceLibraryApi
     */
    public apiResourceLibraryServiceNameSubfolderNameFileNameGet(serviceName: string, subfolderName: string, fileName: string, options?: RawAxiosRequestConfig) {
        return ResourceLibraryApiFp(this.configuration).apiResourceLibraryServiceNameSubfolderNameFileNameGet(serviceName, subfolderName, fileName, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ServiceDeliverablesApi - axios parameter creator
 * @export
 */
export const ServiceDeliverablesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} fileID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesFileFileIDDelete: async (fileID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('apiServiceDeliverablesFileFileIDDelete', 'fileID', fileID)
            const localVarPath = `/api/ServiceDeliverables/file/{fileID}`
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesFileFileIDGet: async (fileID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('apiServiceDeliverablesFileFileIDGet', 'fileID', fileID)
            const localVarPath = `/api/ServiceDeliverables/file/{fileID}`
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileID 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesFileFileIDHistoryGet: async (fileID: string, page?: number, rowsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('apiServiceDeliverablesFileFileIDHistoryGet', 'fileID', fileID)
            const localVarPath = `/api/ServiceDeliverables/file/{fileID}/history`
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (rowsPerPage !== undefined) {
                localVarQueryParameter['rowsPerPage'] = rowsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileID 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesFileFileIDNameNamePut: async (fileID: string, name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('apiServiceDeliverablesFileFileIDNameNamePut', 'fileID', fileID)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiServiceDeliverablesFileFileIDNameNamePut', 'name', name)
            const localVarPath = `/api/ServiceDeliverables/file/{fileID}/name/{name}`
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesFileFileIDPreviewGet: async (fileID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileID' is not null or undefined
            assertParamExists('apiServiceDeliverablesFileFileIDPreviewGet', 'fileID', fileID)
            const localVarPath = `/api/ServiceDeliverables/file/{fileID}/preview`
                .replace(`{${"fileID"}}`, encodeURIComponent(String(fileID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pageID 
         * @param {string} [batchID] 
         * @param {number} [sequenceID] 
         * @param {number} [uploadSize] 
         * @param {boolean} [isEndOfFile] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagePageIDChunkZipPost: async (pageID: string, batchID?: string, sequenceID?: number, uploadSize?: number, isEndOfFile?: boolean, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageID' is not null or undefined
            assertParamExists('apiServiceDeliverablesPagePageIDChunkZipPost', 'pageID', pageID)
            const localVarPath = `/api/ServiceDeliverables/page/{pageID}/chunk/zip`
                .replace(`{${"pageID"}}`, encodeURIComponent(String(pageID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (batchID !== undefined) {
                localVarQueryParameter['batchID'] = batchID;
            }

            if (sequenceID !== undefined) {
                localVarQueryParameter['sequenceID'] = sequenceID;
            }

            if (uploadSize !== undefined) {
                localVarQueryParameter['uploadSize'] = uploadSize;
            }

            if (isEndOfFile !== undefined) {
                localVarQueryParameter['isEndOfFile'] = isEndOfFile;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pageID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagePageIDDelete: async (pageID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageID' is not null or undefined
            assertParamExists('apiServiceDeliverablesPagePageIDDelete', 'pageID', pageID)
            const localVarPath = `/api/ServiceDeliverables/page/{pageID}`
                .replace(`{${"pageID"}}`, encodeURIComponent(String(pageID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pageID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagePageIDGet: async (pageID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageID' is not null or undefined
            assertParamExists('apiServiceDeliverablesPagePageIDGet', 'pageID', pageID)
            const localVarPath = `/api/ServiceDeliverables/page/{pageID}`
                .replace(`{${"pageID"}}`, encodeURIComponent(String(pageID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pageID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagePageIDManageGet: async (pageID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageID' is not null or undefined
            assertParamExists('apiServiceDeliverablesPagePageIDManageGet', 'pageID', pageID)
            const localVarPath = `/api/ServiceDeliverables/page/{pageID}/manage`
                .replace(`{${"pageID"}}`, encodeURIComponent(String(pageID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pageID 
         * @param {CommandsReorderCommand} [commandsReorderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagePageIDOrderSectionsAndFilesPut: async (pageID: string, commandsReorderCommand?: CommandsReorderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageID' is not null or undefined
            assertParamExists('apiServiceDeliverablesPagePageIDOrderSectionsAndFilesPut', 'pageID', pageID)
            const localVarPath = `/api/ServiceDeliverables/page/{pageID}/order-sections-and-files`
                .replace(`{${"pageID"}}`, encodeURIComponent(String(pageID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsReorderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} pageID 
         * @param {string} [batchID] 
         * @param {string} [zipFileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagePageIDUnzipAndImportPost: async (pageID: string, batchID?: string, zipFileName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pageID' is not null or undefined
            assertParamExists('apiServiceDeliverablesPagePageIDUnzipAndImportPost', 'pageID', pageID)
            const localVarPath = `/api/ServiceDeliverables/page/{pageID}/unzip-and-import`
                .replace(`{${"pageID"}}`, encodeURIComponent(String(pageID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (batchID !== undefined) {
                localVarQueryParameter['batchID'] = batchID;
            }

            if (zipFileName !== undefined) {
                localVarQueryParameter['zipFileName'] = zipFileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateServiceDeliverablePageCommand} [commandsCreateServiceDeliverablePageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagePost: async (commandsCreateServiceDeliverablePageCommand?: CommandsCreateServiceDeliverablePageCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServiceDeliverables/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateServiceDeliverablePageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsUpdateServiceDeliverablePageCommand} [commandsUpdateServiceDeliverablePageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagePut: async (commandsUpdateServiceDeliverablePageCommand?: CommandsUpdateServiceDeliverablePageCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServiceDeliverables/page`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateServiceDeliverablePageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsSavePageOrderAndActiveStatusCommand} [commandsSavePageOrderAndActiveStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagesOrderAndActivePut: async (commandsSavePageOrderAndActiveStatusCommand?: CommandsSavePageOrderAndActiveStatusCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServiceDeliverables/pages/order-and-active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsSavePageOrderAndActiveStatusCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateSectionCommand} [commandsCreateSectionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesSectionPost: async (commandsCreateSectionCommand?: CommandsCreateSectionCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ServiceDeliverables/section`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateSectionCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {string} [batchID] 
         * @param {number} [sequenceID] 
         * @param {number} [uploadSize] 
         * @param {boolean} [isEndOfFile] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesSectionSectionIDChunkPost: async (sectionID: string, batchID?: string, sequenceID?: number, uploadSize?: number, isEndOfFile?: boolean, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionID' is not null or undefined
            assertParamExists('apiServiceDeliverablesSectionSectionIDChunkPost', 'sectionID', sectionID)
            const localVarPath = `/api/ServiceDeliverables/section/{sectionID}/chunk`
                .replace(`{${"sectionID"}}`, encodeURIComponent(String(sectionID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (batchID !== undefined) {
                localVarQueryParameter['batchID'] = batchID;
            }

            if (sequenceID !== undefined) {
                localVarQueryParameter['sequenceID'] = sequenceID;
            }

            if (uploadSize !== undefined) {
                localVarQueryParameter['uploadSize'] = uploadSize;
            }

            if (isEndOfFile !== undefined) {
                localVarQueryParameter['isEndOfFile'] = isEndOfFile;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesSectionSectionIDDelete: async (sectionID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionID' is not null or undefined
            assertParamExists('apiServiceDeliverablesSectionSectionIDDelete', 'sectionID', sectionID)
            const localVarPath = `/api/ServiceDeliverables/section/{sectionID}`
                .replace(`{${"sectionID"}}`, encodeURIComponent(String(sectionID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesSectionSectionIDFilesGet: async (sectionID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionID' is not null or undefined
            assertParamExists('apiServiceDeliverablesSectionSectionIDFilesGet', 'sectionID', sectionID)
            const localVarPath = `/api/ServiceDeliverables/section/{sectionID}/files`
                .replace(`{${"sectionID"}}`, encodeURIComponent(String(sectionID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {CommandsUploadFilesCommand} [commandsUploadFilesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesSectionSectionIDFilesPost: async (sectionID: string, commandsUploadFilesCommand?: CommandsUploadFilesCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionID' is not null or undefined
            assertParamExists('apiServiceDeliverablesSectionSectionIDFilesPost', 'sectionID', sectionID)
            const localVarPath = `/api/ServiceDeliverables/section/{sectionID}/files`
                .replace(`{${"sectionID"}}`, encodeURIComponent(String(sectionID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUploadFilesCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesSectionSectionIDNameNamePut: async (sectionID: string, name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionID' is not null or undefined
            assertParamExists('apiServiceDeliverablesSectionSectionIDNameNamePut', 'sectionID', sectionID)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('apiServiceDeliverablesSectionSectionIDNameNamePut', 'name', name)
            const localVarPath = `/api/ServiceDeliverables/section/{sectionID}/name/{name}`
                .replace(`{${"sectionID"}}`, encodeURIComponent(String(sectionID)))
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesSectionSectionIDUpdateAccessPost: async (sectionID: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionID' is not null or undefined
            assertParamExists('apiServiceDeliverablesSectionSectionIDUpdateAccessPost', 'sectionID', sectionID)
            const localVarPath = `/api/ServiceDeliverables/section/{sectionID}/update-access`
                .replace(`{${"sectionID"}}`, encodeURIComponent(String(sectionID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesSectionSectionIDUsersGet: async (sectionID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sectionID' is not null or undefined
            assertParamExists('apiServiceDeliverablesSectionSectionIDUsersGet', 'sectionID', sectionID)
            const localVarPath = `/api/ServiceDeliverables/section/{sectionID}/users`
                .replace(`{${"sectionID"}}`, encodeURIComponent(String(sectionID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} serviceID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesServiceIDPagesGet: async (serviceID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceID' is not null or undefined
            assertParamExists('apiServiceDeliverablesServiceIDPagesGet', 'serviceID', serviceID)
            const localVarPath = `/api/ServiceDeliverables/{serviceID}/pages`
                .replace(`{${"serviceID"}}`, encodeURIComponent(String(serviceID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceDeliverablesApi - functional programming interface
 * @export
 */
export const ServiceDeliverablesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceDeliverablesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} fileID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesFileFileIDDelete(fileID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesFileFileIDDelete(fileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesFileFileIDDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fileID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesFileFileIDGet(fileID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesFileFileIDGet(fileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesFileFileIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fileID 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesFileFileIDHistoryGet(fileID: string, page?: number, rowsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetFileHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesFileFileIDHistoryGet(fileID, page, rowsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesFileFileIDHistoryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fileID 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesFileFileIDNameNamePut(fileID: string, name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesFileFileIDNameNamePut(fileID, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesFileFileIDNameNamePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} fileID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesFileFileIDPreviewGet(fileID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesFileFileIDPreviewGet(fileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesFileFileIDPreviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} pageID 
         * @param {string} [batchID] 
         * @param {number} [sequenceID] 
         * @param {number} [uploadSize] 
         * @param {boolean} [isEndOfFile] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesPagePageIDChunkZipPost(pageID: string, batchID?: string, sequenceID?: number, uploadSize?: number, isEndOfFile?: boolean, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsReadZipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesPagePageIDChunkZipPost(pageID, batchID, sequenceID, uploadSize, isEndOfFile, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesPagePageIDChunkZipPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} pageID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesPagePageIDDelete(pageID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesPagePageIDDelete(pageID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesPagePageIDDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} pageID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesPagePageIDGet(pageID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetServiceDeliverablesPageDetailResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesPagePageIDGet(pageID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesPagePageIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} pageID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesPagePageIDManageGet(pageID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueriesGetManageDeliverablesPageDetailResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesPagePageIDManageGet(pageID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesPagePageIDManageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} pageID 
         * @param {CommandsReorderCommand} [commandsReorderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesPagePageIDOrderSectionsAndFilesPut(pageID: string, commandsReorderCommand?: CommandsReorderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesPagePageIDOrderSectionsAndFilesPut(pageID, commandsReorderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesPagePageIDOrderSectionsAndFilesPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} pageID 
         * @param {string} [batchID] 
         * @param {string} [zipFileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesPagePageIDUnzipAndImportPost(pageID: string, batchID?: string, zipFileName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsUnzipAndSaveFilesCommand>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesPagePageIDUnzipAndImportPost(pageID, batchID, zipFileName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesPagePageIDUnzipAndImportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateServiceDeliverablePageCommand} [commandsCreateServiceDeliverablePageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesPagePost(commandsCreateServiceDeliverablePageCommand?: CommandsCreateServiceDeliverablePageCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesPagePost(commandsCreateServiceDeliverablePageCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesPagePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsUpdateServiceDeliverablePageCommand} [commandsUpdateServiceDeliverablePageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesPagePut(commandsUpdateServiceDeliverablePageCommand?: CommandsUpdateServiceDeliverablePageCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesPagePut(commandsUpdateServiceDeliverablePageCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesPagePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsSavePageOrderAndActiveStatusCommand} [commandsSavePageOrderAndActiveStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesPagesOrderAndActivePut(commandsSavePageOrderAndActiveStatusCommand?: CommandsSavePageOrderAndActiveStatusCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesPagesOrderAndActivePut(commandsSavePageOrderAndActiveStatusCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesPagesOrderAndActivePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateSectionCommand} [commandsCreateSectionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesSectionPost(commandsCreateSectionCommand?: CommandsCreateSectionCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesSectionPost(commandsCreateSectionCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesSectionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {string} [batchID] 
         * @param {number} [sequenceID] 
         * @param {number} [uploadSize] 
         * @param {boolean} [isEndOfFile] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesSectionSectionIDChunkPost(sectionID: string, batchID?: string, sequenceID?: number, uploadSize?: number, isEndOfFile?: boolean, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesSectionSectionIDChunkPost(sectionID, batchID, sequenceID, uploadSize, isEndOfFile, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesSectionSectionIDChunkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesSectionSectionIDDelete(sectionID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesSectionSectionIDDelete(sectionID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesSectionSectionIDDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesSectionSectionIDFilesGet(sectionID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesSectionSectionIDFilesGet(sectionID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesSectionSectionIDFilesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {CommandsUploadFilesCommand} [commandsUploadFilesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesSectionSectionIDFilesPost(sectionID: string, commandsUploadFilesCommand?: CommandsUploadFilesCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesSectionSectionIDFilesPost(sectionID, commandsUploadFilesCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesSectionSectionIDFilesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesSectionSectionIDNameNamePut(sectionID: string, name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesSectionSectionIDNameNamePut(sectionID, name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesSectionSectionIDNameNamePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesSectionSectionIDUpdateAccessPost(sectionID: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesSectionSectionIDUpdateAccessPost(sectionID, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesSectionSectionIDUpdateAccessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesSectionSectionIDUsersGet(sectionID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransferObjectsUserWithAccess>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesSectionSectionIDUsersGet(sectionID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesSectionSectionIDUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} serviceID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceDeliverablesServiceIDPagesGet(serviceID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueriesGetManageDeliverablesPageListResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceDeliverablesServiceIDPagesGet(serviceID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceDeliverablesApi.apiServiceDeliverablesServiceIDPagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceDeliverablesApi - factory interface
 * @export
 */
export const ServiceDeliverablesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceDeliverablesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} fileID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesFileFileIDDelete(fileID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiServiceDeliverablesFileFileIDDelete(fileID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesFileFileIDGet(fileID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiServiceDeliverablesFileFileIDGet(fileID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileID 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesFileFileIDHistoryGet(fileID: string, page?: number, rowsPerPage?: number, options?: any): AxiosPromise<QueriesGetFileHistoryResponse> {
            return localVarFp.apiServiceDeliverablesFileFileIDHistoryGet(fileID, page, rowsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileID 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesFileFileIDNameNamePut(fileID: string, name: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiServiceDeliverablesFileFileIDNameNamePut(fileID, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesFileFileIDPreviewGet(fileID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiServiceDeliverablesFileFileIDPreviewGet(fileID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} pageID 
         * @param {string} [batchID] 
         * @param {number} [sequenceID] 
         * @param {number} [uploadSize] 
         * @param {boolean} [isEndOfFile] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagePageIDChunkZipPost(pageID: string, batchID?: string, sequenceID?: number, uploadSize?: number, isEndOfFile?: boolean, file?: File, options?: any): AxiosPromise<TransferObjectsReadZipResponse> {
            return localVarFp.apiServiceDeliverablesPagePageIDChunkZipPost(pageID, batchID, sequenceID, uploadSize, isEndOfFile, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} pageID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagePageIDDelete(pageID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiServiceDeliverablesPagePageIDDelete(pageID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} pageID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagePageIDGet(pageID: string, options?: any): AxiosPromise<QueriesGetServiceDeliverablesPageDetailResponse> {
            return localVarFp.apiServiceDeliverablesPagePageIDGet(pageID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} pageID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagePageIDManageGet(pageID: string, options?: any): AxiosPromise<Array<QueriesGetManageDeliverablesPageDetailResponse>> {
            return localVarFp.apiServiceDeliverablesPagePageIDManageGet(pageID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} pageID 
         * @param {CommandsReorderCommand} [commandsReorderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagePageIDOrderSectionsAndFilesPut(pageID: string, commandsReorderCommand?: CommandsReorderCommand, options?: any): AxiosPromise<File> {
            return localVarFp.apiServiceDeliverablesPagePageIDOrderSectionsAndFilesPut(pageID, commandsReorderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} pageID 
         * @param {string} [batchID] 
         * @param {string} [zipFileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagePageIDUnzipAndImportPost(pageID: string, batchID?: string, zipFileName?: string, options?: any): AxiosPromise<CommandsUnzipAndSaveFilesCommand> {
            return localVarFp.apiServiceDeliverablesPagePageIDUnzipAndImportPost(pageID, batchID, zipFileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateServiceDeliverablePageCommand} [commandsCreateServiceDeliverablePageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagePost(commandsCreateServiceDeliverablePageCommand?: CommandsCreateServiceDeliverablePageCommand, options?: any): AxiosPromise<File> {
            return localVarFp.apiServiceDeliverablesPagePost(commandsCreateServiceDeliverablePageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsUpdateServiceDeliverablePageCommand} [commandsUpdateServiceDeliverablePageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagePut(commandsUpdateServiceDeliverablePageCommand?: CommandsUpdateServiceDeliverablePageCommand, options?: any): AxiosPromise<File> {
            return localVarFp.apiServiceDeliverablesPagePut(commandsUpdateServiceDeliverablePageCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsSavePageOrderAndActiveStatusCommand} [commandsSavePageOrderAndActiveStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesPagesOrderAndActivePut(commandsSavePageOrderAndActiveStatusCommand?: CommandsSavePageOrderAndActiveStatusCommand, options?: any): AxiosPromise<File> {
            return localVarFp.apiServiceDeliverablesPagesOrderAndActivePut(commandsSavePageOrderAndActiveStatusCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateSectionCommand} [commandsCreateSectionCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesSectionPost(commandsCreateSectionCommand?: CommandsCreateSectionCommand, options?: any): AxiosPromise<File> {
            return localVarFp.apiServiceDeliverablesSectionPost(commandsCreateSectionCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {string} [batchID] 
         * @param {number} [sequenceID] 
         * @param {number} [uploadSize] 
         * @param {boolean} [isEndOfFile] 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesSectionSectionIDChunkPost(sectionID: string, batchID?: string, sequenceID?: number, uploadSize?: number, isEndOfFile?: boolean, file?: File, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiServiceDeliverablesSectionSectionIDChunkPost(sectionID, batchID, sequenceID, uploadSize, isEndOfFile, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesSectionSectionIDDelete(sectionID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiServiceDeliverablesSectionSectionIDDelete(sectionID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesSectionSectionIDFilesGet(sectionID: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiServiceDeliverablesSectionSectionIDFilesGet(sectionID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {CommandsUploadFilesCommand} [commandsUploadFilesCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesSectionSectionIDFilesPost(sectionID: string, commandsUploadFilesCommand?: CommandsUploadFilesCommand, options?: any): AxiosPromise<string> {
            return localVarFp.apiServiceDeliverablesSectionSectionIDFilesPost(sectionID, commandsUploadFilesCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesSectionSectionIDNameNamePut(sectionID: string, name: string, options?: any): AxiosPromise<File> {
            return localVarFp.apiServiceDeliverablesSectionSectionIDNameNamePut(sectionID, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesSectionSectionIDUpdateAccessPost(sectionID: string, requestBody?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.apiServiceDeliverablesSectionSectionIDUpdateAccessPost(sectionID, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} sectionID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesSectionSectionIDUsersGet(sectionID: string, options?: any): AxiosPromise<Array<TransferObjectsUserWithAccess>> {
            return localVarFp.apiServiceDeliverablesSectionSectionIDUsersGet(sectionID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} serviceID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceDeliverablesServiceIDPagesGet(serviceID: string, options?: any): AxiosPromise<Array<QueriesGetManageDeliverablesPageListResponse>> {
            return localVarFp.apiServiceDeliverablesServiceIDPagesGet(serviceID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceDeliverablesApi - object-oriented interface
 * @export
 * @class ServiceDeliverablesApi
 * @extends {BaseAPI}
 */
export class ServiceDeliverablesApi extends BaseAPI {
    /**
     * 
     * @param {string} fileID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesFileFileIDDelete(fileID: string, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesFileFileIDDelete(fileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesFileFileIDGet(fileID: string, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesFileFileIDGet(fileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileID 
     * @param {number} [page] 
     * @param {number} [rowsPerPage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesFileFileIDHistoryGet(fileID: string, page?: number, rowsPerPage?: number, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesFileFileIDHistoryGet(fileID, page, rowsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileID 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesFileFileIDNameNamePut(fileID: string, name: string, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesFileFileIDNameNamePut(fileID, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesFileFileIDPreviewGet(fileID: string, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesFileFileIDPreviewGet(fileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} pageID 
     * @param {string} [batchID] 
     * @param {number} [sequenceID] 
     * @param {number} [uploadSize] 
     * @param {boolean} [isEndOfFile] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesPagePageIDChunkZipPost(pageID: string, batchID?: string, sequenceID?: number, uploadSize?: number, isEndOfFile?: boolean, file?: File, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesPagePageIDChunkZipPost(pageID, batchID, sequenceID, uploadSize, isEndOfFile, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} pageID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesPagePageIDDelete(pageID: string, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesPagePageIDDelete(pageID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} pageID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesPagePageIDGet(pageID: string, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesPagePageIDGet(pageID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} pageID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesPagePageIDManageGet(pageID: string, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesPagePageIDManageGet(pageID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} pageID 
     * @param {CommandsReorderCommand} [commandsReorderCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesPagePageIDOrderSectionsAndFilesPut(pageID: string, commandsReorderCommand?: CommandsReorderCommand, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesPagePageIDOrderSectionsAndFilesPut(pageID, commandsReorderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} pageID 
     * @param {string} [batchID] 
     * @param {string} [zipFileName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesPagePageIDUnzipAndImportPost(pageID: string, batchID?: string, zipFileName?: string, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesPagePageIDUnzipAndImportPost(pageID, batchID, zipFileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateServiceDeliverablePageCommand} [commandsCreateServiceDeliverablePageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesPagePost(commandsCreateServiceDeliverablePageCommand?: CommandsCreateServiceDeliverablePageCommand, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesPagePost(commandsCreateServiceDeliverablePageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsUpdateServiceDeliverablePageCommand} [commandsUpdateServiceDeliverablePageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesPagePut(commandsUpdateServiceDeliverablePageCommand?: CommandsUpdateServiceDeliverablePageCommand, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesPagePut(commandsUpdateServiceDeliverablePageCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsSavePageOrderAndActiveStatusCommand} [commandsSavePageOrderAndActiveStatusCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesPagesOrderAndActivePut(commandsSavePageOrderAndActiveStatusCommand?: CommandsSavePageOrderAndActiveStatusCommand, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesPagesOrderAndActivePut(commandsSavePageOrderAndActiveStatusCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateSectionCommand} [commandsCreateSectionCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesSectionPost(commandsCreateSectionCommand?: CommandsCreateSectionCommand, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesSectionPost(commandsCreateSectionCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sectionID 
     * @param {string} [batchID] 
     * @param {number} [sequenceID] 
     * @param {number} [uploadSize] 
     * @param {boolean} [isEndOfFile] 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesSectionSectionIDChunkPost(sectionID: string, batchID?: string, sequenceID?: number, uploadSize?: number, isEndOfFile?: boolean, file?: File, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesSectionSectionIDChunkPost(sectionID, batchID, sequenceID, uploadSize, isEndOfFile, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sectionID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesSectionSectionIDDelete(sectionID: string, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesSectionSectionIDDelete(sectionID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sectionID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesSectionSectionIDFilesGet(sectionID: string, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesSectionSectionIDFilesGet(sectionID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sectionID 
     * @param {CommandsUploadFilesCommand} [commandsUploadFilesCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesSectionSectionIDFilesPost(sectionID: string, commandsUploadFilesCommand?: CommandsUploadFilesCommand, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesSectionSectionIDFilesPost(sectionID, commandsUploadFilesCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sectionID 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesSectionSectionIDNameNamePut(sectionID: string, name: string, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesSectionSectionIDNameNamePut(sectionID, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sectionID 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesSectionSectionIDUpdateAccessPost(sectionID: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesSectionSectionIDUpdateAccessPost(sectionID, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} sectionID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesSectionSectionIDUsersGet(sectionID: string, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesSectionSectionIDUsersGet(sectionID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} serviceID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceDeliverablesApi
     */
    public apiServiceDeliverablesServiceIDPagesGet(serviceID: string, options?: RawAxiosRequestConfig) {
        return ServiceDeliverablesApiFp(this.configuration).apiServiceDeliverablesServiceIDPagesGet(serviceID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ServiceLinesApi - axios parameter creator
 * @export
 */
export const ServiceLinesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} serviceID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceLinesServiceIDLeftNavMenuGet: async (serviceID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceID' is not null or undefined
            assertParamExists('apiServiceLinesServiceIDLeftNavMenuGet', 'serviceID', serviceID)
            const localVarPath = `/api/ServiceLines/{serviceID}/left-nav-menu`
                .replace(`{${"serviceID"}}`, encodeURIComponent(String(serviceID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ServiceLinesApi - functional programming interface
 * @export
 */
export const ServiceLinesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ServiceLinesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} serviceID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiServiceLinesServiceIDLeftNavMenuGet(serviceID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetLeftNavMenuResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiServiceLinesServiceIDLeftNavMenuGet(serviceID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ServiceLinesApi.apiServiceLinesServiceIDLeftNavMenuGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ServiceLinesApi - factory interface
 * @export
 */
export const ServiceLinesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ServiceLinesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} serviceID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiServiceLinesServiceIDLeftNavMenuGet(serviceID: string, options?: any): AxiosPromise<QueriesGetLeftNavMenuResponse> {
            return localVarFp.apiServiceLinesServiceIDLeftNavMenuGet(serviceID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ServiceLinesApi - object-oriented interface
 * @export
 * @class ServiceLinesApi
 * @extends {BaseAPI}
 */
export class ServiceLinesApi extends BaseAPI {
    /**
     * 
     * @param {string} serviceID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLinesApi
     */
    public apiServiceLinesServiceIDLeftNavMenuGet(serviceID: string, options?: RawAxiosRequestConfig) {
        return ServiceLinesApiFp(this.configuration).apiServiceLinesServiceIDLeftNavMenuGet(serviceID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SystemAlertsApi - axios parameter creator
 * @export
 */
export const SystemAlertsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CommandsAcknowledgeAlertRequest} [commandsAcknowledgeAlertRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsAcknowledgePost: async (commandsAcknowledgeAlertRequest?: CommandsAcknowledgeAlertRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SystemAlerts/acknowledge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsAcknowledgeAlertRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsAdminGet: async (page?: number, rowsPerPage?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SystemAlerts/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (rowsPerPage !== undefined) {
                localVarQueryParameter['rowsPerPage'] = rowsPerPage;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} systemAlertID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsAdminInfoSystemAlertIDGet: async (systemAlertID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemAlertID' is not null or undefined
            assertParamExists('apiSystemAlertsAdminInfoSystemAlertIDGet', 'systemAlertID', systemAlertID)
            const localVarPath = `/api/SystemAlerts/admin-info/{systemAlertID}`
                .replace(`{${"systemAlertID"}}`, encodeURIComponent(String(systemAlertID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} systemAlertID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsAdminSystemAlertIDGet: async (systemAlertID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemAlertID' is not null or undefined
            assertParamExists('apiSystemAlertsAdminSystemAlertIDGet', 'systemAlertID', systemAlertID)
            const localVarPath = `/api/SystemAlerts/admin/{systemAlertID}`
                .replace(`{${"systemAlertID"}}`, encodeURIComponent(String(systemAlertID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateAlertRequest} [commandsCreateAlertRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsPost: async (commandsCreateAlertRequest?: CommandsCreateAlertRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SystemAlerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateAlertRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsEditAlertRequest} [commandsEditAlertRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsPut: async (commandsEditAlertRequest?: CommandsEditAlertRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SystemAlerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsEditAlertRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsToggleAlertStatusRequest} [commandsToggleAlertStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsStatusPut: async (commandsToggleAlertStatusRequest?: CommandsToggleAlertStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SystemAlerts/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsToggleAlertStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsUnreadGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SystemAlerts/unread`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} systemAlertID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsUserSystemAlertIDGet: async (systemAlertID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'systemAlertID' is not null or undefined
            assertParamExists('apiSystemAlertsUserSystemAlertIDGet', 'systemAlertID', systemAlertID)
            const localVarPath = `/api/SystemAlerts/user/{systemAlertID}`
                .replace(`{${"systemAlertID"}}`, encodeURIComponent(String(systemAlertID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemAlertsApi - functional programming interface
 * @export
 */
export const SystemAlertsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemAlertsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CommandsAcknowledgeAlertRequest} [commandsAcknowledgeAlertRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemAlertsAcknowledgePost(commandsAcknowledgeAlertRequest?: CommandsAcknowledgeAlertRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemAlertsAcknowledgePost(commandsAcknowledgeAlertRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemAlertsApi.apiSystemAlertsAcknowledgePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemAlertsAdminGet(page?: number, rowsPerPage?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetAdminSystemAlertViewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemAlertsAdminGet(page, rowsPerPage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemAlertsApi.apiSystemAlertsAdminGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} systemAlertID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemAlertsAdminInfoSystemAlertIDGet(systemAlertID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetAlertInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemAlertsAdminInfoSystemAlertIDGet(systemAlertID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemAlertsApi.apiSystemAlertsAdminInfoSystemAlertIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} systemAlertID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemAlertsAdminSystemAlertIDGet(systemAlertID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetAlertDetailsForAdminResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemAlertsAdminSystemAlertIDGet(systemAlertID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemAlertsApi.apiSystemAlertsAdminSystemAlertIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateAlertRequest} [commandsCreateAlertRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemAlertsPost(commandsCreateAlertRequest?: CommandsCreateAlertRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsCreateAlertResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemAlertsPost(commandsCreateAlertRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemAlertsApi.apiSystemAlertsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsEditAlertRequest} [commandsEditAlertRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemAlertsPut(commandsEditAlertRequest?: CommandsEditAlertRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsStatusCodeResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemAlertsPut(commandsEditAlertRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemAlertsApi.apiSystemAlertsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsToggleAlertStatusRequest} [commandsToggleAlertStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemAlertsStatusPut(commandsToggleAlertStatusRequest?: CommandsToggleAlertStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemAlertsStatusPut(commandsToggleAlertStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemAlertsApi.apiSystemAlertsStatusPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemAlertsUnreadGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetUnreadAlertsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemAlertsUnreadGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemAlertsApi.apiSystemAlertsUnreadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} systemAlertID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemAlertsUserSystemAlertIDGet(systemAlertID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SystemAlertsSystemAlertDetailsForUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemAlertsUserSystemAlertIDGet(systemAlertID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemAlertsApi.apiSystemAlertsUserSystemAlertIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SystemAlertsApi - factory interface
 * @export
 */
export const SystemAlertsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemAlertsApiFp(configuration)
    return {
        /**
         * 
         * @param {CommandsAcknowledgeAlertRequest} [commandsAcknowledgeAlertRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsAcknowledgePost(commandsAcknowledgeAlertRequest?: CommandsAcknowledgeAlertRequest, options?: any): AxiosPromise<TransferObjectsResponseDTO> {
            return localVarFp.apiSystemAlertsAcknowledgePost(commandsAcknowledgeAlertRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [rowsPerPage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsAdminGet(page?: number, rowsPerPage?: number, options?: any): AxiosPromise<QueriesGetAdminSystemAlertViewResponse> {
            return localVarFp.apiSystemAlertsAdminGet(page, rowsPerPage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} systemAlertID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsAdminInfoSystemAlertIDGet(systemAlertID: string, options?: any): AxiosPromise<QueriesGetAlertInfoResponse> {
            return localVarFp.apiSystemAlertsAdminInfoSystemAlertIDGet(systemAlertID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} systemAlertID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsAdminSystemAlertIDGet(systemAlertID: string, options?: any): AxiosPromise<QueriesGetAlertDetailsForAdminResponse> {
            return localVarFp.apiSystemAlertsAdminSystemAlertIDGet(systemAlertID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateAlertRequest} [commandsCreateAlertRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsPost(commandsCreateAlertRequest?: CommandsCreateAlertRequest, options?: any): AxiosPromise<CommandsCreateAlertResponse> {
            return localVarFp.apiSystemAlertsPost(commandsCreateAlertRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsEditAlertRequest} [commandsEditAlertRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsPut(commandsEditAlertRequest?: CommandsEditAlertRequest, options?: any): AxiosPromise<TransferObjectsStatusCodeResponseDTO> {
            return localVarFp.apiSystemAlertsPut(commandsEditAlertRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsToggleAlertStatusRequest} [commandsToggleAlertStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsStatusPut(commandsToggleAlertStatusRequest?: CommandsToggleAlertStatusRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiSystemAlertsStatusPut(commandsToggleAlertStatusRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsUnreadGet(options?: any): AxiosPromise<QueriesGetUnreadAlertsResponse> {
            return localVarFp.apiSystemAlertsUnreadGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} systemAlertID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemAlertsUserSystemAlertIDGet(systemAlertID: string, options?: any): AxiosPromise<SystemAlertsSystemAlertDetailsForUser> {
            return localVarFp.apiSystemAlertsUserSystemAlertIDGet(systemAlertID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemAlertsApi - object-oriented interface
 * @export
 * @class SystemAlertsApi
 * @extends {BaseAPI}
 */
export class SystemAlertsApi extends BaseAPI {
    /**
     * 
     * @param {CommandsAcknowledgeAlertRequest} [commandsAcknowledgeAlertRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemAlertsApi
     */
    public apiSystemAlertsAcknowledgePost(commandsAcknowledgeAlertRequest?: CommandsAcknowledgeAlertRequest, options?: RawAxiosRequestConfig) {
        return SystemAlertsApiFp(this.configuration).apiSystemAlertsAcknowledgePost(commandsAcknowledgeAlertRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [page] 
     * @param {number} [rowsPerPage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemAlertsApi
     */
    public apiSystemAlertsAdminGet(page?: number, rowsPerPage?: number, options?: RawAxiosRequestConfig) {
        return SystemAlertsApiFp(this.configuration).apiSystemAlertsAdminGet(page, rowsPerPage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} systemAlertID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemAlertsApi
     */
    public apiSystemAlertsAdminInfoSystemAlertIDGet(systemAlertID: string, options?: RawAxiosRequestConfig) {
        return SystemAlertsApiFp(this.configuration).apiSystemAlertsAdminInfoSystemAlertIDGet(systemAlertID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} systemAlertID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemAlertsApi
     */
    public apiSystemAlertsAdminSystemAlertIDGet(systemAlertID: string, options?: RawAxiosRequestConfig) {
        return SystemAlertsApiFp(this.configuration).apiSystemAlertsAdminSystemAlertIDGet(systemAlertID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateAlertRequest} [commandsCreateAlertRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemAlertsApi
     */
    public apiSystemAlertsPost(commandsCreateAlertRequest?: CommandsCreateAlertRequest, options?: RawAxiosRequestConfig) {
        return SystemAlertsApiFp(this.configuration).apiSystemAlertsPost(commandsCreateAlertRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsEditAlertRequest} [commandsEditAlertRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemAlertsApi
     */
    public apiSystemAlertsPut(commandsEditAlertRequest?: CommandsEditAlertRequest, options?: RawAxiosRequestConfig) {
        return SystemAlertsApiFp(this.configuration).apiSystemAlertsPut(commandsEditAlertRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsToggleAlertStatusRequest} [commandsToggleAlertStatusRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemAlertsApi
     */
    public apiSystemAlertsStatusPut(commandsToggleAlertStatusRequest?: CommandsToggleAlertStatusRequest, options?: RawAxiosRequestConfig) {
        return SystemAlertsApiFp(this.configuration).apiSystemAlertsStatusPut(commandsToggleAlertStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemAlertsApi
     */
    public apiSystemAlertsUnreadGet(options?: RawAxiosRequestConfig) {
        return SystemAlertsApiFp(this.configuration).apiSystemAlertsUnreadGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} systemAlertID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemAlertsApi
     */
    public apiSystemAlertsUserSystemAlertIDGet(systemAlertID: string, options?: RawAxiosRequestConfig) {
        return SystemAlertsApiFp(this.configuration).apiSystemAlertsUserSystemAlertIDGet(systemAlertID, options).then((request) => request(this.axios, this.basePath));
    }
}



